// import React, { useEffect, useState } from "react"
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import Loader from "components/Loader/Loader";
// import { useNavigate, useParams } from "react-router-dom";
// import { getAllStudents, getAllStudentsForTata } from "helpers/student_helper";
// import { Modal } from "react-bootstrap";
// import { fetchAllCourses } from "helpers/course_helper";
// import { DOWNLOAD_BATCH_STUDENT_FILE, url } from "helpers/url_helper";
// import { DataGrid } from '@mui/x-data-grid';
// import Paper from '@mui/material/Paper';
// import { generatePresignedUrlForAccess } from "helpers/Content_helper";
// import { 
//     addCourseToBatch, 
//     addStudentToBatch, 
//     addTrainerToBatch, 
//     deleteBatch, 
//     fetchSingleBatch, 
//     getAllCourseOfBatch, 
//     getAllScormCourseOfBatch, 
//     getAllStudentOfBatch, 
//     getAllTrainerOfBatch, 
//     removeAllStudentsFromBatch, 
//     removeAllTrainersFromBatch, 
//     removeCourseFromBatch, 
//     removeStudentFromBatch, 
//     removeTrainerFromBatch, 
//     updateBatch 
// } from "helpers/batch_helper";
// import { fetchAllTrainers, fetchAllUsers } from "helpers/user_helper";
// import axios from "axios";
// import Select from "react-select"
// import Attendance from "./Components/Attendance";
// import Simulator from "./Components/Simulator";
// import TrainerAttendance from "./Components/TrainerAttendance";
// import ExamList from "./Components/ExamList";
// import { ExamResultsModal } from "./Components/ExamResultsModal";
// import Feedback from "./Components/Feedback";
// import DriverMarkingSystem from "./Components/DriverMarkingSystem";
// import BronzeAssessment from "./Components/BronzeAssessment";
// import SilverAssessment from "./Components/SilverAssessment";
// import GoldAssessment from "./Components/GoldAssessment";
// import { TextField, CircularProgress, Box, Chip, IconButton, Avatar, Checkbox, Tooltip, InputAdornment } from "@mui/material";
// import { fetchAllScormCourse } from "helpers/scorm_helper";
// import ScormCourse from "./Components/ScormCourse";
// import ImageUploader from "./Components/ImageUploader";
// import NotificationButtons from "./Components/NotificationButtons";
// import LClass from "./Components/LClass";
// import InfoIcon from '@mui/icons-material/Info';
// import EventIcon from '@mui/icons-material/Event';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import SchoolIcon from '@mui/icons-material/School';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import PersonOffIcon from '@mui/icons-material/PersonOff';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
// import VideoCallIcon from '@mui/icons-material/VideoCall';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import SubjectIcon from '@mui/icons-material/Subject';
// import LinkIcon from '@mui/icons-material/Link';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import ViewWeekIcon from '@mui/icons-material/ViewWeek';
// import ViewDayIcon from '@mui/icons-material/ViewDay';
// import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
// import TodayIcon from '@mui/icons-material/Today';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import AddIcon from '@mui/icons-material/Add';
// import FingerprintIcon from '@mui/icons-material/Fingerprint';
// import BadgeIcon from '@mui/icons-material/Badge';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import DescriptionIcon from '@mui/icons-material/Description';
// import WorkIcon from '@mui/icons-material/Work';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import BusinessIcon from '@mui/icons-material/Business';

// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';

// import { getResult } from "helpers/exam_helper";
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';

// const localizer = momentLocalizer(moment);

// const allDepartments = [
//     { id: 1, name: "Skilling" },
//     { id: 2, name: "Upskilling" },
//     { id: 3, name: "Paid Trainings" },
//     { id: 4, name: "Corporate" },
//     { id: 5, name: "School Project" },
//     { id: 6, name: "University & College" },
// ]

// const paginationModel = { page: 0, pageSize: 5 };

// const BatchDetails = (props) => {
//     document.title = "Content Management | Batch Details";
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [loader, setLoader] = useState(false);
//     const [batchZipLoading, setBatchZipLoading] = useState(false);
//     const navigate = useNavigate();
//     const params = useParams();

//     const [batchDetails, setBatchDetails] = useState(null);
//     const [selectedTab, setSelectedTab] = useState("Courses");
//     const [editModal, setEditModal] = useState(false);
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [addCourseModal, setAddCourseModal] = useState(false);
//     const [addTrainerModal, setAddTrainerModal] = useState(false);
//     const [addStudentModal, setAddStudentModal] = useState(false);
//     const [allCourses, setAllCourses] = useState([]);
//     const [allScormCourses, setAllScormCourses] = useState([]);
//     const [allCoursesOfBatch, setAllCourseOfBatch] = useState([]);
//     const [allScormCoursesOfBatch, setAllScormCourseOfBatch] = useState([]);
//     const [allTrainers, setAllTrainers] = useState([]);
//     const [allStudents, setAllStudents] = useState([]);
//     const [allTrainerOfBatch, setAllTrainerOfBatch] = useState([]);
//     const [allStudentOfBatch, setAllStudentOfBatch] = useState([]);
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const [selectedStudent, setSelectedStudent] = useState(null);
//     const [selectedTrainer, setSelectedTrainer] = useState(null);
//     const [trainerDeleteModal, setTrainerDeleteModal] = useState(false);
//     const [studentDeleteModal, setStudentDeleteModal] = useState(false);
//     const [courseDeleteModal, setCourseDeleteModal] = useState(false);
//     const [department, setDepartment] = useState(null);
//     const [liveClasses, setLiveClasses] = useState([]);
//     const [showExamResults, setShowExamResults] = useState(false);
//     const [trainingImages, setTrainingImages] = useState([]);
//     const [organizationId, setOrganizationId] = useState(null);
    
//     const [assessmentType, setAssessmentType] = useState("none");
//     const [assessmentDebug, setAssessmentDebug] = useState("");
    
//     const [selectedStudentsForBatch, setSelectedStudentsForBatch] = useState([]);
//     const [selectAll, setSelectAll] = useState(false);
//     const [showSelectedStudents, setShowSelectedStudents] = useState(false);
//     const [recentlyAddedStudents, setRecentlyAddedStudents] = useState([]);
//     const [showSuccessMessage, setShowSuccessMessage] = useState(false);
//     const [successMessage, setSuccessMessage] = useState("");

//     // State for multiple student removal from batch
//     const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//     const [batchStudentSearchTerm, setBatchStudentSearchTerm] = useState("");
//     const [filteredBatchStudents, setFilteredBatchStudents] = useState([]);
//     const [removeAllStudentsModal, setRemoveAllStudentsModal] = useState(false);
//     const [bulkRemoveModal, setBulkRemoveModal] = useState(false);

//     const [certificateProgress, setCertificateProgress] = useState({
//         total: 0,
//         completed: 0,
//         failed: 0,
//         inProgress: false
//     });
    
//     const [calendarView, setCalendarView] = useState('month');
//     const [currentDate, setCurrentDate] = useState(new Date());
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [showEventModal, setShowEventModal] = useState(false);
//     const [calendarStats, setCalendarStats] = useState({
//         pastClassesCurrentMonth: 0,
//         pastClassesPrevMonth: 0,
//         upcomingClasses: 0,
//         totalClasses: 0
//     });

//     const [searchStudentText, setSearchStudentText] = useState("");
//     const [searchTrainerText, setSearchTrainerText] = useState("");
//     const [searchCourseText, setSearchCourseText] = useState("");
//     const [searchAadhaarText, setSearchAadhaarText] = useState("");
//     const [stateFilter, setStateFilter] = useState(null);
//     const [divisionFilter, setDivisionFilter] = useState(null);
//     const [availableStates, setAvailableStates] = useState([]);
//     const [availableDivisions, setAvailableDivisions] = useState([]);
//     const [availableAadhaarNumbers, setAvailableAadhaarNumbers] = useState([]);
//     const [aadhaarFilter, setAadhaarFilter] = useState(null);
//     const [availableContractorTokens, setAvailableContractorTokens] = useState([]);
//     const [contractorTokenFilter, setContractorTokenFilter] = useState(null);
    
//     const [availableNatureOfWork, setAvailableNatureOfWork] = useState([]);
//     const [natureOfWorkFilter, setNatureOfWorkFilter] = useState(null);

//     const [filteredAllStudents, setFilteredAllStudents] = useState([]);
//     const [filteredAllTrainers, setFilteredAllTrainers] = useState([]);
//     const [filteredAllCourses, setFilteredAllCourses] = useState([]);

//     const [studentExamResults, setStudentExamResults] = useState({});
//     const [driverMarkingResults, setDriverMarkingResults] = useState({});
//     const [loadingExamResults, setLoadingExamResults] = useState({});
//     const [fetchingExamResults, setFetchingExamResults] = useState(false);

//     const [type, setType] = useState(null);

//     const breadcrumbItems = [
//         { title: "Batch", link: "#" },
//         { title: "Batch Details", link: "#" },
//     ]

//     const determineAssessmentType = (batchDepartment, batchName) => {
//         const isDriverDepartment = batchDepartment && batchDepartment.toLowerCase().includes("driver");
//         const isSurakshaBatch = batchName && batchName.toLowerCase().startsWith("suraksha");
        
//         if (isDriverDepartment && isSurakshaBatch) {
//             console.log("Driver department + Suraksha batch → DriverMarkingSystem");
//             return "driver";
//         }
        
//         const isTechnicalDepartment = batchDepartment && batchDepartment.toLowerCase().includes("technical");
        
//         if (isTechnicalDepartment && batchName) {
//             const lowerCaseName = batchName.toLowerCase().trim();
            
//             if (lowerCaseName.startsWith("bronze")) {
//                 console.log("Technical department + Bronze batch → Bronze Assessment");
//                 return "bronze";
//             } 
//             else if (lowerCaseName.startsWith("silver")) {
//                 console.log("Technical department + Silver batch → Silver Assessment");
//                 return "silver";
//             } 
//             else if (lowerCaseName.startsWith("gold")) {
//                 console.log("Technical department + Gold batch → Gold Assessment");
//                 return "gold";
//             }
//         }
        
//         console.log("No matching criteria → No Practical");
//         return "none";
//     };

//     const hasPracticalAssessment = () => {
//         return assessmentType !== "none";
//     };

//     useEffect(() => {
//         let authUser = JSON.parse(localStorage.getItem("authUser"));
//         setOrganizationId(authUser?.organizationId);
//         setType(authUser?.userType);
//     }, []);

//     useEffect(() => {
//         props.setBreadcrumbItems('Student Details', breadcrumbItems)
//     }, []);

//     useEffect(() => {
//         fetchBatchDetails();
//         fetchAllStudents();
//         getAllTrainers();
//         fetchCourses();
//         fetchScormCourses();
//     }, []);

//     useEffect(() => {
//         getCourseOfBatch();
//         getScormCourseOfBatch();
//         getStudentOfBatch();
//         getTrainerOfBatch();
//     }, []);

//     useEffect(() => {
//         if (selectedTab === "Student" && allStudentOfBatch.length > 0) {
//             autoFetchExamResultsForAllStudents();
//         }
//         // Filter batch students when search term changes
//         filterBatchStudents();
//     }, [selectedTab, allStudentOfBatch, batchStudentSearchTerm]);

//     const autoFetchExamResultsForAllStudents = async () => {
//         if (fetchingExamResults) return;
        
//         setFetchingExamResults(true);
//         const results = {};
        
//         for (const student of allStudentOfBatch) {
//             try {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: true }));
//                 const examResponse = await getResult(`${params.id}/${student.id}`);
                
//                 if (examResponse?.success) {
//                     let preTestScore = null;
//                     let postTestScore = null;
                    
//                     if (examResponse.result) {
//                         const preTest = examResponse.result.preTest;
//                         const postTest = examResponse.result.postTest;
                        
//                         if (preTest !== undefined && preTest !== null) {
//                             preTestScore = typeof preTest === 'number' ? preTest : 
//                                          (preTest.percentage || preTest.score || 0);
//                         }
                        
//                         if (postTest !== undefined && postTest !== null) {
//                             postTestScore = typeof postTest === 'number' ? postTest : 
//                                           (postTest.percentage || postTest.score || 0);
//                         }
//                     }
                    
//                     results[student.id] = {
//                         preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                         postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                         lastUpdated: new Date().toISOString()
//                     };
//                 }
                
//                 await new Promise(resolve => setTimeout(resolve, 100));
                
//             } catch (error) {
//                 console.error(`Error auto-fetching exam results for student ${student.id}:`, error);
//             } finally {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: false }));
//             }
//         }
        
//         setStudentExamResults(prev => ({ ...prev, ...results }));
//         setFetchingExamResults(false);
//     };

//     const filterBatchStudents = () => {
//         if (!allStudentOfBatch || allStudentOfBatch.length === 0) {
//             setFilteredBatchStudents([]);
//             return;
//         }

//         if (!batchStudentSearchTerm || batchStudentSearchTerm.trim() === "") {
//             setFilteredBatchStudents(allStudentOfBatch);
//             return;
//         }

//         const searchTerm = batchStudentSearchTerm.toLowerCase().trim();
//         const filtered = allStudentOfBatch.filter(student => {
//             const firstName = student.firstName?.toLowerCase() || '';
//             const lastName = student.lastName?.toLowerCase() || '';
//             const fullName = `${firstName} ${lastName}`.trim();
//             const mobile = student.mobile || '';
//             const email = student.email?.toLowerCase() || '';
//             const depot = student.tataStudentDetailsDto?.depot?.toLowerCase() || '';
//             const division = student.tataStudentDetailsDto?.division?.toLowerCase() || '';
//             const state = student.tataStudentDetailsDto?.state?.toLowerCase() || '';

//             return fullName.includes(searchTerm) ||
//                    mobile.includes(searchTerm) ||
//                    email.includes(searchTerm) ||
//                    depot.includes(searchTerm) ||
//                    division.includes(searchTerm) ||
//                    state.includes(searchTerm);
//         });

//         setFilteredBatchStudents(filtered);
//     };

//     const extractFilters = (students) => {
//         if (!students || students.length === 0) return;

//         const states = [...new Set(students
//             .map(student => {
//                 return student.tataStudentDetailsDto?.state ||
//                     student.state ||
//                     student.studentAddressInfo?.state;
//             })
//             .filter(state => state && state.trim() !== '')
//             .sort())];

//         const divisions = [...new Set(students
//             .map(student => {
//                 return student.tataStudentDetailsDto?.division ||
//                     student.division;
//             })
//             .filter(division => division && division.trim() !== '')
//             .sort())];

//         const aadhaarNumbers = [...new Set(students
//             .map(student => {
//                 const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                  student.aadhaarNo || 
//                                  student.aadharNo;
//                 return aadhaarNo ? String(aadhaarNo).trim() : null;
//             })
//             .filter(aadhaar => aadhaar && aadhaar.trim() !== '')
//             .sort())];

//         const contractorTokens = [...new Set(students
//             .map(student => {
//                 const token = student.tataStudentDetailsDto?.contractorTokenNo || 
//                             student.contractorTokenNo;
//                 return token ? String(token).trim() : null;
//             })
//             .filter(token => token && token.trim() !== '')
//             .sort((a, b) => {
//                 return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
//             }))];
            
//         const natureOfWorkValues = [...new Set(students
//             .map(student => {
//                 const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                    student.natureOfWork;
//                 return natureOfWork ? String(natureOfWork).trim() : null;
//             })
//             .filter(natureOfWork => natureOfWork && natureOfWork.trim() !== '')
//             .sort())];

//         setAvailableStates(states.map(state => ({ value: state, label: state })));
//         setAvailableDivisions(divisions.map(division => ({ value: division, label: division })));
//         setAvailableAadhaarNumbers(aadhaarNumbers.map(aadhaar => ({ 
//             value: aadhaar, 
//             label: aadhaar,
//             display: formatAadhaarNumber(aadhaar)
//         })));
//         setAvailableContractorTokens(contractorTokens.map(token => ({ 
//             value: token, 
//             label: token,
//             display: token
//         })));
        
//         setAvailableNatureOfWork(natureOfWorkValues.map(natureOfWork => ({ 
//             value: natureOfWork, 
//             label: natureOfWork,
//             display: natureOfWork
//         })));
//     }

//     const formatAadhaarNumber = (aadhaar) => {
//         if (!aadhaar) return '--';
//         const cleanAadhaar = String(aadhaar).replace(/\D/g, '');
//         if (cleanAadhaar.length === 12) {
//             return `${cleanAadhaar.substring(0, 4)} ${cleanAadhaar.substring(4, 8)} ${cleanAadhaar.substring(8, 12)}`;
//         }
//         return cleanAadhaar;
//     };

//     const applyStudentFilters = () => {
//         let filtered = allStudents;

//         if (searchStudentText) {
//             const searchTerm = searchStudentText.toLowerCase();

//             filtered = filtered.filter(student => {
//                 if (type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer") {
//                     const firstName = student.firstName?.toLowerCase() || '';
//                     const lastName = student.lastName?.toLowerCase() || '';
//                     const mobile = student.mobile || '';
//                     const depot = student.depot?.toLowerCase() || '';
//                     const state = student.state?.toLowerCase() || '';
//                     const division = student.division?.toLowerCase() || '';
//                     const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo || 
//                                      '';
//                     const contractorTokenNo = student.tataStudentDetailsDto?.contractorTokenNo || 
//                                             student.contractorTokenNo || 
//                                             '';
//                     const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                        student.natureOfWork || 
//                                        '';

//                     return (
//                         firstName.includes(searchTerm) ||
//                         lastName.includes(searchTerm) ||
//                         depot.includes(searchTerm) ||
//                         state.includes(searchTerm) ||
//                         division.includes(searchTerm) ||
//                         aadhaarNo.includes(searchTerm) ||
//                         contractorTokenNo.includes(searchTerm) ||
//                         natureOfWork.toLowerCase().includes(searchTerm) ||
//                         mobile.includes(searchStudentText)
//                     );
//                 } else {
//                     const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo || 
//                                      '';
//                     const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                        student.natureOfWork || 
//                                        '';
//                     return (
//                         (student.firstName && student.firstName.toLowerCase().includes(searchTerm)) ||
//                         (student.lastName && student.lastName.toLowerCase().includes(searchTerm)) ||
//                         (student.email && student.email.toLowerCase().includes(searchTerm)) ||
//                         (student.mobile && student.mobile.includes(searchStudentText)) ||
//                         (aadhaarNo && aadhaarNo.includes(searchTerm)) ||
//                         (natureOfWork && natureOfWork.toLowerCase().includes(searchTerm))
//                     );
//                 }
//             });
//         }

//         if (searchAadhaarText) {
//             const aadhaarSearchTerm = searchAadhaarText.toLowerCase();
//             filtered = filtered.filter(student => {
//                 const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                  student.aadhaarNo || 
//                                  student.aadharNo || 
//                                  '';
//                 return aadhaarNo && aadhaarNo.toLowerCase().includes(aadhaarSearchTerm);
//             });
//         }

//         if (stateFilter) {
//             filtered = filtered.filter(student => {
//                 const studentState = student.tataStudentDetailsDto?.state ||
//                     student.state ||
//                     student.studentAddressInfo?.state;
//                 return studentState && studentState === stateFilter.value;
//             });
//         }

//         if (divisionFilter) {
//             filtered = filtered.filter(student => {
//                 const studentDivision = student.tataStudentDetailsDto?.division || 
//                                       student.division;
//                 return studentDivision && studentDivision === divisionFilter.value;
//             });
//         }

//         if (aadhaarFilter) {
//             filtered = filtered.filter(student => {
//                 const studentAadhaar = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo;
//                 return studentAadhaar && studentAadhaar === aadhaarFilter.value;
//             });
//         }

//         if (contractorTokenFilter) {
//             filtered = filtered.filter(student => {
//                 const studentContractorToken = student.tataStudentDetailsDto?.contractorTokenNo || 
//                                              student.contractorTokenNo;
//                 return studentContractorToken && studentContractorToken === contractorTokenFilter.value;
//             });
//         }
        
//         if (natureOfWorkFilter) {
//             filtered = filtered.filter(student => {
//                 const studentNatureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                           student.natureOfWork;
//                 return studentNatureOfWork && studentNatureOfWork === natureOfWorkFilter.value;
//             });
//         }

//         setFilteredAllStudents(filtered);
//     }

//     const clearStudentFilters = () => {
//         setSearchStudentText("");
//         setSearchAadhaarText("");
//         setStateFilter(null);
//         setDivisionFilter(null);
//         setAadhaarFilter(null);
//         setContractorTokenFilter(null);
//         setNatureOfWorkFilter(null);
//         setFilteredAllStudents(allStudents);
//     };

//     useEffect(() => {
//         if (allStudents.length > 0) {
//             applyStudentFilters();
//         }
//     }, [searchStudentText, searchAadhaarText, stateFilter, divisionFilter, aadhaarFilter, contractorTokenFilter, natureOfWorkFilter, allStudents]);

//     useEffect(() => {
//         if (filteredAllStudents.length > 0) {
//             const allFilteredSelected = filteredAllStudents.every(student => 
//                 selectedStudentsForBatch.some(selected => selected.id === student.id)
//             );
//             setSelectAll(allFilteredSelected);
//         } else {
//             setSelectAll(false);
//         }
//     }, [filteredAllStudents, selectedStudentsForBatch]);

//     useEffect(() => {
//         if (!addStudentModal) {
//             setSearchStudentText("");
//             setSearchAadhaarText("");
//             setStateFilter(null);
//             setDivisionFilter(null);
//             setAadhaarFilter(null);
//             setContractorTokenFilter(null);
//             setNatureOfWorkFilter(null);
//             setSelectedStudentsForBatch([]);
//             setSelectAll(false);
//             setShowSelectedStudents(false);
//             setRecentlyAddedStudents([]);
//             setShowSuccessMessage(false);
//         }
//     }, [addStudentModal]);

//     useEffect(() => {
//         if (searchTrainerText === '') {
//             setFilteredAllTrainers(allTrainers);
//         } else {
//             const filtered = allTrainers.filter(trainer => {
//                 return (
//                     (trainer.name && trainer.name.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                     (trainer.email && trainer.email.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                     (trainer.mobile && trainer.mobile.toLowerCase().includes(searchTrainerText.toLowerCase()))
//                 );
//             });
//             setFilteredAllTrainers(filtered);
//         }
//     }, [searchTrainerText, allTrainers]);

//     useEffect(() => {
//         const filtered = allCourses.filter(course =>
//             course.title.toLowerCase().includes(searchCourseText.toLowerCase())
//         );
//         setFilteredAllCourses(filtered);
//     }, [searchCourseText, allCourses]);

//     const fetchBatchDetails = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchSingleBatch(params.id);
//             setLoader(false);
//             if (data?.success) {
//                 setBatchDetails(data?.result[0]);
                
//                 const batchDepartment = data?.result[0]?.department;
//                 const batchName = data?.result[0]?.batchName;
                
//                 console.log("Raw batch department:", batchDepartment);
//                 console.log("Raw batch name:", batchName);
                
//                 const assessment = determineAssessmentType(batchDepartment, batchName);
//                 setAssessmentType(assessment);
                
//                 setAssessmentDebug(`Department: "${batchDepartment}", Batch: "${batchName}" → Assessment: ${assessment === "none" ? "No Practical" : assessment === "driver" ? "Driver Marking System" : assessment === "bronze" ? "Bronze Assessment" : assessment === "silver" ? "Silver Assessment" : "Gold Assessment"}`);
                
//                 const updatedTrainingImages = await updateImagesUrl(data?.result[0]?.images || []);
//                 setTrainingImages(updatedTrainingImages);
//                 const lvClass = data?.result[0]?.liveClasses?.map((liveClass) => ({
//                     id: liveClass.id,
//                     title: liveClass.title,
//                     start: new Date(liveClass.classTime),
//                     end: new Date(new Date(liveClass.classTime).getTime() + 60 * 60 * 1000),
//                     description: liveClass.description,
//                     classLink: liveClass.classLink,
//                     resource: liveClass,
//                 })) || [];
//                 setLiveClasses(lvClass);
//                 calculateCalendarStats(lvClass);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateImagesUrl = async (data) => {
//         const updatedUrls = await Promise.all(
//             data?.map(async (name) => {
//                 if (name) {
//                     const type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return response.presignedUrl;
//                     } else {
//                         console.error('Error generating pre-signed URL for:', name);
//                         return name;
//                     }
//                 }
//                 return name;
//             })
//         );
//         return updatedUrls;
//     };

//     const getAllTrainers = async () => {
//         try {
//             const data = await fetchAllUsers();
//             if (data?.success) {
//                 setAllTrainers(data?.result);
//                 setFilteredAllTrainers(data?.result);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         }
//     };

//     const fetchAllStudents = async () => {
//         try {
//             const type = JSON.parse(localStorage.getItem("authUser")).userType;
//             let data;
//             if (type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer") {
//                 data = await getAllStudentsForTata();
//             } else {
//                 data = await getAllStudents();
//             }

//             if (data?.success) {
//                 setAllStudents(data?.result)
//                 setFilteredAllStudents(data?.result)
//                 extractFilters(data?.result);
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error("Something went wrong");
//         }
//     };

//     const fetchCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllCourses();
//             setLoader(false);
//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourses(updateData);
//                 setFilteredAllCourses(updateData);
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             setLoader(false);
//             toast.error(error?.response?.data?.message);
//         }
//     };

//     const fetchScormCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllScormCourse();
//             setLoader(false);
//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourses(updateData);
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             setLoader(false);
//             toast.error(error?.response?.data?.message);
//         }
//     };

//     const getCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllCourseOfBatch(params.id);

//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourseOfBatch(updateData);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log("Something went wrong");
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getScormCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllScormCourseOfBatch(params.id);

//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourseOfBatch(updateData);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getStudentOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllStudentOfBatch(params.id);
//             if (data?.success) {
//                 setAllStudentOfBatch(data?.result || []);
//                 setFilteredBatchStudents(data?.result || []);
//                 setSelectedStudentIds([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getTrainerOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllTrainerOfBatch(params.id);
//             if (data?.success) {
//                 setAllTrainerOfBatch(data?.result);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateThubmnail = async (data) => {
//         const updateData = await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnailName) {
//                     let name = d.thumbnailName;
//                     let type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return {
//                             ...d,
//                             thumbnailUrl: response.presignedUrl,
//                         };
//                     } else {
//                         console.error('Error generating pre-signed URL for', d.thumbnailName);
//                         return d;
//                     }
//                 }
//                 return d;
//             })
//         );
//         return updateData;
//     };

//     const updateScormThubmnail = async (data) => {
//         const updateData = await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnail) {
//                     let name = d.thumbnail;
//                     let type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return {
//                             ...d,
//                             thumbnailUrl: response.presignedUrl,
//                         };
//                     } else {
//                         console.error('Error generating pre-signed URL for', d.thumbnail);
//                         return d;
//                     }
//                 }
//                 return d;
//             })
//         );
//         return updateData;
//     };

//     const handleUpdate = async () => {
//         try {
//             setLoader(true);
//             setBatchDetails({ ...batchDetails, department: department?.name });
//             const data = await updateBatch(batchDetails);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setEditModal(false);
//                 fetchBatchDetails();
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDeleteBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await deleteBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 navigate("/all-batches");
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setDeleteModal(false);
//         }
//     };

//     const handleAddCourseToBatch = async (id) => {
//         try {
//             setLoader(true);
//             const data = await addCourseToBatch(params.id + "/" + id);

//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setAddCourseModal(false);
//             } else {
//                 toast.error(data?.message);
//             }

//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveCourseFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeCourseFromBatch(params.id + "/" + selectedCourse?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setCourseDeleteModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleAddTrainerToBatch = async (d) => {
//         try {
//             setLoader(true);
//             const data = await addTrainerToBatch(params.id + "/" + d.id);

//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setAddTrainerModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log("error", error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveTrainerFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeTrainerFromBatch(params.id + "/" + selectedTrainer?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setTrainerDeleteModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };
    
//     // Handle single student removal
//     const handleRemoveStudentFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeStudentFromBatch(params.id + "/" + selectedStudent?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getStudentOfBatch();
//                 setStudentDeleteModal(false);
//                 setSelectedStudent(null);
//                 setSelectedStudentIds(prev => prev.filter(id => id !== selectedStudent?.id));
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // Handle multiple student removal with confirmation
//     const handleBulkRemoveStudents = () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             return;
//         }
//         // Show confirmation modal
//         setBulkRemoveModal(true);
//     };

//     // Execute bulk removal after confirmation
//     const confirmBulkRemoveStudents = async () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             setBulkRemoveModal(false);
//             return;
//         }

//         // Get the selected student objects
//         const selectedStudents = allStudentOfBatch.filter(student => 
//             selectedStudentIds.includes(student.id)
//         );

//         try {
//             setLoader(true);
//             setBulkRemoveModal(false);
            
//             const results = [];
//             const removedStudents = [];
//             const failedRemovals = [];

//             for (const student of selectedStudents) {
//                 try {
//                     const data = await removeStudentFromBatch(`${params.id}/${student.id}`);
//                     results.push({
//                         student,
//                         success: data?.success || false,
//                         message: data?.message || "Unknown error"
//                     });
                    
//                     if (data?.success) {
//                         removedStudents.push(student);
//                     } else {
//                         failedRemovals.push({ student, message: data?.message });
//                     }
                    
//                     await new Promise(resolve => setTimeout(resolve, 100));
//                 } catch (error) {
//                     results.push({
//                         student,
//                         success: false,
//                         message: error?.response?.data?.message || "Network error"
//                     });
//                     failedRemovals.push({ 
//                         student, 
//                         message: error?.response?.data?.message || "Network error" 
//                     });
//                 }
//             }

//             const successful = results.filter(r => r.success);
//             const failed = results.filter(r => !r.success);
            
//             if (successful.length > 0) {
//                 toast.success(`Successfully removed ${successful.length} student(s) from the batch`);
//             }
            
//             if (failed.length > 0) {
//                 toast.error(`${failed.length} student(s) could not be removed`);
//                 failed.forEach(f => {
//                     console.error(`Failed to remove student ${f.student.firstName} ${f.student.lastName}: ${f.message}`);
//                 });
//             }
            
//             // Refresh the student list
//             await getStudentOfBatch();
            
//             // Clear selections
//             setSelectedStudentIds([]);
//             setBatchStudentSearchTerm("");
            
//             if (failed.length > 0 && successful.length === 0) {
//                 toast.error("Failed to remove any students. Please check console for details.");
//             }
            
//         } catch (error) {
//             console.error("Error removing multiple students:", error);
//             toast.error("Error removing students from batch");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // Handle DataGrid selection change
//     const handleSelectionChange = (selectionModel) => {
//         console.log("Selection changed:", selectionModel);
//         setSelectedStudentIds(selectionModel);
//     };

//     // Clear search for batch students
//     const clearBatchStudentSearch = () => {
//         setBatchStudentSearchTerm("");
//         setFilteredBatchStudents(allStudentOfBatch);
//     };

//     const handleRemoveAllTrainer = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllTrainersFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllTrainerOfBatch([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveAllStudents = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllStudentsFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllStudentOfBatch([]);
//                 setFilteredBatchStudents([]);
//                 setSelectedStudentIds([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setRemoveAllStudentsModal(false);
//         }
//     };

//     const handleDownloadStudentDetailsClick = async () => {
//         try {
//             setLoader(true);
//             const response = await axios.get(DOWNLOAD_BATCH_STUDENT_FILE + params.id, {
//                 responseType: 'blob'
//             });

//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'all_student_batches.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const setdept = async () => {
//         const value = batchDetails?.department;
//         const department = allDepartments.find(dept => dept.name === value);
//         if (department) {
//             setDepartment(department);
//         } else {
//             console.log("Department not found");
//         }
//     };

//     const checkStudentEligibility = (student) => {
//         const isAlreadyInCurrentBatch = allStudentOfBatch.some(s => s.id === student.id);
        
//         if (isAlreadyInCurrentBatch) {
//             return {
//                 eligible: false,
//                 reason: "Student already enrolled in this batch",
//                 isAlreadyAdded: true,
//                 code: "ALREADY_IN_CURRENT_BATCH"
//             };
//         }
        
//         return {
//             eligible: true,
//             reason: "Student can be added to batch",
//             isAlreadyAdded: false,
//             code: "ELIGIBLE"
//         };
//     };

//     const handleStudentSelection = (event, student) => {
//         const eligibility = checkStudentEligibility(student);
        
//         if (!eligibility.eligible) {
//             toast.error(`Cannot select student: ${eligibility.reason}`);
//             return;
//         }

//         if (event.target.checked) {
//             setSelectedStudentsForBatch(prev => [...prev, student]);
//         } else {
//             setSelectedStudentsForBatch(prev => prev.filter(s => s.id !== student.id));
//         }
//     };
    
//     const handleSelectAllStudents = (event) => {
//         if (event.target.checked) {
//             const eligibleStudents = filteredAllStudents.filter(student => {
//                 const eligibility = checkStudentEligibility(student);
//                 return eligibility.eligible;
//             });
            
//             setSelectedStudentsForBatch(prev => {
//                 const currentIds = new Set(prev.map(s => s.id));
//                 const newStudents = eligibleStudents.filter(s => !currentIds.has(s.id));
//                 return [...prev, ...newStudents];
//             });
//         } else {
//             const filteredStudentIds = new Set(filteredAllStudents.map(s => s.id));
//             setSelectedStudentsForBatch(prev => 
//                 prev.filter(student => !filteredStudentIds.has(student.id))
//             );
//         }
//     };

//     const handleRemoveSelectedStudent = (studentId) => {
//         setSelectedStudentsForBatch(prev => prev.filter(student => student.id !== studentId));
//     };

//     const handleClearSelectedStudents = () => {
//         setSelectedStudentsForBatch([]);
//     };

//     const handleModalClose = () => {
//         setAddStudentModal(false);
//         setShowSuccessMessage(false);
//         setRecentlyAddedStudents([]);
//     };

//     const handleAddMultipleStudentsToBatch = async () => {
//         if (selectedStudentsForBatch.length === 0) {
//             toast.error("Please select at least one student");
//             return;
//         }

//         const eligibleStudents = [];
//         const ineligibleStudents = [];
        
//         selectedStudentsForBatch.forEach(student => {
//             const eligibility = checkStudentEligibility(student);
//             if (eligibility.eligible) {
//                 eligibleStudents.push(student);
//             } else {
//                 ineligibleStudents.push({ student, reason: eligibility.reason });
//             }
//         });

//         if (eligibleStudents.length === 0) {
//             toast.error("No eligible students selected");
//             return;
//         }

//         if (ineligibleStudents.length > 0) {
//             toast.warning(`${ineligibleStudents.length} student(s) are already in this batch and will not be added`);
//         }

//         try {
//             setLoader(true);
            
//             const results = [];
//             const addedStudents = [];
            
//             for (const student of eligibleStudents) {
//                 try {
//                     const data = await addStudentToBatch(`${params.id}/${student.id}`);
//                     results.push({
//                         student,
//                         success: data?.success || false,
//                         message: data?.message || "Unknown error"
//                     });
                    
//                     if (data?.success) {
//                         addedStudents.push(student);
//                     }
                    
//                     await new Promise(resolve => setTimeout(resolve, 100));
//                 } catch (error) {
//                     results.push({
//                         student,
//                         success: false,
//                         message: error?.response?.data?.message || "Network error"
//                     });
//                 }
//             }

//             const successful = results.filter(r => r.success);
//             const failed = results.filter(r => !r.success);
            
//             if (successful.length > 0) {
//                 setSuccessMessage(`Successfully added ${successful.length} student(s) to the batch`);
//                 setShowSuccessMessage(true);
                
//                 setRecentlyAddedStudents(prev => [...prev, ...addedStudents]);
                
//                 setTimeout(() => {
//                     setShowSuccessMessage(false);
//                 }, 3000);
//             }
            
//             if (failed.length > 0) {
//                 toast.error(`${failed.length} student(s) could not be added`);
//                 failed.forEach(f => {
//                     console.error(`Failed to add student ${f.student.firstName} ${f.student.lastName}: ${f.message}`);
//                 });
//             }
            
//             await getStudentOfBatch();
            
//             if (successful.length > 0) {
//                 const addedIds = new Set(addedStudents.map(s => s.id));
//                 setSelectedStudentsForBatch(prev => 
//                     prev.filter(student => !addedIds.has(student.id))
//                 );
//             }
            
//             if (failed.length === 0) {
//                 setSelectedStudentsForBatch([]);
//             }
            
//         } catch (error) {
//             console.error("Error adding multiple students:", error);
//             toast.error("Error adding students to batch");
//         } finally {
//             setLoader(false);
//         }
//     };
    
//     const handleAddStudentToBatch = async (student) => {
//         try {
//             setLoader(true);
            
//             const eligibility = checkStudentEligibility(student);
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot add student: ${eligibility.reason}`);
//                 setLoader(false);
//                 return;
//             }

//             const data = await addStudentToBatch(`${params.id}/${student.id}`);
            
//             if (data?.success) {
//                 const studentName = `${student.firstName || ''} ${student.lastName || ''}`.trim();
                
//                 setSuccessMessage(`${studentName} added to batch successfully!`);
//                 setShowSuccessMessage(true);
                
//                 setRecentlyAddedStudents(prev => [...prev, student]);
                
//                 await getStudentOfBatch();
                
//                 setSelectedStudentsForBatch(prev => 
//                     prev.filter(s => s.id !== student.id)
//                 );
                
//                 setTimeout(() => {
//                     setShowSuccessMessage(false);
//                 }, 3000);
                
//                 toast.success(`${studentName} added to batch successfully!`);
                
//             } else {
//                 toast.error(data?.message || "Failed to add student to batch");
//             }
//         } catch (error) {
//             console.error("Error adding student:", error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const fetchStudentExamResult = async (studentId) => {
//         if (!studentId || !params.id) return null;
        
//         try {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: true }));
            
//             const examResponse = await getResult(`${params.id}/${studentId}`);
            
//             if (examResponse?.success) {
//                 let preTestScore = null;
//                 let postTestScore = null;
                
//                 if (examResponse.result) {
//                     const preTest = examResponse.result.preTest;
//                     const postTest = examResponse.result.postTest;
                    
//                     if (preTest !== undefined && preTest !== null) {
//                         preTestScore = typeof preTest === 'number' ? preTest : 
//                                      (preTest.percentage || preTest.score || 0);
//                     }
                    
//                     if (postTest !== undefined && postTest !== null) {
//                         postTestScore = typeof postTest === 'number' ? postTest : 
//                                       (postTest.percentage || postTest.score || 0);
//                     }
//                 }
                
//                 const result = {
//                     preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                     postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                     lastUpdated: new Date().toISOString()
//                 };
                
//                 setStudentExamResults(prev => ({
//                     ...prev,
//                     [studentId]: result
//                 }));
                
//                 return result;
//             } else {
//                 return null;
//             }
//         } catch (error) {
//             console.error("Error fetching exam results for student", studentId, ":", error);
//             return null;
//         } finally {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: false }));
//         }
//     };

//     const fetchDriverMarkingResult = async (studentId) => {
//         try {
//             const student = allStudentOfBatch.find(s => s.id === studentId);
//             if (student) {
//                 const result = {
//                     isCompleted: student.driverMarkingCompleted || true,
//                     score: student.driverMarkingScore || student.practicalScore || 0,
//                     lastUpdated: new Date().toISOString()
//                 };
                
//                 setDriverMarkingResults(prev => ({
//                     ...prev,
//                     [studentId]: result
//                 }));
                
//                 return result;
//             }
//             return null;
//         } catch (error) {
//             console.error("Error fetching driver marking for student", studentId, ":", error);
//             return null;
//         }
//     };

//     const fetchExamResultsForAllStudents = async () => {
//         try {
//             setFetchingExamResults(true);
//             const results = {};
            
//             for (const student of allStudentOfBatch) {
//                 try {
//                     const examResponse = await getResult(`${params.id}/${student.id}`);
                    
//                     if (examResponse?.success) {
//                         let preTestScore = null;
//                         let postTestScore = null;
                        
//                         if (examResponse.result) {
//                             const preTest = examResponse.result.preTest;
//                             const postTest = examResponse.result.postTest;
                            
//                             if (preTest !== undefined && preTest !== null) {
//                                 preTestScore = typeof preTest === 'number' ? preTest : 
//                                              (preTest.percentage || preTest.score || 0);
//                             }
                            
//                             if (postTest !== undefined && postTest !== null) {
//                                 postTestScore = typeof postTest === 'number' ? postTest : 
//                                               (postTest.percentage || postTest.score || 0);
//                             }
//                         }
                        
//                         results[student.id] = {
//                             preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                             postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                             lastUpdated: new Date().toISOString()
//                         };
//                     }
                    
//                     if (hasPracticalAssessment()) {
//                         const driverMarkingResult = driverMarkingResults[student.id];
//                         if (!driverMarkingResult) {
//                             await fetchDriverMarkingResult(student.id);
//                         }
//                     }
                    
//                 } catch (error) {
//                     console.error(`Error fetching exam results for student ${student.id}:`, error);
//                     continue;
//                 }
//             }
            
//             setStudentExamResults(prev => ({ ...prev, ...results }));
//             return results;
            
//         } catch (error) {
//             console.error("Error fetching all exam results:", error);
//             throw error;
//         } finally {
//             setFetchingExamResults(false);
//         }
//     };

//     const checkCertificateEligibility = (student, examResults = null) => {
//         const studentExamResult = examResults || studentExamResults[student.id];
//         const postTestScore = studentExamResult?.postTest || 0;
        
//         if (!hasPracticalAssessment()) {
//             if (loadingExamResults[student.id] && !studentExamResult) {
//                 return {
//                     eligible: false,
//                     reason: "Loading exam results...",
//                     isLoading: true
//                 };
//             }
            
//             if (postTestScore === null || postTestScore === undefined) {
//                 return {
//                     eligible: false,
//                     reason: "Post-test results not available"
//                 };
//             }
            
//             if (postTestScore < 80) {
//                 return {
//                     eligible: false,
//                     reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
//                 };
//             }
            
//             return {
//                 eligible: true,
//                 reason: "Eligible for certificate download (Post-test only)"
//             };
//         }
        
//         const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
        
//         if (loadingExamResults[student.id] && !studentExamResult) {
//             return {
//                 eligible: false,
//                 reason: "Loading exam results...",
//                 isLoading: true
//             };
//         }
        
//         if (postTestScore === null || postTestScore === undefined) {
//             return {
//                 eligible: false,
//                 reason: "Post-test results not available"
//             };
//         }
        
//         if (postTestScore < 80) {
//             return {
//                 eligible: false,
//                 reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
//             };
//         }
        
//         if (!isDriverMarkingCompleted) {
//             return {
//                 eligible: false,
//                 reason: `${getAssessmentName()} assessment not completed`
//             };
//         }
        
//         return {
//             eligible: true,
//             reason: "Eligible for certificate download"
//         };
//     };

//     const getPassedStudentsCount = (examResults = null) => {
//         if (!allStudentOfBatch.length) return 0;
        
//         return allStudentOfBatch.filter(student => {
//             const studentExamResult = examResults || studentExamResults[student.id];
//             const postTestScore = studentExamResult?.postTest || 0;
            
//             if (!hasPracticalAssessment()) {
//                 return postTestScore >= 80;
//             }
            
//             const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//             return postTestScore >= 80 && isDriverMarkingCompleted;
//         }).length;
//     };

//     const fetchAndDisplayExamResults = async (student) => {
//         setSelectedStudent(student);
//         const results = await fetchStudentExamResult(student.id);
//         if (results) {
//             setShowExamResults(true);
//         } else {
//             toast.error("Could not fetch exam results for this student");
//         }
//     };

//     const updateDriverMarkingStatus = (studentId) => {
//         setDriverMarkingResults(prev => ({
//             ...prev,
//             [studentId]: {
//                 isCompleted: true,
//                 score: 85,
//                 lastUpdated: new Date().toISOString()
//             }
//         }));
        
//         setAllStudentOfBatch(prev => 
//             prev.map(student => 
//                 student.id === studentId 
//                     ? { ...student, driverMarkingCompleted: true }
//                     : student
//             )
//         );
//     };

//     const generateCertificateForStudent = async (student) => {
//         try {
//             const requestData = {
//                 trainingType: "DDT_OTHER",
//                 studentName: student.firstName + " " + student.lastName,
//                 courseName: batchDetails?.batchName || "Driver Training",
//                 dlNo: student.tataStudentDetailsDto?.driverDlNo || "",
//                 aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || "",
//                 depot: student.tataStudentDetailsDto?.depot || "",
//                 project: student.tataStudentDetailsDto?.project || "",
//                 city: student.state || student.city || "",
//                 fromDate: batchDetails?.startDate || "",
//                 toDate: batchDetails?.endDate || "",
//                 validityDate: batchDetails?.validityDate || "",
//                 trainerName: allTrainerOfBatch[0]?.name || "",
//                 authorizedSignatory: "DGM-Skill Development",
//                 batchId: params.id,
//                 studentId: student.id
//             };

//             const response = await axios.post(
//                 url + 'api/certificate/generate',
//                 requestData,
//                 {
//                     responseType: 'blob',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                 }
//             );

//             return response.data;
//         } catch (error) {
//             console.error('Error generating certificate for student', student.id, ':', error);
//             throw error;
//         }
//     };

//     const downloadIndividualCertificate = async (student) => {
//         setLoader(true);
//         try {
//             const certificateBlob = await generateCertificateForStudent(student);
            
//             const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
            
//             const blob = new Blob([certificateBlob], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = fileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//             toast.success('Certificate downloaded successfully!');

//         } catch (error) {
//             console.error('Error generating certificate:', error);
//             toast.error('Failed to generate certificate.');
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDownloadCertificate = async (student) => {
//         if (!studentExamResults[student.id]) {
//             setLoader(true);
//             try {
//                 const results = await fetchStudentExamResult(student.id);
                
//                 if (!results) {
//                     toast.error("Could not fetch exam results for this student");
//                     setLoader(false);
//                     return;
//                 }
                
//                 const eligibility = checkCertificateEligibility(student, results);
                
//                 if (!eligibility.eligible) {
//                     toast.error(`Cannot download certificate: ${eligibility.reason}`);
//                     setLoader(false);
//                     return;
//                 }
                
//                 await downloadIndividualCertificate(student);
                
//             } catch (error) {
//                 console.error('Error fetching exam results:', error);
//                 toast.error('Failed to fetch exam results. Please try again.');
//                 setLoader(false);
//                 return;
//             }
//         } else {
//             const eligibility = checkCertificateEligibility(student);
            
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot download certificate: ${eligibility.reason}`);
//                 return;
//             }
            
//             await downloadIndividualCertificate(student);
//         }
//     };

//     const generateExcelReport = (progressInfo) => {
//         try {
//             const wb = XLSX.utils.book_new();
            
//             const summaryData = [
//                 ["BATCH CERTIFICATE GENERATION REPORT"],
//                 ["Generated Date:", progressInfo.generatedDate],
//                 ["Batch Name:", progressInfo.batchName],
//                 ["Batch ID:", progressInfo.batchId],
//                 ["Assessment Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
//                 ["Eligibility Criteria:", progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"],
//                 [],
//                 ["SUMMARY STATISTICS"],
//                 ["Total Students in Batch:", progressInfo.totalStudents],
//                 ["Passed Students:", progressInfo.passedStudents],
//                 ["Failed Students:", progressInfo.failedStudents],
//                 ["Certificates Generated:", progressInfo.generatedCertificates],
//                 ["Certificates Failed:", progressInfo.failedCertificates],
//                 [],
//                 ["CERTIFICATE ELIGIBILITY CRITERIA"],
//                 ["1. Post-test Score must be ≥ 80%", ""],
//                 ...(progressInfo.hasPractical ? [[`2. ${getAssessmentName()} assessment must be completed`, ""], ["3. Both conditions must be met for certificate generation", ""]] : [["2. Only post-test score ≥80% is required", ""]]),
//                 [],
//                 ["Assessment Information"],
//                 ["Batch Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
//                 ["Practical Required:", progressInfo.hasPractical ? "Yes" : "No"]
//             ];
            
//             const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//             wsSummary["!cols"] = [
//                 { wch: 30 },
//                 { wch: 50 }
//             ];
            
//             const studentHeaders = [
//                 ["STUDENT CERTIFICATE GENERATION DETAILS"],
//                 [],
//                 ["S.No", "Student ID", "Full Name", "Depot/Division", "State", "Mobile", 
//                  "Post-Test Score", "Practical Completed", "Eligibility Status", 
//                  "Certificate Status", "Remarks"]
//             ];
            
//             const studentRows = progressInfo.students.map((student, index) => [
//                 index + 1,
//                 student.id,
//                 student.name,
//                 student.depotDivision || "N/A",
//                 student.state || "N/A",
//                 student.mobile || "N/A",
//                 student.postTestScore !== null ? `${student.postTestScore}%` : "N/A",
//                 student.practicalCompleted ? "Yes" : (progressInfo.hasPractical ? (student.postTestScore >= 80 ? "Pending" : "N/A") : "N/A"),
//                 student.eligible ? "Eligible" : "Not Eligible",
//                 student.certificateStatus,
//                 student.remarks || student.error || "N/A"
//             ]);
            
//             const studentData = [...studentHeaders, ...studentRows];
//             const wsStudents = XLSX.utils.aoa_to_sheet(studentData);
//             wsStudents["!cols"] = [
//                 { wch: 5 },
//                 { wch: 10 },
//                 { wch: 25 },
//                 { wch: 20 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 18 },
//                 { wch: 15 },
//                 { wch: 20 },
//                 { wch: 30 }
//             ];
            
//             const failedStudents = progressInfo.students.filter(s => s.certificateStatus === "Failed");
//             if (failedStudents.length > 0) {
//                 const failedHeaders = [
//                     ["FAILED CERTIFICATE GENERATIONS"],
//                     [],
//                     ["S.No", "Student ID", "Full Name", "Depot/Division", "Error Reason"]
//                 ];
                
//                 const failedRows = failedStudents.map((student, index) => [
//                     index + 1,
//                     student.id,
//                     student.name,
//                     student.depotDivision || "N/A",
//                     student.error || "Unknown error"
//                 ]);
                
//                 const failedData = [...failedHeaders, ...failedRows];
//                 const wsFailed = XLSX.utils.aoa_to_sheet(failedData);
//                 wsFailed["!cols"] = [
//                     { wch: 5 },
//                     { wch: 10 },
//                     { wch: 25 },
//                     { wch: 20 },
//                     { wch: 50 }
//                 ];
//                 XLSX.utils.book_append_sheet(wb, wsFailed, "Failed Generations");
//             }
            
//             XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
//             XLSX.utils.book_append_sheet(wb, wsStudents, "Student Details");
            
//             const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//             const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
//             return excelBlob;
//         } catch (error) {
//             console.error('Error generating Excel report:', error);
//             throw error;
//         }
//     };

//     const generateAllCertificatesAsZip = async () => {
//         try {
//             setBatchZipLoading(true);
            
//             toast.info("Fetching exam results for all students...");
//             const allExamResults = await fetchExamResultsForAllStudents();
            
//             const hasPractical = hasPracticalAssessment();
            
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0,
//                 failedStudents: 0,
//                 generatedCertificates: 0,
//                 failedCertificates: 0,
//                 hasPractical: hasPractical,
//                 students: []
//             };

//             allStudentOfBatch.forEach((student, index) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 let isPracticalCompleted = true;
//                 if (hasPractical) {
//                     isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 }
                
//                 const isEligible = hasPractical 
//                     ? (postTestScore >= 80 && isPracticalCompleted)
//                     : (postTestScore >= 80);
                
//                 const depot = student.tataStudentDetailsDto?.depot || student.depot || '';
//                 const division = student.tataStudentDetailsDto?.division || student.division || '';
//                 const state = student.tataStudentDetailsDto?.state || student.state || '';
//                 const depotDivision = depot && division ? `${depot} / ${division}` : (depot || division || 'N/A');
                
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     depotDivision: depotDivision,
//                     state: state || 'N/A',
//                     mobile: student.mobile || null,
//                     postTestScore: postTestScore,
//                     practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible,
//                     certificateStatus: "Pending",
//                     remarks: "Not processed yet"
//                 });
                
//                 if (isEligible) {
//                     progressInfo.passedStudents++;
//                 } else {
//                     progressInfo.failedStudents++;
//                 }
//             });

//             const eligibleStudents = allStudentOfBatch.filter(student => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 if (hasPractical) {
//                     const isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                     return postTestScore >= 80 && isPracticalCompleted;
//                 }
//                 return postTestScore >= 80;
//             });

//             if (eligibleStudents.length === 0) {
//                 toast.warning("No eligible students found in this batch. Generating report only.");
                
//                 progressInfo.students = progressInfo.students.map(student => ({
//                     ...student,
//                     certificateStatus: "Failed",
//                     remarks: student.eligible ? "No certificates to generate (0 eligible)" : "Not eligible for certificate"
//                 }));
                
//                 const excelBlob = generateExcelReport(progressInfo);
                
//                 const zip = new JSZip();
//                 zip.file(`Certificate_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`, excelBlob);
                
//                 const zipBlob = await zip.generateAsync({ type: "blob" });
//                 const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificate_Report_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
//                 saveAs(zipBlob, zipFileName);
                
//                 toast.info("Excel report generated and downloaded");
//                 setBatchZipLoading(false);
//                 return;
//             }

//             const confirmed = window.confirm(
//                 `Batch: ${batchDetails?.batchName || "Unknown Batch"}\n` +
//                 `Assessment Type: ${hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
//                 `Eligibility Criteria: ${hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
//                 `Total Students: ${allStudentOfBatch.length}\n` +
//                 `Eligible Students: ${eligibleStudents.length}\n` +
//                 `Failed Students: ${allStudentOfBatch.length - eligibleStudents.length}\n\n` +
//                 `Generate certificates for ${eligibleStudents.length} eligible student(s)?`
//             );
            
//             if (!confirmed) {
//                 setBatchZipLoading(false);
//                 return;
//             }

//             setCertificateProgress({
//                 total: eligibleStudents.length,
//                 completed: 0,
//                 failed: 0,
//                 inProgress: true
//             });

//             const zip = new JSZip();
//             const certificateFolder = zip.folder("Certificates");
//             const reportFolder = zip.folder("Reports");

//             for (let i = 0; i < eligibleStudents.length; i++) {
//                 const student = eligibleStudents[i];
//                 const studentIndex = progressInfo.students.findIndex(s => s.id === student.id);
                
//                 try {
//                     const certificateBlob = await generateCertificateForStudent(student);
                    
//                     const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
                    
//                     certificateFolder.file(fileName, certificateBlob);
                    
//                     progressInfo.students[studentIndex] = {
//                         ...progressInfo.students[studentIndex],
//                         certificateStatus: "Generated",
//                         remarks: "Certificate successfully generated",
//                         fileName: fileName
//                     };
                    
//                     progressInfo.generatedCertificates++;
                    
//                     setCertificateProgress(prev => ({
//                         ...prev,
//                         completed: prev.completed + 1
//                     }));
                    
//                     if (i < eligibleStudents.length - 1) {
//                         await new Promise(resolve => setTimeout(resolve, 300));
//                     }
                    
//                 } catch (error) {
//                     console.error(`Failed to generate certificate for student ${student.id}:`, error);
                    
//                     progressInfo.students[studentIndex] = {
//                         ...progressInfo.students[studentIndex],
//                         certificateStatus: "Failed",
//                         error: error.message || "Unknown error",
//                         remarks: `Failed: ${error.message || "Unknown error"}`
//                     };
                    
//                     progressInfo.failedCertificates++;
                    
//                     setCertificateProgress(prev => ({
//                         ...prev,
//                         failed: prev.failed + 1
//                     }));
//                 }
//             }

//             progressInfo.students.forEach((student, index) => {
//                 if (student.certificateStatus === "Pending") {
//                     progressInfo.students[index] = {
//                         ...student,
//                         certificateStatus: "Not Generated",
//                         remarks: student.eligible ? "Not processed" : "Not eligible for certificate"
//                     };
//                 }
//             });

//             const excelBlob = generateExcelReport(progressInfo);
//             const excelFileName = `Certificate_Generation_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`;
//             reportFolder.file(excelFileName, excelBlob);

//             const summaryText = `CERTIFICATE GENERATION SUMMARY\n` +
//                                `============================\n` +
//                                `Batch: ${progressInfo.batchName}\n` +
//                                `Batch ID: ${progressInfo.batchId}\n` +
//                                `Generated: ${progressInfo.generatedDate}\n` +
//                                `Assessment Type: ${progressInfo.hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
//                                `Eligibility Criteria: ${progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
//                                `Total Students: ${progressInfo.totalStudents}\n` +
//                                `Eligible Students: ${progressInfo.passedStudents}\n` +
//                                `Failed Students: ${progressInfo.failedStudents}\n` +
//                                `Certificates Generated: ${progressInfo.generatedCertificates}\n` +
//                                `Certificates Failed: ${progressInfo.failedCertificates}\n` +
//                                `\nSee Excel report for detailed student information.`;
            
//             reportFolder.file("SUMMARY.txt", summaryText);

//             toast.info("Creating ZIP file with certificates and reports...");
//             const zipBlob = await zip.generateAsync({ type: "blob" });
            
//             const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificates_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
//             saveAs(zipBlob, zipFileName);

//             const successful = certificateProgress.completed;
//             const failed = certificateProgress.failed;
            
//             if (failed === 0) {
//                 toast.success(`Successfully generated ${successful} certificate(s)! Check Excel report for all student statuses.`);
//             } else {
//                 toast.warning(`Generated ${successful} certificate(s), ${failed} failed. Check Excel report for details.`);
//             }

//         } catch (error) {
//             console.error('Error generating zip file:', error);
            
//             if (error.message.includes("Failed to fetch")) {
//                 toast.error('Network error: Could not fetch exam results. Please check your connection and try again.');
//             } else {
//                 toast.error('Failed to generate certificates zip file. Please try again.');
//             }
//         } finally {
//             setBatchZipLoading(false);
//             setCertificateProgress({
//                 total: 0,
//                 completed: 0,
//                 failed: 0,
//                 inProgress: false
//             });
//         }
//     };

//     const generateCertificatesForPassedStudents = async () => {
//         if (allStudentOfBatch.length === 0) {
//             toast.error("No students found in this batch");
//             return;
//         }
        
//         await generateAllCertificatesAsZip();
//     };

//     const generateExcelReportOnly = async () => {
//         try {
//             setLoader(true);
//             toast.info("Generating student status report...");
            
//             const allExamResults = await fetchExamResultsForAllStudents();
//             const hasPractical = hasPracticalAssessment();
            
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0,
//                 failedStudents: 0,
//                 generatedCertificates: 0,
//                 failedCertificates: 0,
//                 hasPractical: hasPractical,
//                 students: []
//             };

//             allStudentOfBatch.forEach((student, index) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 let isPracticalCompleted = true;
//                 if (hasPractical) {
//                     isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 }
                
//                 const isEligible = hasPractical 
//                     ? (postTestScore >= 80 && isPracticalCompleted)
//                     : (postTestScore >= 80);
                
//                 const depot = student.tataStudentDetailsDto?.depot || student.depot || '';
//                 const division = student.tataStudentDetailsDto?.division || student.division || '';
//                 const state = student.tataStudentDetailsDto?.state || student.state || '';
//                 const depotDivision = depot && division ? `${depot} / ${division}` : (depot || division || 'N/A');
                
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     depotDivision: depotDivision,
//                     state: state || 'N/A',
//                     mobile: student.mobile || null,
//                     postTestScore: postTestScore,
//                     practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible,
//                     certificateStatus: isEligible ? "Eligible (Not Generated)" : "Not Eligible",
//                     remarks: isEligible 
//                         ? (hasPractical ? "Meets criteria (Post-test ≥80% + Practical)" : "Meets criteria (Post-test ≥80%)") 
//                         : (hasPractical 
//                             ? (postTestScore >= 80 ? "Missing practical assessment" : "Post-test score below 80%")
//                             : "Post-test score below 80%")
//                 });
                
//                 if (isEligible) {
//                     progressInfo.passedStudents++;
//                 } else {
//                     progressInfo.failedStudents++;
//                 }
//             });

//             const excelBlob = generateExcelReport(progressInfo);
            
//             const excelFileName = `Student_Certificate_Status_${batchDetails?.batchName || "Batch"}_${moment().format('YYYY-MM-DD')}.xlsx`;
//             const url = window.URL.createObjectURL(excelBlob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = excelFileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//             toast.success(`Excel report generated for ${allStudentOfBatch.length} students!`);
            
//         } catch (error) {
//             console.error('Error generating Excel report:', error);
//             toast.error('Failed to generate Excel report');
//         } finally {
//             setLoader(false);
//         }
//     };

//     const calculateCalendarStats = (classes) => {
//         const now = new Date();
//         const currentMonth = now.getMonth();
//         const currentYear = now.getFullYear();
        
//         let prevMonth = currentMonth - 1;
//         let prevYear = currentYear;
//         if (prevMonth < 0) {
//             prevMonth = 11;
//             prevYear = currentYear - 1;
//         }
        
//         const pastClasses = classes.filter(lc => new Date(lc.end) < now);
//         const pastClassesCurrentMonth = pastClasses.filter(lc => {
//             const classDate = new Date(lc.start);
//             return classDate.getMonth() === currentMonth && classDate.getFullYear() === currentYear;
//         }).length;
        
//         const pastClassesPrevMonth = pastClasses.filter(lc => {
//             const classDate = new Date(lc.start);
//             return classDate.getMonth() === prevMonth && classDate.getFullYear() === prevYear;
//         }).length;
        
//         const upcomingClasses = classes.filter(lc => new Date(lc.start) > now).length;
        
//         setCalendarStats({
//             pastClassesCurrentMonth,
//             pastClassesPrevMonth,
//             upcomingClasses,
//             totalClasses: classes.length
//         });
//     };

//     const handleEventClick = (event) => {
//         setSelectedEvent(event.resource);
//         setShowEventModal(true);
//     };

//     const openLiveClassLink = (link) => {
//         if (!link) {
//             toast.error("No class link available");
//             return;
//         }
        
//         let formattedLink = link;
//         if (!formattedLink.startsWith('http://') && !formattedLink.startsWith('https://')) {
//             formattedLink = 'https://' + formattedLink;
//         }
        
//         window.open(formattedLink, '_blank', 'noopener,noreferrer');
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     const formatDateTime = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true
//         });
//     };

//     const isTataUser = type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer";
//     const isTrainerRole = type === "Trainer" || type === "Tata Trainer";

//     const getAssessmentComponent = () => {
//         console.log("Rendering assessment component for type:", assessmentType);
        
//         switch(assessmentType) {
//             case "bronze":
//                 return (
//                     <BronzeAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "silver":
//                 return (
//                     <SilverAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "gold":
//                 return (
//                     <GoldAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "driver":
//                 return (
//                     <DriverMarkingSystem 
//                         students={allStudentOfBatch} 
//                         onDriverMarkingComplete={updateDriverMarkingStatus}
//                     />
//                 );
//             case "none":
//             default:
//                 return (
//                     <div className="alert alert-warning text-center">
//                         <h4 className="mb-2">No Practical Assessment Available</h4>
//                         <p className="mb-0">
//                             This batch does not have any practical assessment section configured.
//                             Certificate eligibility is based only on post-test score (≥80%).
//                         </p>
//                     </div>
//                 );
//         }
//     };

//     const getAssessmentName = () => {
//         switch(assessmentType) {
//             case "bronze":
//                 return "Bronze Assessment";
//             case "silver":
//                 return "Silver Assessment";
//             case "gold":
//                 return "Gold Assessment";
//             case "driver":
//                 return "Driver Assessment";
//             case "none":
//             default:
//                 return "Post-test Only Assessment";
//         }
//     };

//     const getAssessmentColor = () => {
//         switch(assessmentType) {
//             case "bronze":
//                 return "#CD7F32";
//             case "silver":
//                 return "#C0C0C0";
//             case "gold":
//                 return "#FFD700";
//             case "driver":
//                 return "#FF9800";
//             case "none":
//             default:
//                 return "#6c757d";
//         }
//     };

//     const shouldShowPracticalTab = () => {
//         return assessmentType !== "none";
//     };

//     // STUDENT COLUMNS - using DataGrid's native selection
//     const columnsStudent = [
//         { field: 'id', headerName: 'ID', width: 60 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 150,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             type: 'text',
//             width: 200,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'text',
//             width: 130,
//         },
//         {
//             field: 'depotDivision',
//             headerName: 'Depot/Division',
//             width: 200,
//             renderCell: (params) => {
//                 const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
//                 const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
//                 const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
//                 return (
//                     <div style={{ display: 'flex', flexDirection: 'column' }}>
//                         {depot && division ? (
//                             <>
//                                 <span style={{ display: 'flex', alignItems: 'center' }}>
//                                     <LocationOnIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
//                                     <strong>{depot}</strong>
//                                 </span>
//                                 <span style={{ fontSize: '0.8rem', color: '#666', marginLeft: '22px' }}>
//                                     <BusinessIcon style={{ fontSize: '0.8rem', marginRight: '4px' }} />
//                                     {division}
//                                 </span>
//                                 {state && (
//                                     <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '22px' }}>
//                                         📍 {state}
//                                     </span>
//                                 )}
//                             </>
//                         ) : depot ? (
//                             <span style={{ display: 'flex', alignItems: 'center' }}>
//                                 <LocationOnIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
//                                 {depot}
//                                 {state && <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '8px' }}>({state})</span>}
//                             </span>
//                         ) : division ? (
//                             <span style={{ display: 'flex', alignItems: 'center' }}>
//                                 <BusinessIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
//                                 {division}
//                                 {state && <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '8px' }}>({state})</span>}
//                             </span>
//                         ) : (
//                             <span style={{ color: '#999' }}>--</span>
//                         )}
//                     </div>
//                 );
//             }
//         },
//         {
//             field: 'postTestScore',
//             headerName: 'Post-Test',
//             type: 'number',
//             width: 90,
//             valueGetter: (value, row) => {
//                 const result = studentExamResults[row.id];
//                 if (loadingExamResults[row.id]) {
//                     return 'Loading...';
//                 }
//                 return result?.postTest !== undefined && result?.postTest !== null ? `${Math.round(result.postTest)}%` : '--';
//             },
//             renderCell: (params) => {
//                 const result = studentExamResults[params.row.id];
                
//                 if (loadingExamResults[params.row.id]) {
//                     return (
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={16} sx={{ mr: 1 }} />
//                             <span>Loading...</span>
//                         </Box>
//                     );
//                 }
                
//                 if (result?.postTest === undefined || result?.postTest === null) {
//                     return '--';
//                 }
                
//                 return (
//                     <span style={{ 
//                         color: result.postTest >= 80 ? 'green' : 'red',
//                         fontWeight: result.postTest >= 80 ? 'bold' : 'normal'
//                     }}>
//                         {Math.round(result.postTest)}%
//                     </span>
//                 );
//             }
//         },
//         ...(shouldShowPracticalTab() ? [{
//             field: 'driverMarking',
//             headerName: 'Practical',
//             width: 100,
//             valueGetter: (value, row) => {
//                 const result = driverMarkingResults[row.id];
//                 return result?.isCompleted ? 'Completed' : 'Pending';
//             },
//             renderCell: (params) => {
//                 const result = driverMarkingResults[params.row.id];
//                 const isCompleted = result?.isCompleted;
//                 const score = result?.score;
                
//                 return (
//                     <div>
//                         <span style={{ 
//                             color: isCompleted ? 'green' : 'orange',
//                             fontWeight: 'bold'
//                         }}>
//                             {isCompleted ? '✓ Completed' : '⏳ Pending'}
//                         </span>
//                         {isCompleted && score && (
//                             <div style={{ fontSize: '0.8em', color: 'gray' }}>
//                                 Score: {score}%
//                             </div>
//                         )}
//                     </div>
//                 );
//             }
//         }] : []),
//         {
//             field: 'passStatus',
//             headerName: 'Result',
//             width: 100,
//             valueGetter: (value, row) => {
//                 const studentExamResult = studentExamResults[row.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 if (!shouldShowPracticalTab()) {
//                     return postTestScore >= 80 ? 'Passed' : 'Failed';
//                 }
                
//                 const isDriverMarkingCompleted = driverMarkingResults[row.id]?.isCompleted || false;
//                 return postTestScore >= 80 && isDriverMarkingCompleted ? 'Passed' : 'Failed';
//             },
//             renderCell: (params) => {
//                 const studentExamResult = studentExamResults[params.row.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 let isPassed = false;
//                 if (!shouldShowPracticalTab()) {
//                     isPassed = postTestScore >= 80;
//                 } else {
//                     const isDriverMarkingCompleted = driverMarkingResults[params.row.id]?.isCompleted || false;
//                     isPassed = postTestScore >= 80 && isDriverMarkingCompleted;
//                 }
                
//                 return (
//                     <Chip 
//                         label={isPassed ? 'Passed' : 'Failed'} 
//                         color={isPassed ? 'success' : 'error'} 
//                         size="small"
//                     />
//                 );
//             }
//         },
//         {
//             field: 'examResults',
//             headerName: 'Exam Results',
//             width: 130,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={() => fetchAndDisplayExamResults(params.row)}
//                     disabled={loadingExamResults[params.row.id]}
//                     size="small"
//                 >
//                     {loadingExamResults[params.row.id] ? 'Loading...' : 'View Results'}
//                 </Button>
//             ),
//         },
//         ...(organizationId === 2 && !isTrainerRole
//             ? [
//                 {
//                     field: 'downloadCertificate',
//                     headerName: 'Certificate',
//                     width: 150,
//                     renderCell: (params) => {
//                         const eligibility = checkCertificateEligibility(params.row);
                        
//                         if (eligibility.isLoading) {
//                             return (
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <CircularProgress size={20} sx={{ mr: 1 }} />
//                                     <span>Loading...</span>
//                                 </Box>
//                             );
//                         }
                        
//                         return (
//                             <Tooltip title={eligibility.reason} arrow>
//                                 <span>
//                                     <Button
//                                         variant="contained"
//                                         color={eligibility.eligible ? "success" : "secondary"}
//                                         onClick={() => handleDownloadCertificate(params.row)}
//                                         disabled={!eligibility.eligible}
//                                         startIcon={eligibility.eligible ? <DownloadIcon /> : <InfoIcon />}
//                                         size="small"
//                                     >
//                                         {eligibility.eligible ? "Download" : "Not Eligible"}
//                                     </Button>
//                                 </span>
//                             </Tooltip>
//                         );
//                     },
//                 },
//             ]
//             : []),
//         {
//             field: 'actions',
//             headerName: 'Actions',
//             width: 100,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="danger"
//                     onClick={() => { 
//                         setSelectedStudent(params.row); 
//                         setStudentDeleteModal(true); 
//                     }}
//                     size="small"
//                 >
//                     Remove
//                 </Button>
//             ),
//         },
//     ];

//     const columnsTrainer = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         { field: 'name', headerName: 'Name', width: 300 },
//         {
//             field: 'email',
//             headerName: 'Email',
//             type: 'text',
//             width: 300,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile No.',
//             type: 'text',
//             width: 300,
//         },
//         {
//             field: 'actions',
//             headerName: 'Actions',
//             width: 150,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="danger"
//                     onClick={() => { setSelectedTrainer(params.row); setTrainerDeleteModal(true); }}
//                 >
//                     Remove
//                 </Button>
//             ),
//         },
//     ];

//     const columnsTrainerModal = [
//         { field: 'id', headerName: 'ID', width: 100 },
//         { field: 'name', headerName: 'Name', width: 150 },
//         {
//             field: 'email',
//             headerName: 'Email',
//             type: 'text',
//             width: 150,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Number',
//             type: 'number',
//             width: 150,
//         },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 150,
//             renderCell: (params) => {
//                 return (
//                     <Button
//                         variant="contained"
//                         color="success"
//                         onClick={() => handleAddTrainerToBatch(params.row)}
//                     >
//                         Add
//                     </Button>
//                 );
//             }
//         },
//     ];

//     const columnsStudentModal = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 160,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             type: 'text',
//             width: 200,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 130,
//         },
//         {
//             field: 'depotDivision',
//             headerName: 'Depot/Division',
//             width: 150,
//             renderCell: (params) => {
//                 const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
//                 const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
//                 const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
//                 if (depot && division) {
//                     return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
//                 } else if (depot) {
//                     return <span>{depot}{state ? ` (${state})` : ''}</span>;
//                 } else if (division) {
//                     return <span>{division}{state ? ` (${state})` : ''}</span>;
//                 }
//                 return <span style={{ color: '#999' }}>--</span>;
//             }
//         },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 150,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
                
//                 if (eligibility.isAlreadyAdded) {
//                     return (
//                         <Button
//                             variant="contained"
//                             color="secondary"
//                             disabled
//                             title="Already added to this batch"
//                             size="small"
//                         >
//                             <PersonOffIcon style={{ marginRight: '4px' }} />
//                             In Batch
//                         </Button>
//                     );
//                 }

//                 return (
//                     <Tooltip title="Add student to this batch" arrow>
//                         <span>
//                             <Button
//                                 variant="contained"
//                                 color="success"
//                                 onClick={() => handleAddStudentToBatch(params.row)}
//                                 disabled={loader}
//                                 size="small"
//                                 startIcon={<PersonAddIcon />}
//                             >
//                                 {loader ? 'Adding...' : 'Add to Batch'}
//                             </Button>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         },
//     ];

//     const columnsStudentModalForTata = [
//         {
//             field: 'select',
//             headerName: (
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                     <Checkbox
//                         checked={selectAll}
//                         onChange={handleSelectAllStudents}
//                         disabled={filteredAllStudents.length === 0 || loader}
//                         indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
//                     />
//                     <span style={{ fontSize: '0.85rem' }}>Select All</span>
//                 </div>
//             ),
//             width: 100,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
//                 const isSelected = selectedStudentsForBatch.some(student => student.id === params.row.id);
                
//                 return (
//                     <Checkbox
//                         checked={isSelected}
//                         onChange={(e) => handleStudentSelection(e, params.row)}
//                         disabled={eligibility.isAlreadyAdded}
//                         title={eligibility.isAlreadyAdded ? "Already in this batch" : "Select to add to batch"}
//                         color="primary"
//                     />
//                 );
//             },
//         },
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 120,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 100,
//         },
//         {
//             field: 'depotDivision',
//             headerName: 'Depot/Division',
//             width: 140,
//             renderCell: (params) => {
//                 const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
//                 const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
//                 const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
//                 if (depot && division) {
//                     return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
//                 } else if (depot) {
//                     return <span>{depot}{state ? ` (${state})` : ''}</span>;
//                 } else if (division) {
//                     return <span>{division}{state ? ` (${state})` : ''}</span>;
//                 }
//                 return <span style={{ color: '#999' }}>--</span>;
//             }
//         },
//         {
//             field: 'division',
//             headerName: 'Division',
//             type: 'text',
//             width: 100,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.division || 
//                        row.division || 
//                        '--';
//             },
//         },
//         {
//             field: 'state',
//             headerName: 'State',
//             type: 'text',
//             width: 100,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.state || 
//                        row.state || 
//                        '--';
//             },
//         },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 150,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
                
//                 if (eligibility.isAlreadyAdded) {
//                     return (
//                         <Button
//                             variant="contained"
//                             color="secondary"
//                             disabled
//                             title="Already added to this batch"
//                             size="small"
//                         >
//                             <PersonOffIcon style={{ marginRight: '4px' }} />
//                             In Batch
//                         </Button>
//                     );
//                 }

//                 return (
//                     <Tooltip title="Add student to this batch" arrow>
//                         <span>
//                             <Button
//                                 variant="contained"
//                                 color="success"
//                                 onClick={() => handleAddStudentToBatch(params.row)}
//                                 disabled={loader}
//                                 size="small"
//                                 startIcon={<PersonAddIcon />}
//                             >
//                                 {loader ? 'Adding...' : 'Add to Batch'}
//                             </Button>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         },
//     ];

//     const columnsSelectedStudents = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 120,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 120,
//         },
//         {
//             field: 'depotDivision',
//             headerName: 'Depot/Division',
//             width: 150,
//             renderCell: (params) => {
//                 const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
//                 const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
//                 const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
//                 if (depot && division) {
//                     return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
//                 } else if (depot) {
//                     return <span>{depot}{state ? ` (${state})` : ''}</span>;
//                 } else if (division) {
//                     return <span>{division}{state ? ` (${state})` : ''}</span>;
//                 }
//                 return <span style={{ color: '#999' }}>--</span>;
//             }
//         },
//         {
//             field: 'remove',
//             headerName: 'Remove',
//             width: 100,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="danger"
//                     size="small"
//                     onClick={() => handleRemoveSelectedStudent(params.row.id)}
//                     startIcon={<PersonOffIcon />}
//                 >
//                     Remove
//                 </Button>
//             ),
//         },
//     ];

//     const CustomToolbar = (toolbar) => {
//         const goToBack = () => {
//             toolbar.onNavigate('PREV');
//             const newDate = moment(toolbar.date).subtract(1, toolbar.view === 'day' ? 'day' : toolbar.view === 'week' ? 'week' : 'month').toDate();
//             setCurrentDate(newDate);
//         };

//         const goToNext = () => {
//             toolbar.onNavigate('NEXT');
//             const newDate = moment(toolbar.date).add(1, toolbar.view === 'day' ? 'day' : toolbar.view === 'week' ? 'week' : 'month').toDate();
//             setCurrentDate(newDate);
//         };

//         const goToCurrent = () => {
//             toolbar.onNavigate('TODAY');
//             const today = new Date();
//             setCurrentDate(today);
//         };

//         const viewChange = (view) => {
//             toolbar.onView(view);
//             setCalendarView(view);
//         };

//         return (
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '20px',
//                 padding: '15px',
//                 backgroundColor: '#667eea',
//                 borderRadius: '10px',
//                 color: 'white',
//                 boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//             }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <IconButton onClick={goToBack} style={{ color: 'white' }}>
//                         <NavigateBeforeIcon />
//                     </IconButton>
//                     <IconButton onClick={goToCurrent} style={{ color: 'white' }}>
//                         <TodayIcon />
//                     </IconButton>
//                     <IconButton onClick={goToNext} style={{ color: 'white' }}>
//                         <NavigateNextIcon />
//                     </IconButton>
//                     <span style={{ 
//                         fontSize: '1.5rem', 
//                         fontWeight: 'bold',
//                         marginLeft: '10px'
//                     }}>
//                         {moment(toolbar.date).format('MMMM YYYY')}
//                     </span>
//                 </div>
                
//                 <div style={{ display: 'flex', gap: '5px' }}>
//                     <Button 
//                         color={calendarView === 'month' ? 'light' : 'white'}
//                         onClick={() => viewChange('month')}
//                         style={{
//                             backgroundColor: calendarView === 'month' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
//                             border: '1px solid rgba(255, 255, 255, 0.3)',
//                             color: 'white'
//                         }}
//                     >
//                         <CalendarMonthIcon style={{ marginRight: '5px' }} />
//                         Month
//                     </Button>
//                     <Button 
//                         color={calendarView === 'week' ? 'light' : 'white'}
//                         onClick={() => viewChange('week')}
//                         style={{
//                             backgroundColor: calendarView === 'week' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
//                             border: '1px solid rgba(255, 255, 255, 0.3)',
//                             color: 'white'
//                         }}
//                     >
//                         <ViewWeekIcon style={{ marginRight: '5px' }} />
//                         Week
//                     </Button>
//                     <Button 
//                         color={calendarView === 'day' ? 'light' : 'white'}
//                         onClick={() => viewChange('day')}
//                         style={{
//                             backgroundColor: calendarView === 'day' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
//                             border: '1px solid rgba(255, 255, 255, 0.3)',
//                             color: 'white'
//                         }}
//                     >
//                         <ViewDayIcon style={{ marginRight: '5px' }} />
//                         Day
//                     </Button>
//                 </div>
                
//                 <div>
//                 </div>
//             </div>
//         );
//     };

//     const CustomEvent = ({ event }) => {
//         const now = new Date();
//         const isPast = event.end < now;
        
//         return (
//             <div style={{
//                 padding: '5px',
//                 borderRadius: '4px',
//                 fontSize: '0.85em',
//                 color: 'white',
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//                 opacity: isPast ? 0.7 : 1
//             }}>
//                 <strong>{event.title}</strong>
//                 <div style={{ fontSize: '0.8em', marginTop: '2px' }}>
//                     {moment(event.start).format('h:mm A')}
//                 </div>
//             </div>
//         );
//     };

//     const CustomAgendaEvent = ({ event }) => {
//         return (
//             <div style={{
//                 padding: '10px',
//                 marginBottom: '10px',
//                 backgroundColor: '#667eea',
//                 borderRadius: '8px',
//                 color: 'white',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 cursor: 'pointer'
//             }}
//             onClick={() => handleEventClick(event)}
//             >
//                 <div>
//                     <strong>{event.title}</strong>
//                     <div style={{ fontSize: '0.9em', marginTop: '5px' }}>
//                         {moment(event.start).format('MMMM D, YYYY • h:mm A')}
//                     </div>
//                     {event.description && (
//                         <div style={{ fontSize: '0.85em', marginTop: '5px', opacity: 0.9 }}>
//                             {event.description}
//                         </div>
//                     )}
//                 </div>
//                 <IconButton 
//                     size="small" 
//                     style={{ color: 'white' }}
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         handleEventClick(event);
//                     }}
//                 >
//                     <InfoIcon />
//                 </IconButton>
//             </div>
//         );
//     };

//     const eventStyleGetter = (event, start, end, isSelected) => {
//         const now = new Date();
//         const isPast = end < now;
        
//         let backgroundColor = '#667eea';
        
//         if (isPast) {
//             backgroundColor = '#6c757d';
//         } else if (event.title?.toLowerCase().includes('exam')) {
//             backgroundColor = '#f56565';
//         } else if (event.title?.toLowerCase().includes('review') || event.title?.toLowerCase().includes('assessment')) {
//             backgroundColor = '#ed8936';
//         }
        
//         const style = {
//             backgroundColor: backgroundColor,
//             borderRadius: '8px',
//             opacity: isPast ? 0.7 : 1,
//             color: 'white',
//             border: '0px',
//             display: 'block',
//             padding: '2px 5px',
//             fontSize: '0.9em'
//         };
        
//         return {
//             style: style
//         };
//     };

//     const calendarStyles = {
//         calendarContainer: {
//             height: '70vh',
//             marginTop: '20px',
//             backgroundColor: 'white',
//             borderRadius: '10px',
//             boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//             padding: '15px'
//         },
//         header: {
//             backgroundColor: '#667eea',
//             color: 'white',
//             padding: '15px',
//             borderRadius: '10px',
//             marginBottom: '20px',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center'
//         },
//         statsCard: {
//             backgroundColor: 'white',
//             padding: '15px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
//             marginBottom: '15px'
//         }
//     };

//     return (
//         <React.Fragment>
//             {loader && <Loader />}
            
//             <Row>
//                 <Col>
//                     <Card>
//                         <CardBody className="" style={{ minHeight: "70vh" }}>
//                             <div
//                                 className="d-flex mt-4"
//                                 style={{
//                                     borderBottom: "1px solid gray",
//                                     width: "100%",
//                                     overflowX: "auto",
//                                     whiteSpace: "nowrap"
//                                 }}
//                             >
//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Info" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Info")}
//                                 >
//                                     <h5>Info</h5>
//                                 </div>
//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Notification" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Notification")}
//                                 >
//                                     <h5>Notification</h5>
//                                 </div>
//                                 {type != "Trainer" && type != "Tata Trainer" &&
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "Trainer" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("Trainer")}
//                                     >
//                                         <h5>Trainer</h5>
//                                     </div>
//                                 }

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Student" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Student")}
//                                 >
//                                     <h5>Student</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Courses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Courses")}
//                                 >
//                                     <h5>Courses</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "ScormCourses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("ScormCourses")}
//                                 >
//                                     <h5>Scorm Courses</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "LiveClasses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("LiveClasses")}
//                                 >
//                                     <h5>Live Classes</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Attendance" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Attendance")}
//                                 >
//                                     <h5>Attendance</h5>
//                                 </div>
//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Simulator" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Simulator")}
//                                 >
//                                     <h5>Simulator</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Exam" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Exam")}
//                                 >
//                                     <h5>Exam</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Feedback" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Feedback")}
//                                 >
//                                     <h5>Feedback</h5>
//                                 </div>

//                                 {organizationId === 2 && shouldShowPracticalTab() && (
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "Practical" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("Practical")}
//                                     >
//                                         <h5>
//                                             Practical
//                                             <span style={{ fontSize: '0.8rem', color: getAssessmentColor(), marginLeft: '5px', fontWeight: 'bold' }}>
//                                                 ({getAssessmentName()})
//                                             </span>
//                                         </h5>
//                                     </div>
//                                 )}

//                                 {organizationId === 2 && (
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "TrainingImages" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("TrainingImages")}
//                                     >
//                                         <h5>Training Images</h5>
//                                     </div>
//                                 )}
//                             </div>

//                             {selectedTab === "Info" && (
//                                 <>
//                                     <div className="d-flex flex-column justify-content-between " style={{ height: "60vh" }}>
//                                         <div className="mt-4">
//                                             <div className="row">
//                                                 <div className="col-6">
//                                                     <h5>Batch Name</h5>
//                                                     <p>{batchDetails?.batchName ? batchDetails?.batchName : "--"}</p>
//                                                     {batchDetails?.batchName && (
//                                                         <div style={{ 
//                                                             color: getAssessmentColor(), 
//                                                             fontWeight: 'bold',
//                                                             marginTop: '5px',
//                                                             padding: '5px 10px',
//                                                             backgroundColor: '#f8f9fa',
//                                                             borderRadius: '5px',
//                                                             display: 'inline-block'
//                                                         }}>
//                                                             Assessment Type: {getAssessmentName()}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <div className="col-6">
//                                                     <h5>Department Name</h5>
//                                                     <p>{batchDetails?.department ? batchDetails?.department : "--"}</p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         {type != "Tata Trainer" && type != "Trainer" &&
//                                             <>
//                                                 <div className="d-flex justify-content-end">
//                                                     <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}> <i className="mdi mdi-pencil "></i> Edit</button>
//                                                     <button className="px-3" style={{ cursor: "pointer", border: "none", backgroundColor: "red", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setDeleteModal(true)}> <i className="mdi mdi-delete "></i> Delete</button>
//                                                 </div>
//                                             </>
//                                         }
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Notification" && (
//                                 <>
//                                     <NotificationButtons />
//                                 </>
//                             )}

//                             {selectedTab === "Trainer" && (
//                                 <>
//                                     <div className="row mt-5">
//                                         <div className="col-md-12" style={{}}>
//                                             <h1 className="text-center">Assign to Trainer</h1>
//                                             <div className="d-flex justify-content-end mb-2">
//                                                 {type != "Tata Trainer" && type != "Trainer" &&
//                                                     <>
//                                                         <Button type="button" color="primary" onClick={() => setAddTrainerModal(true)} className="waves-effect waves-light align-self-end me-2">Add Trainer</Button>
//                                                         <Button type="button" color="danger" onClick={() => handleRemoveAllTrainer()} className="waves-effect waves-light align-self-end">Remove All Trainer</Button>
//                                                     </>
//                                                 }
//                                             </div>
//                                             <Paper sx={{ height: 400, width: '100%' }}>
//                                                 <DataGrid
//                                                     rows={allTrainerOfBatch}
//                                                     columns={columnsTrainer}
//                                                     initialState={{ pagination: { paginationModel } }}
//                                                     pageSizeOptions={[5, 10]}
//                                                     disableRowSelectionOnClick
//                                                     getRowClassName={() => 'data-grid-row'}
//                                                     sx={{ border: 0 }}
//                                                 />
//                                             </Paper>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Student" && (
//                                 <>
//                                     <div className="row mt-5">
//                                         <div className="col-md-12" style={{}}>
//                                             <h1 className="text-center">Assign To Student</h1>
                                            
//                                             {organizationId === 2 && !isTrainerRole && (
//                                                 <div className="alert alert-warning mb-3">
//                                                     <div className="d-flex justify-content-between align-items-center">
//                                                         <div>
//                                                             <strong>Certificate Status:</strong>
//                                                             <ul className="mb-0 mt-2">
//                                                                 <li>Total Students: <strong>{allStudentOfBatch.length}</strong></li>
//                                                                 <li>
//                                                                     Eligible Students: 
//                                                                     <strong className="text-success">
//                                                                         {fetchingExamResults ? (
//                                                                             <span className="ms-1">
//                                                                                 <CircularProgress size={12} sx={{ mr: 1, verticalAlign: 'middle' }} />
//                                                                                 Calculating...
//                                                                             </span>
//                                                                         ) : (
//                                                                             ` ${getPassedStudentsCount()}`
//                                                                         )}
//                                                                     </strong>
//                                                                 </li>
//                                                                 <li>
//                                                                     Exam Results Status: 
//                                                                     <span className={`ms-1 fw-bold ${fetchingExamResults ? 'text-warning' : 'text-success'}`}>
//                                                                         {fetchingExamResults ? 'Fetching...' : 'Loaded'}
//                                                                     </span>
//                                                                 </li>
//                                                                 <li>Certificate Eligibility: 
//                                                                     {hasPracticalAssessment() 
//                                                                         ? "Post-test ≥80% + Practical Assessment" 
//                                                                         : "Post-test ≥80%"}
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <div>
//                                                             <div className="d-flex flex-column gap-2">
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="success"
//                                                                     onClick={generateCertificatesForPassedStudents}
//                                                                     disabled={batchZipLoading || fetchingExamResults}
//                                                                     className="waves-effect waves-light"
//                                                                     startIcon={batchZipLoading ? <CircularProgress size={20} /> : <ArchiveIcon />}
//                                                                 >
//                                                                     {fetchingExamResults ? 'Fetching Results...' : 
//                                                                      batchZipLoading ? 'Generating ZIP...' : 
//                                                                      'Download All Certificates (ZIP)'}
//                                                                 </Button>
                                                                
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="info"
//                                                                     onClick={generateExcelReportOnly}
//                                                                     disabled={loader || fetchingExamResults}
//                                                                     className="waves-effect waves-light"
//                                                                     startIcon={<DescriptionIcon />}
//                                                                 >
//                                                                     Generate Excel Report Only
//                                                                 </Button>
//                                                             </div>
//                                                             {batchZipLoading && (
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="secondary"
//                                                                     onClick={() => setBatchZipLoading(false)}
//                                                                     className="waves-effect waves-light mt-2"
//                                                                     size="sm"
//                                                                 >
//                                                                     Cancel
//                                                                 </Button>
//                                                             )}
//                                                         </div>
//                                                     </div>
                                                    
//                                                     {certificateProgress.inProgress && (
//                                                         <div className="mt-3">
//                                                             <div className="d-flex justify-content-between mb-1">
//                                                                 <small>
//                                                                     Generating certificates: {certificateProgress.completed}/{certificateProgress.total}
//                                                                     {certificateProgress.failed > 0 && (
//                                                                         <span className="text-danger ms-2">({certificateProgress.failed} failed)</span>
//                                                                     )}
//                                                                 </small>
//                                                                 <small>{Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%</small>
//                                                             </div>
//                                                             <div className="progress">
//                                                                 <div 
//                                                                     className="progress-bar progress-bar-striped progress-bar-animated" 
//                                                                     role="progressbar" 
//                                                                     style={{ width: `${(certificateProgress.completed / certificateProgress.total) * 100}%` }}
//                                                                 >
//                                                                     {Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%
//                                                                 </div>
//                                                             </div>
//                                                             <div className="text-center mt-1">
//                                                                 <small className="text-muted">
//                                                                     This may take a few minutes. Please don't close the browser.
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     )}
                                                    
//                                                     {!fetchingExamResults && Object.keys(studentExamResults).length === 0 && (
//                                                         <div className="alert alert-info mt-2 mb-0 py-1">
//                                                             <small>
//                                                                 <InfoIcon fontSize="small" className="me-1" />
//                                                                 Exam results will be automatically fetched when generating certificates or reports
//                                                             </small>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )}

//                                             <div className="mb-3">
//                                                 <div className="alert alert-success">
//                                                     <strong>Student Addition Policy:</strong>
//                                                     <ul className="mb-0">
//                                                         <li><strong>ALL students</strong> can be added to this batch</li>
//                                                         <li>Students can be in multiple batches simultaneously</li>
//                                                         <li>{hasPracticalAssessment() 
//                                                             ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
//                                                             : `Only post-test (≥80%) is required for eligibility`}</li>
//                                                         <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
//                                                         <li>Total Students in Batch: <strong>{allStudentOfBatch.length}</strong></li>
//                                                     </ul>
//                                                 </div>
//                                             </div>
                                            
//                                             {/* Enhanced Search and Bulk Removal Section */}
//                                             <div className="d-flex justify-content-between mb-3">
//                                                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
//                                                     <TextField
//                                                         size="small"
//                                                         placeholder="Search students in batch by name, mobile, depot, division..."
//                                                         value={batchStudentSearchTerm}
//                                                         onChange={(e) => setBatchStudentSearchTerm(e.target.value)}
//                                                         sx={{ flex: 1, maxWidth: '500px' }}
//                                                         InputProps={{
//                                                             startAdornment: (
//                                                                 <InputAdornment position="start">
//                                                                     <SearchIcon />
//                                                                 </InputAdornment>
//                                                             ),
//                                                             endAdornment: batchStudentSearchTerm && (
//                                                                 <InputAdornment position="end">
//                                                                     <IconButton size="small" onClick={clearBatchStudentSearch}>
//                                                                         <ClearIcon />
//                                                                     </IconButton>
//                                                                 </InputAdornment>
//                                                             )
//                                                         }}
//                                                     />
//                                                     <span className="text-muted" style={{ fontSize: '0.85rem' }}>
//                                                         {filteredBatchStudents.length} students
//                                                         {batchStudentSearchTerm && ` (filtered from ${allStudentOfBatch.length})`}
//                                                     </span>
//                                                 </div>
//                                                 <div className="d-flex align-items-center gap-2">
//                                                     {/* REMOVE SELECTED BUTTON - Shows only when students are selected */}
//                                                     {selectedStudentIds.length > 0 && (
//                                                         <Button
//                                                             type="button"
//                                                             color="danger"
//                                                             onClick={handleBulkRemoveStudents}
//                                                             disabled={loader}
//                                                             size="sm"
//                                                             startIcon={<PersonOffIcon />}
//                                                             className="fw-bold"
//                                                             style={{
//                                                                 backgroundColor: '#dc3545',
//                                                                 borderColor: '#dc3545',
//                                                                 boxShadow: '0 2px 4px rgba(220, 53, 69, 0.3)',
//                                                                 padding: '8px 16px',
//                                                                 borderRadius: '8px'
//                                                             }}
//                                                         >
//                                                             Remove Selected ({selectedStudentIds.length})
//                                                         </Button>
//                                                     )}
//                                                     <Button 
//                                                         type="button" 
//                                                         color="primary" 
//                                                         onClick={() => setAddStudentModal(true)} 
//                                                         className="waves-effect waves-light"
//                                                         size="sm"
//                                                         startIcon={<PersonAddIcon />}
//                                                     >
//                                                         Add Student
//                                                     </Button>
//                                                     <Button 
//                                                         type="button" 
//                                                         color="danger" 
//                                                         onClick={() => setRemoveAllStudentsModal(true)} 
//                                                         className="waves-effect waves-light"
//                                                         size="sm"
//                                                         startIcon={<DeleteIcon />}
//                                                         variant="outline"
//                                                     >
//                                                         Remove All
//                                                     </Button>
//                                                 </div>
//                                             </div>
                                            
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <button type="submit" className="btn btn-info w-md" onClick={handleDownloadStudentDetailsClick}>
//                                                     <DownloadIcon style={{ marginRight: '5px' }} /> Download All Student File
//                                                 </button>
//                                             </div>
                                            
//                                             <Paper sx={{ height: 500, width: '100%' }}>
//                                                 <DataGrid
//                                                     rows={filteredBatchStudents}
//                                                     columns={columnsStudent}
//                                                     initialState={{ pagination: { paginationModel } }}
//                                                     pageSizeOptions={[5, 10, 25]}
//                                                     checkboxSelection
//                                                     onRowSelectionModelChange={handleSelectionChange}
//                                                     rowSelectionModel={selectedStudentIds}
//                                                     sx={{ border: 0 }}
//                                                     loading={loader}
//                                                 />
//                                             </Paper>
//                                         </div>
//                                     </div>
//                                     <ExamResultsModal
//                                         student={selectedStudent}
//                                         batchId={params.id}
//                                         open={showExamResults}
//                                         onClose={() => setShowExamResults(false)}
//                                         examResults={studentExamResults[selectedStudent?.id]}
//                                         loading={loadingExamResults[selectedStudent?.id]}
//                                     />
//                                 </>
//                             )}

//                             {selectedTab === "Courses" && (
//                                 <>
//                                     <div className="d-flex justify-content-end mt-2">
//                                         {type != "Trainer" && type != "Tata Trainer" &&
//                                             <Button type="button" color="primary" onClick={() => setAddCourseModal(true)} className="waves-effect waves-light align-self-end">Add Course</Button>
//                                         }
//                                     </div>
//                                     <div className="d-flex flex-row flex-wrap mt-3">
//                                         {allCoursesOfBatch?.map((d, index) => (
//                                             <div key={index} className="card me-5" style={{ width: "18rem", border: "2px solid gray", borderRadius: "10px", cursor: "pointer" }} onClick={() => navigate("/course-view/" + d.id)}>
//                                                 <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"200px"} />
//                                                 <div className="card-body">
//                                                     <h5 className="card-title">{d?.title}</h5>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Duration: </h5>
//                                                         <p>{d?.duration} Hours</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Level: </h5>
//                                                         <p>{d?.levelDto?.name}</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Language: </h5>
//                                                         <p>{d?.language}</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         {type !== "Trainer" && (
//                                                             <Button
//                                                                 type="button"
//                                                                 color="danger"
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     setSelectedCourse(d);
//                                                                     setCourseDeleteModal(true);
//                                                                 }}
//                                                                 className="waves-effect waves-light"
//                                                             >
//                                                                 Remove Course
//                                                             </Button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "ScormCourses" && (
//                                 <>
//                                     <ScormCourse getScormCourseOfBatch={getScormCourseOfBatch} allScormCourses={allScormCourses} allScormCoursesOfBatch={allScormCoursesOfBatch} type={type} />
//                                 </>
//                             )}

//                             {selectedTab === "LiveClasses" && (
//                                 <LClass
//                                     liveClasses={liveClasses}
//                                     loader={loader}
//                                     setLoader={setLoader}
//                                     params={params}
//                                     fetchBatchDetails={fetchBatchDetails}
//                                     spanDisplay={spanDisplay}
//                                 />
//                             )}

//                             {selectedTab === "Attendance" && (
//                                 <>
//                                     <div className="">
//                                         <TrainerAttendance trainers={allTrainerOfBatch} batchDetails={batchDetails} />
//                                     </div>
//                                     <Attendance students={allStudentOfBatch} batchDetails={batchDetails} />
//                                 </>
//                             )}


//                             {selectedTab === "Simulator" && (
//                                 <>
//                                     <div className="">
//                                     </div>
//                                     <Simulator students={allStudentOfBatch} batchDetails={batchDetails} />
//                                 </>
//                             )}

//                             {selectedTab === "Exam" && (
//                                 <>
//                                     <div className="mt-2">
//                                         <ExamList />
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Feedback" && (
//                                 <>
//                                     <div className="mt-2">
//                                         <Feedback />
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Practical" && shouldShowPracticalTab() && (
//                                 <>
//                                     <div className="mt-2">
//                                         {getAssessmentComponent()}
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "TrainingImages" && (
//                                 <>
//                                     <ImageUploader batchId={params.id} trainingImages={trainingImages} fetchBatchDetails={fetchBatchDetails} />
//                                 </>
//                             )}
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>

//             {/* Bulk Remove Confirmation Modal */}
//             <Modal show={bulkRemoveModal} size="lg" centered onHide={() => setBulkRemoveModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <PersonOffIcon style={{ color: '#dc3545', marginRight: '10px' }} />
//                             <span>Confirm Bulk Removal</span>
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center py-3">
//                         <div style={{ fontSize: '3rem', marginBottom: '20px' }}>
//                             ⚠️
//                         </div>
//                         <h4 className="mb-3">Are you sure you want to remove these students?</h4>
//                         <div className="alert alert-danger">
//                             <strong>You are about to remove {selectedStudentIds.length} student(s) from this batch.</strong>
//                         </div>
//                         <div className="mt-3">
//                             <p className="text-muted">
//                                 <strong>Selected Students:</strong>
//                             </p>
//                             <div style={{ maxHeight: '200px', overflowY: 'auto', textAlign: 'left' }}>
//                                 <ul className="list-group">
//                                     {allStudentOfBatch
//                                         .filter(student => selectedStudentIds.includes(student.id))
//                                         .slice(0, 10)
//                                         .map((student, index) => (
//                                             <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
//                                                 <span>
//                                                     <strong>{student.firstName} {student.lastName}</strong>
//                                                 </span>
//                                                 <span className="badge bg-secondary rounded-pill">
//                                                     ID: {student.id}
//                                                 </span>
//                                             </li>
//                                         ))}
//                                     {selectedStudentIds.length > 10 && (
//                                         <li className="list-group-item text-center text-muted">
//                                             ... and {selectedStudentIds.length - 10} more students
//                                         </li>
//                                     )}
//                                 </ul>
//                             </div>
//                         </div>
//                         <div className="mt-3">
//                             <p className="text-danger">
//                                 <strong>This action cannot be undone!</strong>
//                             </p>
//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button 
//                         type="button" 
//                         color="secondary" 
//                         onClick={() => setBulkRemoveModal(false)} 
//                         className="waves-effect waves-light"
//                         disabled={loader}
//                     >
//                         Cancel
//                     </Button>
//                     <Button 
//                         type="button" 
//                         color="danger" 
//                         onClick={confirmBulkRemoveStudents} 
//                         className="waves-effect waves-light"
//                         disabled={loader}
//                         startIcon={<PersonOffIcon />}
//                         style={{
//                             backgroundColor: '#dc3545',
//                             borderColor: '#dc3545'
//                         }}
//                     >
//                         {loader ? 'Removing...' : `Yes, Remove ${selectedStudentIds.length} Student(s)`}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={showEventModal} centered onHide={() => setShowEventModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <VideoCallIcon style={{ marginRight: '10px', color: '#667eea' }} />
//                             <span>Class Details</span>
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {selectedEvent && (
//                         <div>
//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: '#667eea', marginBottom: '10px' }}>{selectedEvent.title}</h4>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
//                                     <AccessTimeIcon style={{ marginRight: '10px', color: '#666' }} />
//                                     <span>{formatDateTime(selectedEvent.classTime)}</span>
//                                 </div>
//                                 {selectedEvent.description && (
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
//                                         <SubjectIcon style={{ marginRight: '10px', color: '#666', marginTop: '3px' }} />
//                                         <span>{selectedEvent.description}</span>
//                                     </div>
//                                 )}
//                                 {selectedEvent.classLink && (
//                                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
//                                         <LinkIcon style={{ marginRight: '10px', color: '#666' }} />
//                                         <a 
//                                             href={selectedEvent.classLink} 
//                                             target="_blank" 
//                                             rel="noopener noreferrer" 
//                                             style={{ color: '#667eea', textDecoration: 'underline' }}
//                                             onClick={(e) => {
//                                                 e.preventDefault();
//                                                 openLiveClassLink(selectedEvent.classLink);
//                                             }}
//                                         >
//                                             {selectedEvent.classLink}
//                                         </a>
//                                     </div>
//                                 )}
//                             </div>
                            
//                             <div style={{
//                                 backgroundColor: '#f8f9fa',
//                                 padding: '15px',
//                                 borderRadius: '8px',
//                                 marginTop: '20px'
//                             }}>
//                                 <h6 style={{ marginBottom: '10px' }}>Quick Actions</h6>
//                                 <div style={{ display: 'flex', gap: '10px' }}>
//                                     {selectedEvent.classLink && (
//                                         <Button 
//                                             color="primary" 
//                                             onClick={() => openLiveClassLink(selectedEvent.classLink)}
//                                             style={{ flex: 1 }}
//                                         >
//                                             <VideoCallIcon style={{ marginRight: '5px' }} />
//                                             Join Now
//                                         </Button>
//                                     )}
//                                     <Button 
//                                         color="secondary" 
//                                         style={{ flex: 1 }}
//                                         onClick={() => {
//                                             if (selectedEvent.classLink) {
//                                                 navigator.clipboard.writeText(selectedEvent.classLink);
//                                                 toast.success('Link copied to clipboard!');
//                                             }
//                                         }}
//                                     >
//                                         <LinkIcon style={{ marginRight: '5px' }} />
//                                         Copy Link
//                                     </Button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setShowEventModal(false)}>
//                         Close
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={deleteModal} size="lg" centered>
//                 <Modal.Header></Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <h1> Are you sure want To delete this Batch</h1>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setDeleteModal(false)} className="waves-effect waves-light">Close</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleDeleteBatch} className="waves-effect waves-light">Delete</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={editModal} size="lg" centered>
//                 <Modal.Header>
//                     <Modal.Title>Edit Batch Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <Row className="mb-3">
//                             <label htmlFor="example-text-input" className="col-md-2 col-form-label">
//                                 Batch Name
//                             </label>
//                             <div className="col-md-10">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Enter Batch Name"
//                                     value={batchDetails?.batchName || ""}
//                                     maxLength="50"
//                                     onChange={(e) => setBatchDetails(prevDetails => ({
//                                         ...prevDetails,
//                                         batchName: e.target.value
//                                     }))}
//                                 />
//                                 {!batchDetails?.batchName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                             </div>
//                         </Row>
//                         <Row className="mb-3">
//                             <label htmlFor="example-text-input" className="col-md-2 col-form-label">
//                                 Department Name
//                             </label>
//                             <div className="col-md-10">
//                                 <Select
//                                     value={department}
//                                     onChange={(selectedValue) => setDepartment(selectedValue)}
//                                     options={allDepartments}
//                                     getOptionLabel={option => option.name}
//                                     getOptionValue={option => option.id.toString()}
//                                     classNamePrefix="select2-selection"
//                                 />
//                                 {!batchDetails?.department && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                             </div>
//                         </Row>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setEditModal(false)} className="waves-effect waves-light">Close</Button>{" "}
//                     <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addTrainerModal} size="lg" centered>
//                 <Modal.Header>Add Trainer</Modal.Header>
//                 <Modal.Body>
//                     <div className="" >
//                         <h1 className="text-center">All Trainers</h1>
//                         <div className="mb-3 d-flex justify-content-center">
//                             <div style={{ width: '50%' }}>
//                                 <TextField
//                                     fullWidth
//                                     variant="outlined"
//                                     label="Search Trainer"
//                                     value={searchTrainerText}
//                                     onChange={(e) => setSearchTrainerText(e.target.value)}
//                                     sx={{ marginBottom: 2 }}
//                                 />
//                             </div>
//                         </div>
//                         <Paper sx={{ height: 400, width: '100%' }}>
//                             <DataGrid
//                                 rows={filteredAllTrainers?.map((row, index) => ({
//                                     ...row,
//                                     serialNo: index + 1,
//                                 }))}
//                                 columns={columnsTrainerModal}
//                                 initialState={{ pagination: { paginationModel } }}
//                                 pageSizeOptions={[5, 10]}
//                                 disableRowSelectionOnClick
//                                 getRowClassName={() => 'data-grid-row'}
//                                 sx={{ border: 0 }}
//                             />
//                         </Paper>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setAddTrainerModal(false)} className="waves-effect waves-light">Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addStudentModal} size="xl" centered onHide={handleModalClose}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div>
//                             <h4>Add Students to Batch</h4>
//                             {batchDetails && (
//                                 <div className="batch-info-card mt-2 p-3 bg-light rounded">
//                                     <div className="d-flex align-items-center mb-2">
//                                         <SchoolIcon className="me-2 text-primary" />
//                                         <h5 className="mb-0 text-primary">{batchDetails.batchName || "Batch"}</h5>
//                                     </div>
//                                     <div className="row">
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small>
//                                                     <strong>Start Date:</strong> {formatDate(batchDetails.startDate)}
//                                                 </small>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small>
//                                                     <strong>End Date:</strong> {formatDate(batchDetails.endDate)}
//                                                 </small>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         <small className="text-success fw-bold">
//                                             <strong>ALL students</strong> can be added. Students can be in multiple batches.
//                                         </small>
//                                     </div>
//                                     {assessmentType !== "none" && (
//                                         <div className="mt-2">
//                                             <small style={{ color: getAssessmentColor() }} className="fw-bold">
//                                                 <strong>Assessment Type:</strong> {getAssessmentName()}
//                                             </small>
//                                         </div>
//                                     )}
//                                     {assessmentType === "none" && (
//                                         <div className="mt-2">
//                                             <small className="text-muted">
//                                                 <strong>Note:</strong> This batch does not have a practical assessment.
//                                                 Certificate eligibility based on post-test score (≥80%).
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <h1 className="text-center">All Students</h1>
                        
//                         {showSuccessMessage && (
//                             <div className="alert alert-success alert-dismissible fade show mb-3" role="alert">
//                                 <strong>Success!</strong> {successMessage}
//                                 <button 
//                                     type="button" 
//                                     className="btn-close" 
//                                     onClick={() => setShowSuccessMessage(false)}
//                                     aria-label="Close"
//                                 ></button>
//                             </div>
//                         )}

//                         {recentlyAddedStudents.length > 0 && (
//                             <div className="alert alert-info mb-3">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <div>
//                                         <strong>Recently Added Students:</strong>
//                                         <ul className="mb-0 mt-1">
//                                             {recentlyAddedStudents.slice(-5).map((student, index) => (
//                                                 <li key={index}>
//                                                     {student.firstName} {student.lastName} 
//                                                     <span className="text-muted"> ({student.mobile})</span>
//                                                     {student.tataStudentDetailsDto?.depot && student.tataStudentDetailsDto?.division && (
//                                                         <span className="text-info ms-2">
//                                                             • {student.tataStudentDetailsDto.depot} / {student.tataStudentDetailsDto.division}
//                                                         </span>
//                                                     )}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                     <Button 
//                                         color="link" 
//                                         size="sm" 
//                                         onClick={() => setRecentlyAddedStudents([])}
//                                     >
//                                         Clear List
//                                     </Button>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="alert alert-info mb-3">
//                             <strong>Student Addition Policy:</strong>
//                             <ul className="mb-0">
//                                 <li><strong>ALL students</strong> can be added to this batch</li>
//                                 <li>Students can be in multiple batches simultaneously</li>
//                                 <li>{hasPracticalAssessment() 
//                                     ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
//                                     : `Only post-test (≥80%) is required for eligibility`}</li>
//                                 <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
//                                 <li>Available Students: <strong>{filteredAllStudents.length}</strong> | Selected: <strong>{selectedStudentsForBatch.length}</strong></li>
//                                 <li><strong>Tip:</strong> Modal stays open after successful addition. Click "Close" button when done.</li>
//                             </ul>
//                         </div>

//                         {selectedStudentsForBatch.length > 0 && (
//                             <div className="alert alert-warning mb-3 d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <strong>Selected {selectedStudentsForBatch.length} student(s)</strong>
//                                     <Button 
//                                         color="link" 
//                                         onClick={() => setShowSelectedStudents(!showSelectedStudents)}
//                                         className="ms-2"
//                                     >
//                                         {showSelectedStudents ? 'Hide Selected' : 'Show Selected'}
//                                     </Button>
//                                 </div>
//                                 <div>
//                                     <Button 
//                                         color="secondary" 
//                                         size="sm" 
//                                         onClick={handleClearSelectedStudents}
//                                         className="me-2"
//                                     >
//                                         Clear All
//                                     </Button>
//                                     <Button 
//                                         color="success" 
//                                         size="sm" 
//                                         onClick={handleAddMultipleStudentsToBatch}
//                                         disabled={loader}
//                                         startIcon={<PersonAddIcon />}
//                                     >
//                                         {loader ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                     </Button>
//                                 </div>
//                             </div>
//                         )}

//                         {showSelectedStudents && selectedStudentsForBatch.length > 0 && (
//                             <div className="mb-3">
//                                 <h5>Selected Students:</h5>
//                                 <Paper sx={{ height: 200, width: '100%', marginBottom: 2 }}>
//                                     <DataGrid
//                                         rows={selectedStudentsForBatch}
//                                         columns={columnsSelectedStudents}
//                                         pageSizeOptions={[5]}
//                                         disableRowSelectionOnClick
//                                         sx={{ border: 0 }}
//                                     />
//                                 </Paper>
//                             </div>
//                         )}

//                         <div className="mb-3">
//                             <Row>
//                                 <Col md={isTataUser ? 2 : 4}>
//                                     <TextField
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Search by Name/Email/Mobile"
//                                         value={searchStudentText}
//                                         onChange={(e) => setSearchStudentText(e.target.value)}
//                                         sx={{ marginBottom: 2 }}
//                                     />
//                                 </Col>
                                
//                                 <Col md={isTataUser ? 2 : 4}>
//                                     <TextField
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Search by Aadhaar No"
//                                         value={searchAadhaarText}
//                                         onChange={(e) => setSearchAadhaarText(e.target.value)}
//                                         sx={{ marginBottom: 2 }}
//                                         InputProps={{
//                                             startAdornment: (
//                                                 <FingerprintIcon style={{ marginRight: '8px', color: '#667eea' }} />
//                                             ),
//                                         }}
//                                     />
//                                 </Col>
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by State"
//                                             value={stateFilter}
//                                             onChange={setStateFilter}
//                                             options={availableStates}
//                                             isClearable
//                                             className="mb-2"
//                                         />
//                                     </Col>
//                                 )}
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by Division"
//                                             value={divisionFilter}
//                                             onChange={setDivisionFilter}
//                                             options={availableDivisions}
//                                             isClearable
//                                             className="mb-2"
//                                         />
//                                     </Col>
//                                 )}
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by Contractor Token"
//                                             value={contractorTokenFilter}
//                                             onChange={setContractorTokenFilter}
//                                             options={availableContractorTokens}
//                                             isClearable
//                                             className="mb-2"
//                                             formatOptionLabel={({ value, label, display }) => (
//                                                 <div>
//                                                     <span className="fw-bold">{display || label}</span>
//                                                 </div>
//                                             )}
//                                         />
//                                     </Col>
//                                 )}
//                             </Row>
                            
//                             {isTataUser && availableNatureOfWork.length > 0 && (
//                                 <Row className="mt-2">
//                                     <Col md={6}>
//                                         <div className="d-flex align-items-center mb-2">
//                                             <WorkIcon className="me-2 text-primary" />
//                                             <span className="me-2" style={{ whiteSpace: 'nowrap' }}>Filter by Nature of Work:</span>
//                                             <Select
//                                                 placeholder="Select Nature of Work"
//                                                 value={natureOfWorkFilter}
//                                                 onChange={setNatureOfWorkFilter}
//                                                 options={availableNatureOfWork}
//                                                 isClearable
//                                                 className="flex-grow-1"
//                                                 formatOptionLabel={({ value, label, display }) => (
//                                                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                                                         <WorkIcon style={{ fontSize: '1rem', marginRight: '8px', color: '#667eea' }} />
//                                                         <span className="fw-bold">{display || label}</span>
//                                                     </div>
//                                                 )}
//                                             />
//                                         </div>
//                                     </Col>
//                                 </Row>
//                             )}
                            
//                             <div className="d-flex justify-content-between align-items-center mt-3">
//                                 <div>
//                                     {isTataUser && (
//                                         <Checkbox
//                                             checked={selectAll}
//                                             onChange={handleSelectAllStudents}
//                                             disabled={filteredAllStudents.length === 0 || loader}
//                                             indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
//                                         />
//                                     )}
//                                     <span className="ms-2 fw-bold">
//                                         {selectedStudentsForBatch.length > 0 && (
//                                             <span style={{ color: '#28a745' }}>
//                                                 {selectedStudentsForBatch.length} selected
//                                             </span>
//                                         )}
//                                     </span>
//                                     <small className="text-muted ms-3">
//                                         Showing {filteredAllStudents.length} of {allStudents.length} students
//                                         {(stateFilter || divisionFilter || aadhaarFilter || contractorTokenFilter || natureOfWorkFilter) && (
//                                             <span className="ms-2">
//                                                 {stateFilter && ` • State: ${stateFilter.label}`}
//                                                 {divisionFilter && ` • Division: ${divisionFilter.label}`}
//                                                 {aadhaarFilter && ` • Aadhaar: ${formatAadhaarNumber(aadhaarFilter.value)}`}
//                                                 {contractorTokenFilter && ` • Contractor Token: ${contractorTokenFilter.label}`}
//                                                 {natureOfWorkFilter && ` • Nature of Work: ${natureOfWorkFilter.label}`}
//                                             </span>
//                                         )}
//                                     </small>
//                                 </div>
//                                 <Button 
//                                     color="secondary" 
//                                     size="sm" 
//                                     onClick={clearStudentFilters}
//                                     disabled={!searchStudentText && !searchAadhaarText && !stateFilter && !divisionFilter && !aadhaarFilter && !contractorTokenFilter && !natureOfWorkFilter || loader}
//                                     startIcon={<FilterListIcon />}
//                                 >
//                                     Clear Filters
//                                 </Button>
//                             </div>
//                         </div>

//                         {isTataUser ? (
//                             <Paper sx={{ height: 500, width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         id: row.id || index + 1,
//                                     }))}
//                                     columns={columnsStudentModalForTata}
//                                     initialState={{ pagination: { paginationModel } }}
//                                     pageSizeOptions={[5, 10, 25]}
//                                     disableRowSelectionOnClick
//                                     getRowClassName={() => 'data-grid-row'}
//                                     sx={{ border: 0 }}
//                                     loading={loader}
//                                 />
//                             </Paper>
//                         ) : (
//                             <Paper sx={{ height: 500, width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         id: row.id || index + 1,
//                                     }))}
//                                     columns={columnsStudentModal}
//                                     initialState={{ pagination: { paginationModel } }}
//                                     pageSizeOptions={[5, 10, 25]}
//                                     disableRowSelectionOnClick
//                                     getRowClassName={() => 'data-grid-row'}
//                                     sx={{ border: 0 }}
//                                     loading={loader}
//                                 />
//                             </Paper>
//                         )}
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <div className="d-flex justify-content-between w-100">
//                         <div>
//                             {selectedStudentsForBatch.length > 0 && (
//                                 <Button 
//                                     type="button" 
//                                     color="success" 
//                                     onClick={handleAddMultipleStudentsToBatch}
//                                     disabled={loader}
//                                     startIcon={<PersonAddIcon />}
//                                 >
//                                     {loader ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                 </Button>
//                             )}
//                         </div>
//                         <div>
//                             <Button 
//                                 type="button" 
//                                 color="secondary" 
//                                 onClick={handleModalClose}
//                                 className="waves-effect waves-light me-2"
//                                 disabled={loader}
//                             >
//                                 Close
//                             </Button>
//                             {recentlyAddedStudents.length > 0 && (
//                                 <Button 
//                                     type="button" 
//                                     color="primary" 
//                                     onClick={() => {
//                                         handleModalClose();
//                                         setSelectedTab("Student");
//                                     }}
//                                     disabled={loader}
//                                 >
//                                     Done ({recentlyAddedStudents.length} added)
//                                 </Button>
//                             )}
//                         </div>
//                     </div>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addCourseModal} size="lg" centered>
//                 <Modal.Header>Add Courses</Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <div className="mb-3 d-flex justify-content-center">
//                             <div style={{ width: '50%' }}>
//                                 <TextField
//                                     fullWidth
//                                     variant="outlined"
//                                     label="Search Course"
//                                     value={searchCourseText}
//                                     onChange={(e) => setSearchCourseText(e.target.value)}
//                                     sx={{ marginBottom: 2 }}
//                                 />
//                             </div>
//                         </div>
//                         <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
//                             {filteredAllCourses.length > 0 && filteredAllCourses?.map((d, i) => (
//                                 <div key={i} className="card me-5 mb-3" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px" }} >
//                                     <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"220px"} />
//                                     <div className="card-body" >
//                                         <h5 className="card-title">{d?.title}</h5>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Duration: </h5>
//                                             <p>{d?.duration} Hours</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Level: </h5>
//                                             <p>{d?.levelDto?.name}</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Language: </h5>
//                                             <p>{d?.language}</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <Button type="button" color="success" onClick={() => handleAddCourseToBatch(d?.id)} className="waves-effect waves-light">Add Course</Button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setAddCourseModal(false)} className="waves-effect waves-light">Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Remove All Students Confirmation Modal */}
//             <Modal show={removeAllStudentsModal} size="lg" centered>
//                 <Modal.Header>
//                     <Modal.Title>Remove All Students</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center">
//                         <h4>Are you sure you want to remove all students from this batch?</h4>
//                         <p className="text-danger mt-2">
//                             <strong>Warning:</strong> This action cannot be undone. 
//                             All {allStudentOfBatch.length} students will be removed from the batch.
//                         </p>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="secondary" onClick={() => setRemoveAllStudentsModal(false)} className="waves-effect waves-light">
//                         Cancel
//                     </Button>
//                     <Button type="button" color="danger" onClick={handleRemoveAllStudents} className="waves-effect waves-light" disabled={loader}>
//                         {loader ? 'Removing...' : 'Yes, Remove All'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={studentDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Student?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setStudentDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveStudentFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={courseDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Course?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setCourseDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveCourseFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={trainerDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Trainer?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setTrainerDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveTrainerFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>
//         </React.Fragment>
//     );
// };

// export default connect(null, {setBreadcrumbItems })(BatchDetails);




// import React, { useEffect, useState } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import Loader from "components/Loader/Loader";
// import { useNavigate, useParams } from "react-router-dom";
// import { getAllStudents, getAllStudentsForTata } from "helpers/student_helper";
// import { Modal } from "react-bootstrap";
// import { fetchAllCourses } from "helpers/course_helper";
// import { DOWNLOAD_BATCH_STUDENT_FILE, url } from "helpers/url_helper";
// import { DataGrid } from '@mui/x-data-grid';
// import Paper from '@mui/material/Paper';
// import { generatePresignedUrlForAccess } from "helpers/Content_helper";
// import { 
//     addCourseToBatch, 
//     addStudentToBatch, 
//     addMultipleStudentsToBatch,
//     addTrainerToBatch, 
//     deleteBatch, 
//     fetchSingleBatch, 
//     getAllCourseOfBatch, 
//     getAllScormCourseOfBatch, 
//     getAllStudentOfBatch, 
//     getAllTrainerOfBatch, 
//     removeAllStudentsFromBatch, 
//     removeAllTrainersFromBatch, 
//     removeCourseFromBatch, 
//     removeStudentFromBatch, 
//     removeTrainerFromBatch, 
//     updateBatch 
// } from "helpers/batch_helper";
// import { fetchAllTrainers, fetchAllUsers } from "helpers/user_helper";
// import axios from "axios";
// import Select from "react-select";
// import Attendance from "./Components/Attendance";
// import Simulator from "./Components/Simulator";
// import TrainerAttendance from "./Components/TrainerAttendance";
// import ExamList from "./Components/ExamList";
// import { ExamResultsModal } from "./Components/ExamResultsModal";
// import Feedback from "./Components/Feedback";
// import DriverMarkingSystem from "./Components/DriverMarkingSystem";
// import BronzeAssessment from "./Components/BronzeAssessment";
// import SilverAssessment from "./Components/SilverAssessment";
// import GoldAssessment from "./Components/GoldAssessment";
// import { TextField, CircularProgress, Box, Chip, IconButton, Avatar, Checkbox, Tooltip, InputAdornment } from "@mui/material";
// import { fetchAllScormCourse } from "helpers/scorm_helper";
// import ScormCourse from "./Components/ScormCourse";
// import ImageUploader from "./Components/ImageUploader";
// import NotificationButtons from "./Components/NotificationButtons";
// import LClass from "./Components/LClass";
// import InfoIcon from '@mui/icons-material/Info';
// import EventIcon from '@mui/icons-material/Event';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import SchoolIcon from '@mui/icons-material/School';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import PersonOffIcon from '@mui/icons-material/PersonOff';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
// import VideoCallIcon from '@mui/icons-material/VideoCall';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import SubjectIcon from '@mui/icons-material/Subject';
// import LinkIcon from '@mui/icons-material/Link';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import ViewWeekIcon from '@mui/icons-material/ViewWeek';
// import ViewDayIcon from '@mui/icons-material/ViewDay';
// import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
// import TodayIcon from '@mui/icons-material/Today';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import AddIcon from '@mui/icons-material/Add';
// import FingerprintIcon from '@mui/icons-material/Fingerprint';
// import BadgeIcon from '@mui/icons-material/Badge';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import DescriptionIcon from '@mui/icons-material/Description';
// import WorkIcon from '@mui/icons-material/Work';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import BusinessIcon from '@mui/icons-material/Business';

// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';

// import { getResult } from "helpers/exam_helper";
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';

// const localizer = momentLocalizer(moment);

// const allDepartments = [
//     { id: 1, name: "Skilling" },
//     { id: 2, name: "Upskilling" },
//     { id: 3, name: "Paid Trainings" },
//     { id: 4, name: "Corporate" },
//     { id: 5, name: "School Project" },
//     { id: 6, name: "University & College" },
// ];

// const paginationModel = { page: 0, pageSize: 5 };

// const BatchDetails = (props) => {
//     document.title = "Content Management | Batch Details";
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [loader, setLoader] = useState(false);
//     const [batchZipLoading, setBatchZipLoading] = useState(false);
//     const navigate = useNavigate();
//     const params = useParams();

//     const [batchDetails, setBatchDetails] = useState(null);
//     const [selectedTab, setSelectedTab] = useState("Courses");
//     const [editModal, setEditModal] = useState(false);
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [addCourseModal, setAddCourseModal] = useState(false);
//     const [addTrainerModal, setAddTrainerModal] = useState(false);
//     const [addStudentModal, setAddStudentModal] = useState(false);
//     const [allCourses, setAllCourses] = useState([]);
//     const [allScormCourses, setAllScormCourses] = useState([]);
//     const [allCoursesOfBatch, setAllCourseOfBatch] = useState([]);
//     const [allScormCoursesOfBatch, setAllScormCourseOfBatch] = useState([]);
//     const [allTrainers, setAllTrainers] = useState([]);
//     const [allStudents, setAllStudents] = useState([]);
//     const [allTrainerOfBatch, setAllTrainerOfBatch] = useState([]);
//     const [allStudentOfBatch, setAllStudentOfBatch] = useState([]);
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const [selectedStudent, setSelectedStudent] = useState(null);
//     const [selectedTrainer, setSelectedTrainer] = useState(null);
//     const [trainerDeleteModal, setTrainerDeleteModal] = useState(false);
//     const [studentDeleteModal, setStudentDeleteModal] = useState(false);
//     const [courseDeleteModal, setCourseDeleteModal] = useState(false);
//     const [department, setDepartment] = useState(null);
//     const [liveClasses, setLiveClasses] = useState([]);
//     const [showExamResults, setShowExamResults] = useState(false);
//     const [trainingImages, setTrainingImages] = useState([]);
//     const [organizationId, setOrganizationId] = useState(null);
    
//     const [assessmentType, setAssessmentType] = useState("none");
//     const [assessmentDebug, setAssessmentDebug] = useState("");
    
//     // State for bulk student addition
//     const [selectedStudentsForBatch, setSelectedStudentsForBatch] = useState([]);
//     const [selectAll, setSelectAll] = useState(false);
//     const [showSelectedStudents, setShowSelectedStudents] = useState(false);
//     const [recentlyAddedStudents, setRecentlyAddedStudents] = useState([]);
//     const [showSuccessMessage, setShowSuccessMessage] = useState(false);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [bulkAddInProgress, setBulkAddInProgress] = useState(false);
//     const [bulkAddProgress, setBulkAddProgress] = useState({ added: 0, total: 0, failed: 0 });
//     const [showBulkProgress, setShowBulkProgress] = useState(false);

//     // State for multiple student removal from batch
//     const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//     const [batchStudentSearchTerm, setBatchStudentSearchTerm] = useState("");
//     const [filteredBatchStudents, setFilteredBatchStudents] = useState([]);
//     const [removeAllStudentsModal, setRemoveAllStudentsModal] = useState(false);
//     const [bulkRemoveModal, setBulkRemoveModal] = useState(false);

//     const [certificateProgress, setCertificateProgress] = useState({
//         total: 0,
//         completed: 0,
//         failed: 0,
//         inProgress: false
//     });
    
//     const [calendarView, setCalendarView] = useState('month');
//     const [currentDate, setCurrentDate] = useState(new Date());
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [showEventModal, setShowEventModal] = useState(false);
//     const [calendarStats, setCalendarStats] = useState({
//         pastClassesCurrentMonth: 0,
//         pastClassesPrevMonth: 0,
//         upcomingClasses: 0,
//         totalClasses: 0
//     });

//     const [searchStudentText, setSearchStudentText] = useState("");
//     const [searchTrainerText, setSearchTrainerText] = useState("");
//     const [searchCourseText, setSearchCourseText] = useState("");
//     const [searchAadhaarText, setSearchAadhaarText] = useState("");
//     const [stateFilter, setStateFilter] = useState(null);
//     const [divisionFilter, setDivisionFilter] = useState(null);
//     const [availableStates, setAvailableStates] = useState([]);
//     const [availableDivisions, setAvailableDivisions] = useState([]);
//     const [availableAadhaarNumbers, setAvailableAadhaarNumbers] = useState([]);
//     const [aadhaarFilter, setAadhaarFilter] = useState(null);
//     const [availableContractorTokens, setAvailableContractorTokens] = useState([]);
//     const [contractorTokenFilter, setContractorTokenFilter] = useState(null);
    
//     const [availableNatureOfWork, setAvailableNatureOfWork] = useState([]);
//     const [natureOfWorkFilter, setNatureOfWorkFilter] = useState(null);

//     const [filteredAllStudents, setFilteredAllStudents] = useState([]);
//     const [filteredAllTrainers, setFilteredAllTrainers] = useState([]);
//     const [filteredAllCourses, setFilteredAllCourses] = useState([]);

//     const [studentExamResults, setStudentExamResults] = useState({});
//     const [driverMarkingResults, setDriverMarkingResults] = useState({});
//     const [loadingExamResults, setLoadingExamResults] = useState({});
//     const [fetchingExamResults, setFetchingExamResults] = useState(false);

//     const [type, setType] = useState(null);

//     // Computed variables
//     const isTataUser = type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer";
//     const isTrainerRole = type === "Trainer" || type === "Tata Trainer";

//     const breadcrumbItems = [
//         { title: "Batch", link: "#" },
//         { title: "Batch Details", link: "#" },
//     ];

//     // ==================== HELPER FUNCTIONS ====================

//     const formatDate = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     const formatDateTime = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true
//         });
//     };

//     const formatAadhaarNumber = (aadhaar) => {
//         if (!aadhaar) return '--';
//         const cleanAadhaar = String(aadhaar).replace(/\D/g, '');
//         if (cleanAadhaar.length === 12) {
//             return `${cleanAadhaar.substring(0, 4)} ${cleanAadhaar.substring(4, 8)} ${cleanAadhaar.substring(8, 12)}`;
//         }
//         return cleanAadhaar;
//     };

//     const getAssessmentName = () => {
//         switch(assessmentType) {
//             case "bronze":
//                 return "Bronze Assessment";
//             case "silver":
//                 return "Silver Assessment";
//             case "gold":
//                 return "Gold Assessment";
//             case "driver":
//                 return "Driver Assessment";
//             case "none":
//             default:
//                 return "Post-test Only Assessment";
//         }
//     };

//     const getAssessmentColor = () => {
//         switch(assessmentType) {
//             case "bronze":
//                 return "#CD7F32";
//             case "silver":
//                 return "#C0C0C0";
//             case "gold":
//                 return "#FFD700";
//             case "driver":
//                 return "#FF9800";
//             case "none":
//             default:
//                 return "#6c757d";
//         }
//     };

//     const shouldShowPracticalTab = () => {
//         return assessmentType !== "none";
//     };

//     const hasPracticalAssessment = () => {
//         return assessmentType !== "none";
//     };

//     const shouldShowSimulatorTab = () => {
//         const department = batchDetails?.department || '';
//         return department.toLowerCase().startsWith('driver');
//     };

//     const determineAssessmentType = (batchDepartment, batchName) => {
//         const isDriverDepartment = batchDepartment && batchDepartment.toLowerCase().includes("driver");
//         const isSurakshaBatch = batchName && batchName.toLowerCase().startsWith("suraksha");
        
//         if (isDriverDepartment && isSurakshaBatch) {
//             console.log("Driver department + Suraksha batch → DriverMarkingSystem");
//             return "driver";
//         }
        
//         const isTechnicalDepartment = batchDepartment && batchDepartment.toLowerCase().includes("technical");
        
//         if (isTechnicalDepartment && batchName) {
//             const lowerCaseName = batchName.toLowerCase().trim();
            
//             if (lowerCaseName.startsWith("bronze")) {
//                 console.log("Technical department + Bronze batch → Bronze Assessment");
//                 return "bronze";
//             } 
//             else if (lowerCaseName.startsWith("silver")) {
//                 console.log("Technical department + Silver batch → Silver Assessment");
//                 return "silver";
//             } 
//             else if (lowerCaseName.startsWith("gold")) {
//                 console.log("Technical department + Gold batch → Gold Assessment");
//                 return "gold";
//             }
//         }
        
//         console.log("No matching criteria → No Practical");
//         return "none";
//     };

//     const calculateCalendarStats = (classes) => {
//         const now = new Date();
//         const currentMonth = now.getMonth();
//         const currentYear = now.getFullYear();
        
//         let prevMonth = currentMonth - 1;
//         let prevYear = currentYear;
//         if (prevMonth < 0) {
//             prevMonth = 11;
//             prevYear = currentYear - 1;
//         }
        
//         const pastClasses = classes.filter(lc => new Date(lc.end) < now);
//         const pastClassesCurrentMonth = pastClasses.filter(lc => {
//             const classDate = new Date(lc.start);
//             return classDate.getMonth() === currentMonth && classDate.getFullYear() === currentYear;
//         }).length;
        
//         const pastClassesPrevMonth = pastClasses.filter(lc => {
//             const classDate = new Date(lc.start);
//             return classDate.getMonth() === prevMonth && classDate.getFullYear() === prevYear;
//         }).length;
        
//         const upcomingClasses = classes.filter(lc => new Date(lc.start) > now).length;
        
//         setCalendarStats({
//             pastClassesCurrentMonth,
//             pastClassesPrevMonth,
//             upcomingClasses,
//             totalClasses: classes.length
//         });
//     };

//     // ==================== CHECK ELIGIBILITY FUNCTIONS ====================

//     const checkStudentEligibility = (student) => {
//         const isAlreadyInCurrentBatch = allStudentOfBatch.some(s => s.id === student.id);
        
//         if (isAlreadyInCurrentBatch) {
//             return {
//                 eligible: false,
//                 reason: "Student already enrolled in this batch",
//                 isAlreadyAdded: true,
//                 code: "ALREADY_IN_CURRENT_BATCH"
//             };
//         }
        
//         return {
//             eligible: true,
//             reason: "Student can be added to batch",
//             isAlreadyAdded: false,
//             code: "ELIGIBLE"
//         };
//     };

//     const checkCertificateEligibility = (student, examResults = null) => {
//         const studentExamResult = examResults || studentExamResults[student.id];
//         const postTestScore = studentExamResult?.postTest || 0;
        
//         if (!hasPracticalAssessment()) {
//             if (loadingExamResults[student.id] && !studentExamResult) {
//                 return {
//                     eligible: false,
//                     reason: "Loading exam results...",
//                     isLoading: true
//                 };
//             }
            
//             if (postTestScore === null || postTestScore === undefined) {
//                 return {
//                     eligible: false,
//                     reason: "Post-test results not available"
//                 };
//             }
            
//             if (postTestScore < 80) {
//                 return {
//                     eligible: false,
//                     reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
//                 };
//             }
            
//             return {
//                 eligible: true,
//                 reason: "Eligible for certificate download (Post-test only)"
//             };
//         }
        
//         const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
        
//         if (loadingExamResults[student.id] && !studentExamResult) {
//             return {
//                 eligible: false,
//                 reason: "Loading exam results...",
//                 isLoading: true
//             };
//         }
        
//         if (postTestScore === null || postTestScore === undefined) {
//             return {
//                 eligible: false,
//                 reason: "Post-test results not available"
//             };
//         }
        
//         if (postTestScore < 80) {
//             return {
//                 eligible: false,
//                 reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
//             };
//         }
        
//         if (!isDriverMarkingCompleted) {
//             return {
//                 eligible: false,
//                 reason: `${getAssessmentName()} assessment not completed`
//             };
//         }
        
//         return {
//             eligible: true,
//             reason: "Eligible for certificate download"
//         };
//     };

//     const getPassedStudentsCount = (examResults = null) => {
//         if (!allStudentOfBatch.length) return 0;
        
//         return allStudentOfBatch.filter(student => {
//             const studentExamResult = examResults || studentExamResults[student.id];
//             const postTestScore = studentExamResult?.postTest || 0;
            
//             if (!hasPracticalAssessment()) {
//                 return postTestScore >= 80;
//             }
            
//             const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//             return postTestScore >= 80 && isDriverMarkingCompleted;
//         }).length;
//     };

//     // ==================== API CALL FUNCTIONS ====================

//     const fetchBatchDetails = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchSingleBatch(params.id);
//             setLoader(false);
//             if (data?.success) {
//                 setBatchDetails(data?.result[0]);
                
//                 const batchDepartment = data?.result[0]?.department;
//                 const batchName = data?.result[0]?.batchName;
                
//                 const assessment = determineAssessmentType(batchDepartment, batchName);
//                 setAssessmentType(assessment);
                
//                 setAssessmentDebug(`Department: "${batchDepartment}", Batch: "${batchName}" → Assessment: ${assessment === "none" ? "No Practical" : assessment === "driver" ? "Driver Marking System" : assessment === "bronze" ? "Bronze Assessment" : assessment === "silver" ? "Silver Assessment" : "Gold Assessment"}`);
                
//                 const updatedTrainingImages = await updateImagesUrl(data?.result[0]?.images || []);
//                 setTrainingImages(updatedTrainingImages);
//                 const lvClass = data?.result[0]?.liveClasses?.map((liveClass) => ({
//                     id: liveClass.id,
//                     title: liveClass.title,
//                     start: new Date(liveClass.classTime),
//                     end: new Date(new Date(liveClass.classTime).getTime() + 60 * 60 * 1000),
//                     description: liveClass.description,
//                     classLink: liveClass.classLink,
//                     resource: liveClass,
//                 })) || [];
//                 setLiveClasses(lvClass);
//                 calculateCalendarStats(lvClass);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateImagesUrl = async (data) => {
//         const updatedUrls = await Promise.all(
//             data?.map(async (name) => {
//                 if (name) {
//                     const type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return response.presignedUrl;
//                     } else {
//                         console.error('Error generating pre-signed URL for:', name);
//                         return name;
//                     }
//                 }
//                 return name;
//             })
//         );
//         return updatedUrls;
//     };

//     const getAllTrainers = async () => {
//         try {
//             const data = await fetchAllUsers();
//             if (data?.success) {
//                 setAllTrainers(data?.result);
//                 setFilteredAllTrainers(data?.result);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         }
//     };

//     const fetchAllStudents = async () => {
//         try {
//             const type = JSON.parse(localStorage.getItem("authUser")).userType;
//             let data;
//             if (type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer") {
//                 data = await getAllStudentsForTata();
//             } else {
//                 data = await getAllStudents();
//             }

//             if (data?.success) {
//                 setAllStudents(data?.result);
//                 setFilteredAllStudents(data?.result);
//                 extractFilters(data?.result);
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error("Something went wrong");
//         }
//     };

//     const fetchCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllCourses();
//             setLoader(false);
//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourses(updateData);
//                 setFilteredAllCourses(updateData);
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             setLoader(false);
//             toast.error(error?.response?.data?.message);
//         }
//     };

//     const fetchScormCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllScormCourse();
//             setLoader(false);
//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourses(updateData);
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             setLoader(false);
//             toast.error(error?.response?.data?.message);
//         }
//     };

//     const getCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllCourseOfBatch(params.id);

//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourseOfBatch(updateData);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log("Something went wrong");
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getScormCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllScormCourseOfBatch(params.id);

//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourseOfBatch(updateData);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getStudentOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllStudentOfBatch(params.id);
//             if (data?.success) {
//                 setAllStudentOfBatch(data?.result || []);
//                 setFilteredBatchStudents(data?.result || []);
//                 setSelectedStudentIds([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getTrainerOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllTrainerOfBatch(params.id);
//             if (data?.success) {
//                 setAllTrainerOfBatch(data?.result);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateThubmnail = async (data) => {
//         const updateData = await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnailName) {
//                     let name = d.thumbnailName;
//                     let type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return {
//                             ...d,
//                             thumbnailUrl: response.presignedUrl,
//                         };
//                     } else {
//                         console.error('Error generating pre-signed URL for', d.thumbnailName);
//                         return d;
//                     }
//                 }
//                 return d;
//             })
//         );
//         return updateData;
//     };

//     const updateScormThubmnail = async (data) => {
//         const updateData = await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnail) {
//                     let name = d.thumbnail;
//                     let type = "image";
//                     const response = await generatePresignedUrlForAccess({ name, type });

//                     if (response.success) {
//                         return {
//                             ...d,
//                             thumbnailUrl: response.presignedUrl,
//                         };
//                     } else {
//                         console.error('Error generating pre-signed URL for', d.thumbnail);
//                         return d;
//                     }
//                 }
//                 return d;
//             })
//         );
//         return updateData;
//     };

//     const extractFilters = (students) => {
//         if (!students || students.length === 0) return;

//         const states = [...new Set(students
//             .map(student => {
//                 return student.tataStudentDetailsDto?.state ||
//                     student.state ||
//                     student.studentAddressInfo?.state;
//             })
//             .filter(state => state && state.trim() !== '')
//             .sort())];

//         const divisions = [...new Set(students
//             .map(student => {
//                 return student.tataStudentDetailsDto?.division ||
//                     student.division;
//             })
//             .filter(division => division && division.trim() !== '')
//             .sort())];

//         const aadhaarNumbers = [...new Set(students
//             .map(student => {
//                 const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                  student.aadhaarNo || 
//                                  student.aadharNo;
//                 return aadhaarNo ? String(aadhaarNo).trim() : null;
//             })
//             .filter(aadhaar => aadhaar && aadhaar.trim() !== '')
//             .sort())];

//         const contractorTokens = [...new Set(students
//             .map(student => {
//                 const token = student.tataStudentDetailsDto?.contractorTokenNo || 
//                             student.contractorTokenNo;
//                 return token ? String(token).trim() : null;
//             })
//             .filter(token => token && token.trim() !== '')
//             .sort((a, b) => {
//                 return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
//             }))];
            
//         const natureOfWorkValues = [...new Set(students
//             .map(student => {
//                 const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                    student.natureOfWork;
//                 return natureOfWork ? String(natureOfWork).trim() : null;
//             })
//             .filter(natureOfWork => natureOfWork && natureOfWork.trim() !== '')
//             .sort())];

//         setAvailableStates(states.map(state => ({ value: state, label: state })));
//         setAvailableDivisions(divisions.map(division => ({ value: division, label: division })));
//         setAvailableAadhaarNumbers(aadhaarNumbers.map(aadhaar => ({ 
//             value: aadhaar, 
//             label: aadhaar,
//             display: formatAadhaarNumber(aadhaar)
//         })));
//         setAvailableContractorTokens(contractorTokens.map(token => ({ 
//             value: token, 
//             label: token,
//             display: token
//         })));
        
//         setAvailableNatureOfWork(natureOfWorkValues.map(natureOfWork => ({ 
//             value: natureOfWork, 
//             label: natureOfWork,
//             display: natureOfWork
//         })));
//     };

//     const applyStudentFilters = () => {
//         let filtered = allStudents;

//         if (searchStudentText) {
//             const searchTerm = searchStudentText.toLowerCase();

//             filtered = filtered.filter(student => {
//                 if (isTataUser) {
//                     const firstName = student.firstName?.toLowerCase() || '';
//                     const lastName = student.lastName?.toLowerCase() || '';
//                     const mobile = student.mobile || '';
//                     const depot = student.depot?.toLowerCase() || '';
//                     const state = student.state?.toLowerCase() || '';
//                     const division = student.division?.toLowerCase() || '';
//                     const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo || 
//                                      '';
//                     const contractorTokenNo = student.tataStudentDetailsDto?.contractorTokenNo || 
//                                             student.contractorTokenNo || 
//                                             '';
//                     const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                        student.natureOfWork || 
//                                        '';

//                     return (
//                         firstName.includes(searchTerm) ||
//                         lastName.includes(searchTerm) ||
//                         depot.includes(searchTerm) ||
//                         state.includes(searchTerm) ||
//                         division.includes(searchTerm) ||
//                         aadhaarNo.includes(searchTerm) ||
//                         contractorTokenNo.includes(searchTerm) ||
//                         natureOfWork.toLowerCase().includes(searchTerm) ||
//                         mobile.includes(searchStudentText)
//                     );
//                 } else {
//                     const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo || 
//                                      '';
//                     const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                        student.natureOfWork || 
//                                        '';
//                     return (
//                         (student.firstName && student.firstName.toLowerCase().includes(searchTerm)) ||
//                         (student.lastName && student.lastName.toLowerCase().includes(searchTerm)) ||
//                         (student.email && student.email.toLowerCase().includes(searchTerm)) ||
//                         (student.mobile && student.mobile.includes(searchStudentText)) ||
//                         (aadhaarNo && aadhaarNo.includes(searchTerm)) ||
//                         (natureOfWork && natureOfWork.toLowerCase().includes(searchTerm))
//                     );
//                 }
//             });
//         }

//         if (searchAadhaarText) {
//             const aadhaarSearchTerm = searchAadhaarText.toLowerCase();
//             filtered = filtered.filter(student => {
//                 const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
//                                  student.aadhaarNo || 
//                                  student.aadharNo || 
//                                  '';
//                 return aadhaarNo && aadhaarNo.toLowerCase().includes(aadhaarSearchTerm);
//             });
//         }

//         if (stateFilter) {
//             filtered = filtered.filter(student => {
//                 const studentState = student.tataStudentDetailsDto?.state ||
//                     student.state ||
//                     student.studentAddressInfo?.state;
//                 return studentState && studentState === stateFilter.value;
//             });
//         }

//         if (divisionFilter) {
//             filtered = filtered.filter(student => {
//                 const studentDivision = student.tataStudentDetailsDto?.division || 
//                                       student.division;
//                 return studentDivision && studentDivision === divisionFilter.value;
//             });
//         }

//         if (aadhaarFilter) {
//             filtered = filtered.filter(student => {
//                 const studentAadhaar = student.tataStudentDetailsDto?.aadhaarNo || 
//                                      student.aadhaarNo || 
//                                      student.aadharNo;
//                 return studentAadhaar && studentAadhaar === aadhaarFilter.value;
//             });
//         }

//         if (contractorTokenFilter) {
//             filtered = filtered.filter(student => {
//                 const studentContractorToken = student.tataStudentDetailsDto?.contractorTokenNo || 
//                                              student.contractorTokenNo;
//                 return studentContractorToken && studentContractorToken === contractorTokenFilter.value;
//             });
//         }
        
//         if (natureOfWorkFilter) {
//             filtered = filtered.filter(student => {
//                 const studentNatureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
//                                           student.natureOfWork;
//                 return studentNatureOfWork && studentNatureOfWork === natureOfWorkFilter.value;
//             });
//         }

//         setFilteredAllStudents(filtered);
//     };

//     const clearStudentFilters = () => {
//         setSearchStudentText("");
//         setSearchAadhaarText("");
//         setStateFilter(null);
//         setDivisionFilter(null);
//         setAadhaarFilter(null);
//         setContractorTokenFilter(null);
//         setNatureOfWorkFilter(null);
//         setFilteredAllStudents(allStudents);
//     };

//     const filterBatchStudents = () => {
//         if (!allStudentOfBatch || allStudentOfBatch.length === 0) {
//             setFilteredBatchStudents([]);
//             return;
//         }

//         if (!batchStudentSearchTerm || batchStudentSearchTerm.trim() === "") {
//             setFilteredBatchStudents(allStudentOfBatch);
//             return;
//         }

//         const searchTerm = batchStudentSearchTerm.toLowerCase().trim();
//         const filtered = allStudentOfBatch.filter(student => {
//             const firstName = student.firstName?.toLowerCase() || '';
//             const lastName = student.lastName?.toLowerCase() || '';
//             const fullName = `${firstName} ${lastName}`.trim();
//             const mobile = student.mobile || '';
//             const email = student.email?.toLowerCase() || '';
//             const depot = student.tataStudentDetailsDto?.depot?.toLowerCase() || '';
//             const division = student.tataStudentDetailsDto?.division?.toLowerCase() || '';
//             const state = student.tataStudentDetailsDto?.state?.toLowerCase() || '';
//             const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || student.aadhaarNo || student.aadharNo || '';
//             const contractorToken = student.tataStudentDetailsDto?.contractorTokenNo || student.contractorTokenNo || '';
//             const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || student.natureOfWork || '';

//             return fullName.includes(searchTerm) ||
//                    mobile.includes(searchTerm) ||
//                    email.includes(searchTerm) ||
//                    depot.includes(searchTerm) ||
//                    division.includes(searchTerm) ||
//                    state.includes(searchTerm) ||
//                    aadhaarNo.toLowerCase().includes(searchTerm) ||
//                    contractorToken.toLowerCase().includes(searchTerm) ||
//                    natureOfWork.toLowerCase().includes(searchTerm);
//         });

//         setFilteredBatchStudents(filtered);
//     };

//     const clearBatchStudentSearch = () => {
//         setBatchStudentSearchTerm("");
//         setFilteredBatchStudents(allStudentOfBatch);
//     };

//     // ==================== BULK ADD STUDENTS ====================

//     const handleAddMultipleStudentsToBatch = async () => {
//         if (selectedStudentsForBatch.length === 0) {
//             toast.error("Please select at least one student");
//             return;
//         }

//         const eligibleStudents = [];
//         const ineligibleStudents = [];
        
//         selectedStudentsForBatch.forEach(student => {
//             const eligibility = checkStudentEligibility(student);
//             if (eligibility.eligible) {
//                 eligibleStudents.push(student);
//             } else {
//                 ineligibleStudents.push({ student, reason: eligibility.reason });
//             }
//         });

//         if (eligibleStudents.length === 0) {
//             toast.error("No eligible students selected");
//             return;
//         }

//         if (ineligibleStudents.length > 0) {
//             toast.warning(`${ineligibleStudents.length} student(s) are already in this batch and will not be added`);
//         }

//         try {
//             setBulkAddInProgress(true);
//             setShowBulkProgress(true);
//             setBulkAddProgress({ added: 0, total: eligibleStudents.length, failed: 0 });

//             const studentIds = eligibleStudents.map(student => student.id);
            
//             const response = await addMultipleStudentsToBatch(
//                 params.id,
//                 studentIds,
//                 organizationId
//             );

//             if (response?.data?.success) {
//                 setBulkAddProgress(prev => ({ 
//                     ...prev, 
//                     added: eligibleStudents.length, 
//                     failed: 0 
//                 }));

//                 setSuccessMessage(response.data.message || `Successfully added ${eligibleStudents.length} student(s) to the batch`);
//                 setShowSuccessMessage(true);
                
//                 setRecentlyAddedStudents(prev => [...prev, ...eligibleStudents]);
                
//                 await getStudentOfBatch();
                
//                 const addedIds = new Set(eligibleStudents.map(s => s.id));
//                 setSelectedStudentsForBatch(prev => 
//                     prev.filter(student => !addedIds.has(student.id))
//                 );
                
//                 setTimeout(() => {
//                     setShowSuccessMessage(false);
//                 }, 5000);
                
//                 toast.success(response.data.message || `Successfully added ${eligibleStudents.length} student(s)!`);
//             } else {
//                 setBulkAddProgress(prev => ({ 
//                     ...prev, 
//                     failed: eligibleStudents.length 
//                 }));
//                 toast.error(response?.data?.message || "Failed to add students to batch");
//             }

//         } catch (error) {
//             console.error("Error adding multiple students:", error);
            
//             setBulkAddProgress(prev => ({ 
//                 ...prev, 
//                 failed: eligibleStudents.length 
//             }));
            
//             const errorMessage = error?.response?.data?.message || "Error adding students to batch";
//             toast.error(errorMessage);
            
//         } finally {
//             setBulkAddInProgress(false);
//             setTimeout(() => {
//                 setShowBulkProgress(false);
//                 setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//             }, 3000);
//         }
//     };

//     const handleAddStudentToBatch = async (student) => {
//         try {
//             setLoader(true);
            
//             const eligibility = checkStudentEligibility(student);
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot add student: ${eligibility.reason}`);
//                 setLoader(false);
//                 return;
//             }

//             const data = await addStudentToBatch(`${params.id}/${student.id}`);
            
//             if (data?.success) {
//                 const studentName = `${student.firstName || ''} ${student.lastName || ''}`.trim();
                
//                 setSuccessMessage(`${studentName} added to batch successfully!`);
//                 setShowSuccessMessage(true);
                
//                 setRecentlyAddedStudents(prev => [...prev, student]);
                
//                 await getStudentOfBatch();
                
//                 setSelectedStudentsForBatch(prev => 
//                     prev.filter(s => s.id !== student.id)
//                 );
                
//                 setTimeout(() => {
//                     setShowSuccessMessage(false);
//                 }, 3000);
                
//                 toast.success(`${studentName} added to batch successfully!`);
                
//             } else {
//                 toast.error(data?.message || "Failed to add student to batch");
//             }
//         } catch (error) {
//             console.error("Error adding student:", error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleStudentSelection = (event, student) => {
//         const eligibility = checkStudentEligibility(student);
        
//         if (!eligibility.eligible) {
//             toast.error(`Cannot select student: ${eligibility.reason}`);
//             return;
//         }

//         if (event.target.checked) {
//             setSelectedStudentsForBatch(prev => [...prev, student]);
//         } else {
//             setSelectedStudentsForBatch(prev => prev.filter(s => s.id !== student.id));
//         }
//     };
    
//     const handleSelectAllStudents = (event) => {
//         if (event.target.checked) {
//             const eligibleStudents = filteredAllStudents.filter(student => {
//                 const eligibility = checkStudentEligibility(student);
//                 return eligibility.eligible;
//             });
            
//             setSelectedStudentsForBatch(prev => {
//                 const currentIds = new Set(prev.map(s => s.id));
//                 const newStudents = eligibleStudents.filter(s => !currentIds.has(s.id));
//                 return [...prev, ...newStudents];
//             });
//         } else {
//             const filteredStudentIds = new Set(filteredAllStudents.map(s => s.id));
//             setSelectedStudentsForBatch(prev => 
//                 prev.filter(student => !filteredStudentIds.has(student.id))
//             );
//         }
//     };

//     const handleRemoveSelectedStudent = (studentId) => {
//         setSelectedStudentsForBatch(prev => prev.filter(student => student.id !== studentId));
//     };

//     const handleClearSelectedStudents = () => {
//         setSelectedStudentsForBatch([]);
//     };

//     const handleModalClose = () => {
//         setAddStudentModal(false);
//         setShowSuccessMessage(false);
//         setRecentlyAddedStudents([]);
//         setShowBulkProgress(false);
//         setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//         setSelectedStudentsForBatch([]);
//     };

//     // ==================== EXAM RESULT FUNCTIONS ====================

//     const fetchStudentExamResult = async (studentId) => {
//         if (!studentId || !params.id) return null;
        
//         try {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: true }));
            
//             const examResponse = await getResult(`${params.id}/${studentId}`);
            
//             if (examResponse?.success) {
//                 let preTestScore = null;
//                 let postTestScore = null;
                
//                 if (examResponse.result) {
//                     const preTest = examResponse.result.preTest;
//                     const postTest = examResponse.result.postTest;
                    
//                     if (preTest !== undefined && preTest !== null) {
//                         preTestScore = typeof preTest === 'number' ? preTest : 
//                                      (preTest.percentage || preTest.score || 0);
//                     }
                    
//                     if (postTest !== undefined && postTest !== null) {
//                         postTestScore = typeof postTest === 'number' ? postTest : 
//                                       (postTest.percentage || postTest.score || 0);
//                     }
//                 }
                
//                 const result = {
//                     preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                     postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                     lastUpdated: new Date().toISOString()
//                 };
                
//                 setStudentExamResults(prev => ({
//                     ...prev,
//                     [studentId]: result
//                 }));
                
//                 return result;
//             } else {
//                 return null;
//             }
//         } catch (error) {
//             console.error("Error fetching exam results for student", studentId, ":", error);
//             return null;
//         } finally {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: false }));
//         }
//     };

//     const fetchAndDisplayExamResults = async (student) => {
//         setSelectedStudent(student);
//         const results = await fetchStudentExamResult(student.id);
//         if (results) {
//             setShowExamResults(true);
//         } else {
//             toast.error("Could not fetch exam results for this student");
//         }
//     };

//     const fetchExamResultsForAllStudents = async () => {
//         try {
//             setFetchingExamResults(true);
//             const results = {};
            
//             for (const student of allStudentOfBatch) {
//                 try {
//                     const examResponse = await getResult(`${params.id}/${student.id}`);
                    
//                     if (examResponse?.success) {
//                         let preTestScore = null;
//                         let postTestScore = null;
                        
//                         if (examResponse.result) {
//                             const preTest = examResponse.result.preTest;
//                             const postTest = examResponse.result.postTest;
                            
//                             if (preTest !== undefined && preTest !== null) {
//                                 preTestScore = typeof preTest === 'number' ? preTest : 
//                                              (preTest.percentage || preTest.score || 0);
//                             }
                            
//                             if (postTest !== undefined && postTest !== null) {
//                                 postTestScore = typeof postTest === 'number' ? postTest : 
//                                               (postTest.percentage || postTest.score || 0);
//                             }
//                         }
                        
//                         results[student.id] = {
//                             preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                             postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                             lastUpdated: new Date().toISOString()
//                         };
//                     }
                    
//                     if (hasPracticalAssessment()) {
//                         const driverMarkingResult = driverMarkingResults[student.id];
//                         if (!driverMarkingResult) {
//                             await fetchDriverMarkingResult(student.id);
//                         }
//                     }
                    
//                 } catch (error) {
//                     console.error(`Error fetching exam results for student ${student.id}:`, error);
//                     continue;
//                 }
//             }
            
//             setStudentExamResults(prev => ({ ...prev, ...results }));
//             return results;
            
//         } catch (error) {
//             console.error("Error fetching all exam results:", error);
//             throw error;
//         } finally {
//             setFetchingExamResults(false);
//         }
//     };

//     const fetchDriverMarkingResult = async (studentId) => {
//         try {
//             const student = allStudentOfBatch.find(s => s.id === studentId);
//             if (student) {
//                 const result = {
//                     isCompleted: student.driverMarkingCompleted || true,
//                     score: student.driverMarkingScore || student.practicalScore || 0,
//                     lastUpdated: new Date().toISOString()
//                 };
                
//                 setDriverMarkingResults(prev => ({
//                     ...prev,
//                     [studentId]: result
//                 }));
                
//                 return result;
//             }
//             return null;
//         } catch (error) {
//             console.error("Error fetching driver marking for student", studentId, ":", error);
//             return null;
//         }
//     };

//     const updateDriverMarkingStatus = (studentId) => {
//         setDriverMarkingResults(prev => ({
//             ...prev,
//             [studentId]: {
//                 isCompleted: true,
//                 score: 85,
//                 lastUpdated: new Date().toISOString()
//             }
//         }));
        
//         setAllStudentOfBatch(prev => 
//             prev.map(student => 
//                 student.id === studentId 
//                     ? { ...student, driverMarkingCompleted: true }
//                     : student
//             )
//         );
//     };

//     // ==================== CERTIFICATE FUNCTIONS ====================

//     const generateCertificateForStudent = async (student) => {
//         try {
//             const requestData = {
//                 trainingType: "DDT_OTHER",
//                 studentName: student.firstName + " " + student.lastName,
//                 courseName: batchDetails?.batchName || "Driver Training",
//                 dlNo: student.tataStudentDetailsDto?.driverDlNo || "",
//                 aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || "",
//                 depot: student.tataStudentDetailsDto?.depot || "",
//                 project: student.tataStudentDetailsDto?.project || "",
//                 city: student.state || student.city || "",
//                 fromDate: batchDetails?.startDate || "",
//                 toDate: batchDetails?.endDate || "",
//                 validityDate: batchDetails?.validityDate || "",
//                 trainerName: allTrainerOfBatch[0]?.name || "",
//                 authorizedSignatory: "DGM-Skill Development",
//                 batchId: params.id,
//                 studentId: student.id
//             };

//             const response = await axios.post(
//                 url + 'api/certificate/generate',
//                 requestData,
//                 {
//                     responseType: 'blob',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                 }
//             );

//             return response.data;
//         } catch (error) {
//             console.error('Error generating certificate for student', student.id, ':', error);
//             throw error;
//         }
//     };

//     const downloadIndividualCertificate = async (student) => {
//         setLoader(true);
//         try {
//             const certificateBlob = await generateCertificateForStudent(student);
            
//             const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
            
//             const blob = new Blob([certificateBlob], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = fileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//             toast.success('Certificate downloaded successfully!');

//         } catch (error) {
//             console.error('Error generating certificate:', error);
//             toast.error('Failed to generate certificate.');
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDownloadCertificate = async (student) => {
//         if (!studentExamResults[student.id]) {
//             setLoader(true);
//             try {
//                 const results = await fetchStudentExamResult(student.id);
                
//                 if (!results) {
//                     toast.error("Could not fetch exam results for this student");
//                     setLoader(false);
//                     return;
//                 }
                
//                 const eligibility = checkCertificateEligibility(student, results);
                
//                 if (!eligibility.eligible) {
//                     toast.error(`Cannot download certificate: ${eligibility.reason}`);
//                     setLoader(false);
//                     return;
//                 }
                
//                 await downloadIndividualCertificate(student);
                
//             } catch (error) {
//                 console.error('Error fetching exam results:', error);
//                 toast.error('Failed to fetch exam results. Please try again.');
//                 setLoader(false);
//                 return;
//             }
//         } else {
//             const eligibility = checkCertificateEligibility(student);
            
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot download certificate: ${eligibility.reason}`);
//                 return;
//             }
            
//             await downloadIndividualCertificate(student);
//         }
//     };

//     const generateExcelReport = (progressInfo) => {
//         try {
//             const wb = XLSX.utils.book_new();
            
//             const summaryData = [
//                 ["BATCH CERTIFICATE GENERATION REPORT"],
//                 ["Generated Date:", progressInfo.generatedDate],
//                 ["Batch Name:", progressInfo.batchName],
//                 ["Batch ID:", progressInfo.batchId],
//                 ["Assessment Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
//                 ["Eligibility Criteria:", progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"],
//                 [],
//                 ["SUMMARY STATISTICS"],
//                 ["Total Students in Batch:", progressInfo.totalStudents],
//                 ["Passed Students:", progressInfo.passedStudents],
//                 ["Failed Students:", progressInfo.failedStudents],
//                 ["Certificates Generated:", progressInfo.generatedCertificates],
//                 ["Certificates Failed:", progressInfo.failedCertificates],
//                 [],
//                 ["CERTIFICATE ELIGIBILITY CRITERIA"],
//                 ["1. Post-test Score must be ≥ 80%", ""],
//                 ...(progressInfo.hasPractical ? [[`2. ${getAssessmentName()} assessment must be completed`, ""], ["3. Both conditions must be met for certificate generation", ""]] : [["2. Only post-test score ≥80% is required", ""]]),
//                 [],
//                 ["Assessment Information"],
//                 ["Batch Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
//                 ["Practical Required:", progressInfo.hasPractical ? "Yes" : "No"]
//             ];
            
//             const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//             wsSummary["!cols"] = [
//                 { wch: 30 },
//                 { wch: 50 }
//             ];
            
//             const studentHeaders = [
//                 ["STUDENT CERTIFICATE GENERATION DETAILS"],
//                 [],
//                 ["S.No", "Student ID", "Full Name", "Contractor Token", "Aadhaar No", "Nature of Work",
//                  "Mobile", "Post-Test Score", "Practical Completed", "Eligibility Status", 
//                  "Certificate Status", "Remarks"]
//             ];
            
//             const studentRows = progressInfo.students.map((student, index) => [
//                 index + 1,
//                 student.id,
//                 student.name,
//                 student.contractorToken || "N/A",
//                 student.aadhaarNo || "N/A",
//                 student.natureOfWork || "N/A",
//                 student.mobile || "N/A",
//                 student.postTestScore !== null ? `${student.postTestScore}%` : "N/A",
//                 student.practicalCompleted ? "Yes" : (progressInfo.hasPractical ? (student.postTestScore >= 80 ? "Pending" : "N/A") : "N/A"),
//                 student.eligible ? "Eligible" : "Not Eligible",
//                 student.certificateStatus,
//                 student.remarks || student.error || "N/A"
//             ]);
            
//             const studentData = [...studentHeaders, ...studentRows];
//             const wsStudents = XLSX.utils.aoa_to_sheet(studentData);
//             wsStudents["!cols"] = [
//                 { wch: 5 },
//                 { wch: 10 },
//                 { wch: 25 },
//                 { wch: 20 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 15 },
//                 { wch: 20 },
//                 { wch: 30 }
//             ];
            
//             const failedStudents = progressInfo.students.filter(s => s.certificateStatus === "Failed");
//             if (failedStudents.length > 0) {
//                 const failedHeaders = [
//                     ["FAILED CERTIFICATE GENERATIONS"],
//                     [],
//                     ["S.No", "Student ID", "Full Name", "Contractor Token", "Error Reason"]
//                 ];
                
//                 const failedRows = failedStudents.map((student, index) => [
//                     index + 1,
//                     student.id,
//                     student.name,
//                     student.contractorToken || "N/A",
//                     student.error || "Unknown error"
//                 ]);
                
//                 const failedData = [...failedHeaders, ...failedRows];
//                 const wsFailed = XLSX.utils.aoa_to_sheet(failedData);
//                 wsFailed["!cols"] = [
//                     { wch: 5 },
//                     { wch: 10 },
//                     { wch: 25 },
//                     { wch: 20 },
//                     { wch: 50 }
//                 ];
//                 XLSX.utils.book_append_sheet(wb, wsFailed, "Failed Generations");
//             }
            
//             XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
//             XLSX.utils.book_append_sheet(wb, wsStudents, "Student Details");
            
//             const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//             const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
//             return excelBlob;
//         } catch (error) {
//             console.error('Error generating Excel report:', error);
//             throw error;
//         }
//     };

//     const generateAllCertificatesAsZip = async () => {
//         try {
//             setBatchZipLoading(true);
            
//             toast.info("Fetching exam results for all students...");
//             const allExamResults = await fetchExamResultsForAllStudents();
            
//             const hasPractical = hasPracticalAssessment();
            
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0,
//                 failedStudents: 0,
//                 generatedCertificates: 0,
//                 failedCertificates: 0,
//                 hasPractical: hasPractical,
//                 students: []
//             };

//             allStudentOfBatch.forEach((student, index) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 let isPracticalCompleted = true;
//                 if (hasPractical) {
//                     isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 }
                
//                 const isEligible = hasPractical 
//                     ? (postTestScore >= 80 && isPracticalCompleted)
//                     : (postTestScore >= 80);
                
//                 const depot = student.tataStudentDetailsDto?.depot || student.depot || '';
//                 const division = student.tataStudentDetailsDto?.division || student.division || '';
//                 const state = student.tataStudentDetailsDto?.state || student.state || '';
//                 const depotDivision = depot && division ? `${depot} / ${division}` : (depot || division || 'N/A');
                
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     contractorToken: student.tataStudentDetailsDto?.contractorTokenNo || null,
//                     aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || null,
//                     natureOfWork: student.tataStudentDetailsDto?.natureOfWork || null,
//                     depotDivision: depotDivision,
//                     state: state || 'N/A',
//                     mobile: student.mobile || null,
//                     postTestScore: postTestScore,
//                     practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible,
//                     certificateStatus: "Pending",
//                     remarks: "Not processed yet"
//                 });
                
//                 if (isEligible) {
//                     progressInfo.passedStudents++;
//                 } else {
//                     progressInfo.failedStudents++;
//                 }
//             });

//             const eligibleStudents = allStudentOfBatch.filter(student => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 if (hasPractical) {
//                     const isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                     return postTestScore >= 80 && isPracticalCompleted;
//                 }
//                 return postTestScore >= 80;
//             });

//             if (eligibleStudents.length === 0) {
//                 toast.warning("No eligible students found in this batch. Generating report only.");
                
//                 progressInfo.students = progressInfo.students.map(student => ({
//                     ...student,
//                     certificateStatus: "Failed",
//                     remarks: student.eligible ? "No certificates to generate (0 eligible)" : "Not eligible for certificate"
//                 }));
                
//                 const excelBlob = generateExcelReport(progressInfo);
                
//                 const zip = new JSZip();
//                 zip.file(`Certificate_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`, excelBlob);
                
//                 const zipBlob = await zip.generateAsync({ type: "blob" });
//                 const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificate_Report_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
//                 saveAs(zipBlob, zipFileName);
                
//                 toast.info("Excel report generated and downloaded");
//                 setBatchZipLoading(false);
//                 return;
//             }

//             const confirmed = window.confirm(
//                 `Batch: ${batchDetails?.batchName || "Unknown Batch"}\n` +
//                 `Assessment Type: ${hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
//                 `Eligibility Criteria: ${hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
//                 `Total Students: ${allStudentOfBatch.length}\n` +
//                 `Eligible Students: ${eligibleStudents.length}\n` +
//                 `Failed Students: ${allStudentOfBatch.length - eligibleStudents.length}\n\n` +
//                 `Generate certificates for ${eligibleStudents.length} eligible student(s)?`
//             );
            
//             if (!confirmed) {
//                 setBatchZipLoading(false);
//                 return;
//             }

//             setCertificateProgress({
//                 total: eligibleStudents.length,
//                 completed: 0,
//                 failed: 0,
//                 inProgress: true
//             });

//             const zip = new JSZip();
//             const certificateFolder = zip.folder("Certificates");
//             const reportFolder = zip.folder("Reports");

//             for (let i = 0; i < eligibleStudents.length; i++) {
//                 const student = eligibleStudents[i];
//                 const studentIndex = progressInfo.students.findIndex(s => s.id === student.id);
                
//                 try {
//                     const certificateBlob = await generateCertificateForStudent(student);
                    
//                     const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
                    
//                     certificateFolder.file(fileName, certificateBlob);
                    
//                     progressInfo.students[studentIndex] = {
//                         ...progressInfo.students[studentIndex],
//                         certificateStatus: "Generated",
//                         remarks: "Certificate successfully generated",
//                         fileName: fileName
//                     };
                    
//                     progressInfo.generatedCertificates++;
                    
//                     setCertificateProgress(prev => ({
//                         ...prev,
//                         completed: prev.completed + 1
//                     }));
                    
//                     if (i < eligibleStudents.length - 1) {
//                         await new Promise(resolve => setTimeout(resolve, 300));
//                     }
                    
//                 } catch (error) {
//                     console.error(`Failed to generate certificate for student ${student.id}:`, error);
                    
//                     progressInfo.students[studentIndex] = {
//                         ...progressInfo.students[studentIndex],
//                         certificateStatus: "Failed",
//                         error: error.message || "Unknown error",
//                         remarks: `Failed: ${error.message || "Unknown error"}`
//                     };
                    
//                     progressInfo.failedCertificates++;
                    
//                     setCertificateProgress(prev => ({
//                         ...prev,
//                         failed: prev.failed + 1
//                     }));
//                 }
//             }

//             progressInfo.students.forEach((student, index) => {
//                 if (student.certificateStatus === "Pending") {
//                     progressInfo.students[index] = {
//                         ...student,
//                         certificateStatus: "Not Generated",
//                         remarks: student.eligible ? "Not processed" : "Not eligible for certificate"
//                     };
//                 }
//             });

//             const excelBlob = generateExcelReport(progressInfo);
//             const excelFileName = `Certificate_Generation_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`;
//             reportFolder.file(excelFileName, excelBlob);

//             const summaryText = `CERTIFICATE GENERATION SUMMARY\n` +
//                                `============================\n` +
//                                `Batch: ${progressInfo.batchName}\n` +
//                                `Batch ID: ${progressInfo.batchId}\n` +
//                                `Generated: ${progressInfo.generatedDate}\n` +
//                                `Assessment Type: ${progressInfo.hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
//                                `Eligibility Criteria: ${progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
//                                `Total Students: ${progressInfo.totalStudents}\n` +
//                                `Eligible Students: ${progressInfo.passedStudents}\n` +
//                                `Failed Students: ${progressInfo.failedStudents}\n` +
//                                `Certificates Generated: ${progressInfo.generatedCertificates}\n` +
//                                `Certificates Failed: ${progressInfo.failedCertificates}\n` +
//                                `\nSee Excel report for detailed student information.`;
            
//             reportFolder.file("SUMMARY.txt", summaryText);

//             toast.info("Creating ZIP file with certificates and reports...");
//             const zipBlob = await zip.generateAsync({ type: "blob" });
            
//             const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificates_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
//             saveAs(zipBlob, zipFileName);

//             const successful = certificateProgress.completed;
//             const failed = certificateProgress.failed;
            
//             if (failed === 0) {
//                 toast.success(`Successfully generated ${successful} certificate(s)! Check Excel report for all student statuses.`);
//             } else {
//                 toast.warning(`Generated ${successful} certificate(s), ${failed} failed. Check Excel report for details.`);
//             }

//         } catch (error) {
//             console.error('Error generating zip file:', error);
            
//             if (error.message.includes("Failed to fetch")) {
//                 toast.error('Network error: Could not fetch exam results. Please check your connection and try again.');
//             } else {
//                 toast.error('Failed to generate certificates zip file. Please try again.');
//             }
//         } finally {
//             setBatchZipLoading(false);
//             setCertificateProgress({
//                 total: 0,
//                 completed: 0,
//                 failed: 0,
//                 inProgress: false
//             });
//         }
//     };

//     const generateCertificatesForPassedStudents = async () => {
//         if (allStudentOfBatch.length === 0) {
//             toast.error("No students found in this batch");
//             return;
//         }
        
//         await generateAllCertificatesAsZip();
//     };

//     const generateExcelReportOnly = async () => {
//         try {
//             setLoader(true);
//             toast.info("Generating student status report...");
            
//             const allExamResults = await fetchExamResultsForAllStudents();
//             const hasPractical = hasPracticalAssessment();
            
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0,
//                 failedStudents: 0,
//                 generatedCertificates: 0,
//                 failedCertificates: 0,
//                 hasPractical: hasPractical,
//                 students: []
//             };

//             allStudentOfBatch.forEach((student, index) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
                
//                 let isPracticalCompleted = true;
//                 if (hasPractical) {
//                     isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 }
                
//                 const isEligible = hasPractical 
//                     ? (postTestScore >= 80 && isPracticalCompleted)
//                     : (postTestScore >= 80);
                
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     contractorToken: student.tataStudentDetailsDto?.contractorTokenNo || null,
//                     aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || null,
//                     natureOfWork: student.tataStudentDetailsDto?.natureOfWork || null,
//                     mobile: student.mobile || null,
//                     postTestScore: postTestScore,
//                     practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible,
//                     certificateStatus: isEligible ? "Eligible (Not Generated)" : "Not Eligible",
//                     remarks: isEligible 
//                         ? (hasPractical ? "Meets criteria (Post-test ≥80% + Practical)" : "Meets criteria (Post-test ≥80%)") 
//                         : (hasPractical 
//                             ? (postTestScore >= 80 ? "Missing practical assessment" : "Post-test score below 80%")
//                             : "Post-test score below 80%")
//                 });
                
//                 if (isEligible) {
//                     progressInfo.passedStudents++;
//                 } else {
//                     progressInfo.failedStudents++;
//                 }
//             });

//             const excelBlob = generateExcelReport(progressInfo);
            
//             const excelFileName = `Student_Certificate_Status_${batchDetails?.batchName || "Batch"}_${moment().format('YYYY-MM-DD')}.xlsx`;
//             const url = window.URL.createObjectURL(excelBlob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = excelFileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//             toast.success(`Excel report generated for ${allStudentOfBatch.length} students!`);
            
//         } catch (error) {
//             console.error('Error generating Excel report:', error);
//             toast.error('Failed to generate Excel report');
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ==================== OTHER HANDLERS ====================

//     const handleUpdate = async () => {
//         try {
//             setLoader(true);
//             setBatchDetails({ ...batchDetails, department: department?.name });
//             const data = await updateBatch(batchDetails);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setEditModal(false);
//                 fetchBatchDetails();
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDeleteBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await deleteBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 navigate("/all-batches");
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setDeleteModal(false);
//         }
//     };

//     const handleAddCourseToBatch = async (id) => {
//         try {
//             setLoader(true);
//             const data = await addCourseToBatch(params.id + "/" + id);

//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setAddCourseModal(false);
//             } else {
//                 toast.error(data?.message);
//             }

//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveCourseFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeCourseFromBatch(params.id + "/" + selectedCourse?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setCourseDeleteModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleAddTrainerToBatch = async (d) => {
//         try {
//             setLoader(true);
//             const data = await addTrainerToBatch(params.id + "/" + d.id);

//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setAddTrainerModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             console.log("error", error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveTrainerFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeTrainerFromBatch(params.id + "/" + selectedTrainer?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setTrainerDeleteModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };
    
//     const handleRemoveStudentFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeStudentFromBatch(params.id + "/" + selectedStudent?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getStudentOfBatch();
//                 setStudentDeleteModal(false);
//                 setSelectedStudent(null);
//                 setSelectedStudentIds(prev => prev.filter(id => id !== selectedStudent?.id));
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleBulkRemoveStudents = () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             return;
//         }
//         setBulkRemoveModal(true);
//     };

//     const confirmBulkRemoveStudents = async () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             setBulkRemoveModal(false);
//             return;
//         }

//         const selectedStudents = allStudentOfBatch.filter(student => 
//             selectedStudentIds.includes(student.id)
//         );

//         try {
//             setLoader(true);
//             setBulkRemoveModal(false);
            
//             const results = [];
//             const removedStudents = [];
//             const failedRemovals = [];

//             for (const student of selectedStudents) {
//                 try {
//                     const data = await removeStudentFromBatch(`${params.id}/${student.id}`);
//                     results.push({
//                         student,
//                         success: data?.success || false,
//                         message: data?.message || "Unknown error"
//                     });
                    
//                     if (data?.success) {
//                         removedStudents.push(student);
//                     } else {
//                         failedRemovals.push({ student, message: data?.message });
//                     }
                    
//                     await new Promise(resolve => setTimeout(resolve, 100));
//                 } catch (error) {
//                     results.push({
//                         student,
//                         success: false,
//                         message: error?.response?.data?.message || "Network error"
//                     });
//                     failedRemovals.push({ 
//                         student, 
//                         message: error?.response?.data?.message || "Network error" 
//                     });
//                 }
//             }

//             const successful = results.filter(r => r.success);
//             const failed = results.filter(r => !r.success);
            
//             if (successful.length > 0) {
//                 toast.success(`Successfully removed ${successful.length} student(s) from the batch`);
//             }
            
//             if (failed.length > 0) {
//                 toast.error(`${failed.length} student(s) could not be removed`);
//                 failed.forEach(f => {
//                     console.error(`Failed to remove student ${f.student.firstName} ${f.student.lastName}: ${f.message}`);
//                 });
//             }
            
//             await getStudentOfBatch();
            
//             setSelectedStudentIds([]);
//             setBatchStudentSearchTerm("");
            
//             if (failed.length > 0 && successful.length === 0) {
//                 toast.error("Failed to remove any students. Please check console for details.");
//             }
            
//         } catch (error) {
//             console.error("Error removing multiple students:", error);
//             toast.error("Error removing students from batch");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleSelectionChange = (selectionModel) => {
//         console.log("Selection changed:", selectionModel);
//         setSelectedStudentIds(selectionModel);
//     };

//     const handleRemoveAllTrainer = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllTrainersFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllTrainerOfBatch([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveAllStudents = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllStudentsFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllStudentOfBatch([]);
//                 setFilteredBatchStudents([]);
//                 setSelectedStudentIds([]);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setRemoveAllStudentsModal(false);
//         }
//     };

//     const handleDownloadStudentDetailsClick = async () => {
//         try {
//             setLoader(true);
//             const response = await axios.get(DOWNLOAD_BATCH_STUDENT_FILE + params.id, {
//                 responseType: 'blob'
//             });

//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'all_student_batches.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleEventClick = (event) => {
//         setSelectedEvent(event.resource);
//         setShowEventModal(true);
//     };

//     const openLiveClassLink = (link) => {
//         if (!link) {
//             toast.error("No class link available");
//             return;
//         }
        
//         let formattedLink = link;
//         if (!formattedLink.startsWith('http://') && !formattedLink.startsWith('https://')) {
//             formattedLink = 'https://' + formattedLink;
//         }
        
//         window.open(formattedLink, '_blank', 'noopener,noreferrer');
//     };

//     const getAssessmentComponent = () => {
//         console.log("Rendering assessment component for type:", assessmentType);
        
//         switch(assessmentType) {
//             case "bronze":
//                 return (
//                     <BronzeAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "silver":
//                 return (
//                     <SilverAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "gold":
//                 return (
//                     <GoldAssessment 
//                         students={allStudentOfBatch} 
//                         batchId={params.id}
//                         batchDetails={batchDetails}
//                     />
//                 );
//             case "driver":
//                 return (
//                     <DriverMarkingSystem 
//                         students={allStudentOfBatch} 
//                         onDriverMarkingComplete={updateDriverMarkingStatus}
//                     />
//                 );
//             case "none":
//             default:
//                 return (
//                     <div className="alert alert-warning text-center">
//                         <h4 className="mb-2">No Practical Assessment Available</h4>
//                         <p className="mb-0">
//                             This batch does not have any practical assessment section configured.
//                             Certificate eligibility is based only on post-test score (≥80%).
//                         </p>
//                     </div>
//                 );
//         }
//     };

//     // ==================== COLUMN DEFINITIONS ====================

//     const columnsSelectedStudents = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 120,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 120,
//         },
//         {
//             field: 'aadhaarNo',
//             headerName: 'Aadhaar No',
//             width: 140,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.aadhaarNo || 
//                        row.aadhaarNo || 
//                        row.aadharNo || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const aadhaar = params.row.tataStudentDetailsDto?.aadhaarNo || 
//                                params.row.aadhaarNo || 
//                                params.row.aadharNo;
//                 if (!aadhaar) return <span style={{ color: '#999' }}>--</span>;
//                 return formatAadhaarNumber(aadhaar);
//             }
//         },
//         {
//             field: 'contractorTokenNo',
//             headerName: 'Contractor Token',
//             width: 120,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.contractorTokenNo || 
//                        row.contractorTokenNo || 
//                        '--';
//             },
//         },
//         {
//             field: 'natureOfWork',
//             headerName: 'Nature of Work',
//             width: 150,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.natureOfWork || 
//                        row.natureOfWork || 
//                        '--';
//             },
//         },
//         {
//             field: 'remove',
//             headerName: 'Remove',
//             width: 100,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="danger"
//                     size="small"
//                     onClick={() => handleRemoveSelectedStudent(params.row.id)}
//                     startIcon={<PersonOffIcon />}
//                 >
//                     Remove
//                 </Button>
//             ),
//         },
//     ];

//     const columnsStudentModal = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 160,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             type: 'text',
//             width: 200,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 130,
//         },
//         {
//             field: 'contractorTokenNo',
//             headerName: 'Contractor Token',
//             type: 'text',
//             width: 130,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.contractorTokenNo || 
//                        row.contractorTokenNo || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const token = params.row.tataStudentDetailsDto?.contractorTokenNo || 
//                              params.row.contractorTokenNo;
//                 if (!token) return <span style={{ color: '#999' }}>--</span>;
//                 return (
//                     <span style={{ display: 'flex', alignItems: 'center' }}>
//                         <BadgeIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#ff9800' }} />
//                         {token}
//                     </span>
//                 );
//             }
//         },
//         {
//             field: 'natureOfWork',
//             headerName: 'Nature of Work',
//             type: 'text',
//             width: 150,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.natureOfWork || 
//                        row.natureOfWork || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const natureOfWork = params.row.tataStudentDetailsDto?.natureOfWork || 
//                                      params.row.natureOfWork || 
//                                      '--';
//                 return (
//                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                         <WorkIcon style={{ fontSize: '1rem', marginRight: '5px', color: '#667eea' }} />
//                         <span>{natureOfWork}</span>
//                     </div>
//                 );
//             }
//         },
//         {
//             field: 'aadhaarNo',
//             headerName: 'Aadhaar No',
//             type: 'text',
//             width: 150,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.aadhaarNo || 
//                        row.aadhaarNo || 
//                        row.aadharNo || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const aadhaar = params.row.tataStudentDetailsDto?.aadhaarNo || 
//                                params.row.aadhaarNo || 
//                                params.row.aadharNo;
//                 if (!aadhaar) return <span style={{ color: '#999' }}>--</span>;
//                 return (
//                     <span style={{ display: 'flex', alignItems: 'center' }}>
//                         <FingerprintIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
//                         {formatAadhaarNumber(aadhaar)}
//                     </span>
//                 );
//             }
//         },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 150,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
                
//                 if (eligibility.isAlreadyAdded) {
//                     return (
//                         <Button
//                             variant="contained"
//                             color="secondary"
//                             disabled
//                             title="Already added to this batch"
//                             size="small"
//                         >
//                             <PersonOffIcon style={{ marginRight: '4px' }} />
//                             In Batch
//                         </Button>
//                     );
//                 }

//                 return (
//                     <Tooltip title="Add student to this batch" arrow>
//                         <span>
//                             <Button
//                                 variant="contained"
//                                 color="success"
//                                 onClick={() => handleAddStudentToBatch(params.row)}
//                                 disabled={loader}
//                                 size="small"
//                                 startIcon={<PersonAddIcon />}
//                             >
//                                 {loader ? 'Adding...' : 'Add to Batch'}
//                             </Button>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         },
//     ];

//     const columnsStudentModalForTata = [
//         {
//             field: 'select',
//             headerName: (
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                     <Checkbox
//                         checked={selectAll}
//                         onChange={handleSelectAllStudents}
//                         disabled={filteredAllStudents.length === 0 || loader}
//                         indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
//                     />
//                     <span style={{ fontSize: '0.85rem' }}>Select All</span>
//                 </div>
//             ),
//             width: 100,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
//                 const isSelected = selectedStudentsForBatch.some(student => student.id === params.row.id);
                
//                 return (
//                     <Checkbox
//                         checked={isSelected}
//                         onChange={(e) => handleStudentSelection(e, params.row)}
//                         disabled={eligibility.isAlreadyAdded}
//                         title={eligibility.isAlreadyAdded ? "Already in this batch" : "Select to add to batch"}
//                         color="primary"
//                     />
//                 );
//             },
//         },
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full name',
//             sortable: false,
//             width: 120,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'contractorTokenNo',
//             headerName: 'Contractor Token',
//             type: 'text',
//             width: 120,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.contractorTokenNo || 
//                        row.contractorTokenNo || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const token = params.row.tataStudentDetailsDto?.contractorTokenNo || 
//                              params.row.contractorTokenNo;
//                 if (!token) return <span style={{ color: '#999' }}>--</span>;
//                 return (
//                     <span style={{ display: 'flex', alignItems: 'center' }}>
//                         <BadgeIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#ff9800' }} />
//                         {token}
//                     </span>
//                 );
//             }
//         },
//         {
//             field: 'natureOfWork',
//             headerName: 'Nature of Work',
//             type: 'text',
//             width: 150,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.natureOfWork || 
//                        row.natureOfWork || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const natureOfWork = params.row.tataStudentDetailsDto?.natureOfWork || 
//                                      params.row.natureOfWork || 
//                                      '--';
//                 return (
//                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                         <WorkIcon style={{ fontSize: '1rem', marginRight: '5px', color: '#667eea' }} />
//                         <span>{natureOfWork}</span>
//                     </div>
//                 );
//             }
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             type: 'number',
//             width: 100,
//         },
//         {
//             field: 'aadhaarNo',
//             headerName: 'Aadhaar No',
//             type: 'text',
//             width: 140,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.aadhaarNo || 
//                        row.aadhaarNo || 
//                        row.aadharNo || 
//                        '--';
//             },
//             renderCell: (params) => {
//                 const aadhaar = params.row.tataStudentDetailsDto?.aadhaarNo || 
//                                params.row.aadhaarNo || 
//                                params.row.aadharNo;
//                 if (!aadhaar) return <span style={{ color: '#999' }}>--</span>;
//                 return (
//                     <span style={{ display: 'flex', alignItems: 'center' }}>
//                         <FingerprintIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
//                         {formatAadhaarNumber(aadhaar)}
//                     </span>
//                 );
//             }
//         },
//         {
//             field: 'division',
//             headerName: 'Division',
//             type: 'text',
//             width: 100,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.division || 
//                        row.division || 
//                        '--';
//             },
//         },
//         {
//             field: 'state',
//             headerName: 'State',
//             type: 'text',
//             width: 100,
//             valueGetter: (value, row) => {
//                 return row.tataStudentDetailsDto?.state || 
//                        row.state || 
//                        '--';
//             },
//         },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 150,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
                
//                 if (eligibility.isAlreadyAdded) {
//                     return (
//                         <Button
//                             variant="contained"
//                             color="secondary"
//                             disabled
//                             title="Already added to this batch"
//                             size="small"
//                         >
//                             <PersonOffIcon style={{ marginRight: '4px' }} />
//                             In Batch
//                         </Button>
//                     );
//                 }

//                 return (
//                     <Tooltip title="Add student to this batch" arrow>
//                         <span>
//                             <Button
//                                 variant="contained"
//                                 color="success"
//                                 onClick={() => handleAddStudentToBatch(params.row)}
//                                 disabled={loader}
//                                 size="small"
//                                 startIcon={<PersonAddIcon />}
//                             >
//                                 {loader ? 'Adding...' : 'Add to Batch'}
//                             </Button>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         },
//     ];

//     // ==================== EFFECTS ====================

//     useEffect(() => {
//         let authUser = JSON.parse(localStorage.getItem("authUser"));
//         setOrganizationId(authUser?.organizationId);
//         setType(authUser?.userType);
//     }, []);

//     useEffect(() => {
//         props.setBreadcrumbItems('Student Details', breadcrumbItems);
//     }, []);

//     useEffect(() => {
//         fetchBatchDetails();
//         fetchAllStudents();
//         getAllTrainers();
//         fetchCourses();
//         fetchScormCourses();
//     }, []);

//     useEffect(() => {
//         getCourseOfBatch();
//         getScormCourseOfBatch();
//         getStudentOfBatch();
//         getTrainerOfBatch();
//     }, []);

//     useEffect(() => {
//         if (selectedTab === "Student" && allStudentOfBatch.length > 0) {
//             autoFetchExamResultsForAllStudents();
//         }
//         filterBatchStudents();
//     }, [selectedTab, allStudentOfBatch, batchStudentSearchTerm]);

//     useEffect(() => {
//         if (allStudents.length > 0) {
//             applyStudentFilters();
//         }
//     }, [searchStudentText, searchAadhaarText, stateFilter, divisionFilter, aadhaarFilter, contractorTokenFilter, natureOfWorkFilter, allStudents]);

//     useEffect(() => {
//         if (filteredAllStudents.length > 0) {
//             const allFilteredSelected = filteredAllStudents.every(student => 
//                 selectedStudentsForBatch.some(selected => selected.id === student.id)
//             );
//             setSelectAll(allFilteredSelected);
//         } else {
//             setSelectAll(false);
//         }
//     }, [filteredAllStudents, selectedStudentsForBatch]);

//     useEffect(() => {
//         if (!addStudentModal) {
//             setSearchStudentText("");
//             setSearchAadhaarText("");
//             setStateFilter(null);
//             setDivisionFilter(null);
//             setAadhaarFilter(null);
//             setContractorTokenFilter(null);
//             setNatureOfWorkFilter(null);
//             setSelectedStudentsForBatch([]);
//             setSelectAll(false);
//             setShowSelectedStudents(false);
//             setRecentlyAddedStudents([]);
//             setShowSuccessMessage(false);
//             setShowBulkProgress(false);
//             setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//         }
//     }, [addStudentModal]);

//     useEffect(() => {
//         if (searchTrainerText === '') {
//             setFilteredAllTrainers(allTrainers);
//         } else {
//             const filtered = allTrainers.filter(trainer => {
//                 return (
//                     (trainer.name && trainer.name.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                     (trainer.email && trainer.email.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                     (trainer.mobile && trainer.mobile.toLowerCase().includes(searchTrainerText.toLowerCase()))
//                 );
//             });
//             setFilteredAllTrainers(filtered);
//         }
//     }, [searchTrainerText, allTrainers]);

//     useEffect(() => {
//         const filtered = allCourses.filter(course =>
//             course.title.toLowerCase().includes(searchCourseText.toLowerCase())
//         );
//         setFilteredAllCourses(filtered);
//     }, [searchCourseText, allCourses]);

//     const autoFetchExamResultsForAllStudents = async () => {
//         if (fetchingExamResults) return;
        
//         setFetchingExamResults(true);
//         const results = {};
        
//         for (const student of allStudentOfBatch) {
//             try {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: true }));
//                 const examResponse = await getResult(`${params.id}/${student.id}`);
                
//                 if (examResponse?.success) {
//                     let preTestScore = null;
//                     let postTestScore = null;
                    
//                     if (examResponse.result) {
//                         const preTest = examResponse.result.preTest;
//                         const postTest = examResponse.result.postTest;
                        
//                         if (preTest !== undefined && preTest !== null) {
//                             preTestScore = typeof preTest === 'number' ? preTest : 
//                                          (preTest.percentage || preTest.score || 0);
//                         }
                        
//                         if (postTest !== undefined && postTest !== null) {
//                             postTestScore = typeof postTest === 'number' ? postTest : 
//                                           (postTest.percentage || postTest.score || 0);
//                         }
//                     }
                    
//                     results[student.id] = {
//                         preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                         postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                         lastUpdated: new Date().toISOString()
//                     };
//                 }
                
//                 await new Promise(resolve => setTimeout(resolve, 100));
                
//             } catch (error) {
//                 console.error(`Error auto-fetching exam results for student ${student.id}:`, error);
//             } finally {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: false }));
//             }
//         }
        
//         setStudentExamResults(prev => ({ ...prev, ...results }));
//         setFetchingExamResults(false);
//     };

//     // ==================== RENDER ====================

//     return (
//         <React.Fragment>
//             {loader && <Loader />}
            
//             <Row>
//                 <Col>
//                     <Card>
//                         <CardBody className="" style={{ minHeight: "70vh" }}>
//                             <div
//                                 className="d-flex mt-4"
//                                 style={{
//                                     borderBottom: "1px solid gray",
//                                     width: "100%",
//                                     overflowX: "auto",
//                                     whiteSpace: "nowrap"
//                                 }}
//                             >
//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Info" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Info")}
//                                 >
//                                     <h5>Info</h5>
//                                 </div>
//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Notification" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Notification")}
//                                 >
//                                     <h5>Notification</h5>
//                                 </div>
//                                 {type != "Trainer" && type != "Tata Trainer" &&
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "Trainer" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("Trainer")}
//                                     >
//                                         <h5>Trainer</h5>
//                                     </div>
//                                 }

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Student" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Student")}
//                                 >
//                                     <h5>Student</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Courses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Courses")}
//                                 >
//                                     <h5>Courses</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "ScormCourses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("ScormCourses")}
//                                 >
//                                     <h5>Scorm Courses</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "LiveClasses" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("LiveClasses")}
//                                 >
//                                     <h5>Live Classes</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Attendance" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Attendance")}
//                                 >
//                                     <h5>Attendance</h5>
//                                 </div>
                                
//                                 {shouldShowSimulatorTab() && (
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "Simulator" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("Simulator")}
//                                     >
//                                         <h5>Simulator</h5>
//                                     </div>
//                                 )}

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Exam" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Exam")}
//                                 >
//                                     <h5>Exam</h5>
//                                 </div>

//                                 <div
//                                     className="me-4"
//                                     style={{
//                                         borderBottom: selectedTab === "Feedback" ? "4px solid blue" : "none",
//                                         cursor: "pointer"
//                                     }}
//                                     onClick={() => setSelectedTab("Feedback")}
//                                 >
//                                     <h5>Feedback</h5>
//                                 </div>

//                                 {organizationId === 2 && shouldShowPracticalTab() && (
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "Practical" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("Practical")}
//                                     >
//                                         <h5>
//                                             Practical
//                                             <span style={{ fontSize: '0.8rem', color: getAssessmentColor(), marginLeft: '5px', fontWeight: 'bold' }}>
//                                                 ({getAssessmentName()})
//                                             </span>
//                                         </h5>
//                                     </div>
//                                 )}

//                                 {organizationId === 2 && (
//                                     <div
//                                         className="me-4"
//                                         style={{
//                                             borderBottom: selectedTab === "TrainingImages" ? "4px solid blue" : "none",
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setSelectedTab("TrainingImages")}
//                                     >
//                                         <h5>Training Images</h5>
//                                     </div>
//                                 )}
//                             </div>

//                             {selectedTab === "Info" && (
//                                 <>
//                                     <div className="d-flex flex-column justify-content-between " style={{ height: "60vh" }}>
//                                         <div className="mt-4">
//                                             <div className="row">
//                                                 <div className="col-6">
//                                                     <h5>Batch Name</h5>
//                                                     <p>{batchDetails?.batchName ? batchDetails?.batchName : "--"}</p>
//                                                     {batchDetails?.batchName && (
//                                                         <div style={{ 
//                                                             color: getAssessmentColor(), 
//                                                             fontWeight: 'bold',
//                                                             marginTop: '5px',
//                                                             padding: '5px 10px',
//                                                             backgroundColor: '#f8f9fa',
//                                                             borderRadius: '5px',
//                                                             display: 'inline-block'
//                                                         }}>
//                                                             Assessment Type: {getAssessmentName()}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <div className="col-6">
//                                                     <h5>Department Name</h5>
//                                                     <p>{batchDetails?.department ? batchDetails?.department : "--"}</p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         {type != "Tata Trainer" && type != "Trainer" &&
//                                             <>
//                                                 <div className="d-flex justify-content-end">
//                                                     <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}> <i className="mdi mdi-pencil "></i> Edit</button>
//                                                     <button className="px-3" style={{ cursor: "pointer", border: "none", backgroundColor: "red", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setDeleteModal(true)}> <i className="mdi mdi-delete "></i> Delete</button>
//                                                 </div>
//                                             </>
//                                         }
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Notification" && (
//                                 <>
//                                     <NotificationButtons />
//                                 </>
//                             )}

//                             {selectedTab === "Trainer" && (
//                                 <>
//                                     <div className="row mt-5">
//                                         <div className="col-md-12" style={{}}>
//                                             <h1 className="text-center">Assign to Trainer</h1>
//                                             <div className="d-flex justify-content-end mb-2">
//                                                 {type != "Tata Trainer" && type != "Trainer" &&
//                                                     <>
//                                                         <Button type="button" color="primary" onClick={() => setAddTrainerModal(true)} className="waves-effect waves-light align-self-end me-2">Add Trainer</Button>
//                                                         <Button type="button" color="danger" onClick={() => handleRemoveAllTrainer()} className="waves-effect waves-light align-self-end">Remove All Trainer</Button>
//                                                     </>
//                                                 }
//                                             </div>
//                                             <Paper sx={{ height: 400, width: '100%' }}>
//                                                 <DataGrid
//                                                     rows={allTrainerOfBatch}
//                                                     columns={columnsTrainer}
//                                                     initialState={{ pagination: { paginationModel } }}
//                                                     pageSizeOptions={[5, 10]}
//                                                     disableRowSelectionOnClick
//                                                     getRowClassName={() => 'data-grid-row'}
//                                                     sx={{ border: 0 }}
//                                                 />
//                                             </Paper>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Student" && (
//                                 <>
//                                     <div className="row mt-5">
//                                         <div className="col-md-12" style={{}}>
//                                             <h1 className="text-center">Assign To Student</h1>
                                            
//                                             {organizationId === 2 && !isTrainerRole && (
//                                                 <div className="alert alert-warning mb-3">
//                                                     <div className="d-flex justify-content-between align-items-center">
//                                                         <div>
//                                                             <strong>Certificate Status:</strong>
//                                                             <ul className="mb-0 mt-2">
//                                                                 <li>Total Students: <strong>{allStudentOfBatch.length}</strong></li>
//                                                                 <li>
//                                                                     Eligible Students: 
//                                                                     <strong className="text-success">
//                                                                         {fetchingExamResults ? (
//                                                                             <span className="ms-1">
//                                                                                 <CircularProgress size={12} sx={{ mr: 1, verticalAlign: 'middle' }} />
//                                                                                 Calculating...
//                                                                             </span>
//                                                                         ) : (
//                                                                             ` ${getPassedStudentsCount()}`
//                                                                         )}
//                                                                     </strong>
//                                                                 </li>
//                                                                 <li>
//                                                                     Exam Results Status: 
//                                                                     <span className={`ms-1 fw-bold ${fetchingExamResults ? 'text-warning' : 'text-success'}`}>
//                                                                         {fetchingExamResults ? 'Fetching...' : 'Loaded'}
//                                                                     </span>
//                                                                 </li>
//                                                                 <li>Certificate Eligibility: 
//                                                                     {hasPracticalAssessment() 
//                                                                         ? "Post-test ≥80% + Practical Assessment" 
//                                                                         : "Post-test ≥80%"}
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <div>
//                                                             <div className="d-flex flex-column gap-2">
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="success"
//                                                                     onClick={generateCertificatesForPassedStudents}
//                                                                     disabled={batchZipLoading || fetchingExamResults}
//                                                                     className="waves-effect waves-light"
//                                                                     startIcon={batchZipLoading ? <CircularProgress size={20} /> : <ArchiveIcon />}
//                                                                 >
//                                                                     {fetchingExamResults ? 'Fetching Results...' : 
//                                                                      batchZipLoading ? 'Generating ZIP...' : 
//                                                                      'Download All Certificates (ZIP)'}
//                                                                 </Button>
                                                                
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="info"
//                                                                     onClick={generateExcelReportOnly}
//                                                                     disabled={loader || fetchingExamResults}
//                                                                     className="waves-effect waves-light"
//                                                                     startIcon={<DescriptionIcon />}
//                                                                 >
//                                                                     Generate Excel Report Only
//                                                                 </Button>
//                                                             </div>
//                                                             {batchZipLoading && (
//                                                                 <Button
//                                                                     type="button"
//                                                                     color="secondary"
//                                                                     onClick={() => setBatchZipLoading(false)}
//                                                                     className="waves-effect waves-light mt-2"
//                                                                     size="sm"
//                                                                 >
//                                                                     Cancel
//                                                                 </Button>
//                                                             )}
//                                                         </div>
//                                                     </div>
                                                    
//                                                     {certificateProgress.inProgress && (
//                                                         <div className="mt-3">
//                                                             <div className="d-flex justify-content-between mb-1">
//                                                                 <small>
//                                                                     Generating certificates: {certificateProgress.completed}/{certificateProgress.total}
//                                                                     {certificateProgress.failed > 0 && (
//                                                                         <span className="text-danger ms-2">({certificateProgress.failed} failed)</span>
//                                                                     )}
//                                                                 </small>
//                                                                 <small>{Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%</small>
//                                                             </div>
//                                                             <div className="progress">
//                                                                 <div 
//                                                                     className="progress-bar progress-bar-striped progress-bar-animated" 
//                                                                     role="progressbar" 
//                                                                     style={{ width: `${(certificateProgress.completed / certificateProgress.total) * 100}%` }}
//                                                                 >
//                                                                     {Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%
//                                                                 </div>
//                                                             </div>
//                                                             <div className="text-center mt-1">
//                                                                 <small className="text-muted">
//                                                                     This may take a few minutes. Please don't close the browser.
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     )}
                                                    
//                                                     {!fetchingExamResults && Object.keys(studentExamResults).length === 0 && (
//                                                         <div className="alert alert-info mt-2 mb-0 py-1">
//                                                             <small>
//                                                                 <InfoIcon fontSize="small" className="me-1" />
//                                                                 Exam results will be automatically fetched when generating certificates or reports
//                                                             </small>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )}

//                                             <div className="mb-3">
//                                                 <div className="alert alert-success">
//                                                     <strong>Student Addition Policy:</strong>
//                                                     <ul className="mb-0">
//                                                         <li><strong>ALL students</strong> can be added to this batch</li>
//                                                         <li>Students can be in multiple batches simultaneously</li>
//                                                         <li>{hasPracticalAssessment() 
//                                                             ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
//                                                             : `Only post-test (≥80%) is required for eligibility`}</li>
//                                                         <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
//                                                         <li>Total Students in Batch: <strong>{allStudentOfBatch.length}</strong></li>
//                                                     </ul>
//                                                 </div>
//                                             </div>
                                            
//                                             <div className="d-flex justify-content-between mb-3">
//                                                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
//                                                     <TextField
//                                                         size="small"
//                                                         placeholder="Search students in batch by name, mobile, depot, division..."
//                                                         value={batchStudentSearchTerm}
//                                                         onChange={(e) => setBatchStudentSearchTerm(e.target.value)}
//                                                         sx={{ flex: 1, maxWidth: '500px' }}
//                                                         InputProps={{
//                                                             startAdornment: (
//                                                                 <InputAdornment position="start">
//                                                                     <SearchIcon />
//                                                                 </InputAdornment>
//                                                             ),
//                                                             endAdornment: batchStudentSearchTerm && (
//                                                                 <InputAdornment position="end">
//                                                                     <IconButton size="small" onClick={clearBatchStudentSearch}>
//                                                                         <ClearIcon />
//                                                                     </IconButton>
//                                                                 </InputAdornment>
//                                                             )
//                                                         }}
//                                                     />
//                                                     <span className="text-muted" style={{ fontSize: '0.85rem' }}>
//                                                         {filteredBatchStudents.length} students
//                                                         {batchStudentSearchTerm && ` (filtered from ${allStudentOfBatch.length})`}
//                                                     </span>
//                                                 </div>
//                                                 <div className="d-flex align-items-center gap-2">
//                                                     {selectedStudentIds.length > 0 && (
//                                                         <Button
//                                                             type="button"
//                                                             color="danger"
//                                                             onClick={handleBulkRemoveStudents}
//                                                             disabled={loader}
//                                                             size="sm"
//                                                             startIcon={<PersonOffIcon />}
//                                                             className="fw-bold"
//                                                             style={{
//                                                                 backgroundColor: '#dc3545',
//                                                                 borderColor: '#dc3545',
//                                                                 boxShadow: '0 2px 4px rgba(220, 53, 69, 0.3)',
//                                                                 padding: '8px 16px',
//                                                                 borderRadius: '8px'
//                                                             }}
//                                                         >
//                                                             Remove Selected ({selectedStudentIds.length})
//                                                         </Button>
//                                                     )}
//                                                     <Button 
//                                                         type="button" 
//                                                         color="primary" 
//                                                         onClick={() => setAddStudentModal(true)} 
//                                                         className="waves-effect waves-light"
//                                                         size="sm"
//                                                         startIcon={<PersonAddIcon />}
//                                                     >
//                                                         Add Student
//                                                     </Button>
//                                                     <Button 
//                                                         type="button" 
//                                                         color="danger" 
//                                                         onClick={() => setRemoveAllStudentsModal(true)} 
//                                                         className="waves-effect waves-light"
//                                                         size="sm"
//                                                         startIcon={<DeleteIcon />}
//                                                         variant="outline"
//                                                     >
//                                                         Remove All
//                                                     </Button>
//                                                 </div>
//                                             </div>
                                            
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <button type="submit" className="btn btn-info w-md" onClick={handleDownloadStudentDetailsClick}>
//                                                     <DownloadIcon style={{ marginRight: '5px' }} /> Download All Student File
//                                                 </button>
//                                             </div>
                                            
//                                             <Paper sx={{ height: 500, width: '100%' }}>
//                                                 <DataGrid
//                                                     rows={filteredBatchStudents}
//                                                     columns={columnsStudent}
//                                                     initialState={{ pagination: { paginationModel } }}
//                                                     pageSizeOptions={[5, 10, 25]}
//                                                     checkboxSelection
//                                                     onRowSelectionModelChange={handleSelectionChange}
//                                                     rowSelectionModel={selectedStudentIds}
//                                                     sx={{ border: 0 }}
//                                                     loading={loader}
//                                                 />
//                                             </Paper>
//                                         </div>
//                                     </div>
//                                     <ExamResultsModal
//                                         student={selectedStudent}
//                                         batchId={params.id}
//                                         open={showExamResults}
//                                         onClose={() => setShowExamResults(false)}
//                                         examResults={studentExamResults[selectedStudent?.id]}
//                                         loading={loadingExamResults[selectedStudent?.id]}
//                                     />
//                                 </>
//                             )}

//                             {selectedTab === "Courses" && (
//                                 <>
//                                     <div className="d-flex justify-content-end mt-2">
//                                         {type != "Trainer" && type != "Tata Trainer" &&
//                                             <Button type="button" color="primary" onClick={() => setAddCourseModal(true)} className="waves-effect waves-light align-self-end">Add Course</Button>
//                                         }
//                                     </div>
//                                     <div className="d-flex flex-row flex-wrap mt-3">
//                                         {allCoursesOfBatch?.map((d, index) => (
//                                             <div key={index} className="card me-5" style={{ width: "18rem", border: "2px solid gray", borderRadius: "10px", cursor: "pointer" }} onClick={() => navigate("/course-view/" + d.id)}>
//                                                 <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"200px"} />
//                                                 <div className="card-body">
//                                                     <h5 className="card-title">{d?.title}</h5>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Duration: </h5>
//                                                         <p>{d?.duration} Hours</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Level: </h5>
//                                                         <p>{d?.levelDto?.name}</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5>Language: </h5>
//                                                         <p>{d?.language}</p>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         {type !== "Trainer" && (
//                                                             <Button
//                                                                 type="button"
//                                                                 color="danger"
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     setSelectedCourse(d);
//                                                                     setCourseDeleteModal(true);
//                                                                 }}
//                                                                 className="waves-effect waves-light"
//                                                             >
//                                                                 Remove Course
//                                                             </Button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "ScormCourses" && (
//                                 <>
//                                     <ScormCourse getScormCourseOfBatch={getScormCourseOfBatch} allScormCourses={allScormCourses} allScormCoursesOfBatch={allScormCoursesOfBatch} type={type} />
//                                 </>
//                             )}

//                             {selectedTab === "LiveClasses" && (
//                                 <LClass
//                                     liveClasses={liveClasses}
//                                     loader={loader}
//                                     setLoader={setLoader}
//                                     params={params}
//                                     fetchBatchDetails={fetchBatchDetails}
//                                     spanDisplay={spanDisplay}
//                                 />
//                             )}

//                             {selectedTab === "Attendance" && (
//                                 <>
//                                     <div className="">
//                                         <TrainerAttendance trainers={allTrainerOfBatch} batchDetails={batchDetails} />
//                                     </div>
//                                     <Attendance students={allStudentOfBatch} batchDetails={batchDetails} />
//                                 </>
//                             )}

//                             {selectedTab === "Simulator" && shouldShowSimulatorTab() && (
//                                 <>
//                                     <div className="">
//                                     </div>
//                                     <Simulator students={allStudentOfBatch} batchDetails={batchDetails} />
//                                 </>
//                             )}

//                             {selectedTab === "Exam" && (
//                                 <>
//                                     <div className="mt-2">
//                                         <ExamList />
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Feedback" && (
//                                 <>
//                                     <div className="mt-2">
//                                         <Feedback />
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "Practical" && shouldShowPracticalTab() && (
//                                 <>
//                                     <div className="mt-2">
//                                         {getAssessmentComponent()}
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "TrainingImages" && (
//                                 <>
//                                     <ImageUploader batchId={params.id} trainingImages={trainingImages} fetchBatchDetails={fetchBatchDetails} />
//                                 </>
//                             )}
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>

//             {/* ==================== MODALS ==================== */}

//             <Modal show={bulkRemoveModal} size="lg" centered onHide={() => setBulkRemoveModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <PersonOffIcon style={{ color: '#dc3545', marginRight: '10px' }} />
//                             <span>Confirm Bulk Removal</span>
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center py-3">
//                         <div style={{ fontSize: '3rem', marginBottom: '20px' }}>
//                             ⚠️
//                         </div>
//                         <h4 className="mb-3">Are you sure you want to remove these students?</h4>
//                         <div className="alert alert-danger">
//                             <strong>You are about to remove {selectedStudentIds.length} student(s) from this batch.</strong>
//                         </div>
//                         <div className="mt-3">
//                             <p className="text-muted">
//                                 <strong>Selected Students:</strong>
//                             </p>
//                             <div style={{ maxHeight: '200px', overflowY: 'auto', textAlign: 'left' }}>
//                                 <ul className="list-group">
//                                     {allStudentOfBatch
//                                         .filter(student => selectedStudentIds.includes(student.id))
//                                         .slice(0, 10)
//                                         .map((student, index) => (
//                                             <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
//                                                 <span>
//                                                     <strong>{student.firstName} {student.lastName}</strong>
//                                                     {student.tataStudentDetailsDto?.contractorTokenNo && (
//                                                         <span className="ms-2 text-muted" style={{ fontSize: '0.8rem' }}>
//                                                             (Token: {student.tataStudentDetailsDto.contractorTokenNo})
//                                                         </span>
//                                                     )}
//                                                 </span>
//                                                 <span className="badge bg-secondary rounded-pill">
//                                                     ID: {student.id}
//                                                 </span>
//                                             </li>
//                                         ))}
//                                     {selectedStudentIds.length > 10 && (
//                                         <li className="list-group-item text-center text-muted">
//                                             ... and {selectedStudentIds.length - 10} more students
//                                         </li>
//                                     )}
//                                 </ul>
//                             </div>
//                         </div>
//                         <div className="mt-3">
//                             <p className="text-danger">
//                                 <strong>This action cannot be undone!</strong>
//                             </p>
//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button 
//                         type="button" 
//                         color="secondary" 
//                         onClick={() => setBulkRemoveModal(false)} 
//                         className="waves-effect waves-light"
//                         disabled={loader}
//                     >
//                         Cancel
//                     </Button>
//                     <Button 
//                         type="button" 
//                         color="danger" 
//                         onClick={confirmBulkRemoveStudents} 
//                         className="waves-effect waves-light"
//                         disabled={loader}
//                         startIcon={<PersonOffIcon />}
//                         style={{
//                             backgroundColor: '#dc3545',
//                             borderColor: '#dc3545'
//                         }}
//                     >
//                         {loader ? 'Removing...' : `Yes, Remove ${selectedStudentIds.length} Student(s)`}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={showEventModal} centered onHide={() => setShowEventModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <VideoCallIcon style={{ marginRight: '10px', color: '#667eea' }} />
//                             <span>Class Details</span>
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {selectedEvent && (
//                         <div>
//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: '#667eea', marginBottom: '10px' }}>{selectedEvent.title}</h4>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
//                                     <AccessTimeIcon style={{ marginRight: '10px', color: '#666' }} />
//                                     <span>{formatDateTime(selectedEvent.classTime)}</span>
//                                 </div>
//                                 {selectedEvent.description && (
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
//                                         <SubjectIcon style={{ marginRight: '10px', color: '#666', marginTop: '3px' }} />
//                                         <span>{selectedEvent.description}</span>
//                                     </div>
//                                 )}
//                                 {selectedEvent.classLink && (
//                                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
//                                         <LinkIcon style={{ marginRight: '10px', color: '#666' }} />
//                                         <a 
//                                             href={selectedEvent.classLink} 
//                                             target="_blank" 
//                                             rel="noopener noreferrer" 
//                                             style={{ color: '#667eea', textDecoration: 'underline' }}
//                                             onClick={(e) => {
//                                                 e.preventDefault();
//                                                 openLiveClassLink(selectedEvent.classLink);
//                                             }}
//                                         >
//                                             {selectedEvent.classLink}
//                                         </a>
//                                     </div>
//                                 )}
//                             </div>
                            
//                             <div style={{
//                                 backgroundColor: '#f8f9fa',
//                                 padding: '15px',
//                                 borderRadius: '8px',
//                                 marginTop: '20px'
//                             }}>
//                                 <h6 style={{ marginBottom: '10px' }}>Quick Actions</h6>
//                                 <div style={{ display: 'flex', gap: '10px' }}>
//                                     {selectedEvent.classLink && (
//                                         <Button 
//                                             color="primary" 
//                                             onClick={() => openLiveClassLink(selectedEvent.classLink)}
//                                             style={{ flex: 1 }}
//                                         >
//                                             <VideoCallIcon style={{ marginRight: '5px' }} />
//                                             Join Now
//                                         </Button>
//                                     )}
//                                     <Button 
//                                         color="secondary" 
//                                         style={{ flex: 1 }}
//                                         onClick={() => {
//                                             if (selectedEvent.classLink) {
//                                                 navigator.clipboard.writeText(selectedEvent.classLink);
//                                                 toast.success('Link copied to clipboard!');
//                                             }
//                                         }}
//                                     >
//                                         <LinkIcon style={{ marginRight: '5px' }} />
//                                         Copy Link
//                                     </Button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setShowEventModal(false)}>
//                         Close
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={deleteModal} size="lg" centered>
//                 <Modal.Header></Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <h1> Are you sure want To delete this Batch</h1>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setDeleteModal(false)} className="waves-effect waves-light">Close</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleDeleteBatch} className="waves-effect waves-light">Delete</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={editModal} size="lg" centered>
//                 <Modal.Header>
//                     <Modal.Title>Edit Batch Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <Row className="mb-3">
//                             <label htmlFor="example-text-input" className="col-md-2 col-form-label">
//                                 Batch Name
//                             </label>
//                             <div className="col-md-10">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Enter Batch Name"
//                                     value={batchDetails?.batchName || ""}
//                                     maxLength="50"
//                                     onChange={(e) => setBatchDetails(prevDetails => ({
//                                         ...prevDetails,
//                                         batchName: e.target.value
//                                     }))}
//                                 />
//                                 {!batchDetails?.batchName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                             </div>
//                         </Row>
//                         <Row className="mb-3">
//                             <label htmlFor="example-text-input" className="col-md-2 col-form-label">
//                                 Department Name
//                             </label>
//                             <div className="col-md-10">
//                                 <Select
//                                     value={department}
//                                     onChange={(selectedValue) => setDepartment(selectedValue)}
//                                     options={allDepartments}
//                                     getOptionLabel={option => option.name}
//                                     getOptionValue={option => option.id.toString()}
//                                     classNamePrefix="select2-selection"
//                                 />
//                                 {!batchDetails?.department && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                             </div>
//                         </Row>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setEditModal(false)} className="waves-effect waves-light">Close</Button>{" "}
//                     <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addTrainerModal} size="lg" centered>
//                 <Modal.Header>Add Trainer</Modal.Header>
//                 <Modal.Body>
//                     <div className="" >
//                         <h1 className="text-center">All Trainers</h1>
//                         <div className="mb-3 d-flex justify-content-center">
//                             <div style={{ width: '50%' }}>
//                                 <TextField
//                                     fullWidth
//                                     variant="outlined"
//                                     label="Search Trainer"
//                                     value={searchTrainerText}
//                                     onChange={(e) => setSearchTrainerText(e.target.value)}
//                                     sx={{ marginBottom: 2 }}
//                                 />
//                             </div>
//                         </div>
//                         <Paper sx={{ height: 400, width: '100%' }}>
//                             <DataGrid
//                                 rows={filteredAllTrainers?.map((row, index) => ({
//                                     ...row,
//                                     serialNo: index + 1,
//                                 }))}
//                                 columns={columnsTrainerModal}
//                                 initialState={{ pagination: { paginationModel } }}
//                                 pageSizeOptions={[5, 10]}
//                                 disableRowSelectionOnClick
//                                 getRowClassName={() => 'data-grid-row'}
//                                 sx={{ border: 0 }}
//                             />
//                         </Paper>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setAddTrainerModal(false)} className="waves-effect waves-light">Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addStudentModal} size="xl" centered onHide={handleModalClose}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div>
//                             <h4>Add Students to Batch</h4>
//                             {batchDetails && (
//                                 <div className="batch-info-card mt-2 p-3 bg-light rounded">
//                                     <div className="d-flex align-items-center mb-2">
//                                         <SchoolIcon className="me-2 text-primary" />
//                                         <h5 className="mb-0 text-primary">{batchDetails.batchName || "Batch"}</h5>
//                                     </div>
//                                     <div className="row">
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small>
//                                                     <strong>Start Date:</strong> {formatDate(batchDetails.startDate)}
//                                                 </small>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small>
//                                                     <strong>End Date:</strong> {formatDate(batchDetails.endDate)}
//                                                 </small>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="mt-2">
//                                         <small className="text-success fw-bold">
//                                             <strong>ALL students</strong> can be added. Students can be in multiple batches.
//                                         </small>
//                                     </div>
//                                     {assessmentType !== "none" && (
//                                         <div className="mt-2">
//                                             <small style={{ color: getAssessmentColor() }} className="fw-bold">
//                                                 <strong>Assessment Type:</strong> {getAssessmentName()}
//                                             </small>
//                                         </div>
//                                     )}
//                                     {assessmentType === "none" && (
//                                         <div className="mt-2">
//                                             <small className="text-muted">
//                                                 <strong>Note:</strong> This batch does not have a practical assessment.
//                                                 Certificate eligibility based on post-test score (≥80%).
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <h1 className="text-center">All Students</h1>
                        
//                         {showSuccessMessage && (
//                             <div className="alert alert-success alert-dismissible fade show mb-3" role="alert">
//                                 <strong>Success!</strong> {successMessage}
//                                 <button 
//                                     type="button" 
//                                     className="btn-close" 
//                                     onClick={() => setShowSuccessMessage(false)}
//                                     aria-label="Close"
//                                 ></button>
//                             </div>
//                         )}

//                         {showBulkProgress && (
//                             <div className="alert alert-info mb-3">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <div>
//                                         <strong>Adding Students:</strong>
//                                         <div className="mt-1">
//                                             <span className="text-success">✓ {bulkAddProgress.added} added</span>
//                                             {bulkAddProgress.failed > 0 && (
//                                                 <span className="text-danger ms-3">✗ {bulkAddProgress.failed} failed</span>
//                                             )}
//                                             <span className="text-muted ms-3">Total: {bulkAddProgress.total}</span>
//                                         </div>
//                                         <div className="progress mt-1" style={{ height: '8px', width: '300px' }}>
//                                             <div 
//                                                 className="progress-bar progress-bar-striped progress-bar-animated" 
//                                                 role="progressbar" 
//                                                 style={{ 
//                                                     width: `${bulkAddProgress.total > 0 ? ((bulkAddProgress.added + bulkAddProgress.failed) / bulkAddProgress.total) * 100 : 0}%` 
//                                                 }}
//                                             >
//                                             </div>
//                                         </div>
//                                     </div>
//                                     {bulkAddInProgress && (
//                                         <div>
//                                             <CircularProgress size={24} />
//                                             <span className="ms-2">Processing...</span>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         )}

//                         {recentlyAddedStudents.length > 0 && (
//                             <div className="alert alert-info mb-3">
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <div>
//                                         <strong>Recently Added Students:</strong>
//                                         <ul className="mb-0 mt-1" style={{ maxHeight: '100px', overflowY: 'auto' }}>
//                                             {recentlyAddedStudents.slice(-5).map((student, index) => (
//                                                 <li key={index}>
//                                                     {student.firstName} {student.lastName} 
//                                                     <span className="text-muted"> ({student.mobile})</span>
//                                                     {student.tataStudentDetailsDto?.contractorTokenNo && (
//                                                         <span className="text-primary ms-2 fw-bold">
//                                                             • Token: {student.tataStudentDetailsDto.contractorTokenNo}
//                                                         </span>
//                                                     )}
//                                                     {student.tataStudentDetailsDto?.natureOfWork && (
//                                                         <span className="text-success ms-2 fw-bold">
//                                                             • {student.tataStudentDetailsDto.natureOfWork}
//                                                         </span>
//                                                     )}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                     <Button 
//                                         color="link" 
//                                         size="sm" 
//                                         onClick={() => setRecentlyAddedStudents([])}
//                                     >
//                                         Clear List
//                                     </Button>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="alert alert-info mb-3">
//                             <strong>Student Addition Policy:</strong>
//                             <ul className="mb-0">
//                                 <li><strong>ALL students</strong> can be added to this batch</li>
//                                 <li>Students can be in multiple batches simultaneously</li>
//                                 <li>{hasPracticalAssessment() 
//                                     ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
//                                     : `Only post-test (≥80%) is required for eligibility`}</li>
//                                 <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
//                                 <li>Available Students: <strong>{filteredAllStudents.length}</strong> | Selected: <strong>{selectedStudentsForBatch.length}</strong></li>
//                                 <li><strong>Tip:</strong> Modal stays open after successful addition. Click "Close" button when done.</li>
//                             </ul>
//                         </div>

//                         {selectedStudentsForBatch.length > 0 && (
//                             <div className="alert alert-warning mb-3 d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <strong>Selected {selectedStudentsForBatch.length} student(s)</strong>
//                                     <Button 
//                                         color="link" 
//                                         onClick={() => setShowSelectedStudents(!showSelectedStudents)}
//                                         className="ms-2"
//                                     >
//                                         {showSelectedStudents ? 'Hide Selected' : 'Show Selected'}
//                                     </Button>
//                                 </div>
//                                 <div>
//                                     <Button 
//                                         color="secondary" 
//                                         size="sm" 
//                                         onClick={handleClearSelectedStudents}
//                                         className="me-2"
//                                         disabled={bulkAddInProgress}
//                                     >
//                                         Clear All
//                                     </Button>
//                                     <Button 
//                                         color="success" 
//                                         size="sm" 
//                                         onClick={handleAddMultipleStudentsToBatch}
//                                         disabled={bulkAddInProgress}
//                                         startIcon={bulkAddInProgress ? <CircularProgress size={16} /> : <PersonAddIcon />}
//                                     >
//                                         {bulkAddInProgress ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                     </Button>
//                                 </div>
//                             </div>
//                         )}

//                         {showSelectedStudents && selectedStudentsForBatch.length > 0 && (
//                             <div className="mb-3">
//                                 <h5>Selected Students:</h5>
//                                 <Paper sx={{ height: 200, width: '100%', marginBottom: 2 }}>
//                                     <DataGrid
//                                         rows={selectedStudentsForBatch}
//                                         columns={columnsSelectedStudents}
//                                         pageSizeOptions={[5]}
//                                         disableRowSelectionOnClick
//                                         sx={{ border: 0 }}
//                                     />
//                                 </Paper>
//                             </div>
//                         )}

//                         <div className="mb-3">
//                             <Row>
//                                 <Col md={isTataUser ? 2 : 4}>
//                                     <TextField
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Search by Name/Email/Mobile"
//                                         value={searchStudentText}
//                                         onChange={(e) => setSearchStudentText(e.target.value)}
//                                         sx={{ marginBottom: 2 }}
//                                         disabled={bulkAddInProgress}
//                                     />
//                                 </Col>
                                
//                                 <Col md={isTataUser ? 2 : 4}>
//                                     <TextField
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Search by Aadhaar No"
//                                         value={searchAadhaarText}
//                                         onChange={(e) => setSearchAadhaarText(e.target.value)}
//                                         sx={{ marginBottom: 2 }}
//                                         disabled={bulkAddInProgress}
//                                         InputProps={{
//                                             startAdornment: (
//                                                 <FingerprintIcon style={{ marginRight: '8px', color: '#667eea' }} />
//                                             ),
//                                         }}
//                                     />
//                                 </Col>
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by State"
//                                             value={stateFilter}
//                                             onChange={setStateFilter}
//                                             options={availableStates}
//                                             isClearable
//                                             className="mb-2"
//                                             isDisabled={bulkAddInProgress}
//                                         />
//                                     </Col>
//                                 )}
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by Division"
//                                             value={divisionFilter}
//                                             onChange={setDivisionFilter}
//                                             options={availableDivisions}
//                                             isClearable
//                                             className="mb-2"
//                                             isDisabled={bulkAddInProgress}
//                                         />
//                                     </Col>
//                                 )}
                                
//                                 {isTataUser && (
//                                     <Col md={2}>
//                                         <Select
//                                             placeholder="Filter by Contractor Token"
//                                             value={contractorTokenFilter}
//                                             onChange={setContractorTokenFilter}
//                                             options={availableContractorTokens}
//                                             isClearable
//                                             className="mb-2"
//                                             isDisabled={bulkAddInProgress}
//                                             formatOptionLabel={({ value, label, display }) => (
//                                                 <div>
//                                                     <span className="fw-bold">{display || label}</span>
//                                                 </div>
//                                             )}
//                                         />
//                                     </Col>
//                                 )}
//                             </Row>
                            
//                             {isTataUser && availableNatureOfWork.length > 0 && (
//                                 <Row className="mt-2">
//                                     <Col md={6}>
//                                         <div className="d-flex align-items-center mb-2">
//                                             <WorkIcon className="me-2 text-primary" />
//                                             <span className="me-2" style={{ whiteSpace: 'nowrap' }}>Filter by Nature of Work:</span>
//                                             <Select
//                                                 placeholder="Select Nature of Work"
//                                                 value={natureOfWorkFilter}
//                                                 onChange={setNatureOfWorkFilter}
//                                                 options={availableNatureOfWork}
//                                                 isClearable
//                                                 className="flex-grow-1"
//                                                 isDisabled={bulkAddInProgress}
//                                                 formatOptionLabel={({ value, label, display }) => (
//                                                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                                                         <WorkIcon style={{ fontSize: '1rem', marginRight: '8px', color: '#667eea' }} />
//                                                         <span className="fw-bold">{display || label}</span>
//                                                     </div>
//                                                 )}
//                                             />
//                                         </div>
//                                     </Col>
//                                 </Row>
//                             )}
                            
//                             <div className="d-flex justify-content-between align-items-center mt-3">
//                                 <div>
//                                     {isTataUser && (
//                                         <Checkbox
//                                             checked={selectAll}
//                                             onChange={handleSelectAllStudents}
//                                             disabled={filteredAllStudents.length === 0 || loader || bulkAddInProgress}
//                                             indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
//                                         />
//                                     )}
//                                     <span className="ms-2 fw-bold">
//                                         {selectedStudentsForBatch.length > 0 && (
//                                             <span style={{ color: '#28a745' }}>
//                                                 {selectedStudentsForBatch.length} selected
//                                             </span>
//                                         )}
//                                     </span>
//                                     <small className="text-muted ms-3">
//                                         Showing {filteredAllStudents.length} of {allStudents.length} students
//                                         {(stateFilter || divisionFilter || aadhaarFilter || contractorTokenFilter || natureOfWorkFilter) && (
//                                             <span className="ms-2">
//                                                 {stateFilter && ` • State: ${stateFilter.label}`}
//                                                 {divisionFilter && ` • Division: ${divisionFilter.label}`}
//                                                 {aadhaarFilter && ` • Aadhaar: ${formatAadhaarNumber(aadhaarFilter.value)}`}
//                                                 {contractorTokenFilter && ` • Contractor Token: ${contractorTokenFilter.label}`}
//                                                 {natureOfWorkFilter && ` • Nature of Work: ${natureOfWorkFilter.label}`}
//                                             </span>
//                                         )}
//                                     </small>
//                                 </div>
//                                 <Button 
//                                     color="secondary" 
//                                     size="sm" 
//                                     onClick={clearStudentFilters}
//                                     disabled={(!searchStudentText && !searchAadhaarText && !stateFilter && !divisionFilter && !aadhaarFilter && !contractorTokenFilter && !natureOfWorkFilter) || loader || bulkAddInProgress}
//                                     startIcon={<FilterListIcon />}
//                                 >
//                                     Clear Filters
//                                 </Button>
//                             </div>
//                         </div>

//                         {isTataUser ? (
//                             <Paper sx={{ height: 500, width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         id: row.id || index + 1,
//                                     }))}
//                                     columns={columnsStudentModalForTata}
//                                     initialState={{ pagination: { paginationModel } }}
//                                     pageSizeOptions={[5, 10, 25]}
//                                     disableRowSelectionOnClick
//                                     getRowClassName={() => 'data-grid-row'}
//                                     sx={{ border: 0 }}
//                                     loading={loader || bulkAddInProgress}
//                                 />
//                             </Paper>
//                         ) : (
//                             <Paper sx={{ height: 500, width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         id: row.id || index + 1,
//                                     }))}
//                                     columns={columnsStudentModal}
//                                     initialState={{ pagination: { paginationModel } }}
//                                     pageSizeOptions={[5, 10, 25]}
//                                     disableRowSelectionOnClick
//                                     getRowClassName={() => 'data-grid-row'}
//                                     sx={{ border: 0 }}
//                                     loading={loader || bulkAddInProgress}
//                                 />
//                             </Paper>
//                         )}
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <div className="d-flex justify-content-between w-100">
//                         <div>
//                             {selectedStudentsForBatch.length > 0 && (
//                                 <Button 
//                                     type="button" 
//                                     color="success" 
//                                     onClick={handleAddMultipleStudentsToBatch}
//                                     disabled={bulkAddInProgress}
//                                     startIcon={bulkAddInProgress ? <CircularProgress size={16} /> : <PersonAddIcon />}
//                                 >
//                                     {bulkAddInProgress ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                 </Button>
//                             )}
//                         </div>
//                         <div>
//                             <Button 
//                                 type="button" 
//                                 color="secondary" 
//                                 onClick={handleModalClose}
//                                 className="waves-effect waves-light me-2"
//                                 disabled={bulkAddInProgress}
//                             >
//                                 Close
//                             </Button>
//                             {recentlyAddedStudents.length > 0 && (
//                                 <Button 
//                                     type="button" 
//                                     color="primary" 
//                                     onClick={() => {
//                                         handleModalClose();
//                                         setSelectedTab("Student");
//                                     }}
//                                     disabled={bulkAddInProgress}
//                                 >
//                                     Done ({recentlyAddedStudents.length} added)
//                                 </Button>
//                             )}
//                         </div>
//                     </div>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={addCourseModal} size="lg" centered>
//                 <Modal.Header>Add Courses</Modal.Header>
//                 <Modal.Body>
//                     <div className="">
//                         <div className="mb-3 d-flex justify-content-center">
//                             <div style={{ width: '50%' }}>
//                                 <TextField
//                                     fullWidth
//                                     variant="outlined"
//                                     label="Search Course"
//                                     value={searchCourseText}
//                                     onChange={(e) => setSearchCourseText(e.target.value)}
//                                     sx={{ marginBottom: 2 }}
//                                 />
//                             </div>
//                         </div>
//                         <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
//                             {filteredAllCourses.length > 0 && filteredAllCourses?.map((d, i) => (
//                                 <div key={i} className="card me-5 mb-3" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px" }} >
//                                     <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"220px"} />
//                                     <div className="card-body" >
//                                         <h5 className="card-title">{d?.title}</h5>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Duration: </h5>
//                                             <p>{d?.duration} Hours</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Level: </h5>
//                                             <p>{d?.levelDto?.name}</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <h5>Language: </h5>
//                                             <p>{d?.language}</p>
//                                         </div>
//                                         <div className="d-flex justify-content-between">
//                                             <Button type="button" color="success" onClick={() => handleAddCourseToBatch(d?.id)} className="waves-effect waves-light">Add Course</Button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setAddCourseModal(false)} className="waves-effect waves-light">Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={removeAllStudentsModal} size="lg" centered>
//                 <Modal.Header>
//                     <Modal.Title>Remove All Students</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center">
//                         <h4>Are you sure you want to remove all students from this batch?</h4>
//                         <p className="text-danger mt-2">
//                             <strong>Warning:</strong> This action cannot be undone. 
//                             All {allStudentOfBatch.length} students will be removed from the batch.
//                         </p>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="secondary" onClick={() => setRemoveAllStudentsModal(false)} className="waves-effect waves-light">
//                         Cancel
//                     </Button>
//                     <Button type="button" color="danger" onClick={handleRemoveAllStudents} className="waves-effect waves-light" disabled={loader}>
//                         {loader ? 'Removing...' : 'Yes, Remove All'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={studentDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Student?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setStudentDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveStudentFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={courseDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Course?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setCourseDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveCourseFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>

//             <Modal show={trainerDeleteModal} size="lg" centered>
//                 <Modal.Body>
//                     <h4>Are you sure want to remove this Trainer?</h4>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setTrainerDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleRemoveTrainerFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
//                 </Modal.Footer>
//             </Modal>
//         </React.Fragment>
//     );
// };

// // Define columnsTrainer and columnsTrainerModal outside the component
// const columnsTrainer = [
//     { field: 'id', headerName: 'ID', width: 70 },
//     { field: 'name', headerName: 'Name', width: 300 },
//     {
//         field: 'email',
//         headerName: 'Email',
//         type: 'text',
//         width: 300,
//     },
//     {
//         field: 'mobile',
//         headerName: 'Mobile No.',
//         type: 'text',
//         width: 300,
//     },
//     {
//         field: 'actions',
//         headerName: 'Actions',
//         width: 150,
//         renderCell: (params) => (
//             <Button
//                 variant="contained"
//                 color="danger"
//                 onClick={() => { /* Handled in parent */ }}
//             >
//                 Remove
//             </Button>
//         ),
//     },
// ];

// const columnsTrainerModal = [
//     { field: 'id', headerName: 'ID', width: 100 },
//     { field: 'name', headerName: 'Name', width: 150 },
//     {
//         field: 'email',
//         headerName: 'Email',
//         type: 'text',
//         width: 150,
//     },
//     {
//         field: 'mobile',
//         headerName: 'Number',
//         type: 'number',
//         width: 150,
//     },
//     {
//         field: 'action',
//         headerName: 'Action',
//         width: 150,
//         renderCell: (params) => {
//             return (
//                 <Button
//                     variant="contained"
//                     color="success"
//                     onClick={() => { /* Handled in parent */ }}
//                 >
//                     Add
//                 </Button>
//             );
//         }
//     },
// ];

// // Define columnsStudent outside the component
// const columnsStudent = [
//     { field: 'id', headerName: 'ID', width: 60 },
//     {
//         field: 'fullName',
//         headerName: 'Full name',
//         sortable: false,
//         width: 150,
//         valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//     },
//     {
//         field: 'email',
//         headerName: 'Email',
//         type: 'text',
//         width: 200,
//     },
//     {
//         field: 'mobile',
//         headerName: 'Mobile',
//         type: 'text',
//         width: 130,
//     },
//     {
//         field: 'aadhaarNo',
//         headerName: 'Aadhaar No',
//         type: 'text',
//         width: 150,
//         valueGetter: (value, row) => {
//             return row.tataStudentDetailsDto?.aadhaarNo || 
//                    row.aadhaarNo || 
//                    row.aadharNo || 
//                    '--';
//         },
//     },
//     {
//         field: 'contractorToken',
//         headerName: 'Contractor Token',
//         type: 'text',
//         width: 130,
//         valueGetter: (value, row) => {
//             return row.tataStudentDetailsDto?.contractorTokenNo || 
//                    row.contractorTokenNo || 
//                    '--';
//         },
//     },
//     {
//         field: 'natureOfWork',
//         headerName: 'Nature of Work',
//         type: 'text',
//         width: 150,
//         valueGetter: (value, row) => {
//             return row.tataStudentDetailsDto?.natureOfWork || 
//                    row.natureOfWork || 
//                    '--';
//         },
//     },
//     {
//         field: 'depotDivision',
//         headerName: 'Depot/Division',
//         width: 200,
//     },
//     {
//         field: 'postTestScore',
//         headerName: 'Post-Test',
//         type: 'number',
//         width: 90,
//     },
//     {
//         field: 'passStatus',
//         headerName: 'Result',
//         width: 100,
//     },
//     {
//         field: 'examResults',
//         headerName: 'Exam Results',
//         width: 130,
//     },
//     {
//         field: 'downloadCertificate',
//         headerName: 'Certificate',
//         width: 150,
//     },
//     {
//         field: 'actions',
//         headerName: 'Actions',
//         width: 100,
//     },
// ];

// export default connect(null, {setBreadcrumbItems})(BatchDetails);









import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import Loader from "components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { getAllStudents, getAllStudentsForTata } from "helpers/student_helper";
import { Modal } from "react-bootstrap";
import { fetchAllCourses } from "helpers/course_helper";
import { DOWNLOAD_BATCH_STUDENT_FILE, url } from "helpers/url_helper";
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { generatePresignedUrlForAccess } from "helpers/Content_helper";
import { 
    addCourseToBatch, 
    addStudentToBatch, 
    addTrainerToBatch, 
    deleteBatch, 
    fetchSingleBatch, 
    getAllCourseOfBatch, 
    getAllScormCourseOfBatch, 
    getAllStudentOfBatch, 
    getAllTrainerOfBatch, 
    removeAllStudentsFromBatch, 
    removeAllTrainersFromBatch, 
    removeCourseFromBatch, 
    removeStudentFromBatch, 
    removeTrainerFromBatch, 
    updateBatch 
} from "helpers/batch_helper";
import { fetchAllTrainers, fetchAllUsers } from "helpers/user_helper";
import axios from "axios";
import Select from "react-select"
import Attendance from "./Components/Attendance";
import Simulator from "./Components/Simulator";
import TrainerAttendance from "./Components/TrainerAttendance";
import ExamList from "./Components/ExamList";
import { ExamResultsModal } from "./Components/ExamResultsModal";
import Feedback from "./Components/Feedback";
import DriverMarkingSystem from "./Components/DriverMarkingSystem";
import BronzeAssessment from "./Components/BronzeAssessment";
import SilverAssessment from "./Components/SilverAssessment";
import GoldAssessment from "./Components/GoldAssessment";
import { TextField, CircularProgress, Box, Chip, IconButton, Avatar, Checkbox, Tooltip, InputAdornment } from "@mui/material";
import { fetchAllScormCourse } from "helpers/scorm_helper";
import ScormCourse from "./Components/ScormCourse";
import ImageUploader from "./Components/ImageUploader";
import NotificationButtons from "./Components/NotificationButtons";
import LClass from "./Components/LClass";
import InfoIcon from '@mui/icons-material/Info';
import EventIcon from '@mui/icons-material/Event';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SchoolIcon from '@mui/icons-material/School';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SubjectIcon from '@mui/icons-material/Subject';
import LinkIcon from '@mui/icons-material/Link';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import TodayIcon from '@mui/icons-material/Today';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddIcon from '@mui/icons-material/Add';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import BadgeIcon from '@mui/icons-material/Badge';
import FilterListIcon from '@mui/icons-material/FilterList';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import DownloadIcon from '@mui/icons-material/Download';
import ArchiveIcon from '@mui/icons-material/Archive';
import DescriptionIcon from '@mui/icons-material/Description';
import WorkIcon from '@mui/icons-material/Work';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import { getResult } from "helpers/exam_helper";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const localizer = momentLocalizer(moment);

const allDepartments = [
    { id: 1, name: "Skilling" },
    { id: 2, name: "Upskilling" },
    { id: 3, name: "Paid Trainings" },
    { id: 4, name: "Corporate" },
    { id: 5, name: "School Project" },
    { id: 6, name: "University & College" },
]

const paginationModel = { page: 0, pageSize: 5 };

const BatchDetails = (props) => {
    document.title = "Content Management | Batch Details";
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [batchZipLoading, setBatchZipLoading] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    const [batchDetails, setBatchDetails] = useState(null);
    const [selectedTab, setSelectedTab] = useState("Courses");
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addCourseModal, setAddCourseModal] = useState(false);
    const [addTrainerModal, setAddTrainerModal] = useState(false);
    const [addStudentModal, setAddStudentModal] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [allScormCourses, setAllScormCourses] = useState([]);
    const [allCoursesOfBatch, setAllCourseOfBatch] = useState([]);
    const [allScormCoursesOfBatch, setAllScormCourseOfBatch] = useState([]);
    const [allTrainers, setAllTrainers] = useState([]);
    const [allStudents, setAllStudents] = useState([]);
    const [allTrainerOfBatch, setAllTrainerOfBatch] = useState([]);
    const [allStudentOfBatch, setAllStudentOfBatch] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedTrainer, setSelectedTrainer] = useState(null);
    const [trainerDeleteModal, setTrainerDeleteModal] = useState(false);
    const [studentDeleteModal, setStudentDeleteModal] = useState(false);
    const [courseDeleteModal, setCourseDeleteModal] = useState(false);
    const [department, setDepartment] = useState(null);
    const [liveClasses, setLiveClasses] = useState([]);
    const [showExamResults, setShowExamResults] = useState(false);
    const [trainingImages, setTrainingImages] = useState([]);
    const [organizationId, setOrganizationId] = useState(null);
    
    const [assessmentType, setAssessmentType] = useState("none");
    const [assessmentDebug, setAssessmentDebug] = useState("");
    
    const [selectedStudentsForBatch, setSelectedStudentsForBatch] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showSelectedStudents, setShowSelectedStudents] = useState(false);
    const [recentlyAddedStudents, setRecentlyAddedStudents] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    // State for multiple student removal from batch
    const [selectedStudentIds, setSelectedStudentIds] = useState([]);
    const [batchStudentSearchTerm, setBatchStudentSearchTerm] = useState("");
    const [filteredBatchStudents, setFilteredBatchStudents] = useState([]);
    const [removeAllStudentsModal, setRemoveAllStudentsModal] = useState(false);
    const [bulkRemoveModal, setBulkRemoveModal] = useState(false);

    const [certificateProgress, setCertificateProgress] = useState({
        total: 0,
        completed: 0,
        failed: 0,
        inProgress: false
    });
    
    const [calendarView, setCalendarView] = useState('month');
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showEventModal, setShowEventModal] = useState(false);
    const [calendarStats, setCalendarStats] = useState({
        pastClassesCurrentMonth: 0,
        pastClassesPrevMonth: 0,
        upcomingClasses: 0,
        totalClasses: 0
    });

    const [searchStudentText, setSearchStudentText] = useState("");
    const [searchTrainerText, setSearchTrainerText] = useState("");
    const [searchCourseText, setSearchCourseText] = useState("");
    const [searchAadhaarText, setSearchAadhaarText] = useState("");
    const [stateFilter, setStateFilter] = useState(null);
    const [divisionFilter, setDivisionFilter] = useState(null);
    const [availableStates, setAvailableStates] = useState([]);
    const [availableDivisions, setAvailableDivisions] = useState([]);
    const [availableAadhaarNumbers, setAvailableAadhaarNumbers] = useState([]);
    const [aadhaarFilter, setAadhaarFilter] = useState(null);
    const [availableContractorTokens, setAvailableContractorTokens] = useState([]);
    const [contractorTokenFilter, setContractorTokenFilter] = useState(null);
    
    const [availableNatureOfWork, setAvailableNatureOfWork] = useState([]);
    const [natureOfWorkFilter, setNatureOfWorkFilter] = useState(null);

    const [filteredAllStudents, setFilteredAllStudents] = useState([]);
    const [filteredAllTrainers, setFilteredAllTrainers] = useState([]);
    const [filteredAllCourses, setFilteredAllCourses] = useState([]);

    const [studentExamResults, setStudentExamResults] = useState({});
    const [driverMarkingResults, setDriverMarkingResults] = useState({});
    const [loadingExamResults, setLoadingExamResults] = useState({});
    const [fetchingExamResults, setFetchingExamResults] = useState(false);

    const [type, setType] = useState(null);

    const breadcrumbItems = [
        { title: "Batch", link: "#" },
        { title: "Batch Details", link: "#" },
    ]

    const determineAssessmentType = (batchDepartment, batchName) => {
        const isDriverDepartment = batchDepartment && batchDepartment.toLowerCase().includes("driver");
        const isSurakshaBatch = batchName && batchName.toLowerCase().startsWith("suraksha");
        
        if (isDriverDepartment) {
            console.log("Driver department + Suraksha batch → DriverMarkingSystem");
            return "driver";
        }
        
        const isTechnicalDepartment = batchDepartment && batchDepartment.toLowerCase().includes("technical");
        
        if (isTechnicalDepartment && batchName) {
            const lowerCaseName = batchName.toLowerCase().trim();
            
            if (lowerCaseName.startsWith("bronze")) {
                console.log("Technical department + Bronze batch → Bronze Assessment");
                return "bronze";
            } 
            else if (lowerCaseName.startsWith("silver")) {
                console.log("Technical department + Silver batch → Silver Assessment");
                return "silver";
            } 
            else if (lowerCaseName.startsWith("gold")) {
                console.log("Technical department + Gold batch → Gold Assessment");
                return "gold";
            }
        }
        
        console.log("No matching criteria → No Practical");
        return "none";
    };

    const hasPracticalAssessment = () => {
        return assessmentType !== "none";
    };

    // Check if department starts with "driver" to show simulator tab
    const shouldShowSimulatorTab = () => {
        const department = batchDetails?.department || '';
        return department.toLowerCase().startsWith('driver');
    };

    useEffect(() => {
        let authUser = JSON.parse(localStorage.getItem("authUser"));
        setOrganizationId(authUser?.organizationId);
        setType(authUser?.userType);
    }, []);

    useEffect(() => {
        props.setBreadcrumbItems('Student Details', breadcrumbItems)
    }, []);

    useEffect(() => {
        fetchBatchDetails();
        fetchAllStudents();
        getAllTrainers();
        fetchCourses();
        fetchScormCourses();
    }, []);

    useEffect(() => {
        getCourseOfBatch();
        getScormCourseOfBatch();
        getStudentOfBatch();
        getTrainerOfBatch();
    }, []);

    useEffect(() => {
        if (selectedTab === "Student" && allStudentOfBatch.length > 0) {
            autoFetchExamResultsForAllStudents();
        }
        // Filter batch students when search term changes
        filterBatchStudents();
    }, [selectedTab, allStudentOfBatch, batchStudentSearchTerm]);

    const autoFetchExamResultsForAllStudents = async () => {
        if (fetchingExamResults) return;
        
        setFetchingExamResults(true);
        const results = {};
        
        for (const student of allStudentOfBatch) {
            try {
                setLoadingExamResults(prev => ({ ...prev, [student.id]: true }));
                const examResponse = await getResult(`${params.id}/${student.id}`);
                
                if (examResponse?.success) {
                    let preTestScore = null;
                    let postTestScore = null;
                    
                    if (examResponse.result) {
                        const preTest = examResponse.result.preTest;
                        const postTest = examResponse.result.postTest;
                        
                        if (preTest !== undefined && preTest !== null) {
                            preTestScore = typeof preTest === 'number' ? preTest : 
                                         (preTest.percentage || preTest.score || 0);
                        }
                        
                        if (postTest !== undefined && postTest !== null) {
                            postTestScore = typeof postTest === 'number' ? postTest : 
                                          (postTest.percentage || postTest.score || 0);
                        }
                    }
                    
                    results[student.id] = {
                        preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
                        postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
                        lastUpdated: new Date().toISOString()
                    };
                }
                
                await new Promise(resolve => setTimeout(resolve, 100));
                
            } catch (error) {
                console.error(`Error auto-fetching exam results for student ${student.id}:`, error);
            } finally {
                setLoadingExamResults(prev => ({ ...prev, [student.id]: false }));
            }
        }
        
        setStudentExamResults(prev => ({ ...prev, ...results }));
        setFetchingExamResults(false);
    };

    const filterBatchStudents = () => {
        if (!allStudentOfBatch || allStudentOfBatch.length === 0) {
            setFilteredBatchStudents([]);
            return;
        }

        if (!batchStudentSearchTerm || batchStudentSearchTerm.trim() === "") {
            setFilteredBatchStudents(allStudentOfBatch);
            return;
        }

        const searchTerm = batchStudentSearchTerm.toLowerCase().trim();
        const filtered = allStudentOfBatch.filter(student => {
            const firstName = student.firstName?.toLowerCase() || '';
            const lastName = student.lastName?.toLowerCase() || '';
            const fullName = `${firstName} ${lastName}`.trim();
            const mobile = student.mobile || '';
            const email = student.email?.toLowerCase() || '';
            const depot = student.tataStudentDetailsDto?.depot?.toLowerCase() || '';
            const division = student.tataStudentDetailsDto?.division?.toLowerCase() || '';
            const state = student.tataStudentDetailsDto?.state?.toLowerCase() || '';

            return fullName.includes(searchTerm) ||
                   mobile.includes(searchTerm) ||
                   email.includes(searchTerm) ||
                   depot.includes(searchTerm) ||
                   division.includes(searchTerm) ||
                   state.includes(searchTerm);
        });

        setFilteredBatchStudents(filtered);
    };

    const extractFilters = (students) => {
        if (!students || students.length === 0) return;

        const states = [...new Set(students
            .map(student => {
                return student.tataStudentDetailsDto?.state ||
                    student.state ||
                    student.studentAddressInfo?.state;
            })
            .filter(state => state && state.trim() !== '')
            .sort())];

        const divisions = [...new Set(students
            .map(student => {
                return student.tataStudentDetailsDto?.division ||
                    student.division;
            })
            .filter(division => division && division.trim() !== '')
            .sort())];

        const aadhaarNumbers = [...new Set(students
            .map(student => {
                const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
                                 student.aadhaarNo || 
                                 student.aadharNo;
                return aadhaarNo ? String(aadhaarNo).trim() : null;
            })
            .filter(aadhaar => aadhaar && aadhaar.trim() !== '')
            .sort())];

        const contractorTokens = [...new Set(students
            .map(student => {
                const token = student.tataStudentDetailsDto?.contractorTokenNo || 
                            student.contractorTokenNo;
                return token ? String(token).trim() : null;
            })
            .filter(token => token && token.trim() !== '')
            .sort((a, b) => {
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
            }))];
            
        const natureOfWorkValues = [...new Set(students
            .map(student => {
                const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
                                   student.natureOfWork;
                return natureOfWork ? String(natureOfWork).trim() : null;
            })
            .filter(natureOfWork => natureOfWork && natureOfWork.trim() !== '')
            .sort())];

        setAvailableStates(states.map(state => ({ value: state, label: state })));
        setAvailableDivisions(divisions.map(division => ({ value: division, label: division })));
        setAvailableAadhaarNumbers(aadhaarNumbers.map(aadhaar => ({ 
            value: aadhaar, 
            label: aadhaar,
            display: formatAadhaarNumber(aadhaar)
        })));
        setAvailableContractorTokens(contractorTokens.map(token => ({ 
            value: token, 
            label: token,
            display: token
        })));
        
        setAvailableNatureOfWork(natureOfWorkValues.map(natureOfWork => ({ 
            value: natureOfWork, 
            label: natureOfWork,
            display: natureOfWork
        })));
    }

    const formatAadhaarNumber = (aadhaar) => {
        if (!aadhaar) return '--';
        const cleanAadhaar = String(aadhaar).replace(/\D/g, '');
        if (cleanAadhaar.length === 12) {
            return `${cleanAadhaar.substring(0, 4)} ${cleanAadhaar.substring(4, 8)} ${cleanAadhaar.substring(8, 12)}`;
        }
        return cleanAadhaar;
    };

    const applyStudentFilters = () => {
        let filtered = allStudents;

        if (searchStudentText) {
            const searchTerm = searchStudentText.toLowerCase();

            filtered = filtered.filter(student => {
                if (type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer") {
                    const firstName = student.firstName?.toLowerCase() || '';
                    const lastName = student.lastName?.toLowerCase() || '';
                    const mobile = student.mobile || '';
                    const depot = student.depot?.toLowerCase() || '';
                    const state = student.state?.toLowerCase() || '';
                    const division = student.division?.toLowerCase() || '';
                    const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
                                     student.aadhaarNo || 
                                     student.aadharNo || 
                                     '';
                    const contractorTokenNo = student.tataStudentDetailsDto?.contractorTokenNo || 
                                            student.contractorTokenNo || 
                                            '';
                    const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
                                       student.natureOfWork || 
                                       '';

                    return (
                        firstName.includes(searchTerm) ||
                        lastName.includes(searchTerm) ||
                        depot.includes(searchTerm) ||
                        state.includes(searchTerm) ||
                        division.includes(searchTerm) ||
                        aadhaarNo.includes(searchTerm) ||
                        contractorTokenNo.includes(searchTerm) ||
                        natureOfWork.toLowerCase().includes(searchTerm) ||
                        mobile.includes(searchStudentText)
                    );
                } else {
                    const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
                                     student.aadhaarNo || 
                                     student.aadharNo || 
                                     '';
                    const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
                                       student.natureOfWork || 
                                       '';
                    return (
                        (student.firstName && student.firstName.toLowerCase().includes(searchTerm)) ||
                        (student.lastName && student.lastName.toLowerCase().includes(searchTerm)) ||
                        (student.email && student.email.toLowerCase().includes(searchTerm)) ||
                        (student.mobile && student.mobile.includes(searchStudentText)) ||
                        (aadhaarNo && aadhaarNo.includes(searchTerm)) ||
                        (natureOfWork && natureOfWork.toLowerCase().includes(searchTerm))
                    );
                }
            });
        }

        if (searchAadhaarText) {
            const aadhaarSearchTerm = searchAadhaarText.toLowerCase();
            filtered = filtered.filter(student => {
                const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || 
                                 student.aadhaarNo || 
                                 student.aadharNo || 
                                 '';
                return aadhaarNo && aadhaarNo.toLowerCase().includes(aadhaarSearchTerm);
            });
        }

        if (stateFilter) {
            filtered = filtered.filter(student => {
                const studentState = student.tataStudentDetailsDto?.state ||
                    student.state ||
                    student.studentAddressInfo?.state;
                return studentState && studentState === stateFilter.value;
            });
        }

        if (divisionFilter) {
            filtered = filtered.filter(student => {
                const studentDivision = student.tataStudentDetailsDto?.division || 
                                      student.division;
                return studentDivision && studentDivision === divisionFilter.value;
            });
        }

        if (aadhaarFilter) {
            filtered = filtered.filter(student => {
                const studentAadhaar = student.tataStudentDetailsDto?.aadhaarNo || 
                                     student.aadhaarNo || 
                                     student.aadharNo;
                return studentAadhaar && studentAadhaar === aadhaarFilter.value;
            });
        }

        if (contractorTokenFilter) {
            filtered = filtered.filter(student => {
                const studentContractorToken = student.tataStudentDetailsDto?.contractorTokenNo || 
                                             student.contractorTokenNo;
                return studentContractorToken && studentContractorToken === contractorTokenFilter.value;
            });
        }
        
        if (natureOfWorkFilter) {
            filtered = filtered.filter(student => {
                const studentNatureOfWork = student.tataStudentDetailsDto?.natureOfWork || 
                                          student.natureOfWork;
                return studentNatureOfWork && studentNatureOfWork === natureOfWorkFilter.value;
            });
        }

        setFilteredAllStudents(filtered);
    }

    const clearStudentFilters = () => {
        setSearchStudentText("");
        setSearchAadhaarText("");
        setStateFilter(null);
        setDivisionFilter(null);
        setAadhaarFilter(null);
        setContractorTokenFilter(null);
        setNatureOfWorkFilter(null);
        setFilteredAllStudents(allStudents);
    };

    useEffect(() => {
        if (allStudents.length > 0) {
            applyStudentFilters();
        }
    }, [searchStudentText, searchAadhaarText, stateFilter, divisionFilter, aadhaarFilter, contractorTokenFilter, natureOfWorkFilter, allStudents]);

    useEffect(() => {
        if (filteredAllStudents.length > 0) {
            const allFilteredSelected = filteredAllStudents.every(student => 
                selectedStudentsForBatch.some(selected => selected.id === student.id)
            );
            setSelectAll(allFilteredSelected);
        } else {
            setSelectAll(false);
        }
    }, [filteredAllStudents, selectedStudentsForBatch]);

    useEffect(() => {
        if (!addStudentModal) {
            setSearchStudentText("");
            setSearchAadhaarText("");
            setStateFilter(null);
            setDivisionFilter(null);
            setAadhaarFilter(null);
            setContractorTokenFilter(null);
            setNatureOfWorkFilter(null);
            setSelectedStudentsForBatch([]);
            setSelectAll(false);
            setShowSelectedStudents(false);
            setRecentlyAddedStudents([]);
            setShowSuccessMessage(false);
        }
    }, [addStudentModal]);

    useEffect(() => {
        if (searchTrainerText === '') {
            setFilteredAllTrainers(allTrainers);
        } else {
            const filtered = allTrainers.filter(trainer => {
                return (
                    (trainer.name && trainer.name.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
                    (trainer.email && trainer.email.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
                    (trainer.mobile && trainer.mobile.toLowerCase().includes(searchTrainerText.toLowerCase()))
                );
            });
            setFilteredAllTrainers(filtered);
        }
    }, [searchTrainerText, allTrainers]);

    useEffect(() => {
        const filtered = allCourses.filter(course =>
            course.title.toLowerCase().includes(searchCourseText.toLowerCase())
        );
        setFilteredAllCourses(filtered);
    }, [searchCourseText, allCourses]);

    const fetchBatchDetails = async () => {
        try {
            setLoader(true);
            const data = await fetchSingleBatch(params.id);
            setLoader(false);
            if (data?.success) {
                setBatchDetails(data?.result[0]);
                
                const batchDepartment = data?.result[0]?.department;
                const batchName = data?.result[0]?.batchName;
                
                console.log("Raw batch department:", batchDepartment);
                console.log("Raw batch name:", batchName);
                
                const assessment = determineAssessmentType(batchDepartment, batchName);
                setAssessmentType(assessment);
                
                setAssessmentDebug(`Department: "${batchDepartment}", Batch: "${batchName}" → Assessment: ${assessment === "none" ? "No Practical" : assessment === "driver" ? "Driver Marking System" : assessment === "bronze" ? "Bronze Assessment" : assessment === "silver" ? "Silver Assessment" : "Gold Assessment"}`);
                
                const updatedTrainingImages = await updateImagesUrl(data?.result[0]?.images || []);
                setTrainingImages(updatedTrainingImages);
                const lvClass = data?.result[0]?.liveClasses?.map((liveClass) => ({
                    id: liveClass.id,
                    title: liveClass.title,
                    start: new Date(liveClass.classTime),
                    end: new Date(new Date(liveClass.classTime).getTime() + 60 * 60 * 1000),
                    description: liveClass.description,
                    classLink: liveClass.classLink,
                    resource: liveClass,
                })) || [];
                setLiveClasses(lvClass);
                calculateCalendarStats(lvClass);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const updateImagesUrl = async (data) => {
        const updatedUrls = await Promise.all(
            data?.map(async (name) => {
                if (name) {
                    const type = "image";
                    const response = await generatePresignedUrlForAccess({ name, type });

                    if (response.success) {
                        return response.presignedUrl;
                    } else {
                        console.error('Error generating pre-signed URL for:', name);
                        return name;
                    }
                }
                return name;
            })
        );
        return updatedUrls;
    };

    const getAllTrainers = async () => {
        try {
            const data = await fetchAllUsers();
            if (data?.success) {
                setAllTrainers(data?.result);
                setFilteredAllTrainers(data?.result);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    const fetchAllStudents = async () => {
        try {
            const type = JSON.parse(localStorage.getItem("authUser")).userType;
            let data;
            if (type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer") {
                data = await getAllStudentsForTata();
            } else {
                data = await getAllStudents();
            }

            if (data?.success) {
                setAllStudents(data?.result)
                setFilteredAllStudents(data?.result)
                extractFilters(data?.result);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong");
        }
    };

    const fetchCourses = async () => {
        try {
            setLoader(true);
            const data = await fetchAllCourses();
            setLoader(false);
            if (data?.success) {
                let updateData = await updateThubmnail(data?.result);
                setAllCourses(updateData);
                setFilteredAllCourses(updateData);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    };

    const fetchScormCourses = async () => {
        try {
            setLoader(true);
            const data = await fetchAllScormCourse();
            setLoader(false);
            if (data?.success) {
                let updateData = await updateScormThubmnail(data?.result);
                setAllScormCourses(updateData);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    };

    const getCourseOfBatch = async () => {
        try {
            setLoader(true);
            const data = await getAllCourseOfBatch(params.id);

            if (data?.success) {
                let updateData = await updateThubmnail(data?.result);
                setAllCourseOfBatch(updateData);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log("Something went wrong");
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const getScormCourseOfBatch = async () => {
        try {
            setLoader(true);
            const data = await getAllScormCourseOfBatch(params.id);

            if (data?.success) {
                let updateData = await updateScormThubmnail(data?.result);
                setAllScormCourseOfBatch(updateData);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const getStudentOfBatch = async () => {
        try {
            setLoader(true);
            const data = await getAllStudentOfBatch(params.id);
            if (data?.success) {
                setAllStudentOfBatch(data?.result || []);
                setFilteredBatchStudents(data?.result || []);
                setSelectedStudentIds([]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const getTrainerOfBatch = async () => {
        try {
            setLoader(true);
            const data = await getAllTrainerOfBatch(params.id);
            if (data?.success) {
                setAllTrainerOfBatch(data?.result);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const updateThubmnail = async (data) => {
        const updateData = await Promise.all(
            data.map(async (d) => {
                if (d?.thumbnailName) {
                    let name = d.thumbnailName;
                    let type = "image";
                    const response = await generatePresignedUrlForAccess({ name, type });

                    if (response.success) {
                        return {
                            ...d,
                            thumbnailUrl: response.presignedUrl,
                        };
                    } else {
                        console.error('Error generating pre-signed URL for', d.thumbnailName);
                        return d;
                    }
                }
                return d;
            })
        );
        return updateData;
    };

    const updateScormThubmnail = async (data) => {
        const updateData = await Promise.all(
            data.map(async (d) => {
                if (d?.thumbnail) {
                    let name = d.thumbnail;
                    let type = "image";
                    const response = await generatePresignedUrlForAccess({ name, type });

                    if (response.success) {
                        return {
                            ...d,
                            thumbnailUrl: response.presignedUrl,
                        };
                    } else {
                        console.error('Error generating pre-signed URL for', d.thumbnail);
                        return d;
                    }
                }
                return d;
            })
        );
        return updateData;
    };

    const handleUpdate = async () => {
        try {
            setLoader(true);
            setBatchDetails({ ...batchDetails, department: department?.name });
            const data = await updateBatch(batchDetails);
            if (data?.success) {
                toast.success(data?.message);
                setEditModal(false);
                fetchBatchDetails();
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleDeleteBatch = async () => {
        try {
            setLoader(true);
            const data = await deleteBatch(params.id);
            if (data?.success) {
                toast.success(data?.message);
                navigate("/all-batches");
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
            setDeleteModal(false);
        }
    };

    const handleAddCourseToBatch = async (id) => {
        try {
            setLoader(true);
            const data = await addCourseToBatch(params.id + "/" + id);

            if (data?.success) {
                toast.success(data?.message);
                getCourseOfBatch();
                setAddCourseModal(false);
            } else {
                toast.error(data?.message);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleRemoveCourseFromBatch = async () => {
        try {
            setLoader(true);
            const data = await removeCourseFromBatch(params.id + "/" + selectedCourse?.id);
            if (data?.success) {
                toast.success(data?.message);
                getCourseOfBatch();
                setCourseDeleteModal(false);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleAddTrainerToBatch = async (d) => {
        try {
            setLoader(true);
            const data = await addTrainerToBatch(params.id + "/" + d.id);

            if (data?.success) {
                toast.success(data?.message);
                getTrainerOfBatch();
                setAddTrainerModal(false);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log("error", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleRemoveTrainerFromBatch = async () => {
        try {
            setLoader(true);
            const data = await removeTrainerFromBatch(params.id + "/" + selectedTrainer?.id);
            if (data?.success) {
                toast.success(data?.message);
                getTrainerOfBatch();
                setTrainerDeleteModal(false);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };
    
    // Handle single student removal
    const handleRemoveStudentFromBatch = async () => {
        try {
            setLoader(true);
            const data = await removeStudentFromBatch(params.id + "/" + selectedStudent?.id);
            if (data?.success) {
                toast.success(data?.message);
                getStudentOfBatch();
                setStudentDeleteModal(false);
                setSelectedStudent(null);
                setSelectedStudentIds(prev => prev.filter(id => id !== selectedStudent?.id));
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    // Handle multiple student removal with confirmation
    const handleBulkRemoveStudents = () => {
        if (selectedStudentIds.length === 0) {
            toast.error("Please select at least one student to remove");
            return;
        }
        // Show confirmation modal
        setBulkRemoveModal(true);
    };

    // Execute bulk removal after confirmation
    const confirmBulkRemoveStudents = async () => {
        if (selectedStudentIds.length === 0) {
            toast.error("Please select at least one student to remove");
            setBulkRemoveModal(false);
            return;
        }

        // Get the selected student objects
        const selectedStudents = allStudentOfBatch.filter(student => 
            selectedStudentIds.includes(student.id)
        );

        try {
            setLoader(true);
            setBulkRemoveModal(false);
            
            const results = [];
            const removedStudents = [];
            const failedRemovals = [];

            for (const student of selectedStudents) {
                try {
                    const data = await removeStudentFromBatch(`${params.id}/${student.id}`);
                    results.push({
                        student,
                        success: data?.success || false,
                        message: data?.message || "Unknown error"
                    });
                    
                    if (data?.success) {
                        removedStudents.push(student);
                    } else {
                        failedRemovals.push({ student, message: data?.message });
                    }
                    
                    await new Promise(resolve => setTimeout(resolve, 100));
                } catch (error) {
                    results.push({
                        student,
                        success: false,
                        message: error?.response?.data?.message || "Network error"
                    });
                    failedRemovals.push({ 
                        student, 
                        message: error?.response?.data?.message || "Network error" 
                    });
                }
            }

            const successful = results.filter(r => r.success);
            const failed = results.filter(r => !r.success);
            
            if (successful.length > 0) {
                toast.success(`Successfully removed ${successful.length} student(s) from the batch`);
            }
            
            if (failed.length > 0) {
                toast.error(`${failed.length} student(s) could not be removed`);
                failed.forEach(f => {
                    console.error(`Failed to remove student ${f.student.firstName} ${f.student.lastName}: ${f.message}`);
                });
            }
            
            // Refresh the student list
            await getStudentOfBatch();
            
            // Clear selections
            setSelectedStudentIds([]);
            setBatchStudentSearchTerm("");
            
            if (failed.length > 0 && successful.length === 0) {
                toast.error("Failed to remove any students. Please check console for details.");
            }
            
        } catch (error) {
            console.error("Error removing multiple students:", error);
            toast.error("Error removing students from batch");
        } finally {
            setLoader(false);
        }
    };

    // Handle DataGrid selection change
    const handleSelectionChange = (selectionModel) => {
        console.log("Selection changed:", selectionModel);
        setSelectedStudentIds(selectionModel);
    };

    // Clear search for batch students
    const clearBatchStudentSearch = () => {
        setBatchStudentSearchTerm("");
        setFilteredBatchStudents(allStudentOfBatch);
    };

    const handleRemoveAllTrainer = async () => {
        try {
            setLoader(true);
            const data = await removeAllTrainersFromBatch(params.id);
            if (data?.success) {
                toast.success(data?.message);
                setAllTrainerOfBatch([]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleRemoveAllStudents = async () => {
        try {
            setLoader(true);
            const data = await removeAllStudentsFromBatch(params.id);
            if (data?.success) {
                toast.success(data?.message);
                setAllStudentOfBatch([]);
                setFilteredBatchStudents([]);
                setSelectedStudentIds([]);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
            setRemoveAllStudentsModal(false);
        }
    };

    const handleDownloadStudentDetailsClick = async () => {
        try {
            setLoader(true);
            const response = await axios.get(DOWNLOAD_BATCH_STUDENT_FILE + params.id, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'all_student_batches.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const setdept = async () => {
        const value = batchDetails?.department;
        const department = allDepartments.find(dept => dept.name === value);
        if (department) {
            setDepartment(department);
        } else {
            console.log("Department not found");
        }
    };

    const checkStudentEligibility = (student) => {
        const isAlreadyInCurrentBatch = allStudentOfBatch.some(s => s.id === student.id);
        
        if (isAlreadyInCurrentBatch) {
            return {
                eligible: false,
                reason: "Student already enrolled in this batch",
                isAlreadyAdded: true,
                code: "ALREADY_IN_CURRENT_BATCH"
            };
        }
        
        return {
            eligible: true,
            reason: "Student can be added to batch",
            isAlreadyAdded: false,
            code: "ELIGIBLE"
        };
    };

    const handleStudentSelection = (event, student) => {
        const eligibility = checkStudentEligibility(student);
        
        if (!eligibility.eligible) {
            toast.error(`Cannot select student: ${eligibility.reason}`);
            return;
        }

        if (event.target.checked) {
            setSelectedStudentsForBatch(prev => [...prev, student]);
        } else {
            setSelectedStudentsForBatch(prev => prev.filter(s => s.id !== student.id));
        }
    };
    
    const handleSelectAllStudents = (event) => {
        if (event.target.checked) {
            const eligibleStudents = filteredAllStudents.filter(student => {
                const eligibility = checkStudentEligibility(student);
                return eligibility.eligible;
            });
            
            setSelectedStudentsForBatch(prev => {
                const currentIds = new Set(prev.map(s => s.id));
                const newStudents = eligibleStudents.filter(s => !currentIds.has(s.id));
                return [...prev, ...newStudents];
            });
        } else {
            const filteredStudentIds = new Set(filteredAllStudents.map(s => s.id));
            setSelectedStudentsForBatch(prev => 
                prev.filter(student => !filteredStudentIds.has(student.id))
            );
        }
    };

    const handleRemoveSelectedStudent = (studentId) => {
        setSelectedStudentsForBatch(prev => prev.filter(student => student.id !== studentId));
    };

    const handleClearSelectedStudents = () => {
        setSelectedStudentsForBatch([]);
    };

    const handleModalClose = () => {
        setAddStudentModal(false);
        setShowSuccessMessage(false);
        setRecentlyAddedStudents([]);
    };

    const handleAddMultipleStudentsToBatch = async () => {
        if (selectedStudentsForBatch.length === 0) {
            toast.error("Please select at least one student");
            return;
        }

        const eligibleStudents = [];
        const ineligibleStudents = [];
        
        selectedStudentsForBatch.forEach(student => {
            const eligibility = checkStudentEligibility(student);
            if (eligibility.eligible) {
                eligibleStudents.push(student);
            } else {
                ineligibleStudents.push({ student, reason: eligibility.reason });
            }
        });

        if (eligibleStudents.length === 0) {
            toast.error("No eligible students selected");
            return;
        }

        if (ineligibleStudents.length > 0) {
            toast.warning(`${ineligibleStudents.length} student(s) are already in this batch and will not be added`);
        }

        try {
            setLoader(true);
            
            const results = [];
            const addedStudents = [];
            
            for (const student of eligibleStudents) {
                try {
                    const data = await addStudentToBatch(`${params.id}/${student.id}`);
                    results.push({
                        student,
                        success: data?.success || false,
                        message: data?.message || "Unknown error"
                    });
                    
                    if (data?.success) {
                        addedStudents.push(student);
                    }
                    
                    await new Promise(resolve => setTimeout(resolve, 100));
                } catch (error) {
                    results.push({
                        student,
                        success: false,
                        message: error?.response?.data?.message || "Network error"
                    });
                }
            }

            const successful = results.filter(r => r.success);
            const failed = results.filter(r => !r.success);
            
            if (successful.length > 0) {
                setSuccessMessage(`Successfully added ${successful.length} student(s) to the batch`);
                setShowSuccessMessage(true);
                
                setRecentlyAddedStudents(prev => [...prev, ...addedStudents]);
                
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 3000);
            }
            
            if (failed.length > 0) {
                toast.error(`${failed.length} student(s) could not be added`);
                failed.forEach(f => {
                    console.error(`Failed to add student ${f.student.firstName} ${f.student.lastName}: ${f.message}`);
                });
            }
            
            await getStudentOfBatch();
            
            if (successful.length > 0) {
                const addedIds = new Set(addedStudents.map(s => s.id));
                setSelectedStudentsForBatch(prev => 
                    prev.filter(student => !addedIds.has(student.id))
                );
            }
            
            if (failed.length === 0) {
                setSelectedStudentsForBatch([]);
            }
            
        } catch (error) {
            console.error("Error adding multiple students:", error);
            toast.error("Error adding students to batch");
        } finally {
            setLoader(false);
        }
    };
    
    const handleAddStudentToBatch = async (student) => {
        try {
            setLoader(true);
            
            const eligibility = checkStudentEligibility(student);
            if (!eligibility.eligible) {
                toast.error(`Cannot add student: ${eligibility.reason}`);
                setLoader(false);
                return;
            }

            const data = await addStudentToBatch(`${params.id}/${student.id}`);
            
            if (data?.success) {
                const studentName = `${student.firstName || ''} ${student.lastName || ''}`.trim();
                
                setSuccessMessage(`${studentName} added to batch successfully!`);
                setShowSuccessMessage(true);
                
                setRecentlyAddedStudents(prev => [...prev, student]);
                
                await getStudentOfBatch();
                
                setSelectedStudentsForBatch(prev => 
                    prev.filter(s => s.id !== student.id)
                );
                
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 3000);
                
                toast.success(`${studentName} added to batch successfully!`);
                
            } else {
                toast.error(data?.message || "Failed to add student to batch");
            }
        } catch (error) {
            console.error("Error adding student:", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const fetchStudentExamResult = async (studentId) => {
        if (!studentId || !params.id) return null;
        
        try {
            setLoadingExamResults(prev => ({ ...prev, [studentId]: true }));
            
            const examResponse = await getResult(`${params.id}/${studentId}`);
            
            if (examResponse?.success) {
                let preTestScore = null;
                let postTestScore = null;
                
                if (examResponse.result) {
                    const preTest = examResponse.result.preTest;
                    const postTest = examResponse.result.postTest;
                    
                    if (preTest !== undefined && preTest !== null) {
                        preTestScore = typeof preTest === 'number' ? preTest : 
                                     (preTest.percentage || preTest.score || 0);
                    }
                    
                    if (postTest !== undefined && postTest !== null) {
                        postTestScore = typeof postTest === 'number' ? postTest : 
                                      (postTest.percentage || postTest.score || 0);
                    }
                }
                
                const result = {
                    preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
                    postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
                    lastUpdated: new Date().toISOString()
                };
                
                setStudentExamResults(prev => ({
                    ...prev,
                    [studentId]: result
                }));
                
                return result;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Error fetching exam results for student", studentId, ":", error);
            return null;
        } finally {
            setLoadingExamResults(prev => ({ ...prev, [studentId]: false }));
        }
    };

    const fetchDriverMarkingResult = async (studentId) => {
        try {
            const student = allStudentOfBatch.find(s => s.id === studentId);
            if (student) {
                const result = {
                    isCompleted: student.driverMarkingCompleted || true,
                    score: student.driverMarkingScore || student.practicalScore || 0,
                    lastUpdated: new Date().toISOString()
                };
                
                setDriverMarkingResults(prev => ({
                    ...prev,
                    [studentId]: result
                }));
                
                return result;
            }
            return null;
        } catch (error) {
            console.error("Error fetching driver marking for student", studentId, ":", error);
            return null;
        }
    };

    const fetchExamResultsForAllStudents = async () => {
        try {
            setFetchingExamResults(true);
            const results = {};
            
            for (const student of allStudentOfBatch) {
                try {
                    const examResponse = await getResult(`${params.id}/${student.id}`);
                    
                    if (examResponse?.success) {
                        let preTestScore = null;
                        let postTestScore = null;
                        
                        if (examResponse.result) {
                            const preTest = examResponse.result.preTest;
                            const postTest = examResponse.result.postTest;
                            
                            if (preTest !== undefined && preTest !== null) {
                                preTestScore = typeof preTest === 'number' ? preTest : 
                                             (preTest.percentage || preTest.score || 0);
                            }
                            
                            if (postTest !== undefined && postTest !== null) {
                                postTestScore = typeof postTest === 'number' ? postTest : 
                                              (postTest.percentage || postTest.score || 0);
                            }
                        }
                        
                        results[student.id] = {
                            preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
                            postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
                            lastUpdated: new Date().toISOString()
                        };
                    }
                    
                    if (hasPracticalAssessment()) {
                        const driverMarkingResult = driverMarkingResults[student.id];
                        if (!driverMarkingResult) {
                            await fetchDriverMarkingResult(student.id);
                        }
                    }
                    
                } catch (error) {
                    console.error(`Error fetching exam results for student ${student.id}:`, error);
                    continue;
                }
            }
            
            setStudentExamResults(prev => ({ ...prev, ...results }));
            return results;
            
        } catch (error) {
            console.error("Error fetching all exam results:", error);
            throw error;
        } finally {
            setFetchingExamResults(false);
        }
    };

    const checkCertificateEligibility = (student, examResults = null) => {
        const studentExamResult = examResults || studentExamResults[student.id];
        const postTestScore = studentExamResult?.postTest || 0;
        
        if (!hasPracticalAssessment()) {
            if (loadingExamResults[student.id] && !studentExamResult) {
                return {
                    eligible: false,
                    reason: "Loading exam results...",
                    isLoading: true
                };
            }
            
            if (postTestScore === null || postTestScore === undefined) {
                return {
                    eligible: false,
                    reason: "Post-test results not available"
                };
            }
            
            if (postTestScore < 80) {
                return {
                    eligible: false,
                    reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
                };
            }
            
            return {
                eligible: true,
                reason: "Eligible for certificate download (Post-test only)"
            };
        }
        
        const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
        
        if (loadingExamResults[student.id] && !studentExamResult) {
            return {
                eligible: false,
                reason: "Loading exam results...",
                isLoading: true
            };
        }
        
        if (postTestScore === null || postTestScore === undefined) {
            return {
                eligible: false,
                reason: "Post-test results not available"
            };
        }
        
        if (postTestScore < 80) {
            return {
                eligible: false,
                reason: `Post-test score ${postTestScore}% is below 80% minimum requirement`
            };
        }
        
        if (!isDriverMarkingCompleted) {
            return {
                eligible: false,
                reason: `${getAssessmentName()} assessment not completed`
            };
        }
        
        return {
            eligible: true,
            reason: "Eligible for certificate download"
        };
    };

    const getPassedStudentsCount = (examResults = null) => {
        if (!allStudentOfBatch.length) return 0;
        
        return allStudentOfBatch.filter(student => {
            const studentExamResult = examResults || studentExamResults[student.id];
            const postTestScore = studentExamResult?.postTest || 0;
            
            if (!hasPracticalAssessment()) {
                return postTestScore >= 80;
            }
            
            const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
            return postTestScore >= 80 && isDriverMarkingCompleted;
        }).length;
    };

    const fetchAndDisplayExamResults = async (student) => {
        setSelectedStudent(student);
        const results = await fetchStudentExamResult(student.id);
        if (results) {
            setShowExamResults(true);
        } else {
            toast.error("Could not fetch exam results for this student");
        }
    };

    const updateDriverMarkingStatus = (studentId) => {
        setDriverMarkingResults(prev => ({
            ...prev,
            [studentId]: {
                isCompleted: true,
                score: 85,
                lastUpdated: new Date().toISOString()
            }
        }));
        
        setAllStudentOfBatch(prev => 
            prev.map(student => 
                student.id === studentId 
                    ? { ...student, driverMarkingCompleted: true }
                    : student
            )
        );
    };

    const generateCertificateForStudent = async (student) => {
        try {
            const requestData = {
                trainingType: "DDT_OTHER",
                studentName: student.firstName + " " + student.lastName,
                courseName: batchDetails?.batchName || "Driver Training",
                dlNo: student.tataStudentDetailsDto?.driverDlNo || "",
                aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || "",
                depot: student.tataStudentDetailsDto?.depot || "",
                project: student.tataStudentDetailsDto?.project || "",
                city: student.state || student.city || "",
                fromDate: batchDetails?.startDate || "",
                toDate: batchDetails?.endDate || "",
                validityDate: batchDetails?.validityDate || "",
                trainerName: allTrainerOfBatch[0]?.name || "",
                authorizedSignatory: "DGM-Skill Development",
                batchId: params.id,
                studentId: student.id
            };

            const response = await axios.post(
                url + 'api/certificate/generate',
                requestData,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Error generating certificate for student', student.id, ':', error);
            throw error;
        }
    };

    const downloadIndividualCertificate = async (student) => {
        setLoader(true);
        try {
            const certificateBlob = await generateCertificateForStudent(student);
            
            const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
            
            const blob = new Blob([certificateBlob], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            toast.success('Certificate downloaded successfully!');

        } catch (error) {
            console.error('Error generating certificate:', error);
            toast.error('Failed to generate certificate.');
        } finally {
            setLoader(false);
        }
    };

    const handleDownloadCertificate = async (student) => {
        if (!studentExamResults[student.id]) {
            setLoader(true);
            try {
                const results = await fetchStudentExamResult(student.id);
                
                if (!results) {
                    toast.error("Could not fetch exam results for this student");
                    setLoader(false);
                    return;
                }
                
                const eligibility = checkCertificateEligibility(student, results);
                
                if (!eligibility.eligible) {
                    toast.error(`Cannot download certificate: ${eligibility.reason}`);
                    setLoader(false);
                    return;
                }
                
                await downloadIndividualCertificate(student);
                
            } catch (error) {
                console.error('Error fetching exam results:', error);
                toast.error('Failed to fetch exam results. Please try again.');
                setLoader(false);
                return;
            }
        } else {
            const eligibility = checkCertificateEligibility(student);
            
            if (!eligibility.eligible) {
                toast.error(`Cannot download certificate: ${eligibility.reason}`);
                return;
            }
            
            await downloadIndividualCertificate(student);
        }
    };

    const generateExcelReport = (progressInfo) => {
        try {
            const wb = XLSX.utils.book_new();
            
            const summaryData = [
                ["BATCH CERTIFICATE GENERATION REPORT"],
                ["Generated Date:", progressInfo.generatedDate],
                ["Batch Name:", progressInfo.batchName],
                ["Batch ID:", progressInfo.batchId],
                ["Assessment Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
                ["Eligibility Criteria:", progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"],
                [],
                ["SUMMARY STATISTICS"],
                ["Total Students in Batch:", progressInfo.totalStudents],
                ["Passed Students:", progressInfo.passedStudents],
                ["Failed Students:", progressInfo.failedStudents],
                ["Certificates Generated:", progressInfo.generatedCertificates],
                ["Certificates Failed:", progressInfo.failedCertificates],
                [],
                ["CERTIFICATE ELIGIBILITY CRITERIA"],
                ["1. Post-test Score must be ≥ 80%", ""],
                ...(progressInfo.hasPractical ? [[`2. ${getAssessmentName()} assessment must be completed`, ""], ["3. Both conditions must be met for certificate generation", ""]] : [["2. Only post-test score ≥80% is required", ""]]),
                [],
                ["Assessment Information"],
                ["Batch Type:", progressInfo.hasPractical ? `${getAssessmentName()}` : "Post-test Only"],
                ["Practical Required:", progressInfo.hasPractical ? "Yes" : "No"]
            ];
            
            const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
            wsSummary["!cols"] = [
                { wch: 30 },
                { wch: 50 }
            ];
            
            const studentHeaders = [
                ["STUDENT CERTIFICATE GENERATION DETAILS"],
                [],
                ["S.No", "Student ID", "Full Name", "Depot/Division", "State", "Mobile", 
                 "Post-Test Score", "Practical Completed", "Eligibility Status", 
                 "Certificate Status", "Remarks"]
            ];
            
            const studentRows = progressInfo.students.map((student, index) => [
                index + 1,
                student.id,
                student.name,
                student.depotDivision || "N/A",
                student.state || "N/A",
                student.mobile || "N/A",
                student.postTestScore !== null ? `${student.postTestScore}%` : "N/A",
                student.practicalCompleted ? "Yes" : (progressInfo.hasPractical ? (student.postTestScore >= 80 ? "Pending" : "N/A") : "N/A"),
                student.eligible ? "Eligible" : "Not Eligible",
                student.certificateStatus,
                student.remarks || student.error || "N/A"
            ]);
            
            const studentData = [...studentHeaders, ...studentRows];
            const wsStudents = XLSX.utils.aoa_to_sheet(studentData);
            wsStudents["!cols"] = [
                { wch: 5 },
                { wch: 10 },
                { wch: 25 },
                { wch: 20 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 18 },
                { wch: 15 },
                { wch: 20 },
                { wch: 30 }
            ];
            
            const failedStudents = progressInfo.students.filter(s => s.certificateStatus === "Failed");
            if (failedStudents.length > 0) {
                const failedHeaders = [
                    ["FAILED CERTIFICATE GENERATIONS"],
                    [],
                    ["S.No", "Student ID", "Full Name", "Depot/Division", "Error Reason"]
                ];
                
                const failedRows = failedStudents.map((student, index) => [
                    index + 1,
                    student.id,
                    student.name,
                    student.depotDivision || "N/A",
                    student.error || "Unknown error"
                ]);
                
                const failedData = [...failedHeaders, ...failedRows];
                const wsFailed = XLSX.utils.aoa_to_sheet(failedData);
                wsFailed["!cols"] = [
                    { wch: 5 },
                    { wch: 10 },
                    { wch: 25 },
                    { wch: 20 },
                    { wch: 50 }
                ];
                XLSX.utils.book_append_sheet(wb, wsFailed, "Failed Generations");
            }
            
            XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
            XLSX.utils.book_append_sheet(wb, wsStudents, "Student Details");
            
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
            return excelBlob;
        } catch (error) {
            console.error('Error generating Excel report:', error);
            throw error;
        }
    };

    const generateAllCertificatesAsZip = async () => {
        try {
            setBatchZipLoading(true);
            
            toast.info("Fetching exam results for all students...");
            const allExamResults = await fetchExamResultsForAllStudents();
            
            const hasPractical = hasPracticalAssessment();
            
            const progressInfo = {
                batchName: batchDetails?.batchName || "Unknown Batch",
                batchId: params.id,
                generatedDate: new Date().toISOString(),
                totalStudents: allStudentOfBatch.length,
                passedStudents: 0,
                failedStudents: 0,
                generatedCertificates: 0,
                failedCertificates: 0,
                hasPractical: hasPractical,
                students: []
            };

            allStudentOfBatch.forEach((student, index) => {
                const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
                const postTestScore = studentExamResult?.postTest || 0;
                
                let isPracticalCompleted = true;
                if (hasPractical) {
                    isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
                }
                
                const isEligible = hasPractical 
                    ? (postTestScore >= 80 && isPracticalCompleted)
                    : (postTestScore >= 80);
                
                const depot = student.tataStudentDetailsDto?.depot || student.depot || '';
                const division = student.tataStudentDetailsDto?.division || student.division || '';
                const state = student.tataStudentDetailsDto?.state || student.state || '';
                const depotDivision = depot && division ? `${depot} / ${division}` : (depot || division || 'N/A');
                
                progressInfo.students.push({
                    name: `${student.firstName} ${student.lastName}`,
                    id: student.id,
                    depotDivision: depotDivision,
                    state: state || 'N/A',
                    mobile: student.mobile || null,
                    postTestScore: postTestScore,
                    practicalCompleted: isPracticalCompleted,
                    eligible: isEligible,
                    certificateStatus: "Pending",
                    remarks: "Not processed yet"
                });
                
                if (isEligible) {
                    progressInfo.passedStudents++;
                } else {
                    progressInfo.failedStudents++;
                }
            });

            const eligibleStudents = allStudentOfBatch.filter(student => {
                const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
                const postTestScore = studentExamResult?.postTest || 0;
                
                if (hasPractical) {
                    const isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
                    return postTestScore >= 80 && isPracticalCompleted;
                }
                return postTestScore >= 80;
            });

            if (eligibleStudents.length === 0) {
                toast.warning("No eligible students found in this batch. Generating report only.");
                
                progressInfo.students = progressInfo.students.map(student => ({
                    ...student,
                    certificateStatus: "Failed",
                    remarks: student.eligible ? "No certificates to generate (0 eligible)" : "Not eligible for certificate"
                }));
                
                const excelBlob = generateExcelReport(progressInfo);
                
                const zip = new JSZip();
                zip.file(`Certificate_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`, excelBlob);
                
                const zipBlob = await zip.generateAsync({ type: "blob" });
                const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificate_Report_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
                saveAs(zipBlob, zipFileName);
                
                toast.info("Excel report generated and downloaded");
                setBatchZipLoading(false);
                return;
            }

            const confirmed = window.confirm(
                `Batch: ${batchDetails?.batchName || "Unknown Batch"}\n` +
                `Assessment Type: ${hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
                `Eligibility Criteria: ${hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
                `Total Students: ${allStudentOfBatch.length}\n` +
                `Eligible Students: ${eligibleStudents.length}\n` +
                `Failed Students: ${allStudentOfBatch.length - eligibleStudents.length}\n\n` +
                `Generate certificates for ${eligibleStudents.length} eligible student(s)?`
            );
            
            if (!confirmed) {
                setBatchZipLoading(false);
                return;
            }

            setCertificateProgress({
                total: eligibleStudents.length,
                completed: 0,
                failed: 0,
                inProgress: true
            });

            const zip = new JSZip();
            const certificateFolder = zip.folder("Certificates");
            const reportFolder = zip.folder("Reports");

            for (let i = 0; i < eligibleStudents.length; i++) {
                const student = eligibleStudents[i];
                const studentIndex = progressInfo.students.findIndex(s => s.id === student.id);
                
                try {
                    const certificateBlob = await generateCertificateForStudent(student);
                    
                    const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
                    
                    certificateFolder.file(fileName, certificateBlob);
                    
                    progressInfo.students[studentIndex] = {
                        ...progressInfo.students[studentIndex],
                        certificateStatus: "Generated",
                        remarks: "Certificate successfully generated",
                        fileName: fileName
                    };
                    
                    progressInfo.generatedCertificates++;
                    
                    setCertificateProgress(prev => ({
                        ...prev,
                        completed: prev.completed + 1
                    }));
                    
                    if (i < eligibleStudents.length - 1) {
                        await new Promise(resolve => setTimeout(resolve, 300));
                    }
                    
                } catch (error) {
                    console.error(`Failed to generate certificate for student ${student.id}:`, error);
                    
                    progressInfo.students[studentIndex] = {
                        ...progressInfo.students[studentIndex],
                        certificateStatus: "Failed",
                        error: error.message || "Unknown error",
                        remarks: `Failed: ${error.message || "Unknown error"}`
                    };
                    
                    progressInfo.failedCertificates++;
                    
                    setCertificateProgress(prev => ({
                        ...prev,
                        failed: prev.failed + 1
                    }));
                }
            }

            progressInfo.students.forEach((student, index) => {
                if (student.certificateStatus === "Pending") {
                    progressInfo.students[index] = {
                        ...student,
                        certificateStatus: "Not Generated",
                        remarks: student.eligible ? "Not processed" : "Not eligible for certificate"
                    };
                }
            });

            const excelBlob = generateExcelReport(progressInfo);
            const excelFileName = `Certificate_Generation_Report_Batch_${batchDetails?.batchName || params.id}.xlsx`;
            reportFolder.file(excelFileName, excelBlob);

            const summaryText = `CERTIFICATE GENERATION SUMMARY\n` +
                               `============================\n` +
                               `Batch: ${progressInfo.batchName}\n` +
                               `Batch ID: ${progressInfo.batchId}\n` +
                               `Generated: ${progressInfo.generatedDate}\n` +
                               `Assessment Type: ${progressInfo.hasPractical ? getAssessmentName() : "Post-test Only"}\n` +
                               `Eligibility Criteria: ${progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"}\n\n` +
                               `Total Students: ${progressInfo.totalStudents}\n` +
                               `Eligible Students: ${progressInfo.passedStudents}\n` +
                               `Failed Students: ${progressInfo.failedStudents}\n` +
                               `Certificates Generated: ${progressInfo.generatedCertificates}\n` +
                               `Certificates Failed: ${progressInfo.failedCertificates}\n` +
                               `\nSee Excel report for detailed student information.`;
            
            reportFolder.file("SUMMARY.txt", summaryText);

            toast.info("Creating ZIP file with certificates and reports...");
            const zipBlob = await zip.generateAsync({ type: "blob" });
            
            const zipFileName = `Batch_${batchDetails?.batchName || params.id}_Certificates_${moment().format('YYYY-MM-DD_HH-mm')}.zip`;
            saveAs(zipBlob, zipFileName);

            const successful = certificateProgress.completed;
            const failed = certificateProgress.failed;
            
            if (failed === 0) {
                toast.success(`Successfully generated ${successful} certificate(s)! Check Excel report for all student statuses.`);
            } else {
                toast.warning(`Generated ${successful} certificate(s), ${failed} failed. Check Excel report for details.`);
            }

        } catch (error) {
            console.error('Error generating zip file:', error);
            
            if (error.message.includes("Failed to fetch")) {
                toast.error('Network error: Could not fetch exam results. Please check your connection and try again.');
            } else {
                toast.error('Failed to generate certificates zip file. Please try again.');
            }
        } finally {
            setBatchZipLoading(false);
            setCertificateProgress({
                total: 0,
                completed: 0,
                failed: 0,
                inProgress: false
            });
        }
    };

    const generateCertificatesForPassedStudents = async () => {
        if (allStudentOfBatch.length === 0) {
            toast.error("No students found in this batch");
            return;
        }
        
        await generateAllCertificatesAsZip();
    };

    const generateExcelReportOnly = async () => {
        try {
            setLoader(true);
            toast.info("Generating student status report...");
            
            const allExamResults = await fetchExamResultsForAllStudents();
            const hasPractical = hasPracticalAssessment();
            
            const progressInfo = {
                batchName: batchDetails?.batchName || "Unknown Batch",
                batchId: params.id,
                generatedDate: new Date().toISOString(),
                totalStudents: allStudentOfBatch.length,
                passedStudents: 0,
                failedStudents: 0,
                generatedCertificates: 0,
                failedCertificates: 0,
                hasPractical: hasPractical,
                students: []
            };

            allStudentOfBatch.forEach((student, index) => {
                const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
                const postTestScore = studentExamResult?.postTest || 0;
                
                let isPracticalCompleted = true;
                if (hasPractical) {
                    isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
                }
                
                const isEligible = hasPractical 
                    ? (postTestScore >= 80 && isPracticalCompleted)
                    : (postTestScore >= 80);
                
                const depot = student.tataStudentDetailsDto?.depot || student.depot || '';
                const division = student.tataStudentDetailsDto?.division || student.division || '';
                const state = student.tataStudentDetailsDto?.state || student.state || '';
                const depotDivision = depot && division ? `${depot} / ${division}` : (depot || division || 'N/A');
                
                progressInfo.students.push({
                    name: `${student.firstName} ${student.lastName}`,
                    id: student.id,
                    depotDivision: depotDivision,
                    state: state || 'N/A',
                    mobile: student.mobile || null,
                    postTestScore: postTestScore,
                    practicalCompleted: isPracticalCompleted,
                    eligible: isEligible,
                    certificateStatus: isEligible ? "Eligible (Not Generated)" : "Not Eligible",
                    remarks: isEligible 
                        ? (hasPractical ? "Meets criteria (Post-test ≥80% + Practical)" : "Meets criteria (Post-test ≥80%)") 
                        : (hasPractical 
                            ? (postTestScore >= 80 ? "Missing practical assessment" : "Post-test score below 80%")
                            : "Post-test score below 80%")
                });
                
                if (isEligible) {
                    progressInfo.passedStudents++;
                } else {
                    progressInfo.failedStudents++;
                }
            });

            const excelBlob = generateExcelReport(progressInfo);
            
            const excelFileName = `Student_Certificate_Status_${batchDetails?.batchName || "Batch"}_${moment().format('YYYY-MM-DD')}.xlsx`;
            const url = window.URL.createObjectURL(excelBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = excelFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            toast.success(`Excel report generated for ${allStudentOfBatch.length} students!`);
            
        } catch (error) {
            console.error('Error generating Excel report:', error);
            toast.error('Failed to generate Excel report');
        } finally {
            setLoader(false);
        }
    };

    const calculateCalendarStats = (classes) => {
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
        
        let prevMonth = currentMonth - 1;
        let prevYear = currentYear;
        if (prevMonth < 0) {
            prevMonth = 11;
            prevYear = currentYear - 1;
        }
        
        const pastClasses = classes.filter(lc => new Date(lc.end) < now);
        const pastClassesCurrentMonth = pastClasses.filter(lc => {
            const classDate = new Date(lc.start);
            return classDate.getMonth() === currentMonth && classDate.getFullYear() === currentYear;
        }).length;
        
        const pastClassesPrevMonth = pastClasses.filter(lc => {
            const classDate = new Date(lc.start);
            return classDate.getMonth() === prevMonth && classDate.getFullYear() === prevYear;
        }).length;
        
        const upcomingClasses = classes.filter(lc => new Date(lc.start) > now).length;
        
        setCalendarStats({
            pastClassesCurrentMonth,
            pastClassesPrevMonth,
            upcomingClasses,
            totalClasses: classes.length
        });
    };

    const handleEventClick = (event) => {
        setSelectedEvent(event.resource);
        setShowEventModal(true);
    };

    const openLiveClassLink = (link) => {
        if (!link) {
            toast.error("No class link available");
            return;
        }
        
        let formattedLink = link;
        if (!formattedLink.startsWith('http://') && !formattedLink.startsWith('https://')) {
            formattedLink = 'https://' + formattedLink;
        }
        
        window.open(formattedLink, '_blank', 'noopener,noreferrer');
    };

    const formatDate = (dateString) => {
        if (!dateString) return "Not set";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "Not set";
        const date = new Date(dateString);
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const isTataUser = type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer";
    const isTrainerRole = type === "Trainer" || type === "Tata Trainer";

    const getAssessmentComponent = () => {
        console.log("Rendering assessment component for type:", assessmentType);
        
        switch(assessmentType) {
            case "bronze":
                return (
                    <BronzeAssessment 
                        students={allStudentOfBatch} 
                        batchId={params.id}
                        batchDetails={batchDetails}
                    />
                );
            case "silver":
                return (
                    <SilverAssessment 
                        students={allStudentOfBatch} 
                        batchId={params.id}
                        batchDetails={batchDetails}
                    />
                );
            case "gold":
                return (
                    <GoldAssessment 
                        students={allStudentOfBatch} 
                        batchId={params.id}
                        batchDetails={batchDetails}
                    />
                );
            case "driver":
                return (
                    <DriverMarkingSystem 
                        students={allStudentOfBatch} 
                        onDriverMarkingComplete={updateDriverMarkingStatus}
                    />
                );
            case "none":
            default:
                return (
                    <div className="alert alert-warning text-center">
                        <h4 className="mb-2">No Practical Assessment Available</h4>
                        <p className="mb-0">
                            This batch does not have any practical assessment section configured.
                            Certificate eligibility is based only on post-test score (≥80%).
                        </p>
                    </div>
                );
        }
    };

    const getAssessmentName = () => {
        switch(assessmentType) {
            case "bronze":
                return "Bronze Assessment";
            case "silver":
                return "Silver Assessment";
            case "gold":
                return "Gold Assessment";
            case "driver":
                return "Driver Assessment";
            case "none":
            default:
                return "Post-test Only Assessment";
        }
    };

    const getAssessmentColor = () => {
        switch(assessmentType) {
            case "bronze":
                return "#CD7F32";
            case "silver":
                return "#C0C0C0";
            case "gold":
                return "#FFD700";
            case "driver":
                return "#FF9800";
            case "none":
            default:
                return "#6c757d";
        }
    };

    const shouldShowPracticalTab = () => {
        return assessmentType !== "none";
    };

    // STUDENT COLUMNS - using DataGrid's native selection
    const columnsStudent = [
        { field: 'id', headerName: 'ID', width: 60 },
        {
            field: 'fullName',
            headerName: 'Full name',
            sortable: false,
            width: 150,
            valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        },
        {
            field: 'email',
            headerName: 'Email',
            type: 'text',
            width: 200,
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            type: 'text',
            width: 130,
        },
        {
            field: 'depotDivision',
            headerName: 'Depot/Division',
            width: 200,
            renderCell: (params) => {
                const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
                const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
                const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {depot && division ? (
                            <>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <LocationOnIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
                                    <strong>{depot}</strong>
                                </span>
                                <span style={{ fontSize: '0.8rem', color: '#666', marginLeft: '22px' }}>
                                    <BusinessIcon style={{ fontSize: '0.8rem', marginRight: '4px' }} />
                                    {division}
                                </span>
                                {state && (
                                    <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '22px' }}>
                                        📍 {state}
                                    </span>
                                )}
                            </>
                        ) : depot ? (
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <LocationOnIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
                                {depot}
                                {state && <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '8px' }}>({state})</span>}
                            </span>
                        ) : division ? (
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <BusinessIcon style={{ fontSize: '0.9rem', marginRight: '4px', color: '#667eea' }} />
                                {division}
                                {state && <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '8px' }}>({state})</span>}
                            </span>
                        ) : (
                            <span style={{ color: '#999' }}>--</span>
                        )}
                    </div>
                );
            }
        },
        {
            field: 'postTestScore',
            headerName: 'Post-Test',
            type: 'number',
            width: 90,
            valueGetter: (value, row) => {
                const result = studentExamResults[row.id];
                if (loadingExamResults[row.id]) {
                    return 'Loading...';
                }
                return result?.postTest !== undefined && result?.postTest !== null ? `${Math.round(result.postTest)}%` : '--';
            },
            renderCell: (params) => {
                const result = studentExamResults[params.row.id];
                
                if (loadingExamResults[params.row.id]) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={16} sx={{ mr: 1 }} />
                            <span>Loading...</span>
                        </Box>
                    );
                }
                
                if (result?.postTest === undefined || result?.postTest === null) {
                    return '--';
                }
                
                return (
                    <span style={{ 
                        color: result.postTest >= 80 ? 'green' : 'red',
                        fontWeight: result.postTest >= 80 ? 'bold' : 'normal'
                    }}>
                        {Math.round(result.postTest)}%
                    </span>
                );
            }
        },
        ...(shouldShowPracticalTab() ? [{
            field: 'driverMarking',
            headerName: 'Practical',
            width: 100,
            valueGetter: (value, row) => {
                const result = driverMarkingResults[row.id];
                return result?.isCompleted ? 'Completed' : 'Pending';
            },
            renderCell: (params) => {
                const result = driverMarkingResults[params.row.id];
                const isCompleted = result?.isCompleted;
                const score = result?.score;
                
                return (
                    <div>
                        <span style={{ 
                            color: isCompleted ? 'green' : 'orange',
                            fontWeight: 'bold'
                        }}>
                            {isCompleted ? '✓ Completed' : '⏳ Pending'}
                        </span>
                        {isCompleted && score && (
                            <div style={{ fontSize: '0.8em', color: 'gray' }}>
                                Score: {score}%
                            </div>
                        )}
                    </div>
                );
            }
        }] : []),
        {
            field: 'passStatus',
            headerName: 'Result',
            width: 100,
            valueGetter: (value, row) => {
                const studentExamResult = studentExamResults[row.id];
                const postTestScore = studentExamResult?.postTest || 0;
                
                if (!shouldShowPracticalTab()) {
                    return postTestScore >= 80 ? 'Passed' : 'Failed';
                }
                
                const isDriverMarkingCompleted = driverMarkingResults[row.id]?.isCompleted || false;
                return postTestScore >= 80 && isDriverMarkingCompleted ? 'Passed' : 'Failed';
            },
            renderCell: (params) => {
                const studentExamResult = studentExamResults[params.row.id];
                const postTestScore = studentExamResult?.postTest || 0;
                
                let isPassed = false;
                if (!shouldShowPracticalTab()) {
                    isPassed = postTestScore >= 80;
                } else {
                    const isDriverMarkingCompleted = driverMarkingResults[params.row.id]?.isCompleted || false;
                    isPassed = postTestScore >= 80 && isDriverMarkingCompleted;
                }
                
                return (
                    <Chip 
                        label={isPassed ? 'Passed' : 'Failed'} 
                        color={isPassed ? 'success' : 'error'} 
                        size="small"
                    />
                );
            }
        },
        {
            field: 'examResults',
            headerName: 'Exam Results',
            width: 130,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => fetchAndDisplayExamResults(params.row)}
                    disabled={loadingExamResults[params.row.id]}
                    size="small"
                >
                    {loadingExamResults[params.row.id] ? 'Loading...' : 'View Results'}
                </Button>
            ),
        },
        ...(organizationId === 2 && !isTrainerRole
            ? [
                {
                    field: 'downloadCertificate',
                    headerName: 'Certificate',
                    width: 150,
                    renderCell: (params) => {
                        const eligibility = checkCertificateEligibility(params.row);
                        
                        if (eligibility.isLoading) {
                            return (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CircularProgress size={20} sx={{ mr: 1 }} />
                                    <span>Loading...</span>
                                </Box>
                            );
                        }
                        
                        return (
                            <Tooltip title={eligibility.reason} arrow>
                                <span>
                                    <Button
                                        variant="contained"
                                        color={eligibility.eligible ? "success" : "secondary"}
                                        onClick={() => handleDownloadCertificate(params.row)}
                                        disabled={!eligibility.eligible}
                                        startIcon={eligibility.eligible ? <DownloadIcon /> : <InfoIcon />}
                                        size="small"
                                    >
                                        {eligibility.eligible ? "Download" : "Not Eligible"}
                                    </Button>
                                </span>
                            </Tooltip>
                        );
                    },
                },
            ]
            : []),
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="danger"
                    onClick={() => { 
                        setSelectedStudent(params.row); 
                        setStudentDeleteModal(true); 
                    }}
                    size="small"
                >
                    Remove
                </Button>
            ),
        },
    ];

    const columnsTrainer = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', width: 300 },
        {
            field: 'email',
            headerName: 'Email',
            type: 'text',
            width: 300,
        },
        {
            field: 'mobile',
            headerName: 'Mobile No.',
            type: 'text',
            width: 300,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="danger"
                    onClick={() => { setSelectedTrainer(params.row); setTrainerDeleteModal(true); }}
                >
                    Remove
                </Button>
            ),
        },
    ];

    const columnsTrainerModal = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'name', headerName: 'Name', width: 150 },
        {
            field: 'email',
            headerName: 'Email',
            type: 'text',
            width: 150,
        },
        {
            field: 'mobile',
            headerName: 'Number',
            type: 'number',
            width: 150,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleAddTrainerToBatch(params.row)}
                    >
                        Add
                    </Button>
                );
            }
        },
    ];

    const columnsStudentModal = [
        { field: 'id', headerName: 'ID', width: 70 },
        {
            field: 'fullName',
            headerName: 'Full name',
            sortable: false,
            width: 160,
            valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        },
        {
            field: 'email',
            headerName: 'Email',
            type: 'text',
            width: 200,
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            type: 'number',
            width: 130,
        },
        {
            field: 'depotDivision',
            headerName: 'Depot/Division',
            width: 150,
            renderCell: (params) => {
                const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
                const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
                const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
                if (depot && division) {
                    return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
                } else if (depot) {
                    return <span>{depot}{state ? ` (${state})` : ''}</span>;
                } else if (division) {
                    return <span>{division}{state ? ` (${state})` : ''}</span>;
                }
                return <span style={{ color: '#999' }}>--</span>;
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                const eligibility = checkStudentEligibility(params.row);
                
                if (eligibility.isAlreadyAdded) {
                    return (
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled
                            title="Already added to this batch"
                            size="small"
                        >
                            <PersonOffIcon style={{ marginRight: '4px' }} />
                            In Batch
                        </Button>
                    );
                }

                return (
                    <Tooltip title="Add student to this batch" arrow>
                        <span>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => handleAddStudentToBatch(params.row)}
                                disabled={loader}
                                size="small"
                                startIcon={<PersonAddIcon />}
                            >
                                {loader ? 'Adding...' : 'Add to Batch'}
                            </Button>
                        </span>
                    </Tooltip>
                );
            }
        },
    ];

    const columnsStudentModalForTata = [
        {
            field: 'select',
            headerName: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAllStudents}
                        disabled={filteredAllStudents.length === 0 || loader}
                        indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
                    />
                    <span style={{ fontSize: '0.85rem' }}>Select All</span>
                </div>
            ),
            width: 100,
            renderCell: (params) => {
                const eligibility = checkStudentEligibility(params.row);
                const isSelected = selectedStudentsForBatch.some(student => student.id === params.row.id);
                
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={(e) => handleStudentSelection(e, params.row)}
                        disabled={eligibility.isAlreadyAdded}
                        title={eligibility.isAlreadyAdded ? "Already in this batch" : "Select to add to batch"}
                        color="primary"
                    />
                );
            },
        },
        { field: 'id', headerName: 'ID', width: 70 },
        {
            field: 'fullName',
            headerName: 'Full name',
            sortable: false,
            width: 120,
            valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            type: 'number',
            width: 100,
        },
        {
            field: 'depotDivision',
            headerName: 'Depot/Division',
            width: 140,
            renderCell: (params) => {
                const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
                const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
                const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
                if (depot && division) {
                    return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
                } else if (depot) {
                    return <span>{depot}{state ? ` (${state})` : ''}</span>;
                } else if (division) {
                    return <span>{division}{state ? ` (${state})` : ''}</span>;
                }
                return <span style={{ color: '#999' }}>--</span>;
            }
        },
        {
            field: 'division',
            headerName: 'Division',
            type: 'text',
            width: 100,
            valueGetter: (value, row) => {
                return row.tataStudentDetailsDto?.division || 
                       row.division || 
                       '--';
            },
        },
        {
            field: 'state',
            headerName: 'State',
            type: 'text',
            width: 100,
            valueGetter: (value, row) => {
                return row.tataStudentDetailsDto?.state || 
                       row.state || 
                       '--';
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                const eligibility = checkStudentEligibility(params.row);
                
                if (eligibility.isAlreadyAdded) {
                    return (
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled
                            title="Already added to this batch"
                            size="small"
                        >
                            <PersonOffIcon style={{ marginRight: '4px' }} />
                            In Batch
                        </Button>
                    );
                }

                return (
                    <Tooltip title="Add student to this batch" arrow>
                        <span>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => handleAddStudentToBatch(params.row)}
                                disabled={loader}
                                size="small"
                                startIcon={<PersonAddIcon />}
                            >
                                {loader ? 'Adding...' : 'Add to Batch'}
                            </Button>
                        </span>
                    </Tooltip>
                );
            }
        },
    ];

    const columnsSelectedStudents = [
        { field: 'id', headerName: 'ID', width: 70 },
        {
            field: 'fullName',
            headerName: 'Full name',
            sortable: false,
            width: 120,
            valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            type: 'number',
            width: 120,
        },
        {
            field: 'depotDivision',
            headerName: 'Depot/Division',
            width: 150,
            renderCell: (params) => {
                const depot = params.row.tataStudentDetailsDto?.depot || params.row.depot || '';
                const division = params.row.tataStudentDetailsDto?.division || params.row.division || '';
                const state = params.row.tataStudentDetailsDto?.state || params.row.state || '';
                
                if (depot && division) {
                    return <span>{depot} / {division}{state ? ` (${state})` : ''}</span>;
                } else if (depot) {
                    return <span>{depot}{state ? ` (${state})` : ''}</span>;
                } else if (division) {
                    return <span>{division}{state ? ` (${state})` : ''}</span>;
                }
                return <span style={{ color: '#999' }}>--</span>;
            }
        },
        {
            field: 'remove',
            headerName: 'Remove',
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="danger"
                    size="small"
                    onClick={() => handleRemoveSelectedStudent(params.row.id)}
                    startIcon={<PersonOffIcon />}
                >
                    Remove
                </Button>
            ),
        },
    ];

    const CustomToolbar = (toolbar) => {
        const goToBack = () => {
            toolbar.onNavigate('PREV');
            const newDate = moment(toolbar.date).subtract(1, toolbar.view === 'day' ? 'day' : toolbar.view === 'week' ? 'week' : 'month').toDate();
            setCurrentDate(newDate);
        };

        const goToNext = () => {
            toolbar.onNavigate('NEXT');
            const newDate = moment(toolbar.date).add(1, toolbar.view === 'day' ? 'day' : toolbar.view === 'week' ? 'week' : 'month').toDate();
            setCurrentDate(newDate);
        };

        const goToCurrent = () => {
            toolbar.onNavigate('TODAY');
            const today = new Date();
            setCurrentDate(today);
        };

        const viewChange = (view) => {
            toolbar.onView(view);
            setCalendarView(view);
        };

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#667eea',
                borderRadius: '10px',
                color: 'white',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <IconButton onClick={goToBack} style={{ color: 'white' }}>
                        <NavigateBeforeIcon />
                    </IconButton>
                    <IconButton onClick={goToCurrent} style={{ color: 'white' }}>
                        <TodayIcon />
                    </IconButton>
                    <IconButton onClick={goToNext} style={{ color: 'white' }}>
                        <NavigateNextIcon />
                    </IconButton>
                    <span style={{ 
                        fontSize: '1.5rem', 
                        fontWeight: 'bold',
                        marginLeft: '10px'
                    }}>
                        {moment(toolbar.date).format('MMMM YYYY')}
                    </span>
                </div>
                
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button 
                        color={calendarView === 'month' ? 'light' : 'white'}
                        onClick={() => viewChange('month')}
                        style={{
                            backgroundColor: calendarView === 'month' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            color: 'white'
                        }}
                    >
                        <CalendarMonthIcon style={{ marginRight: '5px' }} />
                        Month
                    </Button>
                    <Button 
                        color={calendarView === 'week' ? 'light' : 'white'}
                        onClick={() => viewChange('week')}
                        style={{
                            backgroundColor: calendarView === 'week' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            color: 'white'
                        }}
                    >
                        <ViewWeekIcon style={{ marginRight: '5px' }} />
                        Week
                    </Button>
                    <Button 
                        color={calendarView === 'day' ? 'light' : 'white'}
                        onClick={() => viewChange('day')}
                        style={{
                            backgroundColor: calendarView === 'day' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            color: 'white'
                        }}
                    >
                        <ViewDayIcon style={{ marginRight: '5px' }} />
                        Day
                    </Button>
                </div>
                
                <div>
                </div>
            </div>
        );
    };

    const CustomEvent = ({ event }) => {
        const now = new Date();
        const isPast = event.end < now;
        
        return (
            <div style={{
                padding: '5px',
                borderRadius: '4px',
                fontSize: '0.85em',
                color: 'white',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                opacity: isPast ? 0.7 : 1
            }}>
                <strong>{event.title}</strong>
                <div style={{ fontSize: '0.8em', marginTop: '2px' }}>
                    {moment(event.start).format('h:mm A')}
                </div>
            </div>
        );
    };

    const CustomAgendaEvent = ({ event }) => {
        return (
            <div style={{
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: '#667eea',
                borderRadius: '8px',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer'
            }}
            onClick={() => handleEventClick(event)}
            >
                <div>
                    <strong>{event.title}</strong>
                    <div style={{ fontSize: '0.9em', marginTop: '5px' }}>
                        {moment(event.start).format('MMMM D, YYYY • h:mm A')}
                    </div>
                    {event.description && (
                        <div style={{ fontSize: '0.85em', marginTop: '5px', opacity: 0.9 }}>
                            {event.description}
                        </div>
                    )}
                </div>
                <IconButton 
                    size="small" 
                    style={{ color: 'white' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEventClick(event);
                    }}
                >
                    <InfoIcon />
                </IconButton>
            </div>
        );
    };

    const eventStyleGetter = (event, start, end, isSelected) => {
        const now = new Date();
        const isPast = end < now;
        
        let backgroundColor = '#667eea';
        
        if (isPast) {
            backgroundColor = '#6c757d';
        } else if (event.title?.toLowerCase().includes('exam')) {
            backgroundColor = '#f56565';
        } else if (event.title?.toLowerCase().includes('review') || event.title?.toLowerCase().includes('assessment')) {
            backgroundColor = '#ed8936';
        }
        
        const style = {
            backgroundColor: backgroundColor,
            borderRadius: '8px',
            opacity: isPast ? 0.7 : 1,
            color: 'white',
            border: '0px',
            display: 'block',
            padding: '2px 5px',
            fontSize: '0.9em'
        };
        
        return {
            style: style
        };
    };

    const calendarStyles = {
        calendarContainer: {
            height: '70vh',
            marginTop: '20px',
            backgroundColor: 'white',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            padding: '15px'
        },
        header: {
            backgroundColor: '#667eea',
            color: 'white',
            padding: '15px',
            borderRadius: '10px',
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        statsCard: {
            backgroundColor: 'white',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
            marginBottom: '15px'
        }
    };

    return (
        <React.Fragment>
            {loader && <Loader />}
            
            <Row>
                <Col>
                    <Card>
                        <CardBody className="" style={{ minHeight: "70vh" }}>
                            <div
                                className="d-flex mt-4"
                                style={{
                                    borderBottom: "1px solid gray",
                                    width: "100%",
                                    overflowX: "auto",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Info" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Info")}
                                >
                                    <h5>Info</h5>
                                </div>
                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Notification" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Notification")}
                                >
                                    <h5>Notification</h5>
                                </div>
                                {type != "Trainer" && type != "Tata Trainer" &&
                                    <div
                                        className="me-4"
                                        style={{
                                            borderBottom: selectedTab === "Trainer" ? "4px solid blue" : "none",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setSelectedTab("Trainer")}
                                    >
                                        <h5>Trainer</h5>
                                    </div>
                                }

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Student" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Student")}
                                >
                                    <h5>Student</h5>
                                </div>

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Courses" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Courses")}
                                >
                                    <h5>Courses</h5>
                                </div>

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "ScormCourses" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("ScormCourses")}
                                >
                                    <h5>Scorm Courses</h5>
                                </div>

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "LiveClasses" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("LiveClasses")}
                                >
                                    <h5>Live Classes</h5>
                                </div>

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Attendance" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Attendance")}
                                >
                                    <h5>Attendance</h5>
                                </div>
                                
                                {/* Only show Simulator tab if department starts with "driver" */}
                                {shouldShowSimulatorTab() && (
                                    <div
                                        className="me-4"
                                        style={{
                                            borderBottom: selectedTab === "Simulator" ? "4px solid blue" : "none",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setSelectedTab("Simulator")}
                                    >
                                        <h5>Simulator</h5>
                                    </div>
                                )}

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Exam" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Exam")}
                                >
                                    <h5>Exam</h5>
                                </div>

                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "Feedback" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("Feedback")}
                                >
                                    <h5>Feedback</h5>
                                </div>

                                {organizationId === 2 && shouldShowPracticalTab() && (
                                    <div
                                        className="me-4"
                                        style={{
                                            borderBottom: selectedTab === "Practical" ? "4px solid blue" : "none",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setSelectedTab("Practical")}
                                    >
                                        <h5>
                                            Practical
                                            <span style={{ fontSize: '0.8rem', color: getAssessmentColor(), marginLeft: '5px', fontWeight: 'bold' }}>
                                                ({getAssessmentName()})
                                            </span>
                                        </h5>
                                    </div>
                                )}

                                {organizationId === 2 && (
                                    <div
                                        className="me-4"
                                        style={{
                                            borderBottom: selectedTab === "TrainingImages" ? "4px solid blue" : "none",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setSelectedTab("TrainingImages")}
                                    >
                                        <h5>Training Images</h5>
                                    </div>
                                )}
                            </div>

                            {selectedTab === "Info" && (
                                <>
                                    <div className="d-flex flex-column justify-content-between " style={{ height: "60vh" }}>
                                        <div className="mt-4">
                                            <div className="row">
                                                <div className="col-6">
                                                    <h5>Batch Name</h5>
                                                    <p>{batchDetails?.batchName ? batchDetails?.batchName : "--"}</p>
                                                    {batchDetails?.batchName && (
                                                        <div style={{ 
                                                            color: getAssessmentColor(), 
                                                            fontWeight: 'bold',
                                                            marginTop: '5px',
                                                            padding: '5px 10px',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '5px',
                                                            display: 'inline-block'
                                                        }}>
                                                            Assessment Type: {getAssessmentName()}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-6">
                                                    <h5>Department Name</h5>
                                                    <p>{batchDetails?.department ? batchDetails?.department : "--"}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {type != "Tata Trainer" && type != "Trainer" &&
                                            <>
                                                <div className="d-flex justify-content-end">
                                                    <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}> <i className="mdi mdi-pencil "></i> Edit</button>
                                                    <button className="px-3" style={{ cursor: "pointer", border: "none", backgroundColor: "red", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setDeleteModal(true)}> <i className="mdi mdi-delete "></i> Delete</button>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </>
                            )}

                            {selectedTab === "Notification" && (
                                <>
                                    <NotificationButtons />
                                </>
                            )}

                            {selectedTab === "Trainer" && (
                                <>
                                    <div className="row mt-5">
                                        <div className="col-md-12" style={{}}>
                                            <h1 className="text-center">Assign to Trainer</h1>
                                            <div className="d-flex justify-content-end mb-2">
                                                {type != "Tata Trainer" && type != "Trainer" &&
                                                    <>
                                                        <Button type="button" color="primary" onClick={() => setAddTrainerModal(true)} className="waves-effect waves-light align-self-end me-2">Add Trainer</Button>
                                                        <Button type="button" color="danger" onClick={() => handleRemoveAllTrainer()} className="waves-effect waves-light align-self-end">Remove All Trainer</Button>
                                                    </>
                                                }
                                            </div>
                                            <Paper sx={{ height: 400, width: '100%' }}>
                                                <DataGrid
                                                    rows={allTrainerOfBatch}
                                                    columns={columnsTrainer}
                                                    initialState={{ pagination: { paginationModel } }}
                                                    pageSizeOptions={[5, 10]}
                                                    disableRowSelectionOnClick
                                                    getRowClassName={() => 'data-grid-row'}
                                                    sx={{ border: 0 }}
                                                />
                                            </Paper>
                                        </div>
                                    </div>
                                </>
                            )}

                            {selectedTab === "Student" && (
                                <>
                                    <div className="row mt-5">
                                        <div className="col-md-12" style={{}}>
                                            <h1 className="text-center">Assign To Student</h1>
                                            
                                            {organizationId === 2 && !isTrainerRole && (
                                                <div className="alert alert-warning mb-3">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <strong>Certificate Status:</strong>
                                                            <ul className="mb-0 mt-2">
                                                                <li>Total Students: <strong>{allStudentOfBatch.length}</strong></li>
                                                                <li>
                                                                    Eligible Students: 
                                                                    <strong className="text-success">
                                                                        {fetchingExamResults ? (
                                                                            <span className="ms-1">
                                                                                <CircularProgress size={12} sx={{ mr: 1, verticalAlign: 'middle' }} />
                                                                                Calculating...
                                                                            </span>
                                                                        ) : (
                                                                            ` ${getPassedStudentsCount()}`
                                                                        )}
                                                                    </strong>
                                                                </li>
                                                                <li>
                                                                    Exam Results Status: 
                                                                    <span className={`ms-1 fw-bold ${fetchingExamResults ? 'text-warning' : 'text-success'}`}>
                                                                        {fetchingExamResults ? 'Fetching...' : 'Loaded'}
                                                                    </span>
                                                                </li>
                                                                <li>Certificate Eligibility: 
                                                                    {hasPracticalAssessment() 
                                                                        ? "Post-test ≥80% + Practical Assessment" 
                                                                        : "Post-test ≥80%"}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div>
                                                            <div className="d-flex flex-column gap-2">
                                                                <Button
                                                                    type="button"
                                                                    color="success"
                                                                    onClick={generateCertificatesForPassedStudents}
                                                                    disabled={batchZipLoading || fetchingExamResults}
                                                                    className="waves-effect waves-light"
                                                                    startIcon={batchZipLoading ? <CircularProgress size={20} /> : <ArchiveIcon />}
                                                                >
                                                                    {fetchingExamResults ? 'Fetching Results...' : 
                                                                     batchZipLoading ? 'Generating ZIP...' : 
                                                                     'Download All Certificates (ZIP)'}
                                                                </Button>
                                                                
                                                                <Button
                                                                    type="button"
                                                                    color="info"
                                                                    onClick={generateExcelReportOnly}
                                                                    disabled={loader || fetchingExamResults}
                                                                    className="waves-effect waves-light"
                                                                    startIcon={<DescriptionIcon />}
                                                                >
                                                                    Generate Excel Report Only
                                                                </Button>
                                                            </div>
                                                            {batchZipLoading && (
                                                                <Button
                                                                    type="button"
                                                                    color="secondary"
                                                                    onClick={() => setBatchZipLoading(false)}
                                                                    className="waves-effect waves-light mt-2"
                                                                    size="sm"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    
                                                    {certificateProgress.inProgress && (
                                                        <div className="mt-3">
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <small>
                                                                    Generating certificates: {certificateProgress.completed}/{certificateProgress.total}
                                                                    {certificateProgress.failed > 0 && (
                                                                        <span className="text-danger ms-2">({certificateProgress.failed} failed)</span>
                                                                    )}
                                                                </small>
                                                                <small>{Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%</small>
                                                            </div>
                                                            <div className="progress">
                                                                <div 
                                                                    className="progress-bar progress-bar-striped progress-bar-animated" 
                                                                    role="progressbar" 
                                                                    style={{ width: `${(certificateProgress.completed / certificateProgress.total) * 100}%` }}
                                                                >
                                                                    {Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%
                                                                </div>
                                                            </div>
                                                            <div className="text-center mt-1">
                                                                <small className="text-muted">
                                                                    This may take a few minutes. Please don't close the browser.
                                                                </small>
                                                            </div>
                                                        </div>
                                                    )}
                                                    
                                                    {!fetchingExamResults && Object.keys(studentExamResults).length === 0 && (
                                                        <div className="alert alert-info mt-2 mb-0 py-1">
                                                            <small>
                                                                <InfoIcon fontSize="small" className="me-1" />
                                                                Exam results will be automatically fetched when generating certificates or reports
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            <div className="mb-3">
                                                <div className="alert alert-success">
                                                    <strong>Student Addition Policy:</strong>
                                                    <ul className="mb-0">
                                                        <li><strong>ALL students</strong> can be added to this batch</li>
                                                        <li>Students can be in multiple batches simultaneously</li>
                                                        <li>{hasPracticalAssessment() 
                                                            ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
                                                            : `Only post-test (≥80%) is required for eligibility`}</li>
                                                        <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
                                                        <li>Total Students in Batch: <strong>{allStudentOfBatch.length}</strong></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            
                                            {/* Enhanced Search and Bulk Removal Section */}
                                            <div className="d-flex justify-content-between mb-3">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                                                    <TextField
                                                        size="small"
                                                        placeholder="Search students in batch by name, mobile, depot, division..."
                                                        value={batchStudentSearchTerm}
                                                        onChange={(e) => setBatchStudentSearchTerm(e.target.value)}
                                                        sx={{ flex: 1, maxWidth: '500px' }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SearchIcon />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: batchStudentSearchTerm && (
                                                                <InputAdornment position="end">
                                                                    <IconButton size="small" onClick={clearBatchStudentSearch}>
                                                                        <ClearIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                                                        {filteredBatchStudents.length} students
                                                        {batchStudentSearchTerm && ` (filtered from ${allStudentOfBatch.length})`}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {/* REMOVE SELECTED BUTTON - Shows only when students are selected */}
                                                    {selectedStudentIds.length > 0 && (
                                                        <Button
                                                            type="button"
                                                            color="danger"
                                                            onClick={handleBulkRemoveStudents}
                                                            disabled={loader}
                                                            size="sm"
                                                            startIcon={<PersonOffIcon />}
                                                            className="fw-bold"
                                                            style={{
                                                                backgroundColor: '#dc3545',
                                                                borderColor: '#dc3545',
                                                                boxShadow: '0 2px 4px rgba(220, 53, 69, 0.3)',
                                                                padding: '8px 16px',
                                                                borderRadius: '8px'
                                                            }}
                                                        >
                                                            Remove Selected ({selectedStudentIds.length})
                                                        </Button>
                                                    )}
                                                    <Button 
                                                        type="button" 
                                                        color="primary" 
                                                        onClick={() => setAddStudentModal(true)} 
                                                        className="waves-effect waves-light"
                                                        size="sm"
                                                        startIcon={<PersonAddIcon />}
                                                    >
                                                        Add Student
                                                    </Button>
                                                    <Button 
                                                        type="button" 
                                                        color="danger" 
                                                        onClick={() => setRemoveAllStudentsModal(true)} 
                                                        className="waves-effect waves-light"
                                                        size="sm"
                                                        startIcon={<DeleteIcon />}
                                                        variant="outline"
                                                    >
                                                        Remove All
                                                    </Button>
                                                </div>
                                            </div>
                                            
                                            <div className="d-flex justify-content-between mb-2">
                                                <button type="submit" className="btn btn-info w-md" onClick={handleDownloadStudentDetailsClick}>
                                                    <DownloadIcon style={{ marginRight: '5px' }} /> Download All Student File
                                                </button>
                                            </div>
                                            
                                            <Paper sx={{ height: 500, width: '100%' }}>
                                                <DataGrid
                                                    rows={filteredBatchStudents}
                                                    columns={columnsStudent}
                                                    initialState={{ pagination: { paginationModel } }}
                                                    pageSizeOptions={[5, 10, 25]}
                                                    checkboxSelection
                                                    onRowSelectionModelChange={handleSelectionChange}
                                                    rowSelectionModel={selectedStudentIds}
                                                    sx={{ border: 0 }}
                                                    loading={loader}
                                                />
                                            </Paper>
                                        </div>
                                    </div>
                                    <ExamResultsModal
                                        student={selectedStudent}
                                        batchId={params.id}
                                        open={showExamResults}
                                        onClose={() => setShowExamResults(false)}
                                        examResults={studentExamResults[selectedStudent?.id]}
                                        loading={loadingExamResults[selectedStudent?.id]}
                                    />
                                </>
                            )}

                            {selectedTab === "Courses" && (
                                <>
                                    <div className="d-flex justify-content-end mt-2">
                                        {type != "Trainer" && type != "Tata Trainer" &&
                                            <Button type="button" color="primary" onClick={() => setAddCourseModal(true)} className="waves-effect waves-light align-self-end">Add Course</Button>
                                        }
                                    </div>
                                    <div className="d-flex flex-row flex-wrap mt-3">
                                        {allCoursesOfBatch?.map((d, index) => (
                                            <div key={index} className="card me-5" style={{ width: "18rem", border: "2px solid gray", borderRadius: "10px", cursor: "pointer" }} onClick={() => navigate("/course-view/" + d.id)}>
                                                <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"200px"} />
                                                <div className="card-body">
                                                    <h5 className="card-title">{d?.title}</h5>
                                                    <div className="d-flex justify-content-between">
                                                        <h5>Duration: </h5>
                                                        <p>{d?.duration} Hours</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <h5>Level: </h5>
                                                        <p>{d?.levelDto?.name}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <h5>Language: </h5>
                                                        <p>{d?.language}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        {type !== "Trainer" && (
                                                            <Button
                                                                type="button"
                                                                color="danger"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedCourse(d);
                                                                    setCourseDeleteModal(true);
                                                                }}
                                                                className="waves-effect waves-light"
                                                            >
                                                                Remove Course
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            {selectedTab === "ScormCourses" && (
                                <>
                                    <ScormCourse getScormCourseOfBatch={getScormCourseOfBatch} allScormCourses={allScormCourses} allScormCoursesOfBatch={allScormCoursesOfBatch} type={type} />
                                </>
                            )}

                            {selectedTab === "LiveClasses" && (
                                <LClass
                                    liveClasses={liveClasses}
                                    loader={loader}
                                    setLoader={setLoader}
                                    params={params}
                                    fetchBatchDetails={fetchBatchDetails}
                                    spanDisplay={spanDisplay}
                                />
                            )}

                            {selectedTab === "Attendance" && (
                                <>
                                    <div className="">
                                        <TrainerAttendance trainers={allTrainerOfBatch} batchDetails={batchDetails} />
                                    </div>
                                    <Attendance students={allStudentOfBatch} batchDetails={batchDetails} />
                                </>
                            )}

                            {selectedTab === "Simulator" && shouldShowSimulatorTab() && (
                                <>
                                    <div className="">
                                    </div>
                                    <Simulator students={allStudentOfBatch} batchDetails={batchDetails} />
                                </>
                            )}

                            {selectedTab === "Exam" && (
                                <>
                                    <div className="mt-2">
                                        <ExamList />
                                    </div>
                                </>
                            )}

                            {selectedTab === "Feedback" && (
                                <>
                                    <div className="mt-2">
                                        <Feedback />
                                    </div>
                                </>
                            )}

                            {selectedTab === "Practical" && shouldShowPracticalTab() && (
                                <>
                                    <div className="mt-2">
                                        {getAssessmentComponent()}
                                    </div>
                                </>
                            )}

                            {selectedTab === "TrainingImages" && (
                                <>
                                    <ImageUploader batchId={params.id} trainingImages={trainingImages} fetchBatchDetails={fetchBatchDetails} />
                                </>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Bulk Remove Confirmation Modal */}
            <Modal show={bulkRemoveModal} size="lg" centered onHide={() => setBulkRemoveModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <PersonOffIcon style={{ color: '#dc3545', marginRight: '10px' }} />
                            <span>Confirm Bulk Removal</span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center py-3">
                        <div style={{ fontSize: '3rem', marginBottom: '20px' }}>
                            ⚠️
                        </div>
                        <h4 className="mb-3">Are you sure you want to remove these students?</h4>
                        <div className="alert alert-danger">
                            <strong>You are about to remove {selectedStudentIds.length} student(s) from this batch.</strong>
                        </div>
                        <div className="mt-3">
                            <p className="text-muted">
                                <strong>Selected Students:</strong>
                            </p>
                            <div style={{ maxHeight: '200px', overflowY: 'auto', textAlign: 'left' }}>
                                <ul className="list-group">
                                    {allStudentOfBatch
                                        .filter(student => selectedStudentIds.includes(student.id))
                                        .slice(0, 10)
                                        .map((student, index) => (
                                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                <span>
                                                    <strong>{student.firstName} {student.lastName}</strong>
                                                </span>
                                                <span className="badge bg-secondary rounded-pill">
                                                    ID: {student.id}
                                                </span>
                                            </li>
                                        ))}
                                    {selectedStudentIds.length > 10 && (
                                        <li className="list-group-item text-center text-muted">
                                            ... and {selectedStudentIds.length - 10} more students
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="mt-3">
                            <p className="text-danger">
                                <strong>This action cannot be undone!</strong>
                            </p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        type="button" 
                        color="secondary" 
                        onClick={() => setBulkRemoveModal(false)} 
                        className="waves-effect waves-light"
                        disabled={loader}
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="button" 
                        color="danger" 
                        onClick={confirmBulkRemoveStudents} 
                        className="waves-effect waves-light"
                        disabled={loader}
                        startIcon={<PersonOffIcon />}
                        style={{
                            backgroundColor: '#dc3545',
                            borderColor: '#dc3545'
                        }}
                    >
                        {loader ? 'Removing...' : `Yes, Remove ${selectedStudentIds.length} Student(s)`}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEventModal} centered onHide={() => setShowEventModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <VideoCallIcon style={{ marginRight: '10px', color: '#667eea' }} />
                            <span>Class Details</span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedEvent && (
                        <div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4 style={{ color: '#667eea', marginBottom: '10px' }}>{selectedEvent.title}</h4>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <AccessTimeIcon style={{ marginRight: '10px', color: '#666' }} />
                                    <span>{formatDateTime(selectedEvent.classTime)}</span>
                                </div>
                                {selectedEvent.description && (
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                                        <SubjectIcon style={{ marginRight: '10px', color: '#666', marginTop: '3px' }} />
                                        <span>{selectedEvent.description}</span>
                                    </div>
                                )}
                                {selectedEvent.classLink && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <LinkIcon style={{ marginRight: '10px', color: '#666' }} />
                                        <a 
                                            href={selectedEvent.classLink} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            style={{ color: '#667eea', textDecoration: 'underline' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                openLiveClassLink(selectedEvent.classLink);
                                            }}
                                        >
                                            {selectedEvent.classLink}
                                        </a>
                                    </div>
                                )}
                            </div>
                            
                            <div style={{
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                borderRadius: '8px',
                                marginTop: '20px'
                            }}>
                                <h6 style={{ marginBottom: '10px' }}>Quick Actions</h6>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    {selectedEvent.classLink && (
                                        <Button 
                                            color="primary" 
                                            onClick={() => openLiveClassLink(selectedEvent.classLink)}
                                            style={{ flex: 1 }}
                                        >
                                            <VideoCallIcon style={{ marginRight: '5px' }} />
                                            Join Now
                                        </Button>
                                    )}
                                    <Button 
                                        color="secondary" 
                                        style={{ flex: 1 }}
                                        onClick={() => {
                                            if (selectedEvent.classLink) {
                                                navigator.clipboard.writeText(selectedEvent.classLink);
                                                toast.success('Link copied to clipboard!');
                                            }
                                        }}
                                    >
                                        <LinkIcon style={{ marginRight: '5px' }} />
                                        Copy Link
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button color="secondary" onClick={() => setShowEventModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={deleteModal} size="lg" centered>
                <Modal.Header></Modal.Header>
                <Modal.Body>
                    <div className="">
                        <h1> Are you sure want To delete this Batch</h1>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setDeleteModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteBatch} className="waves-effect waves-light">Delete</Button>{" "}
                </Modal.Footer>
            </Modal>

            <Modal show={editModal} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Edit Batch Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <Row className="mb-3">
                            <label htmlFor="example-text-input" className="col-md-2 col-form-label">
                                Batch Name
                            </label>
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Batch Name"
                                    value={batchDetails?.batchName || ""}
                                    maxLength="50"
                                    onChange={(e) => setBatchDetails(prevDetails => ({
                                        ...prevDetails,
                                        batchName: e.target.value
                                    }))}
                                />
                                {!batchDetails?.batchName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <label htmlFor="example-text-input" className="col-md-2 col-form-label">
                                Department Name
                            </label>
                            <div className="col-md-10">
                                <Select
                                    value={department}
                                    onChange={(selectedValue) => setDepartment(selectedValue)}
                                    options={allDepartments}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id.toString()}
                                    classNamePrefix="select2-selection"
                                />
                                {!batchDetails?.department && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                            </div>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                </Modal.Footer>
            </Modal>

            <Modal show={addTrainerModal} size="lg" centered>
                <Modal.Header>Add Trainer</Modal.Header>
                <Modal.Body>
                    <div className="" >
                        <h1 className="text-center">All Trainers</h1>
                        <div className="mb-3 d-flex justify-content-center">
                            <div style={{ width: '50%' }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Search Trainer"
                                    value={searchTrainerText}
                                    onChange={(e) => setSearchTrainerText(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                />
                            </div>
                        </div>
                        <Paper sx={{ height: 400, width: '100%' }}>
                            <DataGrid
                                rows={filteredAllTrainers?.map((row, index) => ({
                                    ...row,
                                    serialNo: index + 1,
                                }))}
                                columns={columnsTrainerModal}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10]}
                                disableRowSelectionOnClick
                                getRowClassName={() => 'data-grid-row'}
                                sx={{ border: 0 }}
                            />
                        </Paper>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddTrainerModal(false)} className="waves-effect waves-light">Close</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={addStudentModal} size="xl" centered onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div>
                            <h4>Add Students to Batch</h4>
                            {batchDetails && (
                                <div className="batch-info-card mt-2 p-3 bg-light rounded">
                                    <div className="d-flex align-items-center mb-2">
                                        <SchoolIcon className="me-2 text-primary" />
                                        <h5 className="mb-0 text-primary">{batchDetails.batchName || "Batch"}</h5>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-center mb-1">
                                                <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
                                                <small>
                                                    <strong>Start Date:</strong> {formatDate(batchDetails.startDate)}
                                                </small>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-center mb-1">
                                                <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
                                                <small>
                                                    <strong>End Date:</strong> {formatDate(batchDetails.endDate)}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-success fw-bold">
                                            <strong>ALL students</strong> can be added. Students can be in multiple batches.
                                        </small>
                                    </div>
                                    {assessmentType !== "none" && (
                                        <div className="mt-2">
                                            <small style={{ color: getAssessmentColor() }} className="fw-bold">
                                                <strong>Assessment Type:</strong> {getAssessmentName()}
                                            </small>
                                        </div>
                                    )}
                                    {assessmentType === "none" && (
                                        <div className="mt-2">
                                            <small className="text-muted">
                                                <strong>Note:</strong> This batch does not have a practical assessment.
                                                Certificate eligibility based on post-test score (≥80%).
                                            </small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <h1 className="text-center">All Students</h1>
                        
                        {showSuccessMessage && (
                            <div className="alert alert-success alert-dismissible fade show mb-3" role="alert">
                                <strong>Success!</strong> {successMessage}
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={() => setShowSuccessMessage(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                        )}

                        {recentlyAddedStudents.length > 0 && (
                            <div className="alert alert-info mb-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>Recently Added Students:</strong>
                                        <ul className="mb-0 mt-1">
                                            {recentlyAddedStudents.slice(-5).map((student, index) => (
                                                <li key={index}>
                                                    {student.firstName} {student.lastName} 
                                                    <span className="text-muted"> ({student.mobile})</span>
                                                    {student.tataStudentDetailsDto?.depot && student.tataStudentDetailsDto?.division && (
                                                        <span className="text-info ms-2">
                                                            • {student.tataStudentDetailsDto.depot} / {student.tataStudentDetailsDto.division}
                                                        </span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <Button 
                                        color="link" 
                                        size="sm" 
                                        onClick={() => setRecentlyAddedStudents([])}
                                    >
                                        Clear List
                                    </Button>
                                </div>
                            </div>
                        )}

                        <div className="alert alert-info mb-3">
                            <strong>Student Addition Policy:</strong>
                            <ul className="mb-0">
                                <li><strong>ALL students</strong> can be added to this batch</li>
                                <li>Students can be in multiple batches simultaneously</li>
                                <li>{hasPracticalAssessment() 
                                    ? `Post-test (≥80%) and ${getAssessmentName()} will be REQUIRED after addition` 
                                    : `Only post-test (≥80%) is required for eligibility`}</li>
                                <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
                                <li>Available Students: <strong>{filteredAllStudents.length}</strong> | Selected: <strong>{selectedStudentsForBatch.length}</strong></li>
                                <li><strong>Tip:</strong> Modal stays open after successful addition. Click "Close" button when done.</li>
                            </ul>
                        </div>

                        {selectedStudentsForBatch.length > 0 && (
                            <div className="alert alert-warning mb-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>Selected {selectedStudentsForBatch.length} student(s)</strong>
                                    <Button 
                                        color="link" 
                                        onClick={() => setShowSelectedStudents(!showSelectedStudents)}
                                        className="ms-2"
                                    >
                                        {showSelectedStudents ? 'Hide Selected' : 'Show Selected'}
                                    </Button>
                                </div>
                                <div>
                                    <Button 
                                        color="secondary" 
                                        size="sm" 
                                        onClick={handleClearSelectedStudents}
                                        className="me-2"
                                    >
                                        Clear All
                                    </Button>
                                    <Button 
                                        color="success" 
                                        size="sm" 
                                        onClick={handleAddMultipleStudentsToBatch}
                                        disabled={loader}
                                        startIcon={<PersonAddIcon />}
                                    >
                                        {loader ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
                                    </Button>
                                </div>
                            </div>
                        )}

                        {showSelectedStudents && selectedStudentsForBatch.length > 0 && (
                            <div className="mb-3">
                                <h5>Selected Students:</h5>
                                <Paper sx={{ height: 200, width: '100%', marginBottom: 2 }}>
                                    <DataGrid
                                        rows={selectedStudentsForBatch}
                                        columns={columnsSelectedStudents}
                                        pageSizeOptions={[5]}
                                        disableRowSelectionOnClick
                                        sx={{ border: 0 }}
                                    />
                                </Paper>
                            </div>
                        )}

                        <div className="mb-3">
                            <Row>
                                <Col md={isTataUser ? 2 : 4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Search by Name/Email/Mobile"
                                        value={searchStudentText}
                                        onChange={(e) => setSearchStudentText(e.target.value)}
                                        sx={{ marginBottom: 2 }}
                                    />
                                </Col>
                                
                                <Col md={isTataUser ? 2 : 4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Search by Aadhaar No"
                                        value={searchAadhaarText}
                                        onChange={(e) => setSearchAadhaarText(e.target.value)}
                                        sx={{ marginBottom: 2 }}
                                        InputProps={{
                                            startAdornment: (
                                                <FingerprintIcon style={{ marginRight: '8px', color: '#667eea' }} />
                                            ),
                                        }}
                                    />
                                </Col>
                                
                                {isTataUser && (
                                    <Col md={2}>
                                        <Select
                                            placeholder="Filter by State"
                                            value={stateFilter}
                                            onChange={setStateFilter}
                                            options={availableStates}
                                            isClearable
                                            className="mb-2"
                                        />
                                    </Col>
                                )}
                                
                                {isTataUser && (
                                    <Col md={2}>
                                        <Select
                                            placeholder="Filter by Division"
                                            value={divisionFilter}
                                            onChange={setDivisionFilter}
                                            options={availableDivisions}
                                            isClearable
                                            className="mb-2"
                                        />
                                    </Col>
                                )}
                                
                                {isTataUser && (
                                    <Col md={2}>
                                        <Select
                                            placeholder="Filter by Contractor Token"
                                            value={contractorTokenFilter}
                                            onChange={setContractorTokenFilter}
                                            options={availableContractorTokens}
                                            isClearable
                                            className="mb-2"
                                            formatOptionLabel={({ value, label, display }) => (
                                                <div>
                                                    <span className="fw-bold">{display || label}</span>
                                                </div>
                                            )}
                                        />
                                    </Col>
                                )}
                            </Row>
                            
                            {isTataUser && availableNatureOfWork.length > 0 && (
                                <Row className="mt-2">
                                    <Col md={6}>
                                        <div className="d-flex align-items-center mb-2">
                                            <WorkIcon className="me-2 text-primary" />
                                            <span className="me-2" style={{ whiteSpace: 'nowrap' }}>Filter by Nature of Work:</span>
                                            <Select
                                                placeholder="Select Nature of Work"
                                                value={natureOfWorkFilter}
                                                onChange={setNatureOfWorkFilter}
                                                options={availableNatureOfWork}
                                                isClearable
                                                className="flex-grow-1"
                                                formatOptionLabel={({ value, label, display }) => (
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <WorkIcon style={{ fontSize: '1rem', marginRight: '8px', color: '#667eea' }} />
                                                        <span className="fw-bold">{display || label}</span>
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            )}
                            
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    {isTataUser && (
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={handleSelectAllStudents}
                                            disabled={filteredAllStudents.length === 0 || loader}
                                            indeterminate={selectedStudentsForBatch.length > 0 && !selectAll}
                                        />
                                    )}
                                    <span className="ms-2 fw-bold">
                                        {selectedStudentsForBatch.length > 0 && (
                                            <span style={{ color: '#28a745' }}>
                                                {selectedStudentsForBatch.length} selected
                                            </span>
                                        )}
                                    </span>
                                    <small className="text-muted ms-3">
                                        Showing {filteredAllStudents.length} of {allStudents.length} students
                                        {(stateFilter || divisionFilter || aadhaarFilter || contractorTokenFilter || natureOfWorkFilter) && (
                                            <span className="ms-2">
                                                {stateFilter && ` • State: ${stateFilter.label}`}
                                                {divisionFilter && ` • Division: ${divisionFilter.label}`}
                                                {aadhaarFilter && ` • Aadhaar: ${formatAadhaarNumber(aadhaarFilter.value)}`}
                                                {contractorTokenFilter && ` • Contractor Token: ${contractorTokenFilter.label}`}
                                                {natureOfWorkFilter && ` • Nature of Work: ${natureOfWorkFilter.label}`}
                                            </span>
                                        )}
                                    </small>
                                </div>
                                <Button 
                                    color="secondary" 
                                    size="sm" 
                                    onClick={clearStudentFilters}
                                    disabled={!searchStudentText && !searchAadhaarText && !stateFilter && !divisionFilter && !aadhaarFilter && !contractorTokenFilter && !natureOfWorkFilter || loader}
                                    startIcon={<FilterListIcon />}
                                >
                                    Clear Filters
                                </Button>
                            </div>
                        </div>

                        {isTataUser ? (
                            <Paper sx={{ height: 500, width: '100%' }}>
                                <DataGrid
                                    rows={filteredAllStudents?.map((row, index) => ({
                                        ...row,
                                        id: row.id || index + 1,
                                    }))}
                                    columns={columnsStudentModalForTata}
                                    initialState={{ pagination: { paginationModel } }}
                                    pageSizeOptions={[5, 10, 25]}
                                    disableRowSelectionOnClick
                                    getRowClassName={() => 'data-grid-row'}
                                    sx={{ border: 0 }}
                                    loading={loader}
                                />
                            </Paper>
                        ) : (
                            <Paper sx={{ height: 500, width: '100%' }}>
                                <DataGrid
                                    rows={filteredAllStudents?.map((row, index) => ({
                                        ...row,
                                        id: row.id || index + 1,
                                    }))}
                                    columns={columnsStudentModal}
                                    initialState={{ pagination: { paginationModel } }}
                                    pageSizeOptions={[5, 10, 25]}
                                    disableRowSelectionOnClick
                                    getRowClassName={() => 'data-grid-row'}
                                    sx={{ border: 0 }}
                                    loading={loader}
                                />
                            </Paper>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            {selectedStudentsForBatch.length > 0 && (
                                <Button 
                                    type="button" 
                                    color="success" 
                                    onClick={handleAddMultipleStudentsToBatch}
                                    disabled={loader}
                                    startIcon={<PersonAddIcon />}
                                >
                                    {loader ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
                                </Button>
                            )}
                        </div>
                        <div>
                            <Button 
                                type="button" 
                                color="secondary" 
                                onClick={handleModalClose}
                                className="waves-effect waves-light me-2"
                                disabled={loader}
                            >
                                Close
                            </Button>
                            {recentlyAddedStudents.length > 0 && (
                                <Button 
                                    type="button" 
                                    color="primary" 
                                    onClick={() => {
                                        handleModalClose();
                                        setSelectedTab("Student");
                                    }}
                                    disabled={loader}
                                >
                                    Done ({recentlyAddedStudents.length} added)
                                </Button>
                            )}
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={addCourseModal} size="lg" centered>
                <Modal.Header>Add Courses</Modal.Header>
                <Modal.Body>
                    <div className="">
                        <div className="mb-3 d-flex justify-content-center">
                            <div style={{ width: '50%' }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Search Course"
                                    value={searchCourseText}
                                    onChange={(e) => setSearchCourseText(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
                            {filteredAllCourses.length > 0 && filteredAllCourses?.map((d, i) => (
                                <div key={i} className="card me-5 mb-3" style={{ "width": "18rem", border: "2px solid gray", borderRadius: "10px" }} >
                                    <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course thumbnail"} height={"220px"} />
                                    <div className="card-body" >
                                        <h5 className="card-title">{d?.title}</h5>
                                        <div className="d-flex justify-content-between">
                                            <h5>Duration: </h5>
                                            <p>{d?.duration} Hours</p>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <h5>Level: </h5>
                                            <p>{d?.levelDto?.name}</p>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <h5>Language: </h5>
                                            <p>{d?.language}</p>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <Button type="button" color="success" onClick={() => handleAddCourseToBatch(d?.id)} className="waves-effect waves-light">Add Course</Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddCourseModal(false)} className="waves-effect waves-light">Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Remove All Students Confirmation Modal */}
            <Modal show={removeAllStudentsModal} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Remove All Students</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <h4>Are you sure you want to remove all students from this batch?</h4>
                        <p className="text-danger mt-2">
                            <strong>Warning:</strong> This action cannot be undone. 
                            All {allStudentOfBatch.length} students will be removed from the batch.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="secondary" onClick={() => setRemoveAllStudentsModal(false)} className="waves-effect waves-light">
                        Cancel
                    </Button>
                    <Button type="button" color="danger" onClick={handleRemoveAllStudents} className="waves-effect waves-light" disabled={loader}>
                        {loader ? 'Removing...' : 'Yes, Remove All'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={studentDeleteModal} size="lg" centered>
                <Modal.Body>
                    <h4>Are you sure want to remove this Student?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setStudentDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleRemoveStudentFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
                </Modal.Footer>
            </Modal>

            <Modal show={courseDeleteModal} size="lg" centered>
                <Modal.Body>
                    <h4>Are you sure want to remove this Course?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setCourseDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleRemoveCourseFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
                </Modal.Footer>
            </Modal>

            <Modal show={trainerDeleteModal} size="lg" centered>
                <Modal.Body>
                    <h4>Are you sure want to remove this Trainer?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setTrainerDeleteModal(false) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleRemoveTrainerFromBatch} className="waves-effect waves-light">Yes</Button>{" "}
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

export default connect(null, {setBreadcrumbItems })(BatchDetails);












// import React, { useEffect, useState } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import Loader from "components/Loader/Loader";
// import { useNavigate, useParams } from "react-router-dom";
// import { getAllStudents, getAllStudentsForTata } from "helpers/student_helper";
// import { Modal } from "react-bootstrap";
// import { fetchAllCourses } from "helpers/course_helper";
// import { DOWNLOAD_BATCH_STUDENT_FILE, url } from "helpers/url_helper";
// import { DataGrid } from '@mui/x-data-grid';
// import Paper from '@mui/material/Paper';
// import { generatePresignedUrlForAccess } from "helpers/Content_helper";
// import {
//     addCourseToBatch,
//     addStudentToBatch,
//     addMultipleStudentsToBatch,
//     addTrainerToBatch,
//     deleteBatch,
//     fetchSingleBatch,
//     getAllCourseOfBatch,
//     getAllScormCourseOfBatch,
//     getAllStudentOfBatch,
//     getAllTrainerOfBatch,
//     removeAllStudentsFromBatch,
//     removeAllTrainersFromBatch,
//     removeCourseFromBatch,
//     removeStudentFromBatch,
//     removeTrainerFromBatch,
//     updateBatch
// } from "helpers/batch_helper";
// import { fetchAllUsers } from "helpers/user_helper";
// import axios from "axios";
// import Select from "react-select";
// import Attendance from "./Components/Attendance";
// import Simulator from "./Components/Simulator";
// import TrainerAttendance from "./Components/TrainerAttendance";
// import ExamList from "./Components/ExamList";
// import { ExamResultsModal } from "./Components/ExamResultsModal";
// import Feedback from "./Components/Feedback";
// import DriverMarkingSystem from "./Components/DriverMarkingSystem";
// import BronzeAssessment from "./Components/BronzeAssessment";
// import SilverAssessment from "./Components/SilverAssessment";
// import GoldAssessment from "./Components/GoldAssessment";
// import { TextField, CircularProgress, Box, Chip, IconButton, Checkbox, Tooltip, InputAdornment } from "@mui/material";
// import { fetchAllScormCourse } from "helpers/scorm_helper";
// import ScormCourse from "./Components/ScormCourse";
// import ImageUploader from "./Components/ImageUploader";
// import NotificationButtons from "./Components/NotificationButtons";
// import LClass from "./Components/LClass";
// import InfoIcon from '@mui/icons-material/Info';
// import EventIcon from '@mui/icons-material/Event';
// import SchoolIcon from '@mui/icons-material/School';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import PersonOffIcon from '@mui/icons-material/PersonOff';
// import VideoCallIcon from '@mui/icons-material/VideoCall';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import SubjectIcon from '@mui/icons-material/Subject';
// import LinkIcon from '@mui/icons-material/Link';
// import FingerprintIcon from '@mui/icons-material/Fingerprint';
// import BadgeIcon from '@mui/icons-material/Badge';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import DescriptionIcon from '@mui/icons-material/Description';
// import WorkIcon from '@mui/icons-material/Work';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';

// import moment from 'moment';
// import { getResult } from "helpers/exam_helper";
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';

// const allDepartments = [
//     { id: 1, name: "Skilling" },
//     { id: 2, name: "Upskilling" },
//     { id: 3, name: "Paid Trainings" },
//     { id: 4, name: "Corporate" },
//     { id: 5, name: "School Project" },
//     { id: 6, name: "University & College" },
// ];

// const paginationModel = { page: 0, pageSize: 5 };

// const BatchDetails = (props) => {
//     document.title = "Content Management | Batch Details";
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [loader, setLoader] = useState(false);
//     const [batchZipLoading, setBatchZipLoading] = useState(false);
//     const navigate = useNavigate();
//     const params = useParams();

//     const [batchDetails, setBatchDetails] = useState(null);
//     const [selectedTab, setSelectedTab] = useState("Courses");
//     const [editModal, setEditModal] = useState(false);
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [addCourseModal, setAddCourseModal] = useState(false);
//     const [addTrainerModal, setAddTrainerModal] = useState(false);
//     const [addStudentModal, setAddStudentModal] = useState(false);
//     const [allCourses, setAllCourses] = useState([]);
//     const [allScormCourses, setAllScormCourses] = useState([]);
//     const [allCoursesOfBatch, setAllCourseOfBatch] = useState([]);
//     const [allScormCoursesOfBatch, setAllScormCourseOfBatch] = useState([]);
//     const [allTrainers, setAllTrainers] = useState([]);
//     const [allStudents, setAllStudents] = useState([]);
//     const [allTrainerOfBatch, setAllTrainerOfBatch] = useState([]);
//     const [allStudentOfBatch, setAllStudentOfBatch] = useState([]);
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const [selectedStudent, setSelectedStudent] = useState(null);
//     const [selectedTrainer, setSelectedTrainer] = useState(null);
//     const [trainerDeleteModal, setTrainerDeleteModal] = useState(false);
//     const [studentDeleteModal, setStudentDeleteModal] = useState(false);
//     const [courseDeleteModal, setCourseDeleteModal] = useState(false);
//     const [department, setDepartment] = useState(null);
//     const [liveClasses, setLiveClasses] = useState([]);
//     const [showExamResults, setShowExamResults] = useState(false);
//     const [trainingImages, setTrainingImages] = useState([]);
//     const [organizationId, setOrganizationId] = useState(null);

//     const [assessmentType, setAssessmentType] = useState("none");

//     const [selectedStudentsForBatch, setSelectedStudentsForBatch] = useState([]);
//     const [selectAll, setSelectAll] = useState(false);
//     const [showSelectedStudents, setShowSelectedStudents] = useState(false);
//     const [recentlyAddedStudents, setRecentlyAddedStudents] = useState([]);
//     const [showSuccessMessage, setShowSuccessMessage] = useState(false);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [bulkAddInProgress, setBulkAddInProgress] = useState(false);
//     const [bulkAddProgress, setBulkAddProgress] = useState({ added: 0, total: 0, failed: 0 });
//     const [showBulkProgress, setShowBulkProgress] = useState(false);

//     const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//     const [batchStudentSearchTerm, setBatchStudentSearchTerm] = useState("");
//     const [filteredBatchStudents, setFilteredBatchStudents] = useState([]);
//     const [removeAllStudentsModal, setRemoveAllStudentsModal] = useState(false);
//     const [bulkRemoveModal, setBulkRemoveModal] = useState(false);

//     const [certificateProgress, setCertificateProgress] = useState({
//         total: 0, completed: 0, failed: 0, inProgress: false
//     });

//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [showEventModal, setShowEventModal] = useState(false);

//     const [searchStudentText, setSearchStudentText] = useState("");
//     const [searchTrainerText, setSearchTrainerText] = useState("");
//     const [searchCourseText, setSearchCourseText] = useState("");
//     const [searchAadhaarText, setSearchAadhaarText] = useState("");
//     const [stateFilter, setStateFilter] = useState(null);
//     const [divisionFilter, setDivisionFilter] = useState(null);
//     const [availableStates, setAvailableStates] = useState([]);
//     const [availableDivisions, setAvailableDivisions] = useState([]);
//     const [aadhaarFilter, setAadhaarFilter] = useState(null);
//     const [availableContractorTokens, setAvailableContractorTokens] = useState([]);
//     const [contractorTokenFilter, setContractorTokenFilter] = useState(null);
//     const [availableNatureOfWork, setAvailableNatureOfWork] = useState([]);
//     const [natureOfWorkFilter, setNatureOfWorkFilter] = useState(null);

//     const [filteredAllStudents, setFilteredAllStudents] = useState([]);
//     const [filteredAllTrainers, setFilteredAllTrainers] = useState([]);
//     const [filteredAllCourses, setFilteredAllCourses] = useState([]);

//     const [studentExamResults, setStudentExamResults] = useState({});
//     const [driverMarkingResults, setDriverMarkingResults] = useState({});
//     const [loadingExamResults, setLoadingExamResults] = useState({});
//     const [fetchingExamResults, setFetchingExamResults] = useState(false);

//     const [type, setType] = useState(null);

//     const isTataUser = type === "Tata Project Manager" || type === "Tata Depot Manager" || type === "Tata Trainer";
//     const isTrainerRole = type === "Trainer" || type === "Tata Trainer";

//     const breadcrumbItems = [
//         { title: "Batch", link: "#" },
//         { title: "Batch Details", link: "#" },
//     ];

//     // ==================== HELPER FUNCTIONS ====================
//     const formatDate = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
//     };

//     const formatDateTime = (dateString) => {
//         if (!dateString) return "Not set";
//         const date = new Date(dateString);
//         return date.toLocaleString('en-IN', {
//             day: '2-digit', month: 'short', year: 'numeric',
//             hour: '2-digit', minute: '2-digit', hour12: true
//         });
//     };

//     const formatAadhaarNumber = (aadhaar) => {
//         if (!aadhaar) return '--';
//         const cleanAadhaar = String(aadhaar).replace(/\D/g, '');
//         if (cleanAadhaar.length === 12) {
//             return `${cleanAadhaar.substring(0, 4)} ${cleanAadhaar.substring(4, 8)} ${cleanAadhaar.substring(8, 12)}`;
//         }
//         return cleanAadhaar;
//     };

//     const getAssessmentName = () => {
//         switch (assessmentType) {
//             case "bronze": return "Bronze Assessment";
//             case "silver": return "Silver Assessment";
//             case "gold": return "Gold Assessment";
//             case "driver": return "Driver Assessment";
//             default: return "Post-test Only Assessment";
//         }
//     };

//     const getAssessmentColor = () => {
//         switch (assessmentType) {
//             case "bronze": return "#CD7F32";
//             case "silver": return "#C0C0C0";
//             case "gold": return "#FFD700";
//             case "driver": return "#FF9800";
//             default: return "#6c757d";
//         }
//     };

//     const shouldShowPracticalTab = () => assessmentType !== "none";
//     const hasPracticalAssessment = () => assessmentType !== "none";
//     const shouldShowSimulatorTab = () => (batchDetails?.department || '').toLowerCase().startsWith('driver');

//     const determineAssessmentType = (batchDepartment, batchName) => {
//         const isDriverDepartment = batchDepartment && batchDepartment.toLowerCase().includes("driver");
//         const isSurakshaBatch = batchName && batchName.toLowerCase().startsWith("suraksha");
//         if (isDriverDepartment && isSurakshaBatch) return "driver";

//         const isTechnicalDepartment = batchDepartment && batchDepartment.toLowerCase().includes("technical");
//         if (isTechnicalDepartment && batchName) {
//             const lowerCaseName = batchName.toLowerCase().trim();
//             if (lowerCaseName.startsWith("bronze")) return "bronze";
//             if (lowerCaseName.startsWith("silver")) return "silver";
//             if (lowerCaseName.startsWith("gold")) return "gold";
//         }
//         return "none";
//     };

//     // ==================== ELIGIBILITY ====================
//     const checkStudentEligibility = (student) => {
//         const isAlreadyInCurrentBatch = allStudentOfBatch.some(s => s.id === student.id);
//         if (isAlreadyInCurrentBatch) {
//             return { eligible: false, reason: "Student already enrolled in this batch", isAlreadyAdded: true };
//         }
//         return { eligible: true, reason: "Student can be added to batch", isAlreadyAdded: false };
//     };

//     const checkCertificateEligibility = (student, examResults = null) => {
//         const studentExamResult = examResults || studentExamResults[student.id];
//         const postTestScore = studentExamResult?.postTest || 0;

//         if (loadingExamResults[student.id] && !studentExamResult) {
//             return { eligible: false, reason: "Loading exam results...", isLoading: true };
//         }
//         if (postTestScore === null || postTestScore === undefined) {
//             return { eligible: false, reason: "Post-test results not available" };
//         }
//         if (postTestScore < 80) {
//             return { eligible: false, reason: `Post-test score ${postTestScore}% is below 80%` };
//         }
//         if (hasPracticalAssessment()) {
//             const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//             if (!isDriverMarkingCompleted) {
//                 return { eligible: false, reason: `${getAssessmentName()} not completed` };
//             }
//         }
//         return { eligible: true, reason: "Eligible for certificate download" };
//     };

//     const getPassedStudentsCount = (examResults = null) => {
//         if (!allStudentOfBatch.length) return 0;
//         return allStudentOfBatch.filter(student => {
//             const studentExamResult = examResults || studentExamResults[student.id];
//             const postTestScore = studentExamResult?.postTest || 0;
//             if (!hasPracticalAssessment()) return postTestScore >= 80;
//             const isDriverMarkingCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//             return postTestScore >= 80 && isDriverMarkingCompleted;
//         }).length;
//     };

//     // ==================== API FUNCTIONS ====================
//     const fetchBatchDetails = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchSingleBatch(params.id);
//             if (data?.success) {
//                 setBatchDetails(data?.result[0]);
//                 const assessment = determineAssessmentType(data?.result[0]?.department, data?.result[0]?.batchName);
//                 setAssessmentType(assessment);
//                 const updatedTrainingImages = await updateImagesUrl(data?.result[0]?.images || []);
//                 setTrainingImages(updatedTrainingImages);
//                 const lvClass = data?.result[0]?.liveClasses?.map((liveClass) => ({
//                     id: liveClass.id,
//                     title: liveClass.title,
//                     start: new Date(liveClass.classTime),
//                     end: new Date(new Date(liveClass.classTime).getTime() + 60 * 60 * 1000),
//                     description: liveClass.description,
//                     classLink: liveClass.classLink,
//                     resource: liveClass,
//                 })) || [];
//                 setLiveClasses(lvClass);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateImagesUrl = async (data) => {
//         return await Promise.all(
//             data?.map(async (name) => {
//                 if (name) {
//                     const response = await generatePresignedUrlForAccess({ name, type: "image" });
//                     return response.success ? response.presignedUrl : name;
//                 }
//                 return name;
//             })
//         );
//     };

//     const getAllTrainers = async () => {
//         try {
//             const data = await fetchAllUsers();
//             if (data?.success) {
//                 setAllTrainers(data?.result);
//                 setFilteredAllTrainers(data?.result);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         }
//     };

//     const fetchAllStudents = async () => {
//         try {
//             const userType = JSON.parse(localStorage.getItem("authUser")).userType;
//             let data;
//             if (userType === "Tata Project Manager" || userType === "Tata Depot Manager" || userType === "Tata Trainer") {
//                 data = await getAllStudentsForTata();
//             } else {
//                 data = await getAllStudents();
//             }
//             if (data?.success) {
//                 setAllStudents(data?.result);
//                 setFilteredAllStudents(data?.result);
//                 extractFilters(data?.result);
//             }
//         } catch (error) {
//             toast.error("Something went wrong");
//         }
//     };

//     const fetchCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllCourses();
//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourses(updateData);
//                 setFilteredAllCourses(updateData);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const fetchScormCourses = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllScormCourse();
//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourses(updateData);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllCourseOfBatch(params.id);
//             if (data?.success) {
//                 let updateData = await updateThubmnail(data?.result);
//                 setAllCourseOfBatch(updateData);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getScormCourseOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllScormCourseOfBatch(params.id);
//             if (data?.success) {
//                 let updateData = await updateScormThubmnail(data?.result);
//                 setAllScormCourseOfBatch(updateData);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getStudentOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllStudentOfBatch(params.id);
//             if (data?.success) {
//                 setAllStudentOfBatch(data?.result || []);
//                 setFilteredBatchStudents(data?.result || []);
//                 setSelectedStudentIds([]);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getTrainerOfBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllTrainerOfBatch(params.id);
//             if (data?.success) {
//                 setAllTrainerOfBatch(data?.result);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const updateThubmnail = async (data) => {
//         return await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnailName) {
//                     const response = await generatePresignedUrlForAccess({ name: d.thumbnailName, type: "image" });
//                     return response.success ? { ...d, thumbnailUrl: response.presignedUrl } : d;
//                 }
//                 return d;
//             })
//         );
//     };

//     const updateScormThubmnail = async (data) => {
//         return await Promise.all(
//             data.map(async (d) => {
//                 if (d?.thumbnail) {
//                     const response = await generatePresignedUrlForAccess({ name: d.thumbnail, type: "image" });
//                     return response.success ? { ...d, thumbnailUrl: response.presignedUrl } : d;
//                 }
//                 return d;
//             })
//         );
//     };

//     const extractFilters = (students) => {
//         if (!students || students.length === 0) return;
//         const states = [...new Set(students.map(s => s.tataStudentDetailsDto?.state || s.state).filter(Boolean).sort())];
//         const divisions = [...new Set(students.map(s => s.tataStudentDetailsDto?.division || s.division).filter(Boolean).sort())];
//         const contractorTokens = [...new Set(students.map(s => s.tataStudentDetailsDto?.contractorTokenNo || s.contractorTokenNo).filter(Boolean).sort())];
//         const natureOfWorkValues = [...new Set(students.map(s => s.tataStudentDetailsDto?.natureOfWork || s.natureOfWork).filter(Boolean).sort())];

//         setAvailableStates(states.map(s => ({ value: s, label: s })));
//         setAvailableDivisions(divisions.map(d => ({ value: d, label: d })));
//         setAvailableContractorTokens(contractorTokens.map(t => ({ value: t, label: t, display: t })));
//         setAvailableNatureOfWork(natureOfWorkValues.map(n => ({ value: n, label: n, display: n })));
//     };

//     const applyStudentFilters = () => {
//         let filtered = allStudents;
//         if (searchStudentText) {
//             const searchTerm = searchStudentText.toLowerCase();
//             filtered = filtered.filter(student => {
//                 const firstName = student.firstName?.toLowerCase() || '';
//                 const lastName = student.lastName?.toLowerCase() || '';
//                 const mobile = student.mobile || '';
//                 const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || student.aadhaarNo || student.aadharNo || '';
//                 const contractorTokenNo = student.tataStudentDetailsDto?.contractorTokenNo || student.contractorTokenNo || '';
//                 const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || student.natureOfWork || '';
//                 return firstName.includes(searchTerm) || lastName.includes(searchTerm) ||
//                     mobile.includes(searchStudentText) || aadhaarNo.includes(searchTerm) ||
//                     contractorTokenNo.includes(searchTerm) || natureOfWork.toLowerCase().includes(searchTerm) ||
//                     (student.email && student.email.toLowerCase().includes(searchTerm));
//             });
//         }
//         if (searchAadhaarText) {
//             const t = searchAadhaarText.toLowerCase();
//             filtered = filtered.filter(s => ((s.tataStudentDetailsDto?.aadhaarNo || s.aadhaarNo || s.aadharNo || '').toLowerCase()).includes(t));
//         }
//         if (stateFilter) filtered = filtered.filter(s => (s.tataStudentDetailsDto?.state || s.state) === stateFilter.value);
//         if (divisionFilter) filtered = filtered.filter(s => (s.tataStudentDetailsDto?.division || s.division) === divisionFilter.value);
//         if (contractorTokenFilter) filtered = filtered.filter(s => (s.tataStudentDetailsDto?.contractorTokenNo || s.contractorTokenNo) === contractorTokenFilter.value);
//         if (natureOfWorkFilter) filtered = filtered.filter(s => (s.tataStudentDetailsDto?.natureOfWork || s.natureOfWork) === natureOfWorkFilter.value);
//         setFilteredAllStudents(filtered);
//     };

//     const clearStudentFilters = () => {
//         setSearchStudentText("");
//         setSearchAadhaarText("");
//         setStateFilter(null);
//         setDivisionFilter(null);
//         setAadhaarFilter(null);
//         setContractorTokenFilter(null);
//         setNatureOfWorkFilter(null);
//         setFilteredAllStudents(allStudents);
//     };

//     const filterBatchStudents = () => {
//         if (!allStudentOfBatch || allStudentOfBatch.length === 0) {
//             setFilteredBatchStudents([]);
//             return;
//         }
//         if (!batchStudentSearchTerm || batchStudentSearchTerm.trim() === "") {
//             setFilteredBatchStudents(allStudentOfBatch);
//             return;
//         }
//         const searchTerm = batchStudentSearchTerm.toLowerCase().trim();
//         const filtered = allStudentOfBatch.filter(student => {
//             const fullName = `${student.firstName || ''} ${student.lastName || ''}`.toLowerCase();
//             const mobile = student.mobile || '';
//             const aadhaarNo = student.tataStudentDetailsDto?.aadhaarNo || student.aadhaarNo || student.aadharNo || '';
//             const contractorToken = student.tataStudentDetailsDto?.contractorTokenNo || student.contractorTokenNo || '';
//             const natureOfWork = student.tataStudentDetailsDto?.natureOfWork || student.natureOfWork || '';
//             return fullName.includes(searchTerm) || mobile.includes(searchTerm) ||
//                 aadhaarNo.toLowerCase().includes(searchTerm) || contractorToken.toLowerCase().includes(searchTerm) ||
//                 natureOfWork.toLowerCase().includes(searchTerm);
//         });
//         setFilteredBatchStudents(filtered);
//     };

//     const clearBatchStudentSearch = () => {
//         setBatchStudentSearchTerm("");
//         setFilteredBatchStudents(allStudentOfBatch);
//     };

//     // ==================== FIXED CHECKBOX HANDLERS ====================
//     // The KEY fix - This is a plain function that takes an ID and toggles selection
//     const toggleStudentSelection = (studentId) => {
//         console.log("Toggling student ID:", studentId);
//         setSelectedStudentsForBatch(prev => {
//             const exists = prev.some(s => s.id === studentId);
//             if (exists) {
//                 console.log("Removing student:", studentId);
//                 return prev.filter(s => s.id !== studentId);
//             } else {
//                 const student = filteredAllStudents.find(s => s.id === studentId);
//                 if (student) {
//                     const eligibility = checkStudentEligibility(student);
//                     if (!eligibility.eligible) {
//                         toast.error(`Cannot select: ${eligibility.reason}`);
//                         return prev;
//                     }
//                     console.log("Adding student:", studentId);
//                     return [...prev, student];
//                 }
//                 return prev;
//             }
//         });
//     };

//     const isStudentSelected = (studentId) => {
//         return selectedStudentsForBatch.some(s => s.id === studentId);
//     };

//     const handleSelectAllStudents = (e) => {
//         const isChecked = e.target.checked;
//         if (isChecked) {
//             const eligibleStudents = filteredAllStudents.filter(s => checkStudentEligibility(s).eligible);
//             setSelectedStudentsForBatch(prev => {
//                 const currentIds = new Set(prev.map(s => s.id));
//                 const newStudents = eligibleStudents.filter(s => !currentIds.has(s.id));
//                 return [...prev, ...newStudents];
//             });
//         } else {
//             const filteredIds = new Set(filteredAllStudents.map(s => s.id));
//             setSelectedStudentsForBatch(prev => prev.filter(s => !filteredIds.has(s.id)));
//         }
//     };

//     const handleRemoveSelectedStudent = (studentId) => {
//         setSelectedStudentsForBatch(prev => prev.filter(s => s.id !== studentId));
//     };

//     const handleClearSelectedStudents = () => {
//         setSelectedStudentsForBatch([]);
//     };

//     const handleModalClose = () => {
//         setAddStudentModal(false);
//         setShowSuccessMessage(false);
//         setRecentlyAddedStudents([]);
//         setShowBulkProgress(false);
//         setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//         setSelectedStudentsForBatch([]);
//         setSelectAll(false);
//         setShowSelectedStudents(false);
//     };

//     const handleAddMultipleStudentsToBatch = async () => {
//         if (selectedStudentsForBatch.length === 0) {
//             toast.error("Please select at least one student");
//             return;
//         }
//         const eligibleStudents = [];
//         const ineligibleStudents = [];
//         selectedStudentsForBatch.forEach(student => {
//             const eligibility = checkStudentEligibility(student);
//             if (eligibility.eligible) eligibleStudents.push(student);
//             else ineligibleStudents.push({ student, reason: eligibility.reason });
//         });
//         if (eligibleStudents.length === 0) {
//             toast.error("No eligible students selected");
//             return;
//         }
//         if (ineligibleStudents.length > 0) {
//             toast.warning(`${ineligibleStudents.length} student(s) are already in this batch and will not be added`);
//         }
//         try {
//             setBulkAddInProgress(true);
//             setShowBulkProgress(true);
//             setBulkAddProgress({ added: 0, total: eligibleStudents.length, failed: 0 });
//             const studentIds = eligibleStudents.map(s => s.id);
//             const response = await addMultipleStudentsToBatch(params.id, studentIds, organizationId);
//             if (response?.data?.success) {
//                 setBulkAddProgress(prev => ({ ...prev, added: eligibleStudents.length, failed: 0 }));
//                 setSuccessMessage(response.data.message || `Successfully added ${eligibleStudents.length} student(s)`);
//                 setShowSuccessMessage(true);
//                 setRecentlyAddedStudents(prev => [...prev, ...eligibleStudents]);
//                 await getStudentOfBatch();
//                 const addedIds = new Set(eligibleStudents.map(s => s.id));
//                 setSelectedStudentsForBatch(prev => prev.filter(s => !addedIds.has(s.id)));
//                 setSelectAll(false);
//                 setTimeout(() => setShowSuccessMessage(false), 5000);
//                 toast.success(response.data.message || `Successfully added ${eligibleStudents.length} student(s)!`);
//             } else {
//                 setBulkAddProgress(prev => ({ ...prev, failed: eligibleStudents.length }));
//                 toast.error(response?.data?.message || "Failed to add students to batch");
//             }
//         } catch (error) {
//             setBulkAddProgress(prev => ({ ...prev, failed: eligibleStudents.length }));
//             toast.error(error?.response?.data?.message || error?.message || "Error adding students");
//         } finally {
//             setBulkAddInProgress(false);
//             setTimeout(() => {
//                 setShowBulkProgress(false);
//                 setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//             }, 3000);
//         }
//     };

//     const handleAddStudentToBatch = async (student) => {
//         try {
//             setLoader(true);
//             const eligibility = checkStudentEligibility(student);
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot add student: ${eligibility.reason}`);
//                 setLoader(false);
//                 return;
//             }
//             const data = await addStudentToBatch(`${params.id}/${student.id}`);
//             if (data?.success) {
//                 const studentName = `${student.firstName || ''} ${student.lastName || ''}`.trim();
//                 setSuccessMessage(`${studentName} added to batch successfully!`);
//                 setShowSuccessMessage(true);
//                 setRecentlyAddedStudents(prev => [...prev, student]);
//                 await getStudentOfBatch();
//                 setSelectedStudentsForBatch(prev => prev.filter(s => s.id !== student.id));
//                 setSelectAll(false);
//                 setTimeout(() => setShowSuccessMessage(false), 3000);
//                 toast.success(`${studentName} added to batch successfully!`);
//             } else {
//                 toast.error(data?.message || "Failed to add student to batch");
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ==================== BATCH OPERATIONS ====================
//     const handleUpdate = async () => {
//         try {
//             setLoader(true);
//             setBatchDetails({ ...batchDetails, department: department?.name });
//             const data = await updateBatch(batchDetails);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setEditModal(false);
//                 fetchBatchDetails();
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDeleteBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await deleteBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 navigate("/all-batches");
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setDeleteModal(false);
//         }
//     };

//     const handleAddCourseToBatch = async (id) => {
//         try {
//             setLoader(true);
//             const data = await addCourseToBatch(params.id + "/" + id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setAddCourseModal(false);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveCourseFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeCourseFromBatch(params.id + "/" + selectedCourse?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getCourseOfBatch();
//                 setCourseDeleteModal(false);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleAddTrainerToBatch = async (d) => {
//         try {
//             setLoader(true);
//             const data = await addTrainerToBatch(params.id + "/" + d.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setAddTrainerModal(false);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveTrainerFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeTrainerFromBatch(params.id + "/" + selectedTrainer?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getTrainerOfBatch();
//                 setTrainerDeleteModal(false);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveAllTrainer = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllTrainersFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllTrainerOfBatch([]);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveStudentFromBatch = async () => {
//         try {
//             setLoader(true);
//             const data = await removeStudentFromBatch(params.id + "/" + selectedStudent?.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 getStudentOfBatch();
//                 setStudentDeleteModal(false);
//                 setSelectedStudent(null);
//                 setSelectedStudentIds(prev => prev.filter(id => id !== selectedStudent?.id));
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleBulkRemoveStudents = () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             return;
//         }
//         setBulkRemoveModal(true);
//     };

//     const confirmBulkRemoveStudents = async () => {
//         if (selectedStudentIds.length === 0) {
//             toast.error("Please select at least one student to remove");
//             setBulkRemoveModal(false);
//             return;
//         }
//         const selectedStudents = allStudentOfBatch.filter(s => selectedStudentIds.includes(s.id));
//         try {
//             setLoader(true);
//             setBulkRemoveModal(false);
//             const results = [];
//             for (const student of selectedStudents) {
//                 try {
//                     const data = await removeStudentFromBatch(`${params.id}/${student.id}`);
//                     results.push({ student, success: data?.success || false, message: data?.message });
//                     await new Promise(resolve => setTimeout(resolve, 100));
//                 } catch (error) {
//                     results.push({ student, success: false, message: error?.response?.data?.message });
//                 }
//             }
//             const successful = results.filter(r => r.success);
//             const failed = results.filter(r => !r.success);
//             if (successful.length > 0) toast.success(`Successfully removed ${successful.length} student(s)`);
//             if (failed.length > 0) toast.error(`${failed.length} student(s) could not be removed`);
//             await getStudentOfBatch();
//             setSelectedStudentIds([]);
//             setBatchStudentSearchTerm("");
//         } catch (error) {
//             toast.error("Error removing students from batch");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleRemoveAllStudents = async () => {
//         try {
//             setLoader(true);
//             const data = await removeAllStudentsFromBatch(params.id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setAllStudentOfBatch([]);
//                 setFilteredBatchStudents([]);
//                 setSelectedStudentIds([]);
//             } else toast.error(data?.message);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//             setRemoveAllStudentsModal(false);
//         }
//     };

//     const handleDownloadStudentDetailsClick = async () => {
//         try {
//             setLoader(true);
//             const response = await axios.get(DOWNLOAD_BATCH_STUDENT_FILE + params.id, { responseType: 'blob' });
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'all_student_batches.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleSelectionChange = (selectionModel) => {
//         setSelectedStudentIds(selectionModel);
//     };

//     const openLiveClassLink = (link) => {
//         if (!link) {
//             toast.error("No class link available");
//             return;
//         }
//         let formattedLink = link;
//         if (!formattedLink.startsWith('http://') && !formattedLink.startsWith('https://')) {
//             formattedLink = 'https://' + formattedLink;
//         }
//         window.open(formattedLink, '_blank', 'noopener,noreferrer');
//     };

//     // ==================== EXAM RESULTS ====================
//     const fetchStudentExamResult = async (studentId) => {
//         if (!studentId || !params.id) return null;
//         try {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: true }));
//             const examResponse = await getResult(`${params.id}/${studentId}`);
//             if (examResponse?.success) {
//                 let preTestScore = null, postTestScore = null;
//                 if (examResponse.result) {
//                     const preTest = examResponse.result.preTest;
//                     const postTest = examResponse.result.postTest;
//                     if (preTest != null) preTestScore = typeof preTest === 'number' ? preTest : (preTest.percentage || preTest.score || 0);
//                     if (postTest != null) postTestScore = typeof postTest === 'number' ? postTest : (postTest.percentage || postTest.score || 0);
//                 }
//                 const result = {
//                     preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                     postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                     lastUpdated: new Date().toISOString()
//                 };
//                 setStudentExamResults(prev => ({ ...prev, [studentId]: result }));
//                 return result;
//             }
//             return null;
//         } catch (error) {
//             return null;
//         } finally {
//             setLoadingExamResults(prev => ({ ...prev, [studentId]: false }));
//         }
//     };

//     const fetchAndDisplayExamResults = async (student) => {
//         setSelectedStudent(student);
//         const results = await fetchStudentExamResult(student.id);
//         if (results) setShowExamResults(true);
//         else toast.error("Could not fetch exam results for this student");
//     };

//     const fetchExamResultsForAllStudents = async () => {
//         try {
//             setFetchingExamResults(true);
//             const results = {};
//             for (const student of allStudentOfBatch) {
//                 try {
//                     const examResponse = await getResult(`${params.id}/${student.id}`);
//                     if (examResponse?.success) {
//                         let preTestScore = null, postTestScore = null;
//                         if (examResponse.result) {
//                             const preTest = examResponse.result.preTest;
//                             const postTest = examResponse.result.postTest;
//                             if (preTest != null) preTestScore = typeof preTest === 'number' ? preTest : (preTest.percentage || preTest.score || 0);
//                             if (postTest != null) postTestScore = typeof postTest === 'number' ? postTest : (postTest.percentage || postTest.score || 0);
//                         }
//                         results[student.id] = {
//                             preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                             postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                             lastUpdated: new Date().toISOString()
//                         };
//                     }
//                     if (hasPracticalAssessment() && !driverMarkingResults[student.id]) {
//                         await fetchDriverMarkingResult(student.id);
//                     }
//                 } catch (error) {
//                     continue;
//                 }
//             }
//             setStudentExamResults(prev => ({ ...prev, ...results }));
//             return results;
//         } finally {
//             setFetchingExamResults(false);
//         }
//     };

//     const fetchDriverMarkingResult = async (studentId) => {
//         try {
//             const student = allStudentOfBatch.find(s => s.id === studentId);
//             if (student) {
//                 const result = {
//                     isCompleted: student.driverMarkingCompleted || true,
//                     score: student.driverMarkingScore || student.practicalScore || 0,
//                     lastUpdated: new Date().toISOString()
//                 };
//                 setDriverMarkingResults(prev => ({ ...prev, [studentId]: result }));
//                 return result;
//             }
//             return null;
//         } catch (error) {
//             return null;
//         }
//     };

//     const updateDriverMarkingStatus = (studentId) => {
//         setDriverMarkingResults(prev => ({
//             ...prev,
//             [studentId]: { isCompleted: true, score: 85, lastUpdated: new Date().toISOString() }
//         }));
//         setAllStudentOfBatch(prev => prev.map(s => s.id === studentId ? { ...s, driverMarkingCompleted: true } : s));
//     };

//     // ==================== CERTIFICATE FUNCTIONS ====================
//     const generateCertificateForStudent = async (student) => {
//         const requestData = {
//             trainingType: "DDT_OTHER",
//             studentName: student.firstName + " " + student.lastName,
//             courseName: batchDetails?.batchName || "Driver Training",
//             dlNo: student.tataStudentDetailsDto?.driverDlNo || "",
//             aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || "",
//             depot: student.tataStudentDetailsDto?.depot || "",
//             project: student.tataStudentDetailsDto?.project || "",
//             city: student.state || student.city || "",
//             fromDate: batchDetails?.startDate || "",
//             toDate: batchDetails?.endDate || "",
//             validityDate: batchDetails?.validityDate || "",
//             trainerName: allTrainerOfBatch[0]?.name || "",
//             authorizedSignatory: "DGM-Skill Development",
//             batchId: params.id,
//             studentId: student.id
//         };
//         const response = await axios.post(url + 'api/certificate/generate', requestData, {
//             responseType: 'blob',
//             headers: { 'Content-Type': 'application/json' }
//         });
//         return response.data;
//     };

//     const downloadIndividualCertificate = async (student) => {
//         setLoader(true);
//         try {
//             const certificateBlob = await generateCertificateForStudent(student);
//             const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
//             const blob = new Blob([certificateBlob], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = fileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//             toast.success('Certificate downloaded successfully!');
//         } catch (error) {
//             toast.error('Failed to generate certificate.');
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDownloadCertificate = async (student) => {
//         if (!studentExamResults[student.id]) {
//             setLoader(true);
//             try {
//                 const results = await fetchStudentExamResult(student.id);
//                 if (!results) {
//                     toast.error("Could not fetch exam results");
//                     setLoader(false);
//                     return;
//                 }
//                 const eligibility = checkCertificateEligibility(student, results);
//                 if (!eligibility.eligible) {
//                     toast.error(`Cannot download: ${eligibility.reason}`);
//                     setLoader(false);
//                     return;
//                 }
//                 await downloadIndividualCertificate(student);
//             } catch (error) {
//                 toast.error('Failed to fetch exam results');
//                 setLoader(false);
//                 return;
//             }
//         } else {
//             const eligibility = checkCertificateEligibility(student);
//             if (!eligibility.eligible) {
//                 toast.error(`Cannot download: ${eligibility.reason}`);
//                 return;
//             }
//             await downloadIndividualCertificate(student);
//         }
//     };

//     const generateExcelReport = (progressInfo) => {
//         const wb = XLSX.utils.book_new();
//         const summaryData = [
//             ["BATCH CERTIFICATE GENERATION REPORT"],
//             ["Generated Date:", progressInfo.generatedDate],
//             ["Batch Name:", progressInfo.batchName],
//             ["Batch ID:", progressInfo.batchId],
//             ["Assessment Type:", progressInfo.hasPractical ? getAssessmentName() : "Post-test Only"],
//             ["Eligibility Criteria:", progressInfo.hasPractical ? "Post-test ≥80% + Practical Assessment" : "Post-test ≥80%"],
//             [],
//             ["SUMMARY STATISTICS"],
//             ["Total Students:", progressInfo.totalStudents],
//             ["Passed Students:", progressInfo.passedStudents],
//             ["Failed Students:", progressInfo.failedStudents],
//             ["Certificates Generated:", progressInfo.generatedCertificates],
//             ["Certificates Failed:", progressInfo.failedCertificates],
//         ];
//         const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//         wsSummary["!cols"] = [{ wch: 30 }, { wch: 50 }];
//         const studentHeaders = [
//             ["STUDENT CERTIFICATE GENERATION DETAILS"], [],
//             ["S.No", "Student ID", "Full Name", "Contractor Token", "Aadhaar No", "Nature of Work",
//                 "Mobile", "Post-Test Score", "Practical Completed", "Eligibility Status",
//                 "Certificate Status", "Remarks"]
//         ];
//         const studentRows = progressInfo.students.map((s, i) => [
//             i + 1, s.id, s.name, s.contractorToken || "N/A", s.aadhaarNo || "N/A",
//             s.natureOfWork || "N/A", s.mobile || "N/A",
//             s.postTestScore !== null ? `${s.postTestScore}%` : "N/A",
//             s.practicalCompleted ? "Yes" : "No",
//             s.eligible ? "Eligible" : "Not Eligible",
//             s.certificateStatus, s.remarks || s.error || "N/A"
//         ]);
//         const wsStudents = XLSX.utils.aoa_to_sheet([...studentHeaders, ...studentRows]);
//         wsStudents["!cols"] = [
//             { wch: 5 }, { wch: 10 }, { wch: 25 }, { wch: 20 }, { wch: 15 },
//             { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 30 }
//         ];
//         XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
//         XLSX.utils.book_append_sheet(wb, wsStudents, "Student Details");
//         const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//         return new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     };

//     const generateAllCertificatesAsZip = async () => {
//         try {
//             setBatchZipLoading(true);
//             toast.info("Fetching exam results for all students...");
//             const allExamResults = await fetchExamResultsForAllStudents();
//             const hasPractical = hasPracticalAssessment();
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0, failedStudents: 0,
//                 generatedCertificates: 0, failedCertificates: 0,
//                 hasPractical, students: []
//             };
//             allStudentOfBatch.forEach((student) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
//                 let isPracticalCompleted = true;
//                 if (hasPractical) isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 const isEligible = hasPractical ? (postTestScore >= 80 && isPracticalCompleted) : (postTestScore >= 80);
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     contractorToken: student.tataStudentDetailsDto?.contractorTokenNo || null,
//                     aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || null,
//                     natureOfWork: student.tataStudentDetailsDto?.natureOfWork || null,
//                     mobile: student.mobile || null,
//                     postTestScore, practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible, certificateStatus: "Pending", remarks: "Not processed yet"
//                 });
//                 if (isEligible) progressInfo.passedStudents++;
//                 else progressInfo.failedStudents++;
//             });
//             const eligibleStudents = allStudentOfBatch.filter(student => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
//                 if (hasPractical) {
//                     const isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                     return postTestScore >= 80 && isPracticalCompleted;
//                 }
//                 return postTestScore >= 80;
//             });
//             if (eligibleStudents.length === 0) {
//                 toast.warning("No eligible students found. Generating report only.");
//                 progressInfo.students = progressInfo.students.map(s => ({ ...s, certificateStatus: "Failed" }));
//                 const excelBlob = generateExcelReport(progressInfo);
//                 const zip = new JSZip();
//                 zip.file(`Report_${params.id}.xlsx`, excelBlob);
//                 const zipBlob = await zip.generateAsync({ type: "blob" });
//                 saveAs(zipBlob, `Report_${params.id}_${moment().format('YYYY-MM-DD')}.zip`);
//                 setBatchZipLoading(false);
//                 return;
//             }
//             const confirmed = window.confirm(`Generate certificates for ${eligibleStudents.length} eligible student(s)?`);
//             if (!confirmed) {
//                 setBatchZipLoading(false);
//                 return;
//             }
//             setCertificateProgress({ total: eligibleStudents.length, completed: 0, failed: 0, inProgress: true });
//             const zip = new JSZip();
//             const certificateFolder = zip.folder("Certificates");
//             const reportFolder = zip.folder("Reports");
//             for (let i = 0; i < eligibleStudents.length; i++) {
//                 const student = eligibleStudents[i];
//                 const studentIndex = progressInfo.students.findIndex(s => s.id === student.id);
//                 try {
//                     const certificateBlob = await generateCertificateForStudent(student);
//                     const fileName = `${student.firstName}_${student.lastName}_${student.tataStudentDetailsDto?.contractorTokenNo || student.id}_Certificate.pdf`;
//                     certificateFolder.file(fileName, certificateBlob);
//                     progressInfo.students[studentIndex] = { ...progressInfo.students[studentIndex], certificateStatus: "Generated", fileName };
//                     progressInfo.generatedCertificates++;
//                     setCertificateProgress(prev => ({ ...prev, completed: prev.completed + 1 }));
//                     if (i < eligibleStudents.length - 1) await new Promise(r => setTimeout(r, 300));
//                 } catch (error) {
//                     progressInfo.students[studentIndex] = { ...progressInfo.students[studentIndex], certificateStatus: "Failed", error: error.message };
//                     progressInfo.failedCertificates++;
//                     setCertificateProgress(prev => ({ ...prev, failed: prev.failed + 1 }));
//                 }
//             }
//             const excelBlob = generateExcelReport(progressInfo);
//             reportFolder.file(`Report_${params.id}.xlsx`, excelBlob);
//             const zipBlob = await zip.generateAsync({ type: "blob" });
//             saveAs(zipBlob, `Batch_${params.id}_Certificates_${moment().format('YYYY-MM-DD_HH-mm')}.zip`);
//             toast.success(`Generated ${progressInfo.generatedCertificates} certificate(s)!`);
//         } catch (error) {
//             toast.error('Failed to generate certificates zip file');
//         } finally {
//             setBatchZipLoading(false);
//             setCertificateProgress({ total: 0, completed: 0, failed: 0, inProgress: false });
//         }
//     };

//     const generateCertificatesForPassedStudents = async () => {
//         if (allStudentOfBatch.length === 0) {
//             toast.error("No students found in this batch");
//             return;
//         }
//         await generateAllCertificatesAsZip();
//     };

//     const generateExcelReportOnly = async () => {
//         try {
//             setLoader(true);
//             toast.info("Generating student status report...");
//             const allExamResults = await fetchExamResultsForAllStudents();
//             const hasPractical = hasPracticalAssessment();
//             const progressInfo = {
//                 batchName: batchDetails?.batchName || "Unknown Batch",
//                 batchId: params.id,
//                 generatedDate: new Date().toISOString(),
//                 totalStudents: allStudentOfBatch.length,
//                 passedStudents: 0, failedStudents: 0,
//                 generatedCertificates: 0, failedCertificates: 0,
//                 hasPractical, students: []
//             };
//             allStudentOfBatch.forEach((student) => {
//                 const studentExamResult = allExamResults[student.id] || studentExamResults[student.id];
//                 const postTestScore = studentExamResult?.postTest || 0;
//                 let isPracticalCompleted = true;
//                 if (hasPractical) isPracticalCompleted = driverMarkingResults[student.id]?.isCompleted || false;
//                 const isEligible = hasPractical ? (postTestScore >= 80 && isPracticalCompleted) : (postTestScore >= 80);
//                 progressInfo.students.push({
//                     name: `${student.firstName} ${student.lastName}`,
//                     id: student.id,
//                     contractorToken: student.tataStudentDetailsDto?.contractorTokenNo || null,
//                     aadhaarNo: student.tataStudentDetailsDto?.aadhaarNo || null,
//                     natureOfWork: student.tataStudentDetailsDto?.natureOfWork || null,
//                     mobile: student.mobile || null,
//                     postTestScore, practicalCompleted: isPracticalCompleted,
//                     eligible: isEligible,
//                     certificateStatus: isEligible ? "Eligible (Not Generated)" : "Not Eligible",
//                     remarks: isEligible ? "Meets criteria" : "Not eligible"
//                 });
//                 if (isEligible) progressInfo.passedStudents++;
//                 else progressInfo.failedStudents++;
//             });
//             const excelBlob = generateExcelReport(progressInfo);
//             const excelFileName = `Student_Status_${params.id}_${moment().format('YYYY-MM-DD')}.xlsx`;
//             const url = window.URL.createObjectURL(excelBlob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = excelFileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//             toast.success(`Excel report generated!`);
//         } catch (error) {
//             toast.error('Failed to generate Excel report');
//         } finally {
//             setLoader(false);
//         }
//     };

//     const getAssessmentComponent = () => {
//         switch (assessmentType) {
//             case "bronze": return <BronzeAssessment students={allStudentOfBatch} batchId={params.id} batchDetails={batchDetails} />;
//             case "silver": return <SilverAssessment students={allStudentOfBatch} batchId={params.id} batchDetails={batchDetails} />;
//             case "gold": return <GoldAssessment students={allStudentOfBatch} batchId={params.id} batchDetails={batchDetails} />;
//             case "driver": return <DriverMarkingSystem students={allStudentOfBatch} onDriverMarkingComplete={updateDriverMarkingStatus} />;
//             default: return (
//                 <div className="alert alert-warning text-center">
//                     <h4>No Practical Assessment Available</h4>
//                     <p>Certificate eligibility based on post-test score (≥80%).</p>
//                 </div>
//             );
//         }
//     };

//     const autoFetchExamResultsForAllStudents = async () => {
//         if (fetchingExamResults) return;
//         setFetchingExamResults(true);
//         const results = {};
//         for (const student of allStudentOfBatch) {
//             try {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: true }));
//                 const examResponse = await getResult(`${params.id}/${student.id}`);
//                 if (examResponse?.success) {
//                     let preTestScore = null, postTestScore = null;
//                     if (examResponse.result) {
//                         const preTest = examResponse.result.preTest;
//                         const postTest = examResponse.result.postTest;
//                         if (preTest != null) preTestScore = typeof preTest === 'number' ? preTest : (preTest.percentage || preTest.score || 0);
//                         if (postTest != null) postTestScore = typeof postTest === 'number' ? postTest : (postTest.percentage || postTest.score || 0);
//                     }
//                     results[student.id] = {
//                         preTest: preTestScore !== null ? parseFloat(preTestScore) : null,
//                         postTest: postTestScore !== null ? parseFloat(postTestScore) : null,
//                         lastUpdated: new Date().toISOString()
//                     };
//                 }
//                 await new Promise(r => setTimeout(r, 100));
//             } catch (error) {
//                 // continue
//             } finally {
//                 setLoadingExamResults(prev => ({ ...prev, [student.id]: false }));
//             }
//         }
//         setStudentExamResults(prev => ({ ...prev, ...results }));
//         setFetchingExamResults(false);
//     };

//     // ==================== COLUMNS - WITH WORKING PLAIN HTML CHECKBOX ====================
//     const columnsStudentModalForTata = [
//         {
//             field: 'select',
//             headerName: (
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
//                     <input
//                         type="checkbox"
//                         checked={selectAll}
//                         onChange={handleSelectAllStudents}
//                         disabled={filteredAllStudents.length === 0 || loader || bulkAddInProgress}
//                         style={{ width: '18px', height: '18px', cursor: 'pointer' }}
//                         title="Select All"
//                     />
//                 </div>
//             ),
//             width: 80,
//             sortable: false,
//             filterable: false,
//             disableColumnMenu: true,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
//                 const isSelected = isStudentSelected(params.row.id);

//                 return (
//                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
//                         <input
//                             type="checkbox"
//                             checked={isSelected}
//                             disabled={eligibility.isAlreadyAdded || bulkAddInProgress}
//                             onChange={(e) => {
//                                 e.stopPropagation();
//                                 e.preventDefault();
//                                 toggleStudentSelection(params.row.id);
//                             }}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                             }}
//                             style={{
//                                 width: '18px',
//                                 height: '18px',
//                                 cursor: eligibility.isAlreadyAdded ? 'not-allowed' : 'pointer'
//                             }}
//                             title={eligibility.isAlreadyAdded ? "Already in batch" : "Select student"}
//                         />
//                     </div>
//                 );
//             },
//         },
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName', headerName: 'Full name', sortable: false, width: 150,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'contractorTokenNo', headerName: 'Contractor Token', width: 140,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.contractorTokenNo || row.contractorTokenNo || '--',
//         },
//         {
//             field: 'natureOfWork', headerName: 'Nature of Work', width: 150,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.natureOfWork || row.natureOfWork || '--',
//         },
//         { field: 'mobile', headerName: 'Mobile', width: 120, valueGetter: (value, row) => row.mobile || '--' },
//         {
//             field: 'aadhaarNo', headerName: 'Aadhaar No', width: 150,
//             valueGetter: (value, row) => {
//                 const aadhaar = row.tataStudentDetailsDto?.aadhaarNo || row.aadhaarNo || row.aadharNo;
//                 return aadhaar ? formatAadhaarNumber(aadhaar) : '--';
//             },
//         },
//         {
//             field: 'division', headerName: 'Division', width: 110,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.division || row.division || '--',
//         },
//         {
//             field: 'state', headerName: 'State', width: 110,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.state || row.state || '--',
//         },
//     ];

//     const columnsStudentModal = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName', headerName: 'Full name', sortable: false, width: 160,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         { field: 'email', headerName: 'Email', width: 200 },
//         { field: 'mobile', headerName: 'Mobile', width: 130 },
//         {
//             field: 'aadhaarNo', headerName: 'Aadhaar No', width: 150,
//             valueGetter: (value, row) => {
//                 const a = row.tataStudentDetailsDto?.aadhaarNo || row.aadhaarNo || row.aadharNo;
//                 return a ? formatAadhaarNumber(a) : '--';
//             },
//         },
//         {
//             field: 'action', headerName: 'Action', width: 150,
//             renderCell: (params) => {
//                 const eligibility = checkStudentEligibility(params.row);
//                 if (eligibility.isAlreadyAdded) {
//                     return (
//                         <Button variant="contained" color="secondary" disabled size="small">
//                             <PersonOffIcon style={{ marginRight: '4px' }} /> In Batch
//                         </Button>
//                     );
//                 }
//                 return (
//                     <Button variant="contained" color="success" onClick={() => handleAddStudentToBatch(params.row)}
//                         disabled={loader || bulkAddInProgress} size="small" startIcon={<PersonAddIcon />}>
//                         {loader ? 'Adding...' : 'Add to Batch'}
//                     </Button>
//                 );
//             }
//         },
//     ];

//     const columnsSelectedStudents = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName', headerName: 'Full name', sortable: false, width: 150,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         { field: 'mobile', headerName: 'Mobile', width: 130 },
//         {
//             field: 'contractorTokenNo', headerName: 'Contractor Token', width: 140,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.contractorTokenNo || row.contractorTokenNo || '--',
//         },
//         {
//             field: 'remove', headerName: 'Remove', width: 100,
//             renderCell: (params) => (
//                 <Button variant="contained" color="danger" size="small"
//                     onClick={() => handleRemoveSelectedStudent(params.row.id)}>Remove</Button>
//             ),
//         },
//     ];

//     const columnsTrainer = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         { field: 'name', headerName: 'Name', width: 300 },
//         { field: 'email', headerName: 'Email', width: 300 },
//         { field: 'mobile', headerName: 'Mobile No.', width: 300 },
//         {
//             field: 'actions', headerName: 'Actions', width: 150,
//             renderCell: (params) => (
//                 <Button variant="contained" color="danger"
//                     onClick={() => { setSelectedTrainer(params.row); setTrainerDeleteModal(true); }}>Remove</Button>
//             ),
//         },
//     ];

//     const columnsTrainerModal = [
//         { field: 'id', headerName: 'ID', width: 100 },
//         { field: 'name', headerName: 'Name', width: 150 },
//         { field: 'email', headerName: 'Email', width: 150 },
//         { field: 'mobile', headerName: 'Number', width: 150 },
//         {
//             field: 'action', headerName: 'Action', width: 150,
//             renderCell: (params) => (
//                 <Button variant="contained" color="success" onClick={() => handleAddTrainerToBatch(params.row)}>Add</Button>
//             ),
//         },
//     ];

//     const columnsStudent = [
//         { field: 'id', headerName: 'ID', width: 60 },
//         {
//             field: 'fullName', headerName: 'Full name', sortable: false, width: 150,
//             valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         { field: 'email', headerName: 'Email', width: 200 },
//         { field: 'mobile', headerName: 'Mobile', width: 130 },
//         {
//             field: 'aadhaarNo', headerName: 'Aadhaar No', width: 150,
//             valueGetter: (value, row) => {
//                 const a = row.tataStudentDetailsDto?.aadhaarNo || row.aadhaarNo || row.aadharNo;
//                 return a ? formatAadhaarNumber(a) : '--';
//             },
//         },
//         {
//             field: 'contractorToken', headerName: 'Contractor Token', width: 130,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.contractorTokenNo || row.contractorTokenNo || '--',
//         },
//         {
//             field: 'natureOfWork', headerName: 'Nature of Work', width: 150,
//             valueGetter: (value, row) => row.tataStudentDetailsDto?.natureOfWork || row.natureOfWork || '--',
//         },
//         {
//             field: 'postTestScore', headerName: 'Post-Test', width: 100,
//             renderCell: (params) => {
//                 const result = studentExamResults[params.row.id];
//                 if (loadingExamResults[params.row.id]) return <CircularProgress size={16} />;
//                 if (!result?.postTest) return '--';
//                 return (
//                     <span style={{
//                         color: result.postTest >= 80 ? 'green' : 'red',
//                         fontWeight: result.postTest >= 80 ? 'bold' : 'normal'
//                     }}>
//                         {Math.round(result.postTest)}%
//                     </span>
//                 );
//             }
//         },
//         {
//             field: 'passStatus', headerName: 'Result', width: 100,
//             renderCell: (params) => {
//                 const result = studentExamResults[params.row.id];
//                 const postTestScore = result?.postTest || 0;
//                 let isPassed = hasPracticalAssessment()
//                     ? (postTestScore >= 80 && driverMarkingResults[params.row.id]?.isCompleted)
//                     : postTestScore >= 80;
//                 return (
//                     <Chip label={isPassed ? 'Passed' : 'Failed'} color={isPassed ? 'success' : 'error'} size="small" />
//                 );
//             }
//         },
//         {
//             field: 'examResults', headerName: 'Exam Results', width: 130,
//             renderCell: (params) => (
//                 <Button variant="contained" color="primary" size="small"
//                     onClick={() => fetchAndDisplayExamResults(params.row)}
//                     disabled={loadingExamResults[params.row.id]}>
//                     {loadingExamResults[params.row.id] ? 'Loading...' : 'View Results'}
//                 </Button>
//             ),
//         },
//         ...(organizationId === 2 && !isTrainerRole
//             ? [{
//                 field: 'downloadCertificate', headerName: 'Certificate', width: 150,
//                 renderCell: (params) => {
//                     const eligibility = checkCertificateEligibility(params.row);
//                     if (eligibility.isLoading) return <CircularProgress size={20} />;
//                     return (
//                         <Tooltip title={eligibility.reason} arrow>
//                             <span>
//                                 <Button variant="contained"
//                                     color={eligibility.eligible ? "success" : "secondary"}
//                                     onClick={() => handleDownloadCertificate(params.row)}
//                                     disabled={!eligibility.eligible}
//                                     startIcon={eligibility.eligible ? <DownloadIcon /> : <InfoIcon />}
//                                     size="small">
//                                     {eligibility.eligible ? "Download" : "Not Eligible"}
//                                 </Button>
//                             </span>
//                         </Tooltip>
//                     );
//                 },
//             }]
//             : []),
//         {
//             field: 'actions', headerName: 'Actions', width: 100,
//             renderCell: (params) => (
//                 <Button variant="contained" color="danger" size="small"
//                     onClick={() => { setSelectedStudent(params.row); setStudentDeleteModal(true); }}>
//                     Remove
//                 </Button>
//             ),
//         },
//     ];

//     // ==================== EFFECTS ====================
//     useEffect(() => {
//         let authUser = JSON.parse(localStorage.getItem("authUser"));
//         setOrganizationId(authUser?.organizationId);
//         setType(authUser?.userType);
//     }, []);

//     useEffect(() => {
//         props.setBreadcrumbItems('Student Details', breadcrumbItems);
//     }, []);

//     useEffect(() => {
//         fetchBatchDetails();
//         fetchAllStudents();
//         getAllTrainers();
//         fetchCourses();
//         fetchScormCourses();
//     }, []);

//     useEffect(() => {
//         getCourseOfBatch();
//         getScormCourseOfBatch();
//         getStudentOfBatch();
//         getTrainerOfBatch();
//     }, []);

//     useEffect(() => {
//         if (selectedTab === "Student" && allStudentOfBatch.length > 0) {
//             autoFetchExamResultsForAllStudents();
//         }
//         filterBatchStudents();
//     }, [selectedTab, allStudentOfBatch, batchStudentSearchTerm]);

//     useEffect(() => {
//         if (allStudents.length > 0) applyStudentFilters();
//     }, [searchStudentText, searchAadhaarText, stateFilter, divisionFilter, contractorTokenFilter, natureOfWorkFilter, allStudents]);

//     useEffect(() => {
//         if (filteredAllStudents.length > 0) {
//             const allFilteredSelected = filteredAllStudents.every(student => {
//                 const eligibility = checkStudentEligibility(student);
//                 if (!eligibility.eligible) return true;
//                 return selectedStudentsForBatch.some(selected => selected.id === student.id);
//             });
//             setSelectAll(allFilteredSelected);
//         } else {
//             setSelectAll(false);
//         }
//     }, [filteredAllStudents, selectedStudentsForBatch]);

//     useEffect(() => {
//         if (!addStudentModal) {
//             setSearchStudentText("");
//             setSearchAadhaarText("");
//             setStateFilter(null);
//             setDivisionFilter(null);
//             setContractorTokenFilter(null);
//             setNatureOfWorkFilter(null);
//             setSelectedStudentsForBatch([]);
//             setSelectAll(false);
//             setShowSelectedStudents(false);
//             setRecentlyAddedStudents([]);
//             setShowSuccessMessage(false);
//             setShowBulkProgress(false);
//             setBulkAddProgress({ added: 0, total: 0, failed: 0 });
//         }
//     }, [addStudentModal]);

//     useEffect(() => {
//         if (searchTrainerText === '') setFilteredAllTrainers(allTrainers);
//         else {
//             const filtered = allTrainers.filter(trainer =>
//                 (trainer.name && trainer.name.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                 (trainer.email && trainer.email.toLowerCase().includes(searchTrainerText.toLowerCase())) ||
//                 (trainer.mobile && trainer.mobile.toLowerCase().includes(searchTrainerText.toLowerCase()))
//             );
//             setFilteredAllTrainers(filtered);
//         }
//     }, [searchTrainerText, allTrainers]);

//     useEffect(() => {
//         const filtered = allCourses.filter(course =>
//             course.title.toLowerCase().includes(searchCourseText.toLowerCase())
//         );
//         setFilteredAllCourses(filtered);
//     }, [searchCourseText, allCourses]);

//     // ==================== RENDER ====================
//     return (
//         <React.Fragment>
//             {loader && <Loader />}
//             <Row>
//                 <Col>
//                     <Card>
//                         <CardBody style={{ minHeight: "70vh" }}>
//                             {/* Tabs */}
//                             <div className="d-flex mt-4" style={{ borderBottom: "1px solid gray", width: "100%", overflowX: "auto", whiteSpace: "nowrap" }}>
//                                 {["Info", "Notification", ...(type !== "Trainer" && type !== "Tata Trainer" ? ["Trainer"] : []), "Student", "Courses", "ScormCourses", "LiveClasses", "Attendance",
//                                     ...(shouldShowSimulatorTab() ? ["Simulator"] : []), "Exam", "Feedback",
//                                     ...(organizationId === 2 && shouldShowPracticalTab() ? ["Practical"] : []),
//                                     ...(organizationId === 2 ? ["TrainingImages"] : [])
//                                 ].map(tab => (
//                                     <div key={tab} className="me-4"
//                                         style={{ borderBottom: selectedTab === tab ? "4px solid blue" : "none", cursor: "pointer" }}
//                                         onClick={() => setSelectedTab(tab)}>
//                                         <h5>{tab}{tab === "Practical" ? ` (${getAssessmentName()})` : ""}</h5>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Info Tab */}
//                             {selectedTab === "Info" && (
//                                 <div className="d-flex flex-column justify-content-between" style={{ height: "60vh" }}>
//                                     <div className="mt-4">
//                                         <div className="row">
//                                             <div className="col-6">
//                                                 <h5>Batch Name</h5>
//                                                 <p>{batchDetails?.batchName || "--"}</p>
//                                                 {batchDetails?.batchName && (
//                                                     <div style={{
//                                                         color: getAssessmentColor(), fontWeight: 'bold',
//                                                         marginTop: '5px', padding: '5px 10px',
//                                                         backgroundColor: '#f8f9fa', borderRadius: '5px',
//                                                         display: 'inline-block'
//                                                     }}>
//                                                         Assessment Type: {getAssessmentName()}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <div className="col-6">
//                                                 <h5>Department Name</h5>
//                                                 <p>{batchDetails?.department || "--"}</p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     {type !== "Tata Trainer" && type !== "Trainer" && (
//                                         <div className="d-flex justify-content-end">
//                                             <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setEditModal(true)}>
//                                                 <i className="mdi mdi-pencil"></i> Edit
//                                             </button>
//                                             <button className="px-3" style={{ cursor: "pointer", border: "none", backgroundColor: "red", color: "white", fontSize: "1.2rem", borderRadius: "10px" }} onClick={() => setDeleteModal(true)}>
//                                                 <i className="mdi mdi-delete"></i> Delete
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {selectedTab === "Notification" && <NotificationButtons />}

//                             {selectedTab === "Trainer" && (
//                                 <div className="row mt-5">
//                                     <div className="col-md-12">
//                                         <h1 className="text-center">Assign to Trainer</h1>
//                                         <div className="d-flex justify-content-end mb-2">
//                                             {type !== "Tata Trainer" && type !== "Trainer" && (
//                                                 <>
//                                                     <Button color="primary" onClick={() => setAddTrainerModal(true)} className="me-2">Add Trainer</Button>
//                                                     <Button color="danger" onClick={handleRemoveAllTrainer}>Remove All Trainer</Button>
//                                                 </>
//                                             )}
//                                         </div>
//                                         <Paper sx={{ height: 400, width: '100%' }}>
//                                             <DataGrid rows={allTrainerOfBatch} columns={columnsTrainer}
//                                                 initialState={{ pagination: { paginationModel } }} pageSizeOptions={[5, 10]}
//                                                 disableRowSelectionOnClick sx={{ border: 0 }} />
//                                         </Paper>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Student Tab */}
//                             {selectedTab === "Student" && (
//                                 <div className="row mt-5">
//                                     <div className="col-md-12">
//                                         <h1 className="text-center">Assign To Student</h1>

//                                         {organizationId === 2 && !isTrainerRole && (
//                                             <div className="alert alert-warning mb-3">
//                                                 <div className="d-flex justify-content-between align-items-center">
//                                                     <div>
//                                                         <strong>Certificate Status:</strong>
//                                                         <ul className="mb-0 mt-2">
//                                                             <li>Total Students: <strong>{allStudentOfBatch.length}</strong></li>
//                                                             <li>Eligible Students: <strong className="text-success">{fetchingExamResults ? "Calculating..." : getPassedStudentsCount()}</strong></li>
//                                                             <li>Certificate Eligibility: {hasPracticalAssessment() ? "Post-test ≥80% + Practical" : "Post-test ≥80%"}</li>
//                                                         </ul>
//                                                     </div>
//                                                     <div className="d-flex flex-column gap-2">
//                                                         <Button color="success" onClick={generateCertificatesForPassedStudents}
//                                                             disabled={batchZipLoading || fetchingExamResults}
//                                                             startIcon={batchZipLoading ? <CircularProgress size={20} /> : <ArchiveIcon />}>
//                                                             {fetchingExamResults ? 'Fetching...' : batchZipLoading ? 'Generating...' : 'Download All Certificates (ZIP)'}
//                                                         </Button>
//                                                         <Button color="info" onClick={generateExcelReportOnly}
//                                                             disabled={loader || fetchingExamResults} startIcon={<DescriptionIcon />}>
//                                                             Generate Excel Report Only
//                                                         </Button>
//                                                     </div>
//                                                 </div>
//                                                 {certificateProgress.inProgress && (
//                                                     <div className="mt-3">
//                                                         <div className="d-flex justify-content-between mb-1">
//                                                             <small>Generating: {certificateProgress.completed}/{certificateProgress.total}</small>
//                                                             <small>{Math.round((certificateProgress.completed / certificateProgress.total) * 100)}%</small>
//                                                         </div>
//                                                         <div className="progress">
//                                                             <div className="progress-bar progress-bar-striped progress-bar-animated"
//                                                                 style={{ width: `${(certificateProgress.completed / certificateProgress.total) * 100}%` }} />
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         )}

//                                         <div className="mb-3">
//                                             <div className="alert alert-success">
//                                                 <strong>Student Addition Policy:</strong>
//                                                 <ul className="mb-0">
//                                                     <li><strong>ALL students</strong> can be added to this batch</li>
//                                                     <li>Students can be in multiple batches simultaneously</li>
//                                                     <li>Only students <strong>already in this batch</strong> cannot be re-added</li>
//                                                     <li>Total Students in Batch: <strong>{allStudentOfBatch.length}</strong></li>
//                                                 </ul>
//                                             </div>
//                                         </div>

//                                         <div className="d-flex justify-content-between mb-3">
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
//                                                 <TextField size="small" placeholder="Search students in batch..."
//                                                     value={batchStudentSearchTerm}
//                                                     onChange={(e) => setBatchStudentSearchTerm(e.target.value)}
//                                                     sx={{ flex: 1, maxWidth: '500px' }}
//                                                     InputProps={{
//                                                         startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
//                                                         endAdornment: batchStudentSearchTerm && (
//                                                             <InputAdornment position="end">
//                                                                 <IconButton size="small" onClick={clearBatchStudentSearch}><ClearIcon /></IconButton>
//                                                             </InputAdornment>
//                                                         )
//                                                     }} />
//                                                 <span className="text-muted">{filteredBatchStudents.length} students</span>
//                                             </div>
//                                             <div className="d-flex align-items-center gap-2">
//                                                 {selectedStudentIds.length > 0 && (
//                                                     <Button color="danger" onClick={handleBulkRemoveStudents} disabled={loader}
//                                                         size="sm" startIcon={<PersonOffIcon />}>
//                                                         Remove Selected ({selectedStudentIds.length})
//                                                     </Button>
//                                                 )}
//                                                 <Button color="primary" onClick={() => setAddStudentModal(true)} size="sm" startIcon={<PersonAddIcon />}>
//                                                     Add Student
//                                                 </Button>
//                                                 <Button color="danger" onClick={() => setRemoveAllStudentsModal(true)} size="sm" startIcon={<DeleteIcon />} outline>
//                                                     Remove All
//                                                 </Button>
//                                             </div>
//                                         </div>

//                                         <div className="d-flex justify-content-between mb-2">
//                                             <button className="btn btn-info" onClick={handleDownloadStudentDetailsClick}>
//                                                 <DownloadIcon style={{ marginRight: '5px' }} /> Download All Student File
//                                             </button>
//                                         </div>

//                                         <Paper sx={{ height: 500, width: '100%' }}>
//                                             <DataGrid rows={filteredBatchStudents} columns={columnsStudent}
//                                                 initialState={{ pagination: { paginationModel } }}
//                                                 pageSizeOptions={[5, 10, 25]}
//                                                 checkboxSelection
//                                                 onRowSelectionModelChange={handleSelectionChange}
//                                                 rowSelectionModel={selectedStudentIds}
//                                                 sx={{ border: 0 }}
//                                                 loading={loader} />
//                                         </Paper>
//                                     </div>
//                                 </div>
//                             )}

//                             {selectedTab === "Courses" && (
//                                 <>
//                                     <div className="d-flex justify-content-end mt-2">
//                                         {type !== "Trainer" && type !== "Tata Trainer" && (
//                                             <Button color="primary" onClick={() => setAddCourseModal(true)}>Add Course</Button>
//                                         )}
//                                     </div>
//                                     <div className="d-flex flex-row flex-wrap mt-3">
//                                         {allCoursesOfBatch?.map((d, index) => (
//                                             <div key={index} className="card me-5" style={{ width: "18rem", border: "2px solid gray", borderRadius: "10px", cursor: "pointer" }}
//                                                 onClick={() => navigate("/course-view/" + d.id)}>
//                                                 <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title || "Course"} height={"200px"} />
//                                                 <div className="card-body">
//                                                     <h5 className="card-title">{d?.title}</h5>
//                                                     <div className="d-flex justify-content-between"><h5>Duration: </h5><p>{d?.duration} Hours</p></div>
//                                                     <div className="d-flex justify-content-between"><h5>Level: </h5><p>{d?.levelDto?.name}</p></div>
//                                                     <div className="d-flex justify-content-between"><h5>Language: </h5><p>{d?.language}</p></div>
//                                                     {type !== "Trainer" && (
//                                                         <Button color="danger" onClick={(e) => {
//                                                             e.stopPropagation();
//                                                             setSelectedCourse(d);
//                                                             setCourseDeleteModal(true);
//                                                         }}>Remove Course</Button>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </>
//                             )}

//                             {selectedTab === "ScormCourses" && (
//                                 <ScormCourse getScormCourseOfBatch={getScormCourseOfBatch} allScormCourses={allScormCourses} allScormCoursesOfBatch={allScormCoursesOfBatch} type={type} />
//                             )}

//                             {selectedTab === "LiveClasses" && (
//                                 <LClass liveClasses={liveClasses} loader={loader} setLoader={setLoader}
//                                     params={params} fetchBatchDetails={fetchBatchDetails} spanDisplay={spanDisplay} />
//                             )}

//                             {selectedTab === "Attendance" && (
//                                 <>
//                                     <TrainerAttendance trainers={allTrainerOfBatch} batchDetails={batchDetails} />
//                                     <Attendance students={allStudentOfBatch} batchDetails={batchDetails} />
//                                 </>
//                             )}

//                             {selectedTab === "Simulator" && shouldShowSimulatorTab() && (
//                                 <Simulator students={allStudentOfBatch} batchDetails={batchDetails} />
//                             )}

//                             {selectedTab === "Exam" && <div className="mt-2"><ExamList /></div>}
//                             {selectedTab === "Feedback" && <div className="mt-2"><Feedback /></div>}
//                             {selectedTab === "Practical" && shouldShowPracticalTab() && <div className="mt-2">{getAssessmentComponent()}</div>}
//                             {selectedTab === "TrainingImages" && (
//                                 <ImageUploader batchId={params.id} trainingImages={trainingImages} fetchBatchDetails={fetchBatchDetails} />
//                             )}
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>

//             {/* ==================== MODALS ==================== */}

//             <ExamResultsModal student={selectedStudent} batchId={params.id}
//                 open={showExamResults} onClose={() => setShowExamResults(false)}
//                 examResults={studentExamResults[selectedStudent?.id]}
//                 loading={loadingExamResults[selectedStudent?.id]} />

//             {/* Add Students Modal */}
//             <Modal show={addStudentModal} size="xl" centered onHide={handleModalClose}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <div>
//                             <h4>Add Students to Batch</h4>
//                             {batchDetails && (
//                                 <div className="batch-info-card mt-2 p-3 bg-light rounded">
//                                     <div className="d-flex align-items-center mb-2">
//                                         <SchoolIcon className="me-2 text-primary" />
//                                         <h5 className="mb-0 text-primary">{batchDetails.batchName || "Batch"}</h5>
//                                     </div>
//                                     <div className="row">
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small><strong>Start:</strong> {formatDate(batchDetails.startDate)}</small>
//                                             </div>
//                                         </div>
//                                         <div className="col-md-6">
//                                             <div className="d-flex align-items-center mb-1">
//                                                 <EventIcon className="me-2" style={{ fontSize: '0.9rem' }} />
//                                                 <small><strong>End:</strong> {formatDate(batchDetails.endDate)}</small>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <h1 className="text-center">All Students</h1>

//                     {showSuccessMessage && (
//                         <div className="alert alert-success alert-dismissible fade show mb-3" role="alert">
//                             <strong>Success!</strong> {successMessage}
//                             <button type="button" className="btn-close" onClick={() => setShowSuccessMessage(false)} />
//                         </div>
//                     )}

//                     {showBulkProgress && (
//                         <div className="alert alert-info mb-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <strong>Adding Students:</strong>
//                                     <div className="mt-1">
//                                         <span className="text-success">✓ {bulkAddProgress.added} added</span>
//                                         {bulkAddProgress.failed > 0 && <span className="text-danger ms-3">✗ {bulkAddProgress.failed} failed</span>}
//                                     </div>
//                                 </div>
//                                 {bulkAddInProgress && <CircularProgress size={24} />}
//                             </div>
//                         </div>
//                     )}

//                     {recentlyAddedStudents.length > 0 && (
//                         <div className="alert alert-info mb-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <strong>Recently Added:</strong>
//                                     <ul className="mb-0 mt-1" style={{ maxHeight: '100px', overflowY: 'auto' }}>
//                                         {recentlyAddedStudents.slice(-5).map((s, i) => (
//                                             <li key={i}>{s.firstName} {s.lastName} <span className="text-muted">({s.mobile})</span></li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                                 <Button color="link" size="sm" onClick={() => setRecentlyAddedStudents([])}>Clear</Button>
//                             </div>
//                         </div>
//                     )}

//                     <div className="alert alert-info mb-3">
//                         <strong>Tip:</strong> Check the boxes to select students, then click "Add Selected" button.
//                         <br />
//                         <strong>Selected: {selectedStudentsForBatch.length}</strong> | Available: {filteredAllStudents.length}
//                     </div>

//                     {selectedStudentsForBatch.length > 0 && (
//                         <div className="alert alert-warning mb-3 d-flex justify-content-between align-items-center">
//                             <div>
//                                 <strong>✓ Selected {selectedStudentsForBatch.length} student(s)</strong>
//                                 <Button color="link" onClick={() => setShowSelectedStudents(!showSelectedStudents)} className="ms-2">
//                                     {showSelectedStudents ? 'Hide' : 'Show'}
//                                 </Button>
//                             </div>
//                             <div>
//                                 <Button color="secondary" size="sm" onClick={handleClearSelectedStudents} className="me-2" disabled={bulkAddInProgress}>Clear All</Button>
//                                 <Button color="success" size="sm" onClick={handleAddMultipleStudentsToBatch} disabled={bulkAddInProgress}
//                                     startIcon={bulkAddInProgress ? <CircularProgress size={16} /> : <PersonAddIcon />}>
//                                     {bulkAddInProgress ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                 </Button>
//                             </div>
//                         </div>
//                     )}

//                     {showSelectedStudents && selectedStudentsForBatch.length > 0 && (
//                         <div className="mb-3">
//                             <h5>Selected Students:</h5>
//                             <Paper sx={{ height: 200, width: '100%', marginBottom: 2 }}>
//                                 <DataGrid rows={selectedStudentsForBatch} columns={columnsSelectedStudents}
//                                     pageSizeOptions={[5]} disableRowSelectionOnClick sx={{ border: 0 }} />
//                             </Paper>
//                         </div>
//                     )}

//                     <div className="mb-3">
//                         <Row>
//                             <Col md={isTataUser ? 3 : 6}>
//                                 <TextField fullWidth variant="outlined" label="Search by Name/Email/Mobile"
//                                     value={searchStudentText} onChange={(e) => setSearchStudentText(e.target.value)}
//                                     sx={{ marginBottom: 2 }} disabled={bulkAddInProgress} />
//                             </Col>
//                             <Col md={isTataUser ? 3 : 6}>
//                                 <TextField fullWidth variant="outlined" label="Search by Aadhaar No"
//                                     value={searchAadhaarText} onChange={(e) => setSearchAadhaarText(e.target.value)}
//                                     sx={{ marginBottom: 2 }} disabled={bulkAddInProgress} />
//                             </Col>
//                             {isTataUser && (
//                                 <>
//                                     <Col md={2}>
//                                         <Select placeholder="State" value={stateFilter} onChange={setStateFilter}
//                                             options={availableStates} isClearable className="mb-2" isDisabled={bulkAddInProgress} />
//                                     </Col>
//                                     <Col md={2}>
//                                         <Select placeholder="Division" value={divisionFilter} onChange={setDivisionFilter}
//                                             options={availableDivisions} isClearable className="mb-2" isDisabled={bulkAddInProgress} />
//                                     </Col>
//                                     <Col md={2}>
//                                         <Select placeholder="Contractor Token" value={contractorTokenFilter} onChange={setContractorTokenFilter}
//                                             options={availableContractorTokens} isClearable className="mb-2" isDisabled={bulkAddInProgress} />
//                                     </Col>
//                                 </>
//                             )}
//                         </Row>

//                         <div className="d-flex justify-content-between align-items-center mt-3">
//                             <div>
//                                 <span className="fw-bold text-success">
//                                     {selectedStudentsForBatch.length > 0 && `✓ ${selectedStudentsForBatch.length} selected`}
//                                 </span>
//                                 <small className="text-muted ms-3">Showing {filteredAllStudents.length} of {allStudents.length} students</small>
//                             </div>
//                             <Button color="secondary" size="sm" onClick={clearStudentFilters}
//                                 disabled={(!searchStudentText && !searchAadhaarText && !stateFilter && !divisionFilter && !contractorTokenFilter) || loader || bulkAddInProgress}
//                                 startIcon={<FilterListIcon />}>
//                                 Clear Filters
//                             </Button>
//                         </div>
//                     </div>

//                     {isTataUser ? (
//                         <Paper sx={{ height: 500, width: '100%' }}>
//                             <DataGrid
//                                 rows={filteredAllStudents?.map((row, index) => ({ ...row, id: row.id || index + 1 }))}
//                                 columns={columnsStudentModalForTata}
//                                 initialState={{ pagination: { paginationModel } }}
//                                 pageSizeOptions={[5, 10, 25]}
//                                 disableRowSelectionOnClick
//                                 sx={{ border: 0 }}
//                                 loading={loader || bulkAddInProgress}
//                                 rowHeight={52}
//                             />
//                         </Paper>
//                     ) : (
//                         <Paper sx={{ height: 500, width: '100%' }}>
//                             <DataGrid
//                                 rows={filteredAllStudents?.map((row, index) => ({ ...row, id: row.id || index + 1 }))}
//                                 columns={columnsStudentModal}
//                                 initialState={{ pagination: { paginationModel } }}
//                                 pageSizeOptions={[5, 10, 25]}
//                                 disableRowSelectionOnClick
//                                 sx={{ border: 0 }}
//                                 loading={loader || bulkAddInProgress}
//                             />
//                         </Paper>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <div className="d-flex justify-content-between w-100">
//                         <div>
//                             {selectedStudentsForBatch.length > 0 && (
//                                 <Button color="success" onClick={handleAddMultipleStudentsToBatch} disabled={bulkAddInProgress}
//                                     startIcon={bulkAddInProgress ? <CircularProgress size={16} /> : <PersonAddIcon />}>
//                                     {bulkAddInProgress ? 'Adding...' : `Add Selected (${selectedStudentsForBatch.length})`}
//                                 </Button>
//                             )}
//                         </div>
//                         <div>
//                             <Button color="secondary" onClick={handleModalClose} className="me-2" disabled={bulkAddInProgress}>Close</Button>
//                             {recentlyAddedStudents.length > 0 && (
//                                 <Button color="primary" onClick={() => { handleModalClose(); setSelectedTab("Student"); }} disabled={bulkAddInProgress}>
//                                     Done ({recentlyAddedStudents.length} added)
//                                 </Button>
//                             )}
//                         </div>
//                     </div>
//                 </Modal.Footer>
//             </Modal>

//             {/* Bulk Remove Modal */}
//             <Modal show={bulkRemoveModal} size="lg" centered onHide={() => setBulkRemoveModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Confirm Bulk Removal</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center py-3">
//                         <div style={{ fontSize: '3rem', marginBottom: '20px' }}>⚠️</div>
//                         <h4>Are you sure you want to remove these students?</h4>
//                         <div className="alert alert-danger">
//                             <strong>You are about to remove {selectedStudentIds.length} student(s) from this batch.</strong>
//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setBulkRemoveModal(false)} disabled={loader}>Cancel</Button>
//                     <Button color="danger" onClick={confirmBulkRemoveStudents} disabled={loader}>
//                         Yes, Remove {selectedStudentIds.length} Student(s)
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Event Modal */}
//             <Modal show={showEventModal} centered onHide={() => setShowEventModal(false)}>
//                 <Modal.Header closeButton><Modal.Title>Class Details</Modal.Title></Modal.Header>
//                 <Modal.Body>
//                     {selectedEvent && (
//                         <div>
//                             <h4>{selectedEvent.title}</h4>
//                             <div><AccessTimeIcon /> {formatDateTime(selectedEvent.classTime)}</div>
//                             {selectedEvent.description && <div><SubjectIcon /> {selectedEvent.description}</div>}
//                             {selectedEvent.classLink && (
//                                 <div><LinkIcon /> <a href={selectedEvent.classLink} target="_blank" rel="noopener noreferrer">{selectedEvent.classLink}</a></div>
//                             )}
//                         </div>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer><Button color="secondary" onClick={() => setShowEventModal(false)}>Close</Button></Modal.Footer>
//             </Modal>

//             {/* Delete Batch Modal */}
//             <Modal show={deleteModal} size="lg" centered>
//                 <Modal.Body><h1>Are you sure want to delete this Batch?</h1></Modal.Body>
//                 <Modal.Footer>
//                     <Button color="primary" onClick={() => setDeleteModal(false)}>Close</Button>
//                     <Button color="danger" onClick={handleDeleteBatch}>Delete</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Edit Modal */}
//             <Modal show={editModal} size="lg" centered>
//                 <Modal.Header><Modal.Title>Edit Batch Details</Modal.Title></Modal.Header>
//                 <Modal.Body>
//                     <Row className="mb-3">
//                         <label className="col-md-2 col-form-label">Batch Name</label>
//                         <div className="col-md-10">
//                             <input type="text" className="form-control" placeholder="Enter Batch Name"
//                                 value={batchDetails?.batchName || ""} maxLength="50"
//                                 onChange={(e) => setBatchDetails(prev => ({ ...prev, batchName: e.target.value }))} />
//                         </div>
//                     </Row>
//                     <Row className="mb-3">
//                         <label className="col-md-2 col-form-label">Department Name</label>
//                         <div className="col-md-10">
//                             <Select value={department} onChange={setDepartment} options={allDepartments}
//                                 getOptionLabel={o => o.name} getOptionValue={o => o.id.toString()} />
//                         </div>
//                     </Row>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="primary" onClick={() => setEditModal(false)}>Close</Button>
//                     <Button color="success" onClick={handleUpdate}>Update</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Add Trainer Modal */}
//             <Modal show={addTrainerModal} size="lg" centered>
//                 <Modal.Header>Add Trainer</Modal.Header>
//                 <Modal.Body>
//                     <div className="mb-3 d-flex justify-content-center">
//                         <div style={{ width: '50%' }}>
//                             <TextField fullWidth variant="outlined" label="Search Trainer"
//                                 value={searchTrainerText} onChange={(e) => setSearchTrainerText(e.target.value)} />
//                         </div>
//                     </div>
//                     <Paper sx={{ height: 400, width: '100%' }}>
//                         <DataGrid rows={filteredAllTrainers} columns={columnsTrainerModal}
//                             initialState={{ pagination: { paginationModel } }} pageSizeOptions={[5, 10]}
//                             disableRowSelectionOnClick sx={{ border: 0 }} />
//                     </Paper>
//                 </Modal.Body>
//                 <Modal.Footer><Button color="primary" onClick={() => setAddTrainerModal(false)}>Close</Button></Modal.Footer>
//             </Modal>

//             {/* Add Course Modal */}
//             <Modal show={addCourseModal} size="lg" centered>
//                 <Modal.Header>Add Courses</Modal.Header>
//                 <Modal.Body>
//                     <div className="mb-3 d-flex justify-content-center">
//                         <div style={{ width: '50%' }}>
//                             <TextField fullWidth label="Search Course" value={searchCourseText}
//                                 onChange={(e) => setSearchCourseText(e.target.value)} />
//                         </div>
//                     </div>
//                     <div className="d-flex flex-row flex-wrap mt-3" style={{ height: "70vh", overflowY: "auto" }}>
//                         {filteredAllCourses.map((d, i) => (
//                             <div key={i} className="card me-5 mb-3" style={{ width: "18rem", border: "2px solid gray", borderRadius: "10px" }}>
//                                 <img className="card-img-top" src={d?.thumbnailUrl} alt={d?.title} height={"220px"} />
//                                 <div className="card-body">
//                                     <h5>{d?.title}</h5>
//                                     <div className="d-flex justify-content-between"><h5>Duration: </h5><p>{d?.duration} Hours</p></div>
//                                     <div className="d-flex justify-content-between"><h5>Level: </h5><p>{d?.levelDto?.name}</p></div>
//                                     <Button color="success" onClick={() => handleAddCourseToBatch(d?.id)}>Add Course</Button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer><Button color="primary" onClick={() => setAddCourseModal(false)}>Close</Button></Modal.Footer>
//             </Modal>

//             {/* Remove All Students Modal */}
//             <Modal show={removeAllStudentsModal} size="lg" centered>
//                 <Modal.Header><Modal.Title>Remove All Students</Modal.Title></Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center">
//                         <h4>Are you sure you want to remove all students from this batch?</h4>
//                         <p className="text-danger"><strong>Warning:</strong> This action cannot be undone. All {allStudentOfBatch.length} students will be removed.</p>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setRemoveAllStudentsModal(false)}>Cancel</Button>
//                     <Button color="danger" onClick={handleRemoveAllStudents} disabled={loader}>
//                         {loader ? 'Removing...' : 'Yes, Remove All'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Student Delete Modal */}
//             <Modal show={studentDeleteModal} size="lg" centered>
//                 <Modal.Body><h4>Are you sure want to remove this Student?</h4></Modal.Body>
//                 <Modal.Footer>
//                     <Button color="primary" onClick={() => setStudentDeleteModal(false)}>No</Button>
//                     <Button color="danger" onClick={handleRemoveStudentFromBatch}>Yes</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Course Delete Modal */}
//             <Modal show={courseDeleteModal} size="lg" centered>
//                 <Modal.Body><h4>Are you sure want to remove this Course?</h4></Modal.Body>
//                 <Modal.Footer>
//                     <Button color="primary" onClick={() => setCourseDeleteModal(false)}>No</Button>
//                     <Button color="danger" onClick={handleRemoveCourseFromBatch}>Yes</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Trainer Delete Modal */}
//             <Modal show={trainerDeleteModal} size="lg" centered>
//                 <Modal.Body><h4>Are you sure want to remove this Trainer?</h4></Modal.Body>
//                 <Modal.Footer>
//                     <Button color="primary" onClick={() => setTrainerDeleteModal(false)}>No</Button>
//                     <Button color="danger" onClick={handleRemoveTrainerFromBatch}>Yes</Button>
//                 </Modal.Footer>
//             </Modal>
//         </React.Fragment>
//     );
// };

// export default connect(null, { setBreadcrumbItems })(BatchDetails);